(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire4c53"];
var parcelRegister = parcelRequire.register;
parcelRegister("S0nQY", function(module, exports) {
/**
 * TinyMCE version 6.8.6 (TBD)
 */ /**
 * This file bundles the code of
 * DOMPurify 3.2.4 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.4/LICENSE
 * The code included in this file has been modified.
 */ !function() {
    "use strict";
    var e1 = function(e1) {
        if (null === e1) return "null";
        if (void 0 === e1) return "undefined";
        var t = typeof e1;
        return "object" === t && (Array.prototype.isPrototypeOf(e1) || e1.constructor && "Array" === e1.constructor.name) ? "array" : "object" === t && (String.prototype.isPrototypeOf(e1) || e1.constructor && "String" === e1.constructor.name) ? "string" : t;
    }, t = function(e1) {
        return {
            eq: e1
        };
    }, n = t(function(e1, t) {
        return e1 === t;
    }), o = function(e1) {
        return t(function(t, n) {
            if (t.length !== n.length) return !1;
            for(var o = t.length, r = 0; r < o; r++)if (!e1.eq(t[r], n[r])) return !1;
            return !0;
        });
    }, r = function(e1) {
        return t(function(r, s) {
            var a = Object.keys(r), i = Object.keys(s);
            if (!(function(e1, n) {
                return function(e1, n) {
                    return t(function(t, o) {
                        return e1.eq(n(t), n(o));
                    });
                }(o(e1), function(e1) {
                    return function(e1, t) {
                        return Array.prototype.slice.call(e1).sort(t);
                    }(e1, n);
                });
            })(n).eq(a, i)) return !1;
            for(var l = a.length, d = 0; d < l; d++){
                var c = a[d];
                if (!e1.eq(r[c], s[c])) return !1;
            }
            return !0;
        });
    }, s = t(function(t, n) {
        if (t === n) return !0;
        var a = e1(t);
        return a === e1(n) && (function(e1) {
            return -1 !== [
                "undefined",
                "boolean",
                "number",
                "string",
                "function",
                "xml",
                "null"
            ].indexOf(e1);
        }(a) ? t === n : "array" === a ? o(s).eq(t, n) : "object" === a && r(s).eq(t, n));
    });
    const a = Object.getPrototypeOf, i = (e1, t, n)=>{
        var o;
        return !!n(e1, t.prototype) || (null === (o = e1.constructor) || void 0 === o ? void 0 : o.name) === t.name;
    }, l = (e1)=>(t)=>((e1)=>{
                const t = typeof e1;
                return null === e1 ? "null" : "object" === t && Array.isArray(e1) ? "array" : "object" === t && i(e1, String, (e1, t)=>t.isPrototypeOf(e1)) ? "string" : t;
            })(t) === e1, d = (e1)=>(t)=>typeof t === e1, c = (e1)=>(t)=>e1 === t, u = (e1, t)=>f(e1) && i(e1, t, (e1, t)=>a(e1) === t), m = l("string"), f = l("object"), g = (e1)=>u(e1, Object), p = l("array"), h = c(null), b = d("boolean"), v = c(void 0), y = (e1)=>null == e1, C = (e1)=>!y(e1), w = d("function"), x = d("number"), E = (e1, t)=>{
        if (p(e1)) {
            for(let n = 0, o = e1.length; n < o; ++n)if (!t(e1[n])) return !1;
            return !0;
        }
        return !1;
    }, _ = ()=>{}, S = (e1, t)=>(...n)=>e1(t.apply(null, n)), k = (e1, t)=>(n)=>e1(t(n)), N = (e1)=>()=>e1, R = (e1)=>e1, A = (e1, t)=>e1 === t;
    function T(e1, ...t) {
        return (...n)=>{
            const o = t.concat(n);
            return e1.apply(null, o);
        };
    }
    const O = (e1)=>(t)=>!e1(t), B = (e1)=>()=>{
            throw new Error(e1);
        }, P = (e1)=>e1(), D = (e1)=>{
        e1();
    }, L = N(!1), M = N(!0);
    class I {
        constructor(e1, t){
            this.tag = e1, this.value = t;
        }
        static some(e1) {
            return new I(!0, e1);
        }
        static none() {
            return I.singletonNone;
        }
        fold(e1, t) {
            return this.tag ? t(this.value) : e1();
        }
        isSome() {
            return this.tag;
        }
        isNone() {
            return !this.tag;
        }
        map(e1) {
            return this.tag ? I.some(e1(this.value)) : I.none();
        }
        bind(e1) {
            return this.tag ? e1(this.value) : I.none();
        }
        exists(e1) {
            return this.tag && e1(this.value);
        }
        forall(e1) {
            return !this.tag || e1(this.value);
        }
        filter(e1) {
            return !this.tag || e1(this.value) ? this : I.none();
        }
        getOr(e1) {
            return this.tag ? this.value : e1;
        }
        or(e1) {
            return this.tag ? this : e1;
        }
        getOrThunk(e1) {
            return this.tag ? this.value : e1();
        }
        orThunk(e1) {
            return this.tag ? this : e1();
        }
        getOrDie(e1) {
            if (this.tag) return this.value;
            throw new Error(null != e1 ? e1 : "Called getOrDie on None");
        }
        static from(e1) {
            return C(e1) ? I.some(e1) : I.none();
        }
        getOrNull() {
            return this.tag ? this.value : null;
        }
        getOrUndefined() {
            return this.value;
        }
        each(e1) {
            this.tag && e1(this.value);
        }
        toArray() {
            return this.tag ? [
                this.value
            ] : [];
        }
        toString() {
            return this.tag ? `some(${this.value})` : "none()";
        }
    }
    I.singletonNone = new I(!1);
    const F = Array.prototype.slice, U = Array.prototype.indexOf, z = Array.prototype.push, j = (e1, t)=>U.call(e1, t), H = (e1, t)=>j(e1, t) > -1, $ = (e1, t)=>{
        for(let n = 0, o = e1.length; n < o; n++)if (t(e1[n], n)) return !0;
        return !1;
    }, q = (e1, t)=>{
        const n = e1.length, o = new Array(n);
        for(let r = 0; r < n; r++){
            const n = e1[r];
            o[r] = t(n, r);
        }
        return o;
    }, V = (e1, t)=>{
        for(let n = 0, o = e1.length; n < o; n++)t(e1[n], n);
    }, W = (e1, t)=>{
        for(let n = e1.length - 1; n >= 0; n--)t(e1[n], n);
    }, K = (e1, t)=>{
        const n = [], o = [];
        for(let r = 0, s = e1.length; r < s; r++){
            const s = e1[r];
            (t(s, r) ? n : o).push(s);
        }
        return {
            pass: n,
            fail: o
        };
    }, Y = (e1, t)=>{
        const n = [];
        for(let o = 0, r = e1.length; o < r; o++){
            const r = e1[o];
            t(r, o) && n.push(r);
        }
        return n;
    }, G = (e1, t, n)=>(W(e1, (e1, o)=>{
            n = t(n, e1, o);
        }), n), X = (e1, t, n)=>(V(e1, (e1, o)=>{
            n = t(n, e1, o);
        }), n), Q = (e1, t, n)=>{
        for(let o = 0, r = e1.length; o < r; o++){
            const r = e1[o];
            if (t(r, o)) return I.some(r);
            if (n(r, o)) break;
        }
        return I.none();
    }, J = (e1, t)=>Q(e1, t, L), Z = (e1, t)=>{
        for(let n = 0, o = e1.length; n < o; n++)if (t(e1[n], n)) return I.some(n);
        return I.none();
    }, ee = (e1)=>{
        const t = [];
        for(let n = 0, o = e1.length; n < o; ++n){
            if (!p(e1[n])) throw new Error("Arr.flatten item " + n + " was not an array, input: " + e1);
            z.apply(t, e1[n]);
        }
        return t;
    }, te = (e1, t)=>ee(q(e1, t)), ne = (e1, t)=>{
        for(let n = 0, o = e1.length; n < o; ++n)if (!0 !== t(e1[n], n)) return !1;
        return !0;
    }, oe = (e1)=>{
        const t = F.call(e1, 0);
        return t.reverse(), t;
    }, re = (e1, t)=>Y(e1, (e1)=>!H(t, e1)), se = (e1, t)=>{
        const n = {};
        for(let o = 0, r = e1.length; o < r; o++){
            const r = e1[o];
            n[String(r)] = t(r, o);
        }
        return n;
    }, ae = (e1, t)=>{
        const n = F.call(e1, 0);
        return n.sort(t), n;
    }, ie = (e1, t)=>t >= 0 && t < e1.length ? I.some(e1[t]) : I.none(), le = (e1)=>ie(e1, 0), de = (e1)=>ie(e1, e1.length - 1), ce = w(Array.from) ? Array.from : (e1)=>F.call(e1), ue = (e1, t)=>{
        for(let n = 0; n < e1.length; n++){
            const o = t(e1[n], n);
            if (o.isSome()) return o;
        }
        return I.none();
    }, me = Object.keys, fe = Object.hasOwnProperty, ge = (e1, t)=>{
        const n = me(e1);
        for(let o = 0, r = n.length; o < r; o++){
            const r = n[o];
            t(e1[r], r);
        }
    }, pe = (e1, t)=>he(e1, (e1, n)=>({
                k: n,
                v: t(e1, n)
            })), he = (e1, t)=>{
        const n = {};
        return ge(e1, (e1, o)=>{
            const r = t(e1, o);
            n[r.k] = r.v;
        }), n;
    }, be = (e1)=>(t, n)=>{
            e1[n] = t;
        }, ve = (e1, t, n, o)=>{
        ge(e1, (e1, r)=>{
            (t(e1, r) ? n : o)(e1, r);
        });
    }, ye = (e1, t)=>{
        const n = {};
        return ve(e1, t, be(n), _), n;
    }, Ce = (e1, t)=>{
        const n = [];
        return ge(e1, (e1, o)=>{
            n.push(t(e1, o));
        }), n;
    }, we = (e1)=>Ce(e1, R), xe = (e1, t)=>Ee(e1, t) ? I.from(e1[t]) : I.none(), Ee = (e1, t)=>fe.call(e1, t), _e = (e1, t)=>Ee(e1, t) && void 0 !== e1[t] && null !== e1[t], Se = (e1)=>{
        const t = {};
        return V(e1, (e1)=>{
            t[e1] = {};
        }), me(t);
    }, ke = (e1)=>void 0 !== e1.length, Ne = Array.isArray, Re = (e1, t, n)=>{
        if (!e1) return !1;
        if (n = n || e1, ke(e1)) {
            for(let o = 0, r = e1.length; o < r; o++)if (!1 === t.call(n, e1[o], o, e1)) return !1;
        } else for(const o in e1)if (Ee(e1, o) && !1 === t.call(n, e1[o], o, e1)) return !1;
        return !0;
    }, Ae = (e1, t)=>{
        const n = [];
        return Re(e1, (o, r)=>{
            n.push(t(o, r, e1));
        }), n;
    }, Te = (e1, t)=>{
        const n = [];
        return Re(e1, (o, r)=>{
            t && !t(o, r, e1) || n.push(o);
        }), n;
    }, Oe = (e1, t, n, o)=>{
        let r = v(n) ? e1[0] : n;
        for(let n = 0; n < e1.length; n++)r = t.call(o, r, e1[n], n);
        return r;
    }, Be = (e1, t, n)=>{
        for(let o = 0, r = e1.length; o < r; o++)if (t.call(n, e1[o], o, e1)) return o;
        return -1;
    }, Pe = (e1)=>e1[e1.length - 1], De = (e1)=>{
        let t, n = !1;
        return (...o)=>(n || (n = !0, t = e1.apply(null, o)), t);
    }, Le = ()=>Me(0, 0), Me = (e1, t)=>({
            major: e1,
            minor: t
        }), Ie = {
        nu: Me,
        detect: (e1, t)=>{
            const n = String(t).toLowerCase();
            return 0 === e1.length ? Le() : ((e1, t)=>{
                const n = ((e1, t)=>{
                    for(let n = 0; n < e1.length; n++){
                        const o = e1[n];
                        if (o.test(t)) return o;
                    }
                })(e1, t);
                if (!n) return {
                    major: 0,
                    minor: 0
                };
                const o = (e1)=>Number(t.replace(n, "$" + e1));
                return Me(o(1), o(2));
            })(e1, n);
        },
        unknown: Le
    }, Fe = (e1, t)=>{
        const n = String(t).toLowerCase();
        return J(e1, (e1)=>e1.search(n));
    }, Ue = (e1, t, n)=>"" === t || e1.length >= t.length && e1.substr(n, n + t.length) === t, ze = (e1, t)=>He(e1, t) ? ((e1, t)=>e1.substring(t))(e1, t.length) : e1, je = (e1, t, n = 0, o)=>{
        const r = e1.indexOf(t, n);
        return -1 !== r && (!!v(o) || r + t.length <= o);
    }, He = (e1, t)=>Ue(e1, t, 0), $e = (e1, t)=>Ue(e1, t, e1.length - t.length), qe = (e1)=>(t)=>t.replace(e1, ""), Ve = qe(/^\s+|\s+$/g), We = qe(/^\s+/g), Ke = qe(/\s+$/g), Ye = (e1)=>e1.length > 0, Ge = (e1)=>!Ye(e1), Xe = (e1, t = 10)=>{
        const n = parseInt(e1, t);
        return isNaN(n) ? I.none() : I.some(n);
    }, Qe = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/, Je = (e1)=>(t)=>je(t, e1), Ze = [
        {
            name: "Edge",
            versionRegexes: [
                /.*?edge\/ ?([0-9]+)\.([0-9]+)$/
            ],
            search: (e1)=>je(e1, "edge/") && je(e1, "chrome") && je(e1, "safari") && je(e1, "applewebkit")
        },
        {
            name: "Chromium",
            brand: "Chromium",
            versionRegexes: [
                /.*?chrome\/([0-9]+)\.([0-9]+).*/,
                Qe
            ],
            search: (e1)=>je(e1, "chrome") && !je(e1, "chromeframe")
        },
        {
            name: "IE",
            versionRegexes: [
                /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
                /.*?rv:([0-9]+)\.([0-9]+).*/
            ],
            search: (e1)=>je(e1, "msie") || je(e1, "trident")
        },
        {
            name: "Opera",
            versionRegexes: [
                Qe,
                /.*?opera\/([0-9]+)\.([0-9]+).*/
            ],
            search: Je("opera")
        },
        {
            name: "Firefox",
            versionRegexes: [
                /.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/
            ],
            search: Je("firefox")
        },
        {
            name: "Safari",
            versionRegexes: [
                Qe,
                /.*?cpu os ([0-9]+)_([0-9]+).*/
            ],
            search: (e1)=>(je(e1, "safari") || je(e1, "mobile/")) && je(e1, "applewebkit")
        }
    ], et = [
        {
            name: "Windows",
            search: Je("win"),
            versionRegexes: [
                /.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/
            ]
        },
        {
            name: "iOS",
            search: (e1)=>je(e1, "iphone") || je(e1, "ipad"),
            versionRegexes: [
                /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
                /.*cpu os ([0-9]+)_([0-9]+).*/,
                /.*cpu iphone os ([0-9]+)_([0-9]+).*/
            ]
        },
        {
            name: "Android",
            search: Je("android"),
            versionRegexes: [
                /.*?android\ ?([0-9]+)\.([0-9]+).*/
            ]
        },
        {
            name: "macOS",
            search: Je("mac os x"),
            versionRegexes: [
                /.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/
            ]
        },
        {
            name: "Linux",
            search: Je("linux"),
            versionRegexes: []
        },
        {
            name: "Solaris",
            search: Je("sunos"),
            versionRegexes: []
        },
        {
            name: "FreeBSD",
            search: Je("freebsd"),
            versionRegexes: []
        },
        {
            name: "ChromeOS",
            search: Je("cros"),
            versionRegexes: [
                /.*?chrome\/([0-9]+)\.([0-9]+).*/
            ]
        }
    ], tt = {
        browsers: N(Ze),
        oses: N(et)
    }, nt = "Edge", ot = "Chromium", rt = "Opera", st = "Firefox", at = "Safari", it = (e1)=>{
        const t = e1.current, n = e1.version, o = (e1)=>()=>t === e1;
        return {
            current: t,
            version: n,
            isEdge: o(nt),
            isChromium: o(ot),
            isIE: o("IE"),
            isOpera: o(rt),
            isFirefox: o(st),
            isSafari: o(at)
        };
    }, lt = ()=>it({
            current: void 0,
            version: Ie.unknown()
        }), dt = it, ct = (N(nt), N(ot), N("IE"), N(rt), N(st), N(at), "Windows"), ut = "Android", mt = "Linux", ft = "macOS", gt = "Solaris", pt = "FreeBSD", ht = "ChromeOS", bt = (e1)=>{
        const t = e1.current, n = e1.version, o = (e1)=>()=>t === e1;
        return {
            current: t,
            version: n,
            isWindows: o(ct),
            isiOS: o("iOS"),
            isAndroid: o(ut),
            isMacOS: o(ft),
            isLinux: o(mt),
            isSolaris: o(gt),
            isFreeBSD: o(pt),
            isChromeOS: o(ht)
        };
    }, vt = ()=>bt({
            current: void 0,
            version: Ie.unknown()
        }), yt = bt, Ct = (N(ct), N("iOS"), N(ut), N(mt), N(ft), N(gt), N(pt), N(ht), (e1)=>window.matchMedia(e1).matches);
    let wt = De(()=>((e1, t, n)=>{
            const o = tt.browsers(), r = tt.oses(), s = t.bind((e1)=>((e1, t)=>ue(t.brands, (t)=>{
                        const n = t.brand.toLowerCase();
                        return J(e1, (e1)=>{
                            var t;
                            return n === (null === (t = e1.brand) || void 0 === t ? void 0 : t.toLowerCase());
                        }).map((e1)=>({
                                current: e1.name,
                                version: Ie.nu(parseInt(t.version, 10), 0)
                            }));
                    }))(o, e1)).orThunk(()=>((e1, t)=>Fe(e1, t).map((e1)=>{
                        const n = Ie.detect(e1.versionRegexes, t);
                        return {
                            current: e1.name,
                            version: n
                        };
                    }))(o, e1)).fold(lt, dt), a = ((e1, t)=>Fe(e1, t).map((e1)=>{
                    const n = Ie.detect(e1.versionRegexes, t);
                    return {
                        current: e1.name,
                        version: n
                    };
                }))(r, e1).fold(vt, yt), i = ((e1, t, n, o)=>{
                const r = e1.isiOS() && !0 === /ipad/i.test(n), s = e1.isiOS() && !r, a = e1.isiOS() || e1.isAndroid(), i = a || o("(pointer:coarse)"), l = r || !s && a && o("(min-device-width:768px)"), d = s || a && !l, c = t.isSafari() && e1.isiOS() && !1 === /safari/i.test(n), u = !d && !l && !c;
                return {
                    isiPad: N(r),
                    isiPhone: N(s),
                    isTablet: N(l),
                    isPhone: N(d),
                    isTouch: N(i),
                    isAndroid: e1.isAndroid,
                    isiOS: e1.isiOS,
                    isWebView: N(c),
                    isDesktop: N(u)
                };
            })(a, s, e1, n);
            return {
                browser: s,
                os: a,
                deviceType: i
            };
        })(navigator.userAgent, I.from(navigator.userAgentData), Ct));
    const xt = ()=>wt(), Et = navigator.userAgent, _t = xt(), St = _t.browser, kt = _t.os, Nt = _t.deviceType, Rt = -1 !== Et.indexOf("Windows Phone"), At = {
        transparentSrc: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
        documentMode: St.isIE() ? document.documentMode || 7 : 10,
        cacheSuffix: null,
        container: null,
        canHaveCSP: !St.isIE(),
        windowsPhone: Rt,
        browser: {
            current: St.current,
            version: St.version,
            isChromium: St.isChromium,
            isEdge: St.isEdge,
            isFirefox: St.isFirefox,
            isIE: St.isIE,
            isOpera: St.isOpera,
            isSafari: St.isSafari
        },
        os: {
            current: kt.current,
            version: kt.version,
            isAndroid: kt.isAndroid,
            isChromeOS: kt.isChromeOS,
            isFreeBSD: kt.isFreeBSD,
            isiOS: kt.isiOS,
            isLinux: kt.isLinux,
            isMacOS: kt.isMacOS,
            isSolaris: kt.isSolaris,
            isWindows: kt.isWindows
        },
        deviceType: {
            isDesktop: Nt.isDesktop,
            isiPad: Nt.isiPad,
            isiPhone: Nt.isiPhone,
            isPhone: Nt.isPhone,
            isTablet: Nt.isTablet,
            isTouch: Nt.isTouch,
            isWebView: Nt.isWebView
        }
    }, Tt = /^\s*|\s*$/g, Ot = (e1)=>y(e1) ? "" : ("" + e1).replace(Tt, ""), Bt = function(e1, t, n, o) {
        o = o || this, e1 && (n && (e1 = e1[n]), Re(e1, (e1, r)=>!1 !== t.call(o, e1, r, n) && (Bt(e1, t, n, o), !0)));
    }, Pt = {
        trim: Ot,
        isArray: Ne,
        is: (e1, t)=>t ? !("array" !== t || !Ne(e1)) || typeof e1 === t : void 0 !== e1,
        toArray: (e1)=>{
            if (Ne(e1)) return e1;
            {
                const t = [];
                for(let n = 0, o = e1.length; n < o; n++)t[n] = e1[n];
                return t;
            }
        },
        makeMap: (e1, t, n = {})=>{
            const o = m(e1) ? e1.split(t || ",") : e1 || [];
            let r = o.length;
            for(; r--;)n[o[r]] = {};
            return n;
        },
        each: Re,
        map: Ae,
        grep: Te,
        inArray: (e1, t)=>{
            if (e1) {
                for(let n = 0, o = e1.length; n < o; n++)if (e1[n] === t) return n;
            }
            return -1;
        },
        hasOwn: Ee,
        extend: (e1, ...t)=>{
            for(let n = 0; n < t.length; n++){
                const o = t[n];
                for(const t in o)if (Ee(o, t)) {
                    const n = o[t];
                    void 0 !== n && (e1[t] = n);
                }
            }
            return e1;
        },
        walk: Bt,
        resolve: (e1, t = window)=>{
            const n = e1.split(".");
            for(let e1 = 0, o = n.length; e1 < o && (t = t[n[e1]]); e1++);
            return t;
        },
        explode: (e1, t)=>p(e1) ? e1 : "" === e1 ? [] : Ae(e1.split(t || ","), Ot),
        _addCacheSuffix: (e1)=>{
            const t = At.cacheSuffix;
            return t && (e1 += (-1 === e1.indexOf("?") ? "?" : "&") + t), e1;
        }
    }, Dt = (e1, t, n = A)=>e1.exists((e1)=>n(e1, t)), Lt = (e1, t, n = A)=>Mt(e1, t, n).getOr(e1.isNone() && t.isNone()), Mt = (e1, t, n)=>e1.isSome() && t.isSome() ? I.some(n(e1.getOrDie(), t.getOrDie())) : I.none(), It = (e1, t)=>e1 ? I.some(t) : I.none(), Ft = "undefined" != typeof window ? window : Function("return this;")(), Ut = (e1, t)=>((e1, t)=>{
            let n = null != t ? t : Ft;
            for(let t = 0; t < e1.length && null != n; ++t)n = n[e1[t]];
            return n;
        })(e1.split("."), t), zt = Object.getPrototypeOf, jt = (e1)=>{
        const t = Ut("ownerDocument.defaultView", e1);
        return f(e1) && (((e1)=>((e1, t)=>{
                const n = ((e1, t)=>Ut(e1, t))(e1, t);
                if (null == n) throw new Error(e1 + " not available on this browser");
                return n;
            })("HTMLElement", e1))(t).prototype.isPrototypeOf(e1) || /^HTML\w*Element$/.test(zt(e1).constructor.name));
    }, Ht = (e1)=>e1.dom.nodeName.toLowerCase(), $t = (e1)=>e1.dom.nodeType, qt = (e1)=>(t)=>$t(t) === e1, Vt = (e1)=>Wt(e1) && jt(e1.dom), Wt = qt(1), Kt = qt(3), Yt = qt(9), Gt = qt(11), Xt = (e1)=>(t)=>Wt(t) && Ht(t) === e1, Qt = (e1, t, n)=>{
        if (!(m(n) || b(n) || x(n))) throw console.error("Invalid call to Attribute.set. Key ", t, ":: Value ", n, ":: Element ", e1), new Error("Attribute value was not simple");
        e1.setAttribute(t, n + "");
    }, Jt = (e1, t, n)=>{
        Qt(e1.dom, t, n);
    }, Zt = (e1, t)=>{
        const n = e1.dom;
        ge(t, (e1, t)=>{
            Qt(n, t, e1);
        });
    }, en = (e1, t)=>{
        const n = e1.dom.getAttribute(t);
        return null === n ? void 0 : n;
    }, tn = (e1, t)=>I.from(en(e1, t)), nn = (e1, t)=>{
        const n = e1.dom;
        return !(!n || !n.hasAttribute) && n.hasAttribute(t);
    }, on = (e1, t)=>{
        e1.dom.removeAttribute(t);
    }, rn = (e1)=>X(e1.dom.attributes, (e1, t)=>(e1[t.name] = t.value, e1), {}), sn = (e1, t)=>{
        const n = en(e1, t);
        return void 0 === n || "" === n ? [] : n.split(" ");
    }, an = (e1)=>void 0 !== e1.dom.classList, ln = (e1)=>sn(e1, "class"), dn = (e1, t)=>((e1, t, n)=>{
            const o = sn(e1, t).concat([
                n
            ]);
            return Jt(e1, t, o.join(" ")), !0;
        })(e1, "class", t), cn = (e1, t)=>((e1, t, n)=>{
            const o = Y(sn(e1, t), (e1)=>e1 !== n);
            return o.length > 0 ? Jt(e1, t, o.join(" ")) : on(e1, t), !1;
        })(e1, "class", t), un = (e1, t)=>{
        an(e1) ? e1.dom.classList.add(t) : dn(e1, t);
    }, mn = (e1)=>{
        0 === (an(e1) ? e1.dom.classList : ln(e1)).length && on(e1, "class");
    }, fn = (e1, t)=>{
        an(e1) ? e1.dom.classList.remove(t) : cn(e1, t), mn(e1);
    }, gn = (e1, t)=>an(e1) && e1.dom.classList.contains(t), pn = (e1)=>{
        if (null == e1) throw new Error("Node cannot be null or undefined");
        return {
            dom: e1
        };
    }, hn = (e1, t)=>{
        const n = (t || document).createElement("div");
        if (n.innerHTML = e1, !n.hasChildNodes() || n.childNodes.length > 1) {
            const t = "HTML does not have a single root node";
            throw console.error(t, e1), new Error(t);
        }
        return pn(n.childNodes[0]);
    }, bn = (e1, t)=>{
        const n = (t || document).createElement(e1);
        return pn(n);
    }, vn = (e1, t)=>{
        const n = (t || document).createTextNode(e1);
        return pn(n);
    }, yn = pn, Cn = (e1, t, n)=>I.from(e1.dom.elementFromPoint(t, n)).map(pn), wn = (e1, t)=>{
        const n = [], o = (e1)=>(n.push(e1), t(e1));
        let r = t(e1);
        do r = r.bind(o);
        while (r.isSome());
        return n;
    }, xn = (e1, t)=>{
        const n = e1.dom;
        if (1 !== n.nodeType) return !1;
        {
            const e1 = n;
            if (void 0 !== e1.matches) return e1.matches(t);
            if (void 0 !== e1.msMatchesSelector) return e1.msMatchesSelector(t);
            if (void 0 !== e1.webkitMatchesSelector) return e1.webkitMatchesSelector(t);
            if (void 0 !== e1.mozMatchesSelector) return e1.mozMatchesSelector(t);
            throw new Error("Browser lacks native selectors");
        }
    }, En = (e1)=>1 !== e1.nodeType && 9 !== e1.nodeType && 11 !== e1.nodeType || 0 === e1.childElementCount, _n = (e1, t)=>e1.dom === t.dom, Sn = (e1, t)=>{
        const n = e1.dom, o = t.dom;
        return n !== o && n.contains(o);
    }, kn = (e1)=>yn(e1.dom.ownerDocument), Nn = (e1)=>Yt(e1) ? e1 : kn(e1), Rn = (e1)=>yn(Nn(e1).dom.defaultView), An = (e1)=>I.from(e1.dom.parentNode).map(yn), Tn = (e1)=>I.from(e1.dom.parentElement).map(yn), On = (e1, t)=>{
        const n = w(t) ? t : L;
        let o = e1.dom;
        const r = [];
        for(; null !== o.parentNode && void 0 !== o.parentNode;){
            const e1 = o.parentNode, t = yn(e1);
            if (r.push(t), !0 === n(t)) break;
            o = e1;
        }
        return r;
    }, Bn = (e1)=>I.from(e1.dom.previousSibling).map(yn), Pn = (e1)=>I.from(e1.dom.nextSibling).map(yn), Dn = (e1)=>oe(wn(e1, Bn)), Ln = (e1)=>wn(e1, Pn), Mn = (e1)=>q(e1.dom.childNodes, yn), In = (e1, t)=>{
        const n = e1.dom.childNodes;
        return I.from(n[t]).map(yn);
    }, Fn = (e1)=>In(e1, 0), Un = (e1)=>In(e1, e1.dom.childNodes.length - 1), zn = (e1)=>e1.dom.childNodes.length, jn = (e1)=>Gt(e1) && C(e1.dom.host), Hn = w(Element.prototype.attachShadow) && w(Node.prototype.getRootNode), $n = N(Hn), qn = Hn ? (e1)=>yn(e1.dom.getRootNode()) : Nn, Vn = (e1)=>jn(e1) ? e1 : ((e1)=>{
            const t = e1.dom.head;
            if (null == t) throw new Error("Head is not available yet");
            return yn(t);
        })(Nn(e1)), Wn = (e1)=>yn(e1.dom.host), Kn = (e1)=>{
        if ($n() && C(e1.target)) {
            const t = yn(e1.target);
            if (Wt(t) && Yn(t) && e1.composed && e1.composedPath) {
                const t = e1.composedPath();
                if (t) return le(t);
            }
        }
        return I.from(e1.target);
    }, Yn = (e1)=>C(e1.dom.shadowRoot), Gn = (e1)=>{
        const t = Kt(e1) ? e1.dom.parentNode : e1.dom;
        if (null == t || null === t.ownerDocument) return !1;
        const n = t.ownerDocument;
        return ((e1)=>{
            const t = qn(e1);
            return jn(t) ? I.some(t) : I.none();
        })(yn(t)).fold(()=>n.body.contains(t), k(Gn, Wn));
    };
    var Xn = (e1, t, n, o, r)=>e1(n, o) ? I.some(n) : w(r) && r(n) ? I.none() : t(n, o, r);
    const Qn = (e1, t, n)=>{
        let o = e1.dom;
        const r = w(n) ? n : L;
        for(; o.parentNode;){
            o = o.parentNode;
            const e1 = yn(o);
            if (t(e1)) return I.some(e1);
            if (r(e1)) break;
        }
        return I.none();
    }, Jn = (e1, t, n)=>Xn((e1, t)=>t(e1), Qn, e1, t, n), Zn = (e1, t)=>{
        const n = (e1)=>{
            for(let o = 0; o < e1.childNodes.length; o++){
                const r = yn(e1.childNodes[o]);
                if (t(r)) return I.some(r);
                const s = n(e1.childNodes[o]);
                if (s.isSome()) return s;
            }
            return I.none();
        };
        return n(e1.dom);
    }, eo = (e1, t, n)=>Qn(e1, (e1)=>xn(e1, t), n), to = (e1, t)=>((e1, t)=>{
            const n = void 0 === t ? document : t.dom;
            return En(n) ? I.none() : I.from(n.querySelector(e1)).map(yn);
        })(t, e1), no = (e1, t, n)=>Xn((e1, t)=>xn(e1, t), eo, e1, t, n), oo = (e1, t = !1)=>{
        var n;
        return Gn(e1) ? e1.dom.isContentEditable : (n = e1, no(n, "[contenteditable]")).fold(N(t), (e1)=>"true" === ro(e1));
    }, ro = (e1)=>e1.dom.contentEditable, so = (e1)=>void 0 !== e1.style && w(e1.style.getPropertyValue), ao = (e1, t, n)=>{
        if (!m(n)) throw console.error("Invalid call to CSS.set. Property ", t, ":: Value ", n, ":: Element ", e1), new Error("CSS value must be a string: " + n);
        so(e1) && e1.style.setProperty(t, n);
    }, io = (e1, t, n)=>{
        const o = e1.dom;
        ao(o, t, n);
    }, lo = (e1, t)=>{
        const n = e1.dom;
        ge(t, (e1, t)=>{
            ao(n, t, e1);
        });
    }, co = (e1, t)=>{
        const n = e1.dom, o = window.getComputedStyle(n).getPropertyValue(t);
        return "" !== o || Gn(e1) ? o : uo(n, t);
    }, uo = (e1, t)=>so(e1) ? e1.style.getPropertyValue(t) : "", mo = (e1, t)=>{
        const n = e1.dom, o = uo(n, t);
        return I.from(o).filter((e1)=>e1.length > 0);
    }, fo = (e1)=>{
        const t = {}, n = e1.dom;
        if (so(n)) for(let e1 = 0; e1 < n.style.length; e1++){
            const o = n.style.item(e1);
            t[o] = n.style[o];
        }
        return t;
    }, go = (e1, t)=>{
        ((e1, t)=>{
            so(e1) && e1.style.removeProperty(t);
        })(e1.dom, t), Dt(tn(e1, "style").map(Ve), "") && on(e1, "style");
    }, po = (e1, t)=>{
        An(e1).each((n)=>{
            n.dom.insertBefore(t.dom, e1.dom);
        });
    }, ho = (e1, t)=>{
        Pn(e1).fold(()=>{
            An(e1).each((e1)=>{
                vo(e1, t);
            });
        }, (e1)=>{
            po(e1, t);
        });
    }, bo = (e1, t)=>{
        Fn(e1).fold(()=>{
            vo(e1, t);
        }, (n)=>{
            e1.dom.insertBefore(t.dom, n.dom);
        });
    }, vo = (e1, t)=>{
        e1.dom.appendChild(t.dom);
    }, yo = (e1, t)=>{
        po(e1, t), vo(t, e1);
    }, Co = (e1, t)=>{
        V(t, (t)=>{
            vo(e1, t);
        });
    }, wo = (e1)=>{
        e1.dom.textContent = "", V(Mn(e1), (e1)=>{
            xo(e1);
        });
    }, xo = (e1)=>{
        const t = e1.dom;
        null !== t.parentNode && t.parentNode.removeChild(t);
    }, Eo = (e1)=>{
        const t = Mn(e1);
        var n, o;
        t.length > 0 && (n = e1, V(o = t, (e1, t)=>{
            const r = 0 === t ? n : o[t - 1];
            ho(r, e1);
        })), xo(e1);
    }, _o = (e1)=>q(e1, yn), So = (e1)=>e1.dom.innerHTML, ko = (e1, t)=>{
        const n = kn(e1).dom, o = yn(n.createDocumentFragment()), r = ((e1, t)=>{
            const n = (t || document).createElement("div");
            return n.innerHTML = e1, Mn(yn(n));
        })(t, n);
        Co(o, r), wo(e1), vo(e1, o);
    }, No = (e1, t, n, o)=>((e1, t, n, o, r)=>{
            const s = ((e1, t)=>(n)=>{
                    e1(n) && t(((e1)=>{
                        const t = yn(Kn(e1).getOr(e1.target)), n = ()=>e1.stopPropagation(), o = ()=>e1.preventDefault(), r = S(o, n);
                        return ((e1, t, n, o, r, s, a)=>({
                                target: e1,
                                x: t,
                                y: n,
                                stop: o,
                                prevent: r,
                                kill: s,
                                raw: a
                            }))(t, e1.clientX, e1.clientY, n, o, r, e1);
                    })(n));
                })(n, o);
            return e1.dom.addEventListener(t, s, false), {
                unbind: T(Ro, e1, t, s, false)
            };
        })(e1, t, n, o), Ro = (e1, t, n, o)=>{
        e1.dom.removeEventListener(t, n, o);
    }, Ao = (e1, t)=>({
            left: e1,
            top: t,
            translate: (n, o)=>Ao(e1 + n, t + o)
        }), To = Ao, Oo = (e1, t)=>void 0 !== e1 ? e1 : void 0 !== t ? t : 0, Bo = (e1)=>{
        const t = e1.dom, n = t.ownerDocument.body;
        return n === t ? To(n.offsetLeft, n.offsetTop) : Gn(e1) ? ((e1)=>{
            const t = e1.getBoundingClientRect();
            return To(t.left, t.top);
        })(t) : To(0, 0);
    }, Po = (e1)=>{
        const t = void 0 !== e1 ? e1.dom : document, n = t.body.scrollLeft || t.documentElement.scrollLeft, o = t.body.scrollTop || t.documentElement.scrollTop;
        return To(n, o);
    }, Do = (e1, t, n)=>{
        const o = (void 0 !== n ? n.dom : document).defaultView;
        o && o.scrollTo(e1, t);
    }, Lo = (e1, t)=>{
        xt().browser.isSafari() && w(e1.dom.scrollIntoViewIfNeeded) ? e1.dom.scrollIntoViewIfNeeded(!1) : e1.dom.scrollIntoView(t);
    }, Mo = (e1, t, n, o)=>({
            x: e1,
            y: t,
            width: n,
            height: o,
            right: e1 + n,
            bottom: t + o
        }), Io = (e1)=>{
        const t = void 0 === e1 ? window : e1, n = t.document, o = Po(yn(n));
        return ((e1)=>{
            const t = void 0 === e1 ? window : e1;
            return xt().browser.isFirefox() ? I.none() : I.from(t.visualViewport);
        })(t).fold(()=>{
            const e1 = t.document.documentElement, n = e1.clientWidth, r = e1.clientHeight;
            return Mo(o.left, o.top, n, r);
        }, (e1)=>Mo(Math.max(e1.pageLeft, o.left), Math.max(e1.pageTop, o.top), e1.width, e1.height));
    }, Fo = (e1, t)=>{
        let n = [];
        return V(Mn(e1), (e1)=>{
            t(e1) && (n = n.concat([
                e1
            ])), n = n.concat(Fo(e1, t));
        }), n;
    }, Uo = (e1, t)=>((e1, t)=>{
            const n = void 0 === t ? document : t.dom;
            return En(n) ? [] : q(n.querySelectorAll(e1), yn);
        })(t, e1), zo = (e1, t, n)=>eo(e1, t, n).isSome();
    class jo {
        constructor(e1, t){
            this.node = e1, this.rootNode = t, this.current = this.current.bind(this), this.next = this.next.bind(this), this.prev = this.prev.bind(this), this.prev2 = this.prev2.bind(this);
        }
        current() {
            return this.node;
        }
        next(e1) {
            return this.node = this.findSibling(this.node, "firstChild", "nextSibling", e1), this.node;
        }
        prev(e1) {
            return this.node = this.findSibling(this.node, "lastChild", "previousSibling", e1), this.node;
        }
        prev2(e1) {
            return this.node = this.findPreviousNode(this.node, e1), this.node;
        }
        findSibling(e1, t, n, o) {
            if (e1) {
                if (!o && e1[t]) return e1[t];
                if (e1 !== this.rootNode) {
                    let t = e1[n];
                    if (t) return t;
                    for(let o = e1.parentNode; o && o !== this.rootNode; o = o.parentNode)if (t = o[n], t) return t;
                }
            }
        }
        findPreviousNode(e1, t) {
            if (e1) {
                const n = e1.previousSibling;
                if (this.rootNode && n === this.rootNode) return;
                if (n) {
                    if (!t) {
                        for(let e1 = n.lastChild; e1; e1 = e1.lastChild)if (!e1.lastChild) return e1;
                    }
                    return n;
                }
                const o = e1.parentNode;
                if (o && o !== this.rootNode) return o;
            }
        }
    }
    const Ho = (e1)=>(t)=>!!t && t.nodeType === e1, $o = (e1)=>!!e1 && !Object.getPrototypeOf(e1), qo = Ho(1), Vo = (e1)=>qo(e1) && Vt(yn(e1)), Wo = (e1)=>{
        const t = e1.toLowerCase();
        return (e1)=>C(e1) && e1.nodeName.toLowerCase() === t;
    }, Ko = (e1)=>{
        const t = e1.map((e1)=>e1.toLowerCase());
        return (e1)=>{
            if (e1 && e1.nodeName) {
                const n = e1.nodeName.toLowerCase();
                return H(t, n);
            }
            return !1;
        };
    }, Yo = (e1, t)=>{
        const n = t.toLowerCase().split(" ");
        return (t)=>{
            if (qo(t)) {
                const o = t.ownerDocument.defaultView;
                if (o) for(let r = 0; r < n.length; r++){
                    const s = o.getComputedStyle(t, null);
                    if ((s ? s.getPropertyValue(e1) : null) === n[r]) return !0;
                }
            }
            return !1;
        };
    }, Go = (e1)=>(t)=>qo(t) && t.hasAttribute(e1), Xo = (e1)=>qo(e1) && e1.hasAttribute("data-mce-bogus"), Qo = (e1)=>qo(e1) && "TABLE" === e1.tagName, Jo = (e1)=>(t)=>{
            if (Vo(t)) {
                if (t.contentEditable === e1) return !0;
                if (t.getAttribute("data-mce-contenteditable") === e1) return !0;
            }
            return !1;
        }, Zo = Ko([
        "textarea",
        "input"
    ]), er = Ho(3), tr = Ho(4), nr = Ho(7), or = Ho(8), rr = Ho(9), sr = Ho(11), ar = Wo("br"), ir = Wo("img"), lr = Jo("true"), dr = Jo("false"), cr = Ko([
        "td",
        "th"
    ]), ur = Ko([
        "td",
        "th",
        "caption"
    ]), mr = Ko([
        "video",
        "audio",
        "object",
        "embed"
    ]), fr = Wo("li"), gr = Wo("details"), pr = Wo("summary"), hr = "\ufeff", br = "\xa0", vr = (e1)=>e1 === hr, yr = ((e1, t)=>{
        const n = (t)=>e1(t) ? I.from(t.dom.nodeValue) : I.none();
        return {
            get: (t)=>{
                if (!e1(t)) throw new Error("Can only get text value of a text node");
                return n(t).getOr("");
            },
            getOption: n,
            set: (t, n)=>{
                if (!e1(t)) throw new Error("Can only set raw text value of a text node");
                t.dom.nodeValue = n;
            }
        };
    })(Kt), Cr = (e1)=>yr.get(e1), wr = (e1)=>yr.getOption(e1), xr = (e1)=>{
        let t;
        return (n)=>(t = t || se(e1, M), Ee(t, Ht(n)));
    }, Er = (e1)=>Wt(e1) && "br" === Ht(e1), _r = xr([
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "p",
        "div",
        "address",
        "pre",
        "form",
        "blockquote",
        "center",
        "dir",
        "fieldset",
        "header",
        "footer",
        "article",
        "section",
        "hgroup",
        "aside",
        "nav",
        "figure"
    ]), Sr = xr([
        "ul",
        "ol",
        "dl"
    ]), kr = xr([
        "li",
        "dd",
        "dt"
    ]), Nr = xr([
        "thead",
        "tbody",
        "tfoot"
    ]), Rr = xr([
        "td",
        "th"
    ]), Ar = xr([
        "pre",
        "script",
        "textarea",
        "style"
    ]), Tr = ()=>{
        const e1 = bn("br");
        return Jt(e1, "data-mce-bogus", "1"), e1;
    }, Or = (e1)=>{
        wo(e1), vo(e1, Tr());
    }, Br = hr, Pr = vr, Dr = (e1)=>e1.replace(/\uFEFF/g, ""), Lr = qo, Mr = er, Ir = (e1)=>(Mr(e1) && (e1 = e1.parentNode), Lr(e1) && e1.hasAttribute("data-mce-caret")), Fr = (e1)=>Mr(e1) && Pr(e1.data), Ur = (e1)=>Ir(e1) || Fr(e1), zr = (e1)=>e1.firstChild !== e1.lastChild || !ar(e1.firstChild), jr = (e1)=>{
        const t = e1.container();
        return !!er(t) && (t.data.charAt(e1.offset()) === Br || e1.isAtStart() && Fr(t.previousSibling));
    }, Hr = (e1)=>{
        const t = e1.container();
        return !!er(t) && (t.data.charAt(e1.offset() - 1) === Br || e1.isAtEnd() && Fr(t.nextSibling));
    }, $r = (e1)=>Mr(e1) && e1.data[0] === Br, qr = (e1)=>Mr(e1) && e1.data[e1.data.length - 1] === Br, Vr = (e1)=>e1 && e1.hasAttribute("data-mce-caret") ? (((e1)=>{
            var t;
            const n = e1.getElementsByTagName("br"), o = n[n.length - 1];
            Xo(o) && (null === (t = o.parentNode) || void 0 === t || t.removeChild(o));
        })(e1), e1.removeAttribute("data-mce-caret"), e1.removeAttribute("data-mce-bogus"), e1.removeAttribute("style"), e1.removeAttribute("data-mce-style"), e1.removeAttribute("_moz_abspos"), e1) : null, Wr = (e1)=>Ir(e1.startContainer), Kr = lr, Yr = dr, Gr = ar, Xr = er, Qr = Ko([
        "script",
        "style",
        "textarea"
    ]), Jr = Ko([
        "img",
        "input",
        "textarea",
        "hr",
        "iframe",
        "video",
        "audio",
        "object",
        "embed"
    ]), Zr = Ko([
        "table"
    ]), es = Ur, ts = (e1)=>!es(e1) && (Xr(e1) ? !Qr(e1.parentNode) : Jr(e1) || Gr(e1) || Zr(e1) || ns(e1)), ns = (e1)=>!((e1)=>qo(e1) && "true" === e1.getAttribute("unselectable"))(e1) && Yr(e1), os = (e1, t)=>ts(e1) && ((e1, t)=>{
            for(let n = e1.parentNode; n && n !== t; n = n.parentNode){
                if (ns(n)) return !1;
                if (Kr(n)) return !0;
            }
            return !0;
        })(e1, t), rs = /^[ \t\r\n]*$/, ss = (e1)=>rs.test(e1), as = (e1)=>{
        for (const t of e1)if (!vr(t)) return !1;
        return !0;
    }, is = (e1)=>"\n" === e1 || "\r" === e1, ls = (e1, t = 4, n = !0, o = !0)=>{
        const r = ((e1, t)=>t <= 0 ? "" : new Array(t + 1).join(" "))(0, t), s = e1.replace(/\t/g, r), a = X(s, (e1, t)=>((e1)=>-1 !== " \f\t\v".indexOf(e1))(t) || t === br ? e1.pcIsSpace || "" === e1.str && n || e1.str.length === s.length - 1 && o || ((e1, t)=>t < e1.length && t >= 0 && is(e1[t]))(s, e1.str.length + 1) ? {
                pcIsSpace: !1,
                str: e1.str + br
            } : {
                pcIsSpace: !0,
                str: e1.str + " "
            } : {
                pcIsSpace: is(t),
                str: e1.str + t
            }, {
            pcIsSpace: !1,
            str: ""
        });
        return a.str;
    }, ds = (e1, t)=>ts(e1) && !((e1, t)=>er(e1) && ss(e1.data) && !((e1, t)=>{
                const n = yn(t), o = yn(e1);
                return zo(o, "pre,code", T(_n, n));
            })(e1, t))(e1, t) || ((e1)=>qo(e1) && "A" === e1.nodeName && !e1.hasAttribute("href") && (e1.hasAttribute("name") || e1.hasAttribute("id")))(e1) || cs(e1), cs = Go("data-mce-bookmark"), us = Go("data-mce-bogus"), ms = (e1)=>qo(e1) && "all" === e1.getAttribute("data-mce-bogus");
    const fs = (e1)=>Tn(yn(e1)).exists((e1)=>!oo(e1)), gs = (e1, t = !0)=>((e1, t)=>{
            let n = 0;
            if (ds(e1, e1)) return !1;
            {
                let o = e1.firstChild;
                if (!o) return !0;
                const r = new jo(o, e1);
                do {
                    if (t) {
                        if (ms(o)) {
                            o = r.next(!0);
                            continue;
                        }
                        if (us(o)) {
                            o = r.next();
                            continue;
                        }
                    }
                    if (lr(o) && fs(o)) return !1;
                    if (ar(o)) n++, o = r.next();
                    else {
                        if (ds(o, e1)) return !1;
                        o = r.next();
                    }
                }while (o);
                return n <= 1;
            }
        })(e1.dom, t), ps = (e1)=>"svg" === e1.toLowerCase(), hs = (e1)=>ps(e1.nodeName), bs = (e1)=>"svg" === (null == e1 ? void 0 : e1.nodeName) ? "svg" : "html", vs = [
        "svg"
    ], ys = "data-mce-block", Cs = (e1)=>q(((e1)=>Y(me(e1), (e1)=>!/[A-Z]/.test(e1)))(e1), (e1)=>`${e1}:` + q(vs, (t)=>`not(${t} ${e1})`).join(":")).join(","), ws = (e1, t)=>C(t.querySelector(e1)) ? (t.setAttribute(ys, "true"), "inline-boundary" === t.getAttribute("data-mce-selected") && t.removeAttribute("data-mce-selected"), !0) : (t.removeAttribute(ys), !1), xs = (e1, t)=>{
        const n = Cs(e1.getTransparentElements()), o = Cs(e1.getBlockElements());
        return Y(t.querySelectorAll(n), (e1)=>ws(o, e1));
    }, Es = (e1, t)=>{
        var n;
        const o = t ? "lastChild" : "firstChild";
        for(let t = e1[o]; t; t = t[o])if (gs(yn(t))) return void (null === (n = t.parentNode) || void 0 === n || n.removeChild(t));
    }, _s = (e1, t, n)=>{
        const o = e1.getBlockElements(), r = yn(t), s = (e1)=>Ht(e1) in o, a = (e1)=>_n(e1, r);
        V(_o(n), (t)=>{
            Qn(t, s, a).each((n)=>{
                const o = ((t, o)=>Y(Mn(t), (t)=>s(t) && !e1.isValidChild(Ht(n), Ht(t))))(t);
                if (o.length > 0) {
                    const t = Tn(n);
                    V(o, (e1)=>{
                        Qn(e1, s, a).each((t)=>{
                            ((e1, t)=>{
                                const n = document.createRange(), o = e1.parentNode;
                                if (o) {
                                    n.setStartBefore(e1), n.setEndBefore(t);
                                    const r = n.extractContents();
                                    Es(r, !0), n.setStartAfter(t), n.setEndAfter(e1);
                                    const s = n.extractContents();
                                    Es(s, !1), gs(yn(r)) || o.insertBefore(r, e1), gs(yn(t)) || o.insertBefore(t, e1), gs(yn(s)) || o.insertBefore(s, e1), o.removeChild(e1);
                                }
                            })(t.dom, e1.dom);
                        });
                    }), t.each((t)=>xs(e1, t.dom));
                }
            });
        });
    }, Ss = (e1, t)=>{
        const n = xs(e1, t);
        _s(e1, t, n), ((e1, t, n)=>{
            V([
                ...n,
                ...Ts(e1, t) ? [
                    t
                ] : []
            ], (t)=>V(Uo(yn(t), t.nodeName.toLowerCase()), (t)=>{
                    Os(e1, t.dom) && Eo(t);
                }));
        })(e1, t, n);
    }, ks = (e1, t)=>{
        if (As(e1, t)) {
            const n = Cs(e1.getBlockElements());
            ws(n, t);
        }
    }, Ns = (e1)=>e1.hasAttribute(ys), Rs = (e1, t)=>Ee(e1.getTransparentElements(), t), As = (e1, t)=>qo(t) && Rs(e1, t.nodeName), Ts = (e1, t)=>As(e1, t) && Ns(t), Os = (e1, t)=>As(e1, t) && !Ns(t), Bs = (e1, t)=>1 === t.type && Rs(e1, t.name) && m(t.attr(ys)), Ps = xt().browser, Ds = (e1)=>J(e1, Wt), Ls = (e1, t)=>e1.children && H(e1.children, t), Ms = (e1, t = {})=>{
        let n = 0;
        const o = {}, r = yn(e1), s = Nn(r), a = (e1)=>{
            vo(Vn(r), e1);
        }, i = (e1)=>{
            const t = Vn(r);
            to(t, "#" + e1).each(xo);
        }, l = (e1)=>xe(o, e1).getOrThunk(()=>({
                    id: "mce-u" + n++,
                    passed: [],
                    failed: [],
                    count: 0
                })), d = (e1)=>new Promise((n, r)=>{
                let i;
                const d = Pt._addCacheSuffix(e1), c = l(d);
                o[d] = c, c.count++;
                const u = (e1, t)=>{
                    V(e1, D), c.status = t, c.passed = [], c.failed = [], i && (i.onload = null, i.onerror = null, i = null);
                }, m = ()=>u(c.passed, 2), f = ()=>u(c.failed, 3);
                if (n && c.passed.push(n), r && c.failed.push(r), 1 === c.status) return;
                if (2 === c.status) return void m();
                if (3 === c.status) return void f();
                c.status = 1;
                const g = bn("link", s.dom);
                Zt(g, {
                    rel: "stylesheet",
                    type: "text/css",
                    id: c.id
                }), t.contentCssCors && Jt(g, "crossOrigin", "anonymous"), t.referrerPolicy && Jt(g, "referrerpolicy", t.referrerPolicy), i = g.dom, i.onload = m, i.onerror = f, a(g), Jt(g, "href", d);
            }), c = (e1)=>{
            const t = Pt._addCacheSuffix(e1);
            xe(o, t).each((e1)=>{
                0 == --e1.count && (delete o[t], i(e1.id));
            });
        };
        return {
            load: d,
            loadRawCss: (e1, t)=>{
                const n = l(e1);
                o[e1] = n, n.count++;
                const r = bn("style", s.dom);
                Zt(r, {
                    rel: "stylesheet",
                    type: "text/css",
                    id: n.id
                }), r.dom.innerHTML = t, a(r);
            },
            loadAll: (e1)=>Promise.allSettled(q(e1, (e1)=>d(e1).then(N(e1)))).then((e1)=>{
                    const t = K(e1, (e1)=>"fulfilled" === e1.status);
                    return t.fail.length > 0 ? Promise.reject(q(t.fail, (e1)=>e1.reason)) : q(t.pass, (e1)=>e1.value);
                }),
            unload: c,
            unloadRawCss: (e1)=>{
                xe(o, e1).each((t)=>{
                    0 == --t.count && (delete o[e1], i(t.id));
                });
            },
            unloadAll: (e1)=>{
                V(e1, (e1)=>{
                    c(e1);
                });
            },
            _setReferrerPolicy: (e1)=>{
                t.referrerPolicy = e1;
            },
            _setContentCssCors: (e1)=>{
                t.contentCssCors = e1;
            }
        };
    }, Is = (()=>{
        const e1 = new WeakMap;
        return {
            forElement: (t, n)=>{
                const o = qn(t).dom;
                return I.from(e1.get(o)).getOrThunk(()=>{
                    const t = Ms(o, n);
                    return e1.set(o, t), t;
                });
            }
        };
    })(), Fs = (e1, t, n)=>C(e1) && (ds(e1, t) || n.isInline(e1.nodeName.toLowerCase())), Us = (e1)=>((e1)=>"span" === e1.nodeName.toLowerCase())(e1) && "bookmark" === e1.getAttribute("data-mce-type"), zs = (e1, t, n, o)=>{
        var r;
        const s = o || t;
        if (qo(t) && Us(t)) return t;
        const a = t.childNodes;
        for(let t = a.length - 1; t >= 0; t--)zs(e1, a[t], n, s);
        if (qo(t)) {
            const e1 = t.childNodes;
            1 === e1.length && Us(e1[0]) && (null === (r = t.parentNode) || void 0 === r || r.insertBefore(e1[0], t));
        }
        return ((e1)=>sr(e1) || rr(e1))(t) || ds(t, s) || ((e1)=>!!qo(e1) && e1.childNodes.length > 0)(t) || ((e1, t, n)=>er(e1) && e1.data.length > 0 && ((e1, t, n)=>{
                const o = new jo(e1, t).prev(!1), r = new jo(e1, t).next(!1), s = v(o) || Fs(o, t, n), a = v(r) || Fs(r, t, n);
                return s && a;
            })(e1, t, n))(t, s, n) || e1.remove(t), t;
    }, js = Pt.makeMap, Hs = /[&<>\"\u0060\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g, $s = /[<>&\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g, qs = /[<>&\"\']/g, Vs = /&#([a-z0-9]+);?|&([a-z0-9]+);/gi, Ws = {
        128: "\u20ac",
        130: "\u201a",
        131: "\u0192",
        132: "\u201e",
        133: "\u2026",
        134: "\u2020",
        135: "\u2021",
        136: "\u02c6",
        137: "\u2030",
        138: "\u0160",
        139: "\u2039",
        140: "\u0152",
        142: "\u017d",
        145: "\u2018",
        146: "\u2019",
        147: "\u201c",
        148: "\u201d",
        149: "\u2022",
        150: "\u2013",
        151: "\u2014",
        152: "\u02dc",
        153: "\u2122",
        154: "\u0161",
        155: "\u203a",
        156: "\u0153",
        158: "\u017e",
        159: "\u0178"
    }, Ks = {
        '"': "&quot;",
        "'": "&#39;",
        "<": "&lt;",
        ">": "&gt;",
        "&": "&amp;",
        "`": "&#96;"
    }, Ys = {
        "&lt;": "<",
        "&gt;": ">",
        "&amp;": "&",
        "&quot;": '"',
        "&apos;": "'"
    }, Gs = (e1, t)=>{
        const n = {};
        if (e1) {
            const o = e1.split(",");
            t = t || 10;
            for(let e1 = 0; e1 < o.length; e1 += 2){
                const r = String.fromCharCode(parseInt(o[e1], t));
                if (!Ks[r]) {
                    const t = "&" + o[e1 + 1] + ";";
                    n[r] = t, n[t] = r;
                }
            }
            return n;
        }
    }, Xs = Gs("50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,t9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro", 32), Qs = (e1, t)=>e1.replace(t ? Hs : $s, (e1)=>Ks[e1] || e1), Js = (e1, t)=>e1.replace(t ? Hs : $s, (e1)=>e1.length > 1 ? "&#" + (1024 * (e1.charCodeAt(0) - 55296) + (e1.charCodeAt(1) - 56320) + 65536) + ";" : Ks[e1] || "&#" + e1.charCodeAt(0) + ";"), Zs = (e1, t, n)=>{
        const o = n || Xs;
        return e1.replace(t ? Hs : $s, (e1)=>Ks[e1] || o[e1] || e1);
    }, ea = {
        encodeRaw: Qs,
        encodeAllRaw: (e1)=>("" + e1).replace(qs, (e1)=>Ks[e1] || e1),
        encodeNumeric: Js,
        encodeNamed: Zs,
        getEncodeFunc: (e1, t)=>{
            const n = Gs(t) || Xs, o = js(e1.replace(/\+/g, ","));
            return o.named && o.numeric ? (e1, t)=>e1.replace(t ? Hs : $s, (e1)=>void 0 !== Ks[e1] ? Ks[e1] : void 0 !== n[e1] ? n[e1] : e1.length > 1 ? "&#" + (1024 * (e1.charCodeAt(0) - 55296) + (e1.charCodeAt(1) - 56320) + 65536) + ";" : "&#" + e1.charCodeAt(0) + ";") : o.named ? t ? (e1, t)=>Zs(e1, t, n) : Zs : o.numeric ? Js : Qs;
        },
        decode: (e1)=>e1.replace(Vs, (e1, t)=>t ? (t = "x" === t.charAt(0).toLowerCase() ? parseInt(t.substr(1), 16) : parseInt(t, 10)) > 65535 ? (t -= 65536, String.fromCharCode(55296 + (t >> 10), 56320 + (1023 & t))) : Ws[t] || String.fromCharCode(t) : Ys[e1] || Xs[e1] || ((e1)=>{
                    const t = bn("div").dom;
                    return t.innerHTML = e1, t.textContent || t.innerText || e1;
                })(e1))
    }, ta = (e1, t)=>(e1 = Pt.trim(e1)) ? e1.split(t || " ") : [], na = (e1)=>new RegExp("^" + e1.replace(/([?+*])/g, ".$1") + "$"), oa = {}, ra = Pt.makeMap, sa = Pt.each, aa = Pt.extend, ia = Pt.explode, la = (e1, t = {})=>{
        const n = ra(e1, " ", ra(e1.toUpperCase(), " "));
        return aa(n, t);
    }, da = (e1)=>la("td th li dt dd figcaption caption details summary", e1.getTextBlockElements()), ca = (e1, t)=>{
        if (e1) {
            const n = {};
            return m(e1) && (e1 = {
                "*": e1
            }), sa(e1, (e1, o)=>{
                n[o] = n[o.toUpperCase()] = "map" === t ? ra(e1, /[, ]/) : ia(e1, /[, ]/);
            }), n;
        }
    }, ua = (e1 = {})=>{
        var t;
        const n = {}, o = {};
        let r = [];
        const s = {}, a = {}, i = (t, n, o)=>{
            const r = e1[t];
            if (r) return ra(r, /[, ]/, ra(r.toUpperCase(), /[, ]/));
            {
                let e1 = oa[t];
                return e1 || (e1 = la(n, o), oa[t] = e1), e1;
            }
        }, l = null !== (t = e1.schema) && void 0 !== t ? t : "html5", d = ((e1)=>{
            const { globalAttributes: t, phrasingContent: n, flowContent: o } = ((e1)=>{
                let t, n, o;
                t = "id accesskey class dir lang style tabindex title role", n = "address blockquote div dl fieldset form h1 h2 h3 h4 h5 h6 hr menu ol p pre table ul", o = "a abbr b bdo br button cite code del dfn em embed i iframe img input ins kbd label map noscript object q s samp script select small span strong sub sup textarea u var #text #comment", "html4" !== e1 && (t += " contenteditable contextmenu draggable dropzone hidden spellcheck translate", n += " article aside details dialog figure main header footer hgroup section nav a ins del canvas map", o += " audio canvas command datalist mark meter output picture progress time wbr video ruby bdi keygen svg"), "html5-strict" !== e1 && (t += " xml:lang", o = [
                    o,
                    "acronym applet basefont big font strike tt"
                ].join(" "), n = [
                    n,
                    "center dir isindex noframes"
                ].join(" "));
                const r = [
                    n,
                    o
                ].join(" ");
                return {
                    globalAttributes: t,
                    blockContent: n,
                    phrasingContent: o,
                    flowContent: r
                };
            })(e1), r = {}, s = (e1, t, n)=>{
                r[e1] = {
                    attributes: se(t, N({})),
                    attributesOrder: t,
                    children: se(n, N({}))
                };
            }, a = (e1, n = "", o = "")=>{
                const r = ta(o), a = ta(e1);
                let i = a.length;
                const l = ta([
                    t,
                    n
                ].join(" "));
                for(; i--;)s(a[i], l.slice(), r);
            }, i = (e1, t)=>{
                const n = ta(e1), o = ta(t);
                let s = n.length;
                for(; s--;){
                    const e1 = r[n[s]];
                    for(let t = 0, n = o.length; t < n; t++)e1.attributes[o[t]] = {}, e1.attributesOrder.push(o[t]);
                }
            };
            return "html5-strict" !== e1 && (V(ta("acronym applet basefont big font strike tt"), (e1)=>{
                a(e1, "", n);
            }), V(ta("center dir isindex noframes"), (e1)=>{
                a(e1, "", o);
            })), a("html", "manifest", "head body"), a("head", "", "base command link meta noscript script style title"), a("title hr noscript br"), a("base", "href target"), a("link", "href rel media hreflang type sizes hreflang"), a("meta", "name http-equiv content charset"), a("style", "media type scoped"), a("script", "src async defer type charset"), a("body", "onafterprint onbeforeprint onbeforeunload onblur onerror onfocus onhashchange onload onmessage onoffline ononline onpagehide onpageshow onpopstate onresize onscroll onstorage onunload", o), a("dd div", "", o), a("address dt caption", "", "html4" === e1 ? n : o), a("h1 h2 h3 h4 h5 h6 pre p abbr code var samp kbd sub sup i b u bdo span legend em strong small s cite dfn", "", n), a("blockquote", "cite", o), a("ol", "reversed start type", "li"), a("ul", "", "li"), a("li", "value", o), a("dl", "", "dt dd"), a("a", "href target rel media hreflang type", "html4" === e1 ? n : o), a("q", "cite", n), a("ins del", "cite datetime", o), a("img", "src sizes srcset alt usemap ismap width height"), a("iframe", "src name width height", o), a("embed", "src type width height"), a("object", "data type typemustmatch name usemap form width height", [
                o,
                "param"
            ].join(" ")), a("param", "name value"), a("map", "name", [
                o,
                "area"
            ].join(" ")), a("area", "alt coords shape href target rel media hreflang type"), a("table", "border", "caption colgroup thead tfoot tbody tr" + ("html4" === e1 ? " col" : "")), a("colgroup", "span", "col"), a("col", "span"), a("tbody thead tfoot", "", "tr"), a("tr", "", "td th"), a("td", "colspan rowspan headers", o), a("th", "colspan rowspan headers scope abbr", o), a("form", "accept-charset action autocomplete enctype method name novalidate target", o), a("fieldset", "disabled form name", [
                o,
                "legend"
            ].join(" ")), a("label", "form for", n), a("input", "accept alt autocomplete checked dirname disabled form formaction formenctype formmethod formnovalidate formtarget height list max maxlength min multiple name pattern readonly required size src step type value width"), a("button", "disabled form formaction formenctype formmethod formnovalidate formtarget name type value", "html4" === e1 ? o : n), a("select", "disabled form multiple name required size", "option optgroup"), a("optgroup", "disabled label", "option"), a("option", "disabled label selected value"), a("textarea", "cols dirname disabled form maxlength name readonly required rows wrap"), a("menu", "type label", [
                o,
                "li"
            ].join(" ")), a("noscript", "", o), "html4" !== e1 && (a("wbr"), a("ruby", "", [
                n,
                "rt rp"
            ].join(" ")), a("figcaption", "", o), a("mark rt rp bdi", "", n), a("summary", "", [
                n,
                "h1 h2 h3 h4 h5 h6"
            ].join(" ")), a("canvas", "width height", o), a("video", "src crossorigin poster preload autoplay mediagroup loop muted controls width height buffered", [
                o,
                "track source"
            ].join(" ")), a("audio", "src crossorigin preload autoplay mediagroup loop muted controls buffered volume", [
                o,
                "track source"
            ].join(" ")), a("picture", "", "img source"), a("source", "src srcset type media sizes"), a("track", "kind src srclang label default"), a("datalist", "", [
                n,
                "option"
            ].join(" ")), a("article section nav aside main header footer", "", o), a("hgroup", "", "h1 h2 h3 h4 h5 h6"), a("figure", "", [
                o,
                "figcaption"
            ].join(" ")), a("time", "datetime", n), a("dialog", "open", o), a("command", "type label icon disabled checked radiogroup command"), a("output", "for form name", n), a("progress", "value max", n), a("meter", "value min max low high optimum", n), a("details", "open", [
                o,
                "summary"
            ].join(" ")), a("keygen", "autofocus challenge disabled form keytype name"), s("svg", "id tabindex lang xml:space class style x y width height viewBox preserveAspectRatio zoomAndPan transform".split(" "), [])), "html5-strict" !== e1 && (i("script", "language xml:space"), i("style", "xml:space"), i("object", "declare classid code codebase codetype archive standby align border hspace vspace"), i("embed", "align name hspace vspace"), i("param", "valuetype type"), i("a", "charset name rev shape coords"), i("br", "clear"), i("applet", "codebase archive code object alt name width height align hspace vspace"), i("img", "name longdesc align border hspace vspace"), i("iframe", "longdesc frameborder marginwidth marginheight scrolling align"), i("font basefont", "size color face"), i("input", "usemap align"), i("select"), i("textarea"), i("h1 h2 h3 h4 h5 h6 div p legend caption", "align"), i("ul", "type compact"), i("li", "type"), i("ol dl menu dir", "compact"), i("pre", "width xml:space"), i("hr", "align noshade size width"), i("isindex", "prompt"), i("table", "summary width frame rules cellspacing cellpadding align bgcolor"), i("col", "width align char charoff valign"), i("colgroup", "width align char charoff valign"), i("thead", "align char charoff valign"), i("tr", "align char charoff valign bgcolor"), i("th", "axis align char charoff valign nowrap bgcolor width height"), i("form", "accept"), i("td", "abbr axis scope align char charoff valign nowrap bgcolor width height"), i("tfoot", "align char charoff valign"), i("tbody", "align char charoff valign"), i("area", "nohref"), i("body", "background bgcolor text link vlink alink")), "html4" !== e1 && (i("input button select textarea", "autofocus"), i("input textarea", "placeholder"), i("a", "download"), i("link script img", "crossorigin"), i("img", "loading"), i("iframe", "sandbox seamless allow allowfullscreen loading")), "html4" !== e1 && V([
                r.video,
                r.audio
            ], (e1)=>{
                delete e1.children.audio, delete e1.children.video;
            }), V(ta("a form meter progress dfn"), (e1)=>{
                r[e1] && delete r[e1].children[e1];
            }), delete r.caption.children.table, delete r.script, r;
        })(l);
        !1 === e1.verify_html && (e1.valid_elements = "*[*]");
        const c = ca(e1.valid_styles), u = ca(e1.invalid_styles, "map"), m = ca(e1.valid_classes, "map"), f = i("whitespace_elements", "pre script noscript style textarea video audio iframe object code"), g = i("self_closing_elements", "colgroup dd dt li option p td tfoot th thead tr"), p = i("void_elements", "area base basefont br col frame hr img input isindex link meta param embed source wbr track"), h = i("boolean_attributes", "checked compact declare defer disabled ismap multiple nohref noresize noshade nowrap readonly selected autoplay loop controls allowfullscreen"), b = "td th iframe video audio object script code", v = i("non_empty_elements", b + " pre svg", p), y = i("move_caret_before_on_enter_elements", b + " table", p), C = "h1 h2 h3 h4 h5 h6", w = i("text_block_elements", C + " p div address pre form blockquote center dir fieldset header footer article section hgroup aside main nav figure"), x = i("block_elements", "hr table tbody thead tfoot th tr td li ol ul caption dl dt dd noscript menu isindex option datalist select optgroup figcaption details summary html body multicol listing", w), E = i("text_inline_elements", "span strong b em i font s strike u var cite dfn code mark q sup sub samp"), _ = i("transparent_elements", "a ins del canvas map"), S = i("wrap_block_elements", "pre " + C);
        sa("script noscript iframe noframes noembed title style textarea xmp plaintext".split(" "), (e1)=>{
            a[e1] = new RegExp("</" + e1 + "[^>]*>", "gi");
        });
        const k = (e1)=>{
            const t = I.from(n["@"]), o = /[*?+]/;
            V(((e1, t)=>{
                const n = /^([#+\-])?([^\[!\/]+)(?:\/([^\[!]+))?(?:(!?)\[([^\]]+)])?$/;
                return te(ta(t, ","), (t)=>{
                    const o = n.exec(t);
                    if (o) {
                        const t = o[1], n = o[2], r = o[3], s = o[4], a = o[5], i = {
                            attributes: {},
                            attributesOrder: []
                        };
                        if (e1.each((e1)=>((e1, t)=>{
                                ge(e1.attributes, (e1, n)=>{
                                    t.attributes[n] = e1;
                                }), t.attributesOrder.push(...e1.attributesOrder);
                            })(e1, i)), "#" === t ? i.paddEmpty = !0 : "-" === t && (i.removeEmpty = !0), "!" === s && (i.removeEmptyAttrs = !0), a && ((e1, t)=>{
                            const n = /^([!\-])?(\w+[\\:]:\w+|[^=~<]+)?(?:([=~<])(.*))?$/, o = /[*?+]/, { attributes: r, attributesOrder: s } = t;
                            V(ta(e1, "|"), (e1)=>{
                                const a = n.exec(e1);
                                if (a) {
                                    const e1 = {}, n = a[1], i = a[2].replace(/[\\:]:/g, ":"), l = a[3], d = a[4];
                                    if ("!" === n && (t.attributesRequired = t.attributesRequired || [], t.attributesRequired.push(i), e1.required = !0), "-" === n) return delete r[i], void s.splice(Pt.inArray(s, i), 1);
                                    if (l && ("=" === l ? (t.attributesDefault = t.attributesDefault || [], t.attributesDefault.push({
                                        name: i,
                                        value: d
                                    }), e1.defaultValue = d) : "~" === l ? (t.attributesForced = t.attributesForced || [], t.attributesForced.push({
                                        name: i,
                                        value: d
                                    }), e1.forcedValue = d) : "<" === l && (e1.validValues = Pt.makeMap(d, "?"))), o.test(i)) {
                                        const n = e1;
                                        t.attributePatterns = t.attributePatterns || [], n.pattern = na(i), t.attributePatterns.push(n);
                                    } else r[i] || s.push(i), r[i] = e1;
                                }
                            });
                        })(a, i), r && (i.outputName = n), "@" === n) {
                            if (!e1.isNone()) return [];
                            e1 = I.some(i);
                        }
                        return [
                            r ? {
                                name: n,
                                element: i,
                                aliasName: r
                            } : {
                                name: n,
                                element: i
                            }
                        ];
                    }
                    return [];
                });
            })(t, null != e1 ? e1 : ""), ({ name: e1, element: t, aliasName: s })=>{
                if (s && (n[s] = t), o.test(e1)) {
                    const n = t;
                    n.pattern = na(e1), r.push(n);
                } else n[e1] = t;
            });
        }, R = (e1)=>{
            r = [], V(me(n), (e1)=>{
                delete n[e1];
            }), k(e1);
        }, A = (e1)=>{
            delete oa.text_block_elements, delete oa.block_elements, V(((e1)=>{
                const t = /^(~)?(.+)$/;
                return te(ta(e1, ","), (e1)=>{
                    const n = t.exec(e1);
                    if (n) {
                        const e1 = "~" === n[1];
                        return [
                            {
                                inline: e1,
                                cloneName: e1 ? "span" : "div",
                                name: n[2]
                            }
                        ];
                    }
                    return [];
                });
            })(null != e1 ? e1 : ""), ({ inline: e1, name: t, cloneName: r })=>{
                if (o[t] = o[r], s[t] = r, v[t.toUpperCase()] = {}, v[t] = {}, e1 || (x[t.toUpperCase()] = {}, x[t] = {}), !n[t]) {
                    let e1 = n[r];
                    e1 = aa({}, e1), delete e1.removeEmptyAttrs, delete e1.removeEmpty, n[t] = e1;
                }
                ge(o, (e1, n)=>{
                    e1[r] && (o[n] = e1 = aa({}, o[n]), e1[t] = e1[r]);
                });
            });
        }, T = (e1)=>{
            V(((e1)=>{
                const t = /^([+\-]?)([A-Za-z0-9_\-.\u00b7\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u037d\u037f-\u1fff\u200c-\u200d\u203f-\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]+)\[([^\]]+)]$/;
                return te(ta(e1, ","), (e1)=>{
                    const n = t.exec(e1);
                    if (n) {
                        const e1 = n[1], t = e1 ? ((e1)=>"-" === e1 ? "remove" : "add")(e1) : "replace";
                        return [
                            {
                                operation: t,
                                name: n[2],
                                validChildren: ta(n[3], "|")
                            }
                        ];
                    }
                    return [];
                });
            })(null != e1 ? e1 : ""), ({ operation: e1, name: t, validChildren: n })=>{
                const r = "replace" === e1 ? {
                    "#comment": {}
                } : o[t];
                V(n, (t)=>{
                    "remove" === e1 ? delete r[t] : r[t] = {};
                }), o[t] = r;
            });
        }, O = (e1)=>{
            const t = n[e1];
            if (t) return t;
            let o = r.length;
            for(; o--;){
                const t = r[o];
                if (t.pattern.test(e1)) return t;
            }
        };
        e1.valid_elements ? (R(e1.valid_elements), sa(d, (e1, t)=>{
            o[t] = e1.children;
        })) : (sa(d, (e1, t)=>{
            n[t] = {
                attributes: e1.attributes,
                attributesOrder: e1.attributesOrder
            }, o[t] = e1.children;
        }), sa(ta("strong/b em/i"), (e1)=>{
            const t = ta(e1, "/");
            n[t[1]].outputName = t[0];
        }), sa(E, (t, o)=>{
            n[o] && (e1.padd_empty_block_inline_children && (n[o].paddInEmptyBlock = !0), n[o].removeEmpty = !0);
        }), sa(ta("ol ul blockquote a table tbody"), (e1)=>{
            n[e1] && (n[e1].removeEmpty = !0);
        }), sa(ta("p h1 h2 h3 h4 h5 h6 th td pre div address caption li summary"), (e1)=>{
            n[e1] && (n[e1].paddEmpty = !0);
        }), sa(ta("span"), (e1)=>{
            n[e1].removeEmptyAttrs = !0;
        })), delete n.svg, A(e1.custom_elements), T(e1.valid_children), k(e1.extended_valid_elements), T("+ol[ul|ol],+ul[ul|ol]"), sa({
            dd: "dl",
            dt: "dl",
            li: "ul ol",
            td: "tr",
            th: "tr",
            tr: "tbody thead tfoot",
            tbody: "table",
            thead: "table",
            tfoot: "table",
            legend: "fieldset",
            area: "map",
            param: "video audio object"
        }, (e1, t)=>{
            n[t] && (n[t].parentsRequired = ta(e1));
        }), e1.invalid_elements && sa(ia(e1.invalid_elements), (e1)=>{
            n[e1] && delete n[e1];
        }), O("span") || k("span[!data-mce-type|*]");
        const B = N(c), P = N(u), D = N(m), L = N(h), M = N(x), F = N(w), U = N(E), z = N(Object.seal(p)), j = N(g), H = N(v), $ = N(y), q = N(f), W = N(_), K = N(S), Y = N(Object.seal(a)), G = (e1, t)=>{
            const n = O(e1);
            if (n) {
                if (!t) return !0;
                {
                    if (n.attributes[t]) return !0;
                    const e1 = n.attributePatterns;
                    if (e1) {
                        let n = e1.length;
                        for(; n--;)if (e1[n].pattern.test(t)) return !0;
                    }
                }
            }
            return !1;
        }, X = (e1)=>Ee(M(), e1), Q = (e1)=>!He(e1, "#") && G(e1) && !X(e1), J = N(s);
        return {
            type: l,
            children: o,
            elements: n,
            getValidStyles: B,
            getValidClasses: D,
            getBlockElements: M,
            getInvalidStyles: P,
            getVoidElements: z,
            getTextBlockElements: F,
            getTextInlineElements: U,
            getBoolAttrs: L,
            getElementRule: O,
            getSelfClosingElements: j,
            getNonEmptyElements: H,
            getMoveCaretBeforeOnEnterElements: $,
            getWhitespaceElements: q,
            getTransparentElements: W,
            getSpecialElements: Y,
            isValidChild: (e1, t)=>{
                const n = o[e1.toLowerCase()];
                return !(!n || !n[t.toLowerCase()]);
            },
            isValid: G,
            isBlock: X,
            isInline: Q,
            isWrapper: (e1)=>Ee(K(), e1) || Q(e1),
            getCustomElements: J,
            addValidElements: k,
            setValidElements: R,
            addCustomElements: A,
            addValidChildren: T
        };
    }, ma = (e1)=>{
        const t = e1.toString(16);
        return (1 === t.length ? "0" + t : t).toUpperCase();
    }, fa = (e1)=>((e1)=>{
            var t;
            return {
                value: (t = e1, ze(t, "#").toUpperCase())
            };
        })(ma(e1.red) + ma(e1.green) + ma(e1.blue)), ga = /^\s*rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)\s*$/i, pa = /^\s*rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d?(?:\.\d+)?)\s*\)\s*$/i, ha = (e1, t, n, o)=>({
            red: e1,
            green: t,
            blue: n,
            alpha: o
        }), ba = (e1, t, n, o)=>{
        const r = parseInt(e1, 10), s = parseInt(t, 10), a = parseInt(n, 10), i = parseFloat(o);
        return ha(r, s, a, i);
    }, va = (e1)=>{
        if ("transparent" === e1) return I.some(ha(0, 0, 0, 0));
        const t = ga.exec(e1);
        if (null !== t) return I.some(ba(t[1], t[2], t[3], "1"));
        const n = pa.exec(e1);
        return null !== n ? I.some(ba(n[1], n[2], n[3], n[4])) : I.none();
    }, ya = (e1)=>`rgba(${e1.red},${e1.green},${e1.blue},${e1.alpha})`, Ca = (e1)=>va(e1).map(fa).map((e1)=>"#" + e1.value).getOr(e1), wa = (e1 = {}, t)=>{
        const n = /(?:url(?:(?:\(\s*\"([^\"]+)\"\s*\))|(?:\(\s*\'([^\']+)\'\s*\))|(?:\(\s*([^)\s]+)\s*\))))|(?:\'([^\']+)\')|(?:\"([^\"]+)\")/gi, o = /\s*([^:]+):\s*([^;]+);?/g, r = /\s+$/, s = {};
        let a, i;
        const l = hr;
        t && (a = t.getValidStyles(), i = t.getInvalidStyles());
        const d = "\\\" \\' \\; \\: ; : \ufeff".split(" ");
        for(let e1 = 0; e1 < d.length; e1++)s[d[e1]] = l + e1, s[l + e1] = d[e1];
        const c = {
            parse: (t)=>{
                const a = {};
                let i = !1;
                const d = e1.url_converter, u = e1.url_converter_scope || c, f = (e1, t, n)=>{
                    const o = a[e1 + "-top" + t];
                    if (!o) return;
                    const r = a[e1 + "-right" + t];
                    if (!r) return;
                    const s = a[e1 + "-bottom" + t];
                    if (!s) return;
                    const i = a[e1 + "-left" + t];
                    if (!i) return;
                    const l = [
                        o,
                        r,
                        s,
                        i
                    ];
                    let d = l.length - 1;
                    for(; d-- && l[d] === l[d + 1];);
                    d > -1 && n || (a[e1 + t] = -1 === d ? l[0] : l.join(" "), delete a[e1 + "-top" + t], delete a[e1 + "-right" + t], delete a[e1 + "-bottom" + t], delete a[e1 + "-left" + t]);
                }, g = (e1)=>{
                    const t = a[e1];
                    if (!t) return;
                    const n = t.indexOf(",") > -1 ? [
                        t
                    ] : t.split(" ");
                    let o = n.length;
                    for(; o--;)if (n[o] !== n[0]) return !1;
                    return a[e1] = n[0], !0;
                }, p = (e1)=>(i = !0, s[e1]), h = (e1, t)=>(i && (e1 = e1.replace(/\uFEFF[0-9]/g, (e1)=>s[e1])), t || (e1 = e1.replace(/\\([\'\";:])/g, "$1")), e1), b = (e1)=>String.fromCharCode(parseInt(e1.slice(1), 16)), v = (e1)=>e1.replace(/\\[0-9a-f]+/gi, b), y = (t, n, o, r, s, a)=>{
                    if (s = s || a) return "'" + (s = h(s)).replace(/\'/g, "\\'") + "'";
                    if (n = h(n || o || r || ""), !e1.allow_script_urls) {
                        const t = n.replace(/[\s\r\n]+/g, "");
                        if (/(java|vb)script:/i.test(t)) return "";
                        if (!e1.allow_svg_data_urls && /^data:image\/svg/i.test(t)) return "";
                    }
                    return d && (n = d.call(u, n, "style")), "url('" + n.replace(/\'/g, "\\'") + "')";
                };
                if (t) {
                    let s;
                    for(t = (t = t.replace(/[\u0000-\u001F]/g, "")).replace(/\\[\"\';:\uFEFF]/g, p).replace(/\"[^\"]+\"|\'[^\']+\'/g, (e1)=>e1.replace(/[;:]/g, p)); s = o.exec(t);){
                        o.lastIndex = s.index + s[0].length;
                        let t = s[1].replace(r, "").toLowerCase(), d = s[2].replace(r, "");
                        if (t && d) {
                            if (t = v(t), d = v(d), -1 !== t.indexOf(l) || -1 !== t.indexOf('"')) continue;
                            if (!e1.allow_script_urls && ("behavior" === t || /expression\s*\(|\/\*|\*\//.test(d))) continue;
                            "font-weight" === t && "700" === d ? d = "bold" : "color" !== t && "background-color" !== t || (d = d.toLowerCase()), m(e1.force_hex_color) && "off" !== e1.force_hex_color && va(d).each((t)=>{
                                "always" !== e1.force_hex_color && 1 !== t.alpha || (d = Ca(ya(t)));
                            }), d = d.replace(n, y), a[t] = i ? h(d, !0) : d;
                        }
                    }
                    f("border", "", !0), f("border", "-width"), f("border", "-color"), f("border", "-style"), f("padding", ""), f("margin", ""), w = "border-style", x = "border-color", g(C = "border-width") && g(w) && g(x) && (a.border = a[C] + " " + a[w] + " " + a[x], delete a[C], delete a[w], delete a[x]), "medium none" === a.border && delete a.border, "none" === a["border-image"] && delete a["border-image"];
                }
                var C, w, x;
                return a;
            },
            serialize: (e1, t)=>{
                let n = "";
                const o = (t, o)=>{
                    const r = o[t];
                    if (r) for(let t = 0, o = r.length; t < o; t++){
                        const o = r[t], s = e1[o];
                        s && (n += (n.length > 0 ? " " : "") + o + ": " + s + ";");
                    }
                };
                return t && a ? (o("*", a), o(t, a)) : ge(e1, (e1, o)=>{
                    e1 && ((e1, t)=>{
                        if (!i || !t) return !0;
                        let n = i["*"];
                        return !(n && n[e1] || (n = i[t], n && n[e1]));
                    })(o, t) && (n += (n.length > 0 ? " " : "") + o + ": " + e1 + ";");
                }), n;
            }
        };
        return c;
    }, xa = {
        keyLocation: !0,
        layerX: !0,
        layerY: !0,
        returnValue: !0,
        webkitMovementX: !0,
        webkitMovementY: !0,
        keyIdentifier: !0,
        mozPressure: !0
    }, Ea = (e1, t)=>{
        const n = null != t ? t : {};
        for(const t in e1)Ee(xa, t) || (n[t] = e1[t]);
        return C(e1.composedPath) && (n.composedPath = ()=>e1.composedPath()), C(e1.getModifierState) && (n.getModifierState = (t)=>e1.getModifierState(t)), C(e1.getTargetRanges) && (n.getTargetRanges = ()=>e1.getTargetRanges()), n;
    }, _a = (e1, t, n, o)=>{
        var r;
        const s = Ea(t, o);
        return s.type = e1, y(s.target) && (s.target = null !== (r = s.srcElement) && void 0 !== r ? r : n), ((e1)=>y(e1.preventDefault) || ((e1)=>e1 instanceof Event || w(e1.initEvent))(e1))(t) && (s.preventDefault = ()=>{
            s.defaultPrevented = !0, s.isDefaultPrevented = M, w(t.preventDefault) && t.preventDefault();
        }, s.stopPropagation = ()=>{
            s.cancelBubble = !0, s.isPropagationStopped = M, w(t.stopPropagation) && t.stopPropagation();
        }, s.stopImmediatePropagation = ()=>{
            s.isImmediatePropagationStopped = M, s.stopPropagation();
        }, ((e1)=>e1.isDefaultPrevented === M || e1.isDefaultPrevented === L)(s) || (s.isDefaultPrevented = !0 === s.defaultPrevented ? M : L, s.isPropagationStopped = !0 === s.cancelBubble ? M : L, s.isImmediatePropagationStopped = L)), s;
    }, Sa = /^(?:mouse|contextmenu)|click/, ka = (e1, t, n, o)=>{
        e1.addEventListener(t, n, o || !1);
    }, Na = (e1, t, n, o)=>{
        e1.removeEventListener(t, n, o || !1);
    }, Ra = (e1, t)=>{
        const n = _a(e1.type, e1, document, t);
        if (((e1)=>C(e1) && Sa.test(e1.type))(e1) && v(e1.pageX) && !v(e1.clientX)) {
            const t = n.target.ownerDocument || document, o = t.documentElement, r = t.body, s = n;
            s.pageX = e1.clientX + (o && o.scrollLeft || r && r.scrollLeft || 0) - (o && o.clientLeft || r && r.clientLeft || 0), s.pageY = e1.clientY + (o && o.scrollTop || r && r.scrollTop || 0) - (o && o.clientTop || r && r.clientTop || 0);
        }
        return n;
    }, Aa = (e1, t, n)=>{
        const o = e1.document, r = {
            type: "ready"
        };
        if (n.domLoaded) return void t(r);
        const s = ()=>{
            Na(e1, "DOMContentLoaded", s), Na(e1, "load", s), n.domLoaded || (n.domLoaded = !0, t(r)), e1 = null;
        };
        "complete" === o.readyState || "interactive" === o.readyState && o.body ? s() : ka(e1, "DOMContentLoaded", s), n.domLoaded || ka(e1, "load", s);
    };
    class Ta {
        constructor(){
            this.domLoaded = !1, this.events = {}, this.count = 1, this.expando = "mce-data-" + (+new Date).toString(32), this.hasFocusIn = "onfocusin" in document.documentElement, this.count = 1;
        }
        bind(e1, t, n, o) {
            const r = this;
            let s;
            const a = window, i = (e1)=>{
                r.executeHandlers(Ra(e1 || a.event), l);
            };
            if (!e1 || er(e1) || or(e1)) return n;
            let l;
            e1[r.expando] ? l = e1[r.expando] : (l = r.count++, e1[r.expando] = l, r.events[l] = {}), o = o || e1;
            const d = t.split(" ");
            let c = d.length;
            for(; c--;){
                let t = d[c], u = i, m = !1, f = !1;
                "DOMContentLoaded" === t && (t = "ready"), r.domLoaded && "ready" === t && "complete" === e1.readyState ? n.call(o, Ra({
                    type: t
                })) : (r.hasFocusIn || "focusin" !== t && "focusout" !== t || (m = !0, f = "focusin" === t ? "focus" : "blur", u = (e1)=>{
                    const t = Ra(e1 || a.event);
                    t.type = "focus" === t.type ? "focusin" : "focusout", r.executeHandlers(t, l);
                }), s = r.events[l][t], s ? "ready" === t && r.domLoaded ? n(Ra({
                    type: t
                })) : s.push({
                    func: n,
                    scope: o
                }) : (r.events[l][t] = s = [
                    {
                        func: n,
                        scope: o
                    }
                ], s.fakeName = f, s.capture = m, s.nativeHandler = u, "ready" === t ? Aa(e1, u, r) : ka(e1, f || t, u, m)));
            }
            return e1 = s = null, n;
        }
        unbind(e1, t, n) {
            if (!e1 || er(e1) || or(e1)) return this;
            const o = e1[this.expando];
            if (o) {
                let r = this.events[o];
                if (t) {
                    const o = t.split(" ");
                    let s = o.length;
                    for(; s--;){
                        const t = o[s], a = r[t];
                        if (a) {
                            if (n) {
                                let e1 = a.length;
                                for(; e1--;)if (a[e1].func === n) {
                                    const n = a.nativeHandler, o = a.fakeName, s = a.capture, i = a.slice(0, e1).concat(a.slice(e1 + 1));
                                    i.nativeHandler = n, i.fakeName = o, i.capture = s, r[t] = i;
                                }
                            }
                            n && 0 !== a.length || (delete r[t], Na(e1, a.fakeName || t, a.nativeHandler, a.capture));
                        }
                    }
                } else ge(r, (t, n)=>{
                    Na(e1, t.fakeName || n, t.nativeHandler, t.capture);
                }), r = {};
                for(const e1 in r)if (Ee(r, e1)) return this;
                delete this.events[o];
                try {
                    delete e1[this.expando];
                } catch (t) {
                    e1[this.expando] = null;
                }
            }
            return this;
        }
        fire(e1, t, n) {
            return this.dispatch(e1, t, n);
        }
        dispatch(e1, t, n) {
            if (!e1 || er(e1) || or(e1)) return this;
            const o = Ra({
                type: t,
                target: e1
            }, n);
            do {
                const t = e1[this.expando];
                t && this.executeHandlers(o, t), e1 = e1.parentNode || e1.ownerDocument || e1.defaultView || e1.parentWindow;
            }while (e1 && !o.isPropagationStopped());
            return this;
        }
        clean(e1) {
            if (!e1 || er(e1) || or(e1)) return this;
            if (e1[this.expando] && this.unbind(e1), e1.getElementsByTagName || (e1 = e1.document), e1 && e1.getElementsByTagName) {
                this.unbind(e1);
                const t = e1.getElementsByTagName("*");
                let n = t.length;
                for(; n--;)(e1 = t[n])[this.expando] && this.unbind(e1);
            }
            return this;
        }
        destroy() {
            this.events = {};
        }
        cancel(e1) {
            return e1 && (e1.preventDefault(), e1.stopImmediatePropagation()), !1;
        }
        executeHandlers(e1, t) {
            const n = this.events[t], o = n && n[e1.type];
            if (o) for(let t = 0, n = o.length; t < n; t++){
                const n = o[t];
                if (n && !1 === n.func.call(n.scope, e1) && e1.preventDefault(), e1.isImmediatePropagationStopped()) return;
            }
        }
    }
    Ta.Event = new Ta;
    const Oa = Pt.each, Ba = Pt.grep, Pa = "data-mce-style", Da = Pt.makeMap("fill-opacity font-weight line-height opacity orphans widows z-index zoom", " "), La = (e1, t, n)=>{
        y(n) || "" === n ? on(e1, t) : Jt(e1, t, n);
    }, Ma = (e1)=>e1.replace(/[A-Z]/g, (e1)=>"-" + e1.toLowerCase()), Ia = (e1, t)=>{
        let n = 0;
        if (e1) for(let o = e1.nodeType, r = e1.previousSibling; r; r = r.previousSibling){
            const e1 = r.nodeType;
            (!t || !er(r) || e1 !== o && r.data.length) && (n++, o = e1);
        }
        return n;
    }, Fa = (e1, t)=>{
        const n = en(t, "style"), o = e1.serialize(e1.parse(n), Ht(t));
        La(t, Pa, o);
    }, Ua = (e1, t, n)=>{
        const o = Ma(t);
        y(n) || "" === n ? go(e1, o) : io(e1, o, ((e1, t)=>x(e1) ? Ee(Da, t) ? e1 + "" : e1 + "px" : e1)(n, o));
    }, za = (e1, t = {})=>{
        const n = {}, o = window, r = {};
        let s = 0;
        const a = Is.forElement(yn(e1), {
            contentCssCors: t.contentCssCors,
            referrerPolicy: t.referrerPolicy
        }), i = [], l = t.schema ? t.schema : ua({}), d = wa({
            url_converter: t.url_converter,
            url_converter_scope: t.url_converter_scope,
            force_hex_color: t.force_hex_color
        }, t.schema), c = t.ownEvents ? new Ta : Ta.Event, u = l.getBlockElements(), f = (t)=>t && e1 && m(t) ? e1.getElementById(t) : t, g = (e1)=>{
            const t = f(e1);
            return C(t) ? yn(t) : null;
        }, h = (e1, t, n = "")=>{
            let o;
            const r = g(e1);
            if (C(r) && Wt(r)) {
                const e1 = G[t];
                o = e1 && e1.get ? e1.get(r.dom, t) : en(r, t);
            }
            return C(o) ? o : n;
        }, b = (e1)=>{
            const t = f(e1);
            return y(t) ? [] : t.attributes;
        }, v = (e1, n, o)=>{
            O(e1, (e1)=>{
                if (qo(e1)) {
                    const r = yn(e1), s = "" === o ? null : o, a = en(r, n), i = G[n];
                    i && i.set ? i.set(r.dom, s, n) : La(r, n, s), a !== s && t.onSetAttrib && t.onSetAttrib({
                        attrElm: r.dom,
                        attrName: n,
                        attrValue: s
                    });
                }
            });
        }, x = ()=>t.root_element || e1.body, E = (t, n)=>((e1, t, n)=>{
                let o = 0, r = 0;
                const s = e1.ownerDocument;
                if (n = n || e1, t) {
                    if (n === e1 && t.getBoundingClientRect && "static" === co(yn(e1), "position")) {
                        const n = t.getBoundingClientRect();
                        return o = n.left + (s.documentElement.scrollLeft || e1.scrollLeft) - s.documentElement.clientLeft, r = n.top + (s.documentElement.scrollTop || e1.scrollTop) - s.documentElement.clientTop, {
                            x: o,
                            y: r
                        };
                    }
                    let a = t;
                    for(; a && a !== n && a.nodeType && !Ls(a, n);){
                        const e1 = a;
                        o += e1.offsetLeft || 0, r += e1.offsetTop || 0, a = e1.offsetParent;
                    }
                    for(a = t.parentNode; a && a !== n && a.nodeType && !Ls(a, n);)o -= a.scrollLeft || 0, r -= a.scrollTop || 0, a = a.parentNode;
                    r += ((e1)=>Ps.isFirefox() && "table" === Ht(e1) ? Ds(Mn(e1)).filter((e1)=>"caption" === Ht(e1)).bind((e1)=>Ds(Ln(e1)).map((t)=>{
                                const n = t.dom.offsetTop, o = e1.dom.offsetTop, r = e1.dom.offsetHeight;
                                return n <= o ? -r : 0;
                            })).getOr(0) : 0)(yn(t));
                }
                return {
                    x: o,
                    y: r
                };
            })(e1.body, f(t), n), S = (e1, t, n)=>{
            const o = f(e1);
            var r;
            if (!y(o) && (Vo(o) || qo(r = o) && "http://www.w3.org/2000/svg" === r.namespaceURI)) return n ? co(yn(o), Ma(t)) : ("float" === (t = t.replace(/-(\D)/g, (e1, t)=>t.toUpperCase())) && (t = "cssFloat"), o.style ? o.style[t] : void 0);
        }, k = (e1)=>{
            const t = f(e1);
            if (!t) return {
                w: 0,
                h: 0
            };
            let n = S(t, "width"), o = S(t, "height");
            return n && -1 !== n.indexOf("px") || (n = "0"), o && -1 !== o.indexOf("px") || (o = "0"), {
                w: parseInt(n, 10) || t.offsetWidth || t.clientWidth,
                h: parseInt(o, 10) || t.offsetHeight || t.clientHeight
            };
        }, R = (e1, t)=>{
            if (!e1) return !1;
            const n = p(e1) ? e1 : [
                e1
            ];
            return $(n, (e1)=>xn(yn(e1), t));
        }, A = (e1, t, n, o)=>{
            const r = [];
            let s = f(e1);
            o = void 0 === o;
            const a = n || ("BODY" !== x().nodeName ? x().parentNode : null);
            if (m(t)) {
                if ("*" === t) t = qo;
                else {
                    const e1 = t;
                    t = (t)=>R(t, e1);
                }
            }
            for(; s && !(s === a || y(s.nodeType) || rr(s) || sr(s));){
                if (!t || t(s)) {
                    if (!o) return [
                        s
                    ];
                    r.push(s);
                }
                s = s.parentNode;
            }
            return o ? r : null;
        }, T = (e1, t, n)=>{
            let o = t;
            if (e1) {
                m(t) && (o = (e1)=>R(e1, t));
                for(let t = e1[n]; t; t = t[n])if (w(o) && o(t)) return t;
            }
            return null;
        }, O = function(e1, t, n) {
            const o = null != n ? n : this;
            if (p(e1)) {
                const n = [];
                return Oa(e1, (e1, r)=>{
                    const s = f(e1);
                    s && n.push(t.call(o, s, r));
                }), n;
            }
            {
                const n = f(e1);
                return !!n && t.call(o, n);
            }
        }, B = (e1, t)=>{
            O(e1, (e1)=>{
                ge(t, (t, n)=>{
                    v(e1, n, t);
                });
            });
        }, P = (e1, t)=>{
            O(e1, (e1)=>{
                const n = yn(e1);
                ko(n, t);
            });
        }, D = (t, n, o, r, s)=>O(t, (t)=>{
                const a = m(n) ? e1.createElement(n) : n;
                return C(o) && B(a, o), r && (!m(r) && r.nodeType ? a.appendChild(r) : m(r) && P(a, r)), s ? a : t.appendChild(a);
            }), L = (t, n, o)=>D(e1.createElement(t), t, n, o, !0), M = ea.encodeAllRaw, I = (e1, t)=>O(e1, (e1)=>{
                const n = yn(e1);
                return t && V(Mn(n), (e1)=>{
                    Kt(e1) && 0 === e1.dom.length ? xo(e1) : po(n, e1);
                }), xo(n), n.dom;
            }), F = (e1, t, n)=>{
            O(e1, (e1)=>{
                if (qo(e1)) {
                    const o = yn(e1), r = t.split(" ");
                    V(r, (e1)=>{
                        C(n) ? (n ? un : fn)(o, e1) : ((e1, t)=>{
                            const n = an(e1) ? e1.dom.classList.toggle(t) : ((e1, t)=>H(ln(e1), t) ? cn(e1, t) : dn(e1, t))(e1, t);
                            mn(e1);
                        })(o, e1);
                    });
                }
            });
        }, U = (e1, t, n)=>O(t, (o)=>{
                var r;
                const s = p(t) ? e1.cloneNode(!0) : e1;
                return n && Oa(Ba(o.childNodes), (e1)=>{
                    s.appendChild(e1);
                }), null === (r = o.parentNode) || void 0 === r || r.replaceChild(s, o), o;
            }), z = (e1)=>{
            if (qo(e1)) {
                const t = "a" === e1.nodeName.toLowerCase() && !h(e1, "href") && h(e1, "id");
                if (h(e1, "name") || h(e1, "data-mce-bookmark") || t) return !0;
            }
            return !1;
        }, j = ()=>e1.createRange(), q = (n, r, s, a)=>{
            if (p(n)) {
                let e1 = n.length;
                const t = [];
                for(; e1--;)t[e1] = q(n[e1], r, s, a);
                return t;
            }
            return !t.collect || n !== e1 && n !== o || i.push([
                n,
                r,
                s,
                a
            ]), c.bind(n, r, s, a || Y);
        }, W = (t, n, r)=>{
            if (p(t)) {
                let e1 = t.length;
                const o = [];
                for(; e1--;)o[e1] = W(t[e1], n, r);
                return o;
            }
            if (i.length > 0 && (t === e1 || t === o)) {
                let e1 = i.length;
                for(; e1--;){
                    const [o, s, a] = i[e1];
                    t !== o || n && n !== s || r && r !== a || c.unbind(o, s, a);
                }
            }
            return c.unbind(t, n, r);
        }, K = (e1)=>{
            if (e1 && Vo(e1)) {
                const t = e1.getAttribute("data-mce-contenteditable");
                return t && "inherit" !== t ? t : "inherit" !== e1.contentEditable ? e1.contentEditable : null;
            }
            return null;
        }, Y = {
            doc: e1,
            settings: t,
            win: o,
            files: r,
            stdMode: !0,
            boxModel: !0,
            styleSheetLoader: a,
            boundEvents: i,
            styles: d,
            schema: l,
            events: c,
            isBlock: (e1)=>m(e1) ? Ee(u, e1) : qo(e1) && (Ee(u, e1.nodeName) || Ts(l, e1)),
            root: null,
            clone: (e1, t)=>e1.cloneNode(t),
            getRoot: x,
            getViewPort: (e1)=>{
                const t = Io(e1);
                return {
                    x: t.x,
                    y: t.y,
                    w: t.width,
                    h: t.height
                };
            },
            getRect: (e1)=>{
                const t = f(e1), n = E(t), o = k(t);
                return {
                    x: n.x,
                    y: n.y,
                    w: o.w,
                    h: o.h
                };
            },
            getSize: k,
            getParent: (e1, t, n)=>{
                const o = A(e1, t, n, !1);
                return o && o.length > 0 ? o[0] : null;
            },
            getParents: A,
            get: f,
            getNext: (e1, t)=>T(e1, t, "nextSibling"),
            getPrev: (e1, t)=>T(e1, t, "previousSibling"),
            select: (n, o)=>{
                var r, s;
                const a = null !== (s = null !== (r = f(o)) && void 0 !== r ? r : t.root_element) && void 0 !== s ? s : e1;
                return w(a.querySelectorAll) ? ce(a.querySelectorAll(n)) : [];
            },
            is: R,
            add: D,
            create: L,
            createHTML: (e1, t, n = "")=>{
                let o = "<" + e1;
                for(const e1 in t)_e(t, e1) && (o += " " + e1 + '="' + M(t[e1]) + '"');
                return Ge(n) && Ee(l.getVoidElements(), e1) ? o + " />" : o + ">" + n + "</" + e1 + ">";
            },
            createFragment: (t)=>{
                const n = e1.createElement("div"), o = e1.createDocumentFragment();
                let r;
                for(o.appendChild(n), t && (n.innerHTML = t); r = n.firstChild;)o.appendChild(r);
                return o.removeChild(n), o;
            },
            remove: I,
            setStyle: (e1, n, o)=>{
                O(e1, (e1)=>{
                    const r = yn(e1);
                    Ua(r, n, o), t.update_styles && Fa(d, r);
                });
            },
            getStyle: S,
            setStyles: (e1, n)=>{
                O(e1, (e1)=>{
                    const o = yn(e1);
                    ge(n, (e1, t)=>{
                        Ua(o, t, e1);
                    }), t.update_styles && Fa(d, o);
                });
            },
            removeAllAttribs: (e1)=>O(e1, (e1)=>{
                    const t = e1.attributes;
                    for(let n = t.length - 1; n >= 0; n--)e1.removeAttributeNode(t.item(n));
                }),
            setAttrib: v,
            setAttribs: B,
            getAttrib: h,
            getPos: E,
            parseStyle: (e1)=>d.parse(e1),
            serializeStyle: (e1, t)=>d.serialize(e1, t),
            addStyle: (t)=>{
                if (Y !== za.DOM && e1 === document) {
                    if (n[t]) return;
                    n[t] = !0;
                }
                let o = e1.getElementById("mceDefaultStyles");
                if (!o) {
                    o = e1.createElement("style"), o.id = "mceDefaultStyles", o.type = "text/css";
                    const t = e1.head;
                    t.firstChild ? t.insertBefore(o, t.firstChild) : t.appendChild(o);
                }
                o.styleSheet ? o.styleSheet.cssText += t : o.appendChild(e1.createTextNode(t));
            },
            loadCSS: (e1)=>{
                e1 || (e1 = ""), V(e1.split(","), (e1)=>{
                    r[e1] = !0, a.load(e1).catch(_);
                });
            },
            addClass: (e1, t)=>{
                F(e1, t, !0);
            },
            removeClass: (e1, t)=>{
                F(e1, t, !1);
            },
            hasClass: (e1, t)=>{
                const n = g(e1), o = t.split(" ");
                return C(n) && ne(o, (e1)=>gn(n, e1));
            },
            toggleClass: F,
            show: (e1)=>{
                O(e1, (e1)=>go(yn(e1), "display"));
            },
            hide: (e1)=>{
                O(e1, (e1)=>io(yn(e1), "display", "none"));
            },
            isHidden: (e1)=>{
                const t = g(e1);
                return C(t) && Dt(mo(t, "display"), "none");
            },
            uniqueId: (e1)=>(e1 || "mce_") + s++,
            setHTML: P,
            getOuterHTML: (e1)=>{
                const t = g(e1);
                return C(t) ? qo(t.dom) ? t.dom.outerHTML : ((e1)=>{
                    const t = bn("div"), n = yn(e1.dom.cloneNode(!0));
                    return vo(t, n), So(t);
                })(t) : "";
            },
            setOuterHTML: (e1, t)=>{
                O(e1, (e1)=>{
                    qo(e1) && (e1.outerHTML = t);
                });
            },
            decode: ea.decode,
            encode: M,
            insertAfter: (e1, t)=>{
                const n = f(t);
                return O(e1, (e1)=>{
                    const t = null == n ? void 0 : n.parentNode, o = null == n ? void 0 : n.nextSibling;
                    return t && (o ? t.insertBefore(e1, o) : t.appendChild(e1)), e1;
                });
            },
            replace: U,
            rename: (e1, t)=>{
                if (e1.nodeName !== t.toUpperCase()) {
                    const n = L(t);
                    return Oa(b(e1), (t)=>{
                        v(n, t.nodeName, h(e1, t.nodeName));
                    }), U(n, e1, !0), n;
                }
                return e1;
            },
            findCommonAncestor: (e1, t)=>{
                let n = e1;
                for(; n;){
                    let e1 = t;
                    for(; e1 && n !== e1;)e1 = e1.parentNode;
                    if (n === e1) break;
                    n = n.parentNode;
                }
                return !n && e1.ownerDocument ? e1.ownerDocument.documentElement : n;
            },
            run: O,
            getAttribs: b,
            isEmpty: (e1, t, n)=>{
                let o = 0;
                if (z(e1)) return !1;
                const r = e1.firstChild;
                if (r) {
                    const s = new jo(r, e1), a = l ? l.getWhitespaceElements() : {}, i = t || (l ? l.getNonEmptyElements() : null);
                    let d = r;
                    do {
                        if (qo(d)) {
                            const e1 = d.getAttribute("data-mce-bogus");
                            if (e1) {
                                d = s.next("all" === e1);
                                continue;
                            }
                            const t = d.nodeName.toLowerCase();
                            if (i && i[t]) {
                                if ("br" === t) {
                                    o++, d = s.next();
                                    continue;
                                }
                                return !1;
                            }
                            if (z(d)) return !1;
                        }
                        if (or(d)) return !1;
                        if (er(d) && !ss(d.data) && (!(null == n ? void 0 : n.includeZwsp) || !as(d.data))) return !1;
                        if (er(d) && d.parentNode && a[d.parentNode.nodeName] && ss(d.data)) return !1;
                        d = s.next();
                    }while (d);
                }
                return o <= 1;
            },
            createRng: j,
            nodeIndex: Ia,
            split: (e1, t, n)=>{
                let o, r, s = j();
                if (e1 && t && e1.parentNode && t.parentNode) {
                    const a = e1.parentNode;
                    return s.setStart(a, Ia(e1)), s.setEnd(t.parentNode, Ia(t)), o = s.extractContents(), s = j(), s.setStart(t.parentNode, Ia(t) + 1), s.setEnd(a, Ia(e1) + 1), r = s.extractContents(), a.insertBefore(zs(Y, o, l), e1), n ? a.insertBefore(n, e1) : a.insertBefore(t, e1), a.insertBefore(zs(Y, r, l), e1), I(e1), n || t;
                }
            },
            bind: q,
            unbind: W,
            fire: (e1, t, n)=>c.dispatch(e1, t, n),
            dispatch: (e1, t, n)=>c.dispatch(e1, t, n),
            getContentEditable: K,
            getContentEditableParent: (e1)=>{
                const t = x();
                let n = null;
                for(let o = e1; o && o !== t && (n = K(o), null === n); o = o.parentNode);
                return n;
            },
            isEditable: (e1)=>{
                if (C(e1)) {
                    const t = qo(e1) ? e1 : e1.parentElement;
                    return C(t) && Vo(t) && oo(yn(t));
                }
                return !1;
            },
            destroy: ()=>{
                if (i.length > 0) {
                    let e1 = i.length;
                    for(; e1--;){
                        const [t, n, o] = i[e1];
                        c.unbind(t, n, o);
                    }
                }
                ge(r, (e1, t)=>{
                    a.unload(t), delete r[t];
                });
            },
            isChildOf: (e1, t)=>e1 === t || t.contains(e1),
            dumpRng: (e1)=>"startContainer: " + e1.startContainer.nodeName + ", startOffset: " + e1.startOffset + ", endContainer: " + e1.endContainer.nodeName + ", endOffset: " + e1.endOffset
        }, G = ((e1, t, n)=>{
            const o = t.keep_values, r = {
                set: (e1, o, r)=>{
                    const s = yn(e1);
                    w(t.url_converter) && C(o) && (o = t.url_converter.call(t.url_converter_scope || n(), String(o), r, e1)), La(s, "data-mce-" + r, o), La(s, r, o);
                },
                get: (e1, t)=>{
                    const n = yn(e1);
                    return en(n, "data-mce-" + t) || en(n, t);
                }
            }, s = {
                style: {
                    set: (t, n)=>{
                        const r = yn(t);
                        o && La(r, Pa, n), on(r, "style"), m(n) && lo(r, e1.parse(n));
                    },
                    get: (t)=>{
                        const n = yn(t), o = en(n, Pa) || en(n, "style");
                        return e1.serialize(e1.parse(o), Ht(n));
                    }
                }
            };
            return o && (s.href = s.src = r), s;
        })(d, t, N(Y));
        return Y;
    };
    za.DOM = za(document), za.nodeIndex = Ia;
    const ja = za.DOM;
    class Ha {
        constructor(e1 = {}){
            this.states = {}, this.queue = [], this.scriptLoadedCallbacks = {}, this.queueLoadedCallbacks = [], this.loading = !1, this.settings = e1;
        }
        _setReferrerPolicy(e1) {
            this.settings.referrerPolicy = e1;
        }
        loadScript(e1) {
            return new Promise((t, n)=>{
                const o = ja;
                let r;
                const s = ()=>{
                    o.remove(a), r && (r.onerror = r.onload = r = null);
                }, a = o.uniqueId();
                r = document.createElement("script"), r.id = a, r.type = "text/javascript", r.src = Pt._addCacheSuffix(e1), this.settings.referrerPolicy && o.setAttrib(r, "referrerpolicy", this.settings.referrerPolicy), r.onload = ()=>{
                    s(), t();
                }, r.onerror = ()=>{
                    s(), n("Failed to load script: " + e1);
                }, (document.getElementsByTagName("head")[0] || document.body).appendChild(r);
            });
        }
        isDone(e1) {
            return 2 === this.states[e1];
        }
        markDone(e1) {
            this.states[e1] = 2;
        }
        add(e1) {
            const t = this;
            return t.queue.push(e1), void 0 === t.states[e1] && (t.states[e1] = 0), new Promise((n, o)=>{
                t.scriptLoadedCallbacks[e1] || (t.scriptLoadedCallbacks[e1] = []), t.scriptLoadedCallbacks[e1].push({
                    resolve: n,
                    reject: o
                });
            });
        }
        load(e1) {
            return this.add(e1);
        }
        remove(e1) {
            delete this.states[e1], delete this.scriptLoadedCallbacks[e1];
        }
        loadQueue() {
            const e1 = this.queue;
            return this.queue = [], this.loadScripts(e1);
        }
        loadScripts(e1) {
            const t = this, n = (e1, n)=>{
                xe(t.scriptLoadedCallbacks, n).each((t)=>{
                    V(t, (t)=>t[e1](n));
                }), delete t.scriptLoadedCallbacks[n];
            }, o = (e1)=>{
                const t = Y(e1, (e1)=>"rejected" === e1.status);
                return t.length > 0 ? Promise.reject(te(t, ({ reason: e1 })=>p(e1) ? e1 : [
                        e1
                    ])) : Promise.resolve();
            }, r = (e1)=>Promise.allSettled(q(e1, (e1)=>2 === t.states[e1] ? (n("resolve", e1), Promise.resolve()) : 3 === t.states[e1] ? (n("reject", e1), Promise.reject(e1)) : (t.states[e1] = 1, t.loadScript(e1).then(()=>{
                        t.states[e1] = 2, n("resolve", e1);
                        const s = t.queue;
                        return s.length > 0 ? (t.queue = [], r(s).then(o)) : Promise.resolve();
                    }, ()=>(t.states[e1] = 3, n("reject", e1), Promise.reject(e1)))))), s = (e1)=>(t.loading = !0, r(e1).then((e1)=>{
                    t.loading = !1;
                    const n = t.queueLoadedCallbacks.shift();
                    return I.from(n).each(D), o(e1);
                })), a = Se(e1);
            return t.loading ? new Promise((e1, n)=>{
                t.queueLoadedCallbacks.push(()=>{
                    s(a).then(e1, n);
                });
            }) : s(a);
        }
    }
    Ha.ScriptLoader = new Ha;
    const $a = (e1)=>{
        let t = e1;
        return {
            get: ()=>t,
            set: (e1)=>{
                t = e1;
            }
        };
    }, qa = {}, Va = $a("en"), Wa = ()=>xe(qa, Va.get()), Ka = {
        getData: ()=>pe(qa, (e1)=>({
                    ...e1
                })),
        setCode: (e1)=>{
            e1 && Va.set(e1);
        },
        getCode: ()=>Va.get(),
        add: (e1, t)=>{
            let n = qa[e1];
            n || (qa[e1] = n = {});
            const o = q(me(t), (e1)=>e1.toLowerCase());
            ge(t, (e1, r)=>{
                const s = r.toLowerCase();
                s !== r && ((e1, t)=>{
                    const n = e1.indexOf(t);
                    return -1 !== n && e1.indexOf(t, n + 1) > n;
                })(o, s) ? (Ee(t, s) || (n[s] = e1), n[r] = e1) : n[s] = e1;
            });
        },
        translate: (e1)=>{
            const t = Wa().getOr({}), n = (e1)=>w(e1) ? Object.prototype.toString.call(e1) : o(e1) ? "" : "" + e1, o = (e1)=>"" === e1 || null == e1, r = (e1)=>{
                const o = n(e1);
                return Ee(t, o) ? n(t[o]) : xe(t, o.toLowerCase()).map(n).getOr(o);
            }, s = (e1)=>e1.replace(/{context:\w+}$/, "");
            if (o(e1)) return "";
            if (f(a = e1) && Ee(a, "raw")) return n(e1.raw);
            var a;
            if (((e1)=>p(e1) && e1.length > 1)(e1)) {
                const t = e1.slice(1);
                return s(r(e1[0]).replace(/\{([0-9]+)\}/g, (e1, o)=>Ee(t, o) ? n(t[o]) : e1));
            }
            return s(r(e1));
        },
        isRtl: ()=>Wa().bind((e1)=>xe(e1, "_dir")).exists((e1)=>"rtl" === e1),
        hasCode: (e1)=>Ee(qa, e1)
    }, Ya = ()=>{
        const e1 = [], t = {}, n = {}, o = [], r = (e1, t)=>{
            const n = Y(o, (n)=>n.name === e1 && n.state === t);
            V(n, (e1)=>e1.resolve());
        }, s = (e1)=>Ee(t, e1), a = (e1, n)=>{
            const o = Ka.getCode();
            !o || n && -1 === ("," + (n || "") + ",").indexOf("," + o + ",") || Ha.ScriptLoader.add(t[e1] + "/langs/" + o + ".js");
        }, i = (e1, t = "added")=>"added" === t && ((e1)=>Ee(n, e1))(e1) || "loaded" === t && s(e1) ? Promise.resolve() : new Promise((n)=>{
                o.push({
                    name: e1,
                    state: t,
                    resolve: n
                });
            });
        return {
            items: e1,
            urls: t,
            lookup: n,
            get: (e1)=>{
                if (n[e1]) return n[e1].instance;
            },
            requireLangPack: (e1, t)=>{
                !1 !== Ya.languageLoad && (s(e1) ? a(e1, t) : i(e1, "loaded").then(()=>a(e1, t)));
            },
            add: (t, o)=>(e1.push(o), n[t] = {
                    instance: o
                }, r(t, "added"), o),
            remove: (e1)=>{
                delete t[e1], delete n[e1];
            },
            createUrl: (e1, t)=>m(t) ? m(e1) ? {
                    prefix: "",
                    resource: t,
                    suffix: ""
                } : {
                    prefix: e1.prefix,
                    resource: t,
                    suffix: e1.suffix
                } : t,
            load: (e1, o)=>{
                if (t[e1]) return Promise.resolve();
                let s = m(o) ? o : o.prefix + o.resource + o.suffix;
                0 !== s.indexOf("/") && -1 === s.indexOf("://") && (s = Ya.baseURL + "/" + s), t[e1] = s.substring(0, s.lastIndexOf("/"));
                const a = ()=>(r(e1, "loaded"), Promise.resolve());
                return n[e1] ? a() : Ha.ScriptLoader.add(s).then(a);
            },
            waitFor: i
        };
    };
    Ya.languageLoad = !0, Ya.baseURL = "", Ya.PluginManager = Ya(), Ya.ThemeManager = Ya(), Ya.ModelManager = Ya();
    const Ga = (e1)=>{
        const t = $a(I.none()), n = ()=>t.get().each((e1)=>clearInterval(e1));
        return {
            clear: ()=>{
                n(), t.set(I.none());
            },
            isSet: ()=>t.get().isSome(),
            get: ()=>t.get(),
            set: (o)=>{
                n(), t.set(I.some(setInterval(o, e1)));
            }
        };
    }, Xa = ()=>{
        const e1 = ((e1)=>{
            const t = $a(I.none()), n = ()=>t.get().each(e1);
            return {
                clear: ()=>{
                    n(), t.set(I.none());
                },
                isSet: ()=>t.get().isSome(),
                get: ()=>t.get(),
                set: (e1)=>{
                    n(), t.set(I.some(e1));
                }
            };
        })(_);
        return {
            ...e1,
            on: (t)=>e1.get().each(t)
        };
    }, Qa = (e1, t)=>{
        let n = null;
        return {
            cancel: ()=>{
                h(n) || (clearTimeout(n), n = null);
            },
            throttle: (...o)=>{
                h(n) && (n = setTimeout(()=>{
                    n = null, e1.apply(null, o);
                }, t));
            }
        };
    }, Ja = (e1, t)=>{
        let n = null;
        const o = ()=>{
            h(n) || (clearTimeout(n), n = null);
        };
        return {
            cancel: o,
            throttle: (...r)=>{
                o(), n = setTimeout(()=>{
                    n = null, e1.apply(null, r);
                }, t);
            }
        };
    }, Za = N("mce-annotation"), ei = N("data-mce-annotation"), ti = N("data-mce-annotation-uid"), ni = N("data-mce-annotation-active"), oi = N("data-mce-annotation-classes"), ri = N("data-mce-annotation-attrs"), si = (e1)=>(t)=>_n(t, e1), ai = (e1, t)=>{
        const n = e1.selection.getRng(), o = yn(n.startContainer), r = yn(e1.getBody()), s = t.fold(()=>"." + Za(), (e1)=>`[${ei()}="${e1}"]`), a = In(o, n.startOffset).getOr(o);
        return no(a, s, si(r)).bind((t)=>tn(t, `${ti()}`).bind((n)=>tn(t, `${ei()}`).map((t)=>{
                    const o = li(e1, n);
                    return {
                        uid: n,
                        name: t,
                        elements: o
                    };
                })));
    }, ii = (e1, t)=>nn(e1, "data-mce-bogus") || zo(e1, '[data-mce-bogus="all"]', si(t)), li = (e1, t)=>{
        const n = yn(e1.getBody()), o = Uo(n, `[${ti()}="${t}"]`);
        return Y(o, (e1)=>!ii(e1, n));
    }, di = (e1, t)=>{
        const n = yn(e1.getBody()), o = Uo(n, `[${ei()}="${t}"]`), r = {};
        return V(o, (e1)=>{
            if (!ii(e1, n)) {
                const t = en(e1, ti()), n = xe(r, t).getOr([]);
                r[t] = n.concat([
                    e1
                ]);
            }
        }), r;
    };
    let ci = 0;
    const ui = (e1)=>{
        const t = (new Date).getTime(), n = Math.floor(1e9 * Math.random());
        return ci++, e1 + "_" + n + ci + String(t);
    }, mi = (e1, t)=>yn(e1.dom.cloneNode(t)), fi = (e1)=>mi(e1, !1), gi = (e1)=>mi(e1, !0), pi = (e1, t, n = L)=>{
        const o = new jo(e1, t), r = (e1)=>{
            let t;
            do t = o[e1]();
            while (t && !er(t) && !n(t));
            return I.from(t).filter(er);
        };
        return {
            current: ()=>I.from(o.current()).filter(er),
            next: ()=>r("next"),
            prev: ()=>r("prev"),
            prev2: ()=>r("prev2")
        };
    }, hi = (e1, t)=>{
        const n = t || ((t)=>e1.isBlock(t) || ar(t) || dr(t)), o = (e1, t, n, r)=>{
            if (er(e1)) {
                const n = r(e1, t, e1.data);
                if (-1 !== n) return I.some({
                    container: e1,
                    offset: n
                });
            }
            return n().bind((e1)=>o(e1.container, e1.offset, n, r));
        };
        return {
            backwards: (t, r, s, a)=>{
                const i = pi(t, null != a ? a : e1.getRoot(), n);
                return o(t, r, ()=>i.prev().map((e1)=>({
                            container: e1,
                            offset: e1.length
                        })), s).getOrNull();
            },
            forwards: (t, r, s, a)=>{
                const i = pi(t, null != a ? a : e1.getRoot(), n);
                return o(t, r, ()=>i.next().map((e1)=>({
                            container: e1,
                            offset: 0
                        })), s).getOrNull();
            }
        };
    }, bi = Math.round, vi = (e1)=>e1 ? {
            left: bi(e1.left),
            top: bi(e1.top),
            bottom: bi(e1.bottom),
            right: bi(e1.right),
            width: bi(e1.width),
            height: bi(e1.height)
        } : {
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
            width: 0,
            height: 0
        }, yi = (e1, t)=>(e1 = vi(e1), t || (e1.left = e1.left + e1.width), e1.right = e1.left, e1.width = 0, e1), Ci = (e1, t, n)=>e1 >= 0 && e1 <= Math.min(t.height, n.height) / 2, wi = (e1, t)=>{
        const n = Math.min(t.height / 2, e1.height / 2);
        return e1.bottom - n < t.top || !(e1.top > t.bottom) && Ci(t.top - e1.bottom, e1, t);
    }, xi = (e1, t)=>e1.top > t.bottom || !(e1.bottom < t.top) && Ci(t.bottom - e1.top, e1, t), Ei = (e1, t, n)=>{
        const o = Math.max(Math.min(t, e1.left + e1.width), e1.left), r = Math.max(Math.min(n, e1.top + e1.height), e1.top);
        return Math.sqrt((t - o) * (t - o) + (n - r) * (n - r));
    }, _i = (e1)=>{
        const t = e1.startContainer, n = e1.startOffset;
        return t === e1.endContainer && t.hasChildNodes() && e1.endOffset === n + 1 ? t.childNodes[n] : null;
    }, Si = (e1, t)=>{
        if (qo(e1) && e1.hasChildNodes()) {
            const n = e1.childNodes, o = ((e1, t, n)=>Math.min(Math.max(e1, 0), n))(t, 0, n.length - 1);
            return n[o];
        }
        return e1;
    }, ki = new RegExp("[\u0300-\u036f\u0483-\u0487\u0488-\u0489\u0591-\u05bd\u05bf\u05c1-\u05c2\u05c4-\u05c5\u05c7\u0610-\u061a\u064b-\u065f\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7-\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u08e3-\u0902\u093a\u093c\u0941-\u0948\u094d\u0951-\u0957\u0962-\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2-\u09e3\u0a01-\u0a02\u0a3c\u0a41-\u0a42\u0a47-\u0a48\u0a4b-\u0a4d\u0a51\u0a70-\u0a71\u0a75\u0a81-\u0a82\u0abc\u0ac1-\u0ac5\u0ac7-\u0ac8\u0acd\u0ae2-\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62-\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c00\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55-\u0c56\u0c62-\u0c63\u0c81\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc-\u0ccd\u0cd5-\u0cd6\u0ce2-\u0ce3\u0d01\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62-\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb-\u0ebc\u0ec8-\u0ecd\u0f18-\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86-\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039-\u103a\u103d-\u103e\u1058-\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085-\u1086\u108d\u109d\u135d-\u135f\u1712-\u1714\u1732-\u1734\u1752-\u1753\u1772-\u1773\u17b4-\u17b5\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927-\u1928\u1932\u1939-\u193b\u1a17-\u1a18\u1a1b\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1ab0-\u1abd\u1abe\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80-\u1b81\u1ba2-\u1ba5\u1ba8-\u1ba9\u1bab-\u1bad\u1be6\u1be8-\u1be9\u1bed\u1bef-\u1bf1\u1c2c-\u1c33\u1c36-\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1cf4\u1cf8-\u1cf9\u1dc0-\u1df5\u1dfc-\u1dff\u200c-\u200d\u20d0-\u20dc\u20dd-\u20e0\u20e1\u20e2-\u20e4\u20e5-\u20f0\u2cef-\u2cf1\u2d7f\u2de0-\u2dff\u302a-\u302d\u302e-\u302f\u3099-\u309a\ua66f\ua670-\ua672\ua674-\ua67d\ua69e-\ua69f\ua6f0-\ua6f1\ua802\ua806\ua80b\ua825-\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\ua9e5\uaa29-\uaa2e\uaa31-\uaa32\uaa35-\uaa36\uaa43\uaa4c\uaa7c\uaab0\uaab2-\uaab4\uaab7-\uaab8\uaabe-\uaabf\uaac1\uaaec-\uaaed\uaaf6\uabe5\uabe8\uabed\ufb1e\ufe00-\ufe0f\ufe20-\ufe2f\uff9e-\uff9f]"), Ni = (e1)=>m(e1) && e1.charCodeAt(0) >= 768 && ki.test(e1), Ri = qo, Ai = ts, Ti = Yo("display", "block table"), Oi = Yo("float", "left right"), Bi = ((...e1)=>(t)=>{
            for(let n = 0; n < e1.length; n++)if (!e1[n](t)) return !1;
            return !0;
        })(Ri, Ai, O(Oi)), Pi = O(Yo("white-space", "pre pre-line pre-wrap")), Di = er, Li = ar, Mi = za.nodeIndex, Ii = (e1, t)=>t < 0 && qo(e1) && e1.hasChildNodes() ? void 0 : Si(e1, t), Fi = (e1)=>e1 ? e1.createRange() : za.DOM.createRng(), Ui = (e1)=>m(e1) && /[\r\n\t ]/.test(e1), zi = (e1)=>!!e1.setStart && !!e1.setEnd, ji = (e1)=>{
        const t = e1.startContainer, n = e1.startOffset;
        if (Ui(e1.toString()) && Pi(t.parentNode) && er(t)) {
            const e1 = t.data;
            if (Ui(e1[n - 1]) || Ui(e1[n + 1])) return !0;
        }
        return !1;
    }, Hi = (e1)=>0 === e1.left && 0 === e1.right && 0 === e1.top && 0 === e1.bottom, $i = (e1)=>{
        var t;
        let n;
        const o = e1.getClientRects();
        return n = o.length > 0 ? vi(o[0]) : vi(e1.getBoundingClientRect()), !zi(e1) && Li(e1) && Hi(n) ? ((e1)=>{
            const t = e1.ownerDocument, n = Fi(t), o = t.createTextNode(br), r = e1.parentNode;
            r.insertBefore(o, e1), n.setStart(o, 0), n.setEnd(o, 1);
            const s = vi(n.getBoundingClientRect());
            return r.removeChild(o), s;
        })(e1) : Hi(n) && zi(e1) && null !== (t = ((e1)=>{
            const t = e1.startContainer, n = e1.endContainer, o = e1.startOffset, r = e1.endOffset;
            if (t === n && er(n) && 0 === o && 1 === r) {
                const t = e1.cloneRange();
                return t.setEndAfter(n), $i(t);
            }
            return null;
        })(e1)) && void 0 !== t ? t : n;
    }, qi = (e1, t)=>{
        const n = yi(e1, t);
        return n.width = 1, n.right = n.left + 1, n;
    }, Vi = (e1, t, n)=>{
        const o = ()=>(n || (n = ((e1)=>{
                const t = [], n = (e1)=>{
                    var n, o;
                    0 !== e1.height && (t.length > 0 && (n = e1, o = t[t.length - 1], n.left === o.left && n.top === o.top && n.bottom === o.bottom && n.right === o.right) || t.push(e1));
                }, o = (e1, t)=>{
                    const o = Fi(e1.ownerDocument);
                    if (t < e1.data.length) {
                        if (Ni(e1.data[t])) return;
                        if (Ni(e1.data[t - 1]) && (o.setStart(e1, t), o.setEnd(e1, t + 1), !ji(o))) return void n(qi($i(o), !1));
                    }
                    t > 0 && (o.setStart(e1, t - 1), o.setEnd(e1, t), ji(o) || n(qi($i(o), !1))), t < e1.data.length && (o.setStart(e1, t), o.setEnd(e1, t + 1), ji(o) || n(qi($i(o), !0)));
                }, r = e1.container(), s = e1.offset();
                if (Di(r)) return o(r, s), t;
                if (Ri(r)) {
                    if (e1.isAtEnd()) {
                        const e1 = Ii(r, s);
                        Di(e1) && o(e1, e1.data.length), Bi(e1) && !Li(e1) && n(qi($i(e1), !1));
                    } else {
                        const a = Ii(r, s);
                        if (Di(a) && o(a, 0), Bi(a) && e1.isAtEnd()) return n(qi($i(a), !1)), t;
                        const i = Ii(e1.container(), e1.offset() - 1);
                        Bi(i) && !Li(i) && (Ti(i) || Ti(a) || !Bi(a)) && n(qi($i(i), !1)), Bi(a) && n(qi($i(a), !0));
                    }
                }
                return t;
            })(Vi(e1, t))), n);
        return {
            container: N(e1),
            offset: N(t),
            toRange: ()=>{
                const n = Fi(e1.ownerDocument);
                return n.setStart(e1, t), n.setEnd(e1, t), n;
            },
            getClientRects: o,
            isVisible: ()=>o().length > 0,
            isAtStart: ()=>(Di(e1), 0 === t),
            isAtEnd: ()=>Di(e1) ? t >= e1.data.length : t >= e1.childNodes.length,
            isEqual: (n)=>n && e1 === n.container() && t === n.offset(),
            getNode: (n)=>Ii(e1, n ? t - 1 : t)
        };
    };
    Vi.fromRangeStart = (e1)=>Vi(e1.startContainer, e1.startOffset), Vi.fromRangeEnd = (e1)=>Vi(e1.endContainer, e1.endOffset), Vi.after = (e1)=>Vi(e1.parentNode, Mi(e1) + 1), Vi.before = (e1)=>Vi(e1.parentNode, Mi(e1)), Vi.isAbove = (e1, t)=>Mt(le(t.getClientRects()), de(e1.getClientRects()), wi).getOr(!1), Vi.isBelow = (e1, t)=>Mt(de(t.getClientRects()), le(e1.getClientRects()), xi).getOr(!1), Vi.isAtStart = (e1)=>!!e1 && e1.isAtStart(), Vi.isAtEnd = (e1)=>!!e1 && e1.isAtEnd(), Vi.isTextPosition = (e1)=>!!e1 && er(e1.container()), Vi.isElementPosition = (e1)=>!Vi.isTextPosition(e1);
    const Wi = (e1, t)=>{
        er(t) && 0 === t.data.length && e1.remove(t);
    }, Ki = (e1, t, n)=>{
        sr(n) ? ((e1, t, n)=>{
            const o = I.from(n.firstChild), r = I.from(n.lastChild);
            t.insertNode(n), o.each((t)=>Wi(e1, t.previousSibling)), r.each((t)=>Wi(e1, t.nextSibling));
        })(e1, t, n) : ((e1, t, n)=>{
            t.insertNode(n), Wi(e1, n.previousSibling), Wi(e1, n.nextSibling);
        })(e1, t, n);
    }, Yi = er, Gi = Xo, Xi = za.nodeIndex, Qi = (e1)=>{
        const t = e1.parentNode;
        return Gi(t) ? Qi(t) : t;
    }, Ji = (e1)=>e1 ? Oe(e1.childNodes, (e1, t)=>(Gi(t) && "BR" !== t.nodeName ? e1 = e1.concat(Ji(t)) : e1.push(t), e1), []) : [], Zi = (e1)=>(t)=>e1 === t, el = (e1)=>(Yi(e1) ? "text()" : e1.nodeName.toLowerCase()) + "[" + ((e1)=>{
            let t, n;
            t = Ji(Qi(e1)), n = Be(t, Zi(e1), e1), t = t.slice(0, n + 1);
            const o = Oe(t, (e1, n, o)=>(Yi(n) && Yi(t[o - 1]) && e1++, e1), 0);
            return t = Te(t, Ko([
                e1.nodeName
            ])), n = Be(t, Zi(e1), e1), n - o;
        })(e1) + "]", tl = (e1, t)=>{
        let n, o = [], r = t.container(), s = t.offset();
        if (Yi(r)) n = ((e1, t)=>{
            let n = e1;
            for(; (n = n.previousSibling) && Yi(n);)t += n.data.length;
            return t;
        })(r, s);
        else {
            const e1 = r.childNodes;
            s >= e1.length ? (n = "after", s = e1.length - 1) : n = "before", r = e1[s];
        }
        o.push(el(r));
        let a = ((e1, t, n)=>{
            const o = [];
            for(let n = t.parentNode; n && n !== e1; n = n.parentNode)o.push(n);
            return o;
        })(e1, r);
        return a = Te(a, O(Xo)), o = o.concat(Ae(a, (e1)=>el(e1))), o.reverse().join("/") + "," + n;
    }, nl = (e1, t)=>{
        if (!t) return null;
        const n = t.split(","), o = n[0].split("/"), r = n.length > 1 ? n[1] : "before", s = Oe(o, (e1, t)=>{
            const n = /([\w\-\(\)]+)\[([0-9]+)\]/.exec(t);
            return n ? ("text()" === n[1] && (n[1] = "#text"), ((e1, t, n)=>{
                let o = Ji(e1);
                return o = Te(o, (e1, t)=>!Yi(e1) || !Yi(o[t - 1])), o = Te(o, Ko([
                    t
                ])), o[n];
            })(e1, n[1], parseInt(n[2], 10))) : null;
        }, e1);
        if (!s) return null;
        if (!Yi(s) && s.parentNode) {
            let e1;
            return e1 = "after" === r ? Xi(s) + 1 : Xi(s), Vi(s.parentNode, e1);
        }
        return ((e1, t)=>{
            let n = e1, o = 0;
            for(; Yi(n);){
                const r = n.data.length;
                if (t >= o && t <= o + r) {
                    e1 = n, t -= o;
                    break;
                }
                if (!Yi(n.nextSibling)) {
                    e1 = n, t = r;
                    break;
                }
                o += r, n = n.nextSibling;
            }
            return Yi(e1) && t > e1.data.length && (t = e1.data.length), Vi(e1, t);
        })(s, parseInt(r, 10));
    }, ol = dr, rl = (e1, t, n, o, r)=>{
        const s = r ? o.startContainer : o.endContainer;
        let a = r ? o.startOffset : o.endOffset;
        const i = [], l = e1.getRoot();
        if (er(s)) i.push(n ? ((e1, t, n)=>{
            let o = e1(t.data.slice(0, n)).length;
            for(let n = t.previousSibling; n && er(n); n = n.previousSibling)o += e1(n.data).length;
            return o;
        })(t, s, a) : a);
        else {
            let t = 0;
            const o = s.childNodes;
            a >= o.length && o.length && (t = 1, a = Math.max(0, o.length - 1)), i.push(e1.nodeIndex(o[a], n) + t);
        }
        for(let t = s; t && t !== l; t = t.parentNode)i.push(e1.nodeIndex(t, n));
        return i;
    }, sl = (e1, t, n)=>{
        let o = 0;
        return Pt.each(e1.select(t), (e1)=>"all" === e1.getAttribute("data-mce-bogus") ? void 0 : e1 !== n && void o++), o;
    }, al = (e1, t)=>{
        let n = t ? e1.startContainer : e1.endContainer, o = t ? e1.startOffset : e1.endOffset;
        if (qo(n) && "TR" === n.nodeName) {
            const r = n.childNodes;
            n = r[Math.min(t ? o : o - 1, r.length - 1)], n && (o = t ? 0 : n.childNodes.length, t ? e1.setStart(n, o) : e1.setEnd(n, o));
        }
    }, il = (e1)=>(al(e1, !0), al(e1, !1), e1), ll = (e1, t)=>{
        if (qo(e1) && (e1 = Si(e1, t), ol(e1))) return e1;
        if (Ur(e1)) {
            er(e1) && Ir(e1) && (e1 = e1.parentNode);
            let t = e1.previousSibling;
            if (ol(t)) return t;
            if (t = e1.nextSibling, ol(t)) return t;
        }
    }, dl = (e1, t, n)=>{
        const o = n.getNode(), r = n.getRng();
        if ("IMG" === o.nodeName || ol(o)) {
            const e1 = o.nodeName;
            return {
                name: e1,
                index: sl(n.dom, e1, o)
            };
        }
        const s = ((e1)=>ll(e1.startContainer, e1.startOffset) || ll(e1.endContainer, e1.endOffset))(r);
        if (s) {
            const e1 = s.tagName;
            return {
                name: e1,
                index: sl(n.dom, e1, s)
            };
        }
        return ((e1, t, n, o)=>{
            const r = t.dom, s = rl(r, e1, n, o, !0), a = t.isForward(), i = Wr(o) ? {
                isFakeCaret: !0
            } : {};
            return t.isCollapsed() ? {
                start: s,
                forward: a,
                ...i
            } : {
                start: s,
                end: rl(r, e1, n, o, !1),
                forward: a,
                ...i
            };
        })(e1, n, t, r);
    }, cl = (e1, t, n)=>{
        const o = {
            "data-mce-type": "bookmark",
            id: t,
            style: "overflow:hidden;line-height:0px"
        };
        return n ? e1.create("span", o, "&#xFEFF;") : e1.create("span", o);
    }, ul = (e1, t)=>{
        const n = e1.dom;
        let o = e1.getRng();
        const r = n.uniqueId(), s = e1.isCollapsed(), a = e1.getNode(), i = a.nodeName, l = e1.isForward();
        if ("IMG" === i) return {
            name: i,
            index: sl(n, i, a)
        };
        const d = il(o.cloneRange());
        if (!s) {
            d.collapse(!1);
            const e1 = cl(n, r + "_end", t);
            Ki(n, d, e1);
        }
        o = il(o), o.collapse(!0);
        const c = cl(n, r + "_start", t);
        return Ki(n, o, c), e1.moveToBookmark({
            id: r,
            keep: !0,
            forward: l
        }), {
            id: r,
            forward: l
        };
    }, ml = T(dl, R, !0), fl = (e1)=>{
        const t = (t)=>t(e1), n = N(e1), o = ()=>r, r = {
            tag: !0,
            inner: e1,
            fold: (t, n)=>n(e1),
            isValue: M,
            isError: L,
            map: (t)=>pl.value(t(e1)),
            mapError: o,
            bind: t,
            exists: t,
            forall: t,
            getOr: n,
            or: o,
            getOrThunk: n,
            orThunk: o,
            getOrDie: n,
            each: (t)=>{
                t(e1);
            },
            toOptional: ()=>I.some(e1)
        };
        return r;
    }, gl = (e1)=>{
        const t = ()=>n, n = {
            tag: !1,
            inner: e1,
            fold: (t, n)=>t(e1),
            isValue: L,
            isError: M,
            map: t,
            mapError: (t)=>pl.error(t(e1)),
            bind: t,
            exists: L,
            forall: M,
            getOr: R,
            or: R,
            getOrThunk: P,
            orThunk: P,
            getOrDie: B(String(e1)),
            each: _,
            toOptional: I.none
        };
        return n;
    }, pl = {
        value: fl,
        error: gl,
        fromOption: (e1, t)=>e1.fold(()=>gl(t), fl)
    }, hl = (e1)=>{
        if (!p(e1)) throw new Error("cases must be an array");
        if (0 === e1.length) throw new Error("there must be at least one case");
        const t = [], n = {};
        return V(e1, (o, r)=>{
            const s = me(o);
            if (1 !== s.length) throw new Error("one and only one name per case");
            const a = s[0], i = o[a];
            if (void 0 !== n[a]) throw new Error("duplicate key detected:" + a);
            if ("cata" === a) throw new Error("cannot have a case named cata (sorry)");
            if (!p(i)) throw new Error("case arguments must be an array");
            t.push(a), n[a] = (...n)=>{
                const o = n.length;
                if (o !== i.length) throw new Error("Wrong number of arguments to case " + a + ". Expected " + i.length + " (" + i + "), got " + o);
                return {
                    fold: (...t)=>{
                        if (t.length !== e1.length) throw new Error("Wrong number of arguments to fold. Expected " + e1.length + ", got " + t.length);
                        return t[r].apply(null, n);
                    },
                    match: (e1)=>{
                        const o = me(e1);
                        if (t.length !== o.length) throw new Error("Wrong number of arguments to match. Expected: " + t.join(",") + "\nActual: " + o.join(","));
                        if (!ne(t, (e1)=>H(o, e1))) throw new Error("Not all branches were specified when using match. Specified: " + o.join(", ") + "\nRequired: " + t.join(", "));
                        return e1[a].apply(null, n);
                    },
                    log: (e1)=>{
                        console.log(e1, {
                            constructors: t,
                            constructor: a,
                            params: n
                        });
                    }
                };
            };
        }), n;
    };
    hl([
        {
            bothErrors: [
                "error1",
                "error2"
            ]
        },
        {
            firstError: [
                "error1",
                "value2"
            ]
        },
        {
            secondError: [
                "value1",
                "error2"
            ]
        },
        {
            bothValues: [
                "value1",
                "value2"
            ]
        }
    ]);
    const bl = (e1)=>"inline-command" === e1.type || "inline-format" === e1.type, vl = (e1)=>"block-command" === e1.type || "block-format" === e1.type, yl = (e1)=>{
        const t = (t)=>pl.error({
                message: t,
                pattern: e1
            }), n = (n, o, r)=>{
            if (void 0 !== e1.format) {
                let r;
                if (p(e1.format)) {
                    if (!ne(e1.format, m)) return t(n + " pattern has non-string items in the `format` array");
                    r = e1.format;
                } else {
                    if (!m(e1.format)) return t(n + " pattern has non-string `format` parameter");
                    r = [
                        e1.format
                    ];
                }
                return pl.value(o(r));
            }
            return void 0 !== e1.cmd ? m(e1.cmd) ? pl.value(r(e1.cmd, e1.value)) : t(n + " pattern has non-string `cmd` parameter") : t(n + " pattern is missing both `format` and `cmd` parameters");
        };
        if (!f(e1)) return t("Raw pattern is not an object");
        if (!m(e1.start)) return t("Raw pattern is missing `start` parameter");
        if (void 0 !== e1.end) {
            if (!m(e1.end)) return t("Inline pattern has non-string `end` parameter");
            if (0 === e1.start.length && 0 === e1.end.length) return t("Inline pattern has empty `start` and `end` parameters");
            let o = e1.start, r = e1.end;
            return 0 === r.length && (r = o, o = ""), n("Inline", (e1)=>({
                    type: "inline-format",
                    start: o,
                    end: r,
                    format: e1
                }), (e1, t)=>({
                    type: "inline-command",
                    start: o,
                    end: r,
                    cmd: e1,
                    value: t
                }));
        }
        return void 0 !== e1.replacement ? m(e1.replacement) ? 0 === e1.start.length ? t("Replacement pattern has empty `start` parameter") : pl.value({
            type: "inline-command",
            start: "",
            end: e1.start,
            cmd: "mceInsertContent",
            value: e1.replacement
        }) : t("Replacement pattern has non-string `replacement` parameter") : 0 === e1.start.length ? t("Block pattern has empty `start` parameter") : n("Block", (t)=>({
                type: "block-format",
                start: e1.start,
                format: t[0]
            }), (t, n)=>({
                type: "block-command",
                start: e1.start,
                cmd: t,
                value: n
            }));
    }, Cl = (e1)=>Y(e1, vl), wl = (e1)=>Y(e1, bl), xl = (e1)=>{
        const t = ((e1)=>{
            const t = [], n = [];
            return V(e1, (e1)=>{
                e1.fold((e1)=>{
                    t.push(e1);
                }, (e1)=>{
                    n.push(e1);
                });
            }), {
                errors: t,
                values: n
            };
        })(q(e1, yl));
        return V(t.errors, (e1)=>console.error(e1.message, e1.pattern)), t.values;
    }, El = xt().deviceType, _l = El.isTouch(), Sl = za.DOM, kl = (e1)=>u(e1, RegExp), Nl = (e1)=>(t)=>t.options.get(e1), Rl = (e1)=>m(e1) || f(e1), Al = (e1, t = "")=>(n)=>{
            const o = m(n);
            if (o) {
                if (-1 !== n.indexOf("=")) {
                    const r = ((e1)=>{
                        const t = e1.indexOf("=") > 0 ? e1.split(/[;,](?![^=;,]*(?:[;,]|$))/) : e1.split(",");
                        return X(t, (e1, t)=>{
                            const n = t.split("="), o = n[0], r = n.length > 1 ? n[1] : o;
                            return e1[Ve(o)] = Ve(r), e1;
                        }, {});
                    })(n);
                    return {
                        value: xe(r, e1.id).getOr(t),
                        valid: o
                    };
                }
                return {
                    value: n,
                    valid: o
                };
            }
            return {
                valid: !1,
                message: "Must be a string."
            };
        }, Tl = Nl("iframe_attrs"), Ol = Nl("doctype"), Bl = Nl("document_base_url"), Pl = Nl("body_id"), Dl = Nl("body_class"), Ll = Nl("content_security_policy"), Ml = Nl("br_in_pre"), Il = Nl("forced_root_block"), Fl = Nl("forced_root_block_attrs"), Ul = Nl("newline_behavior"), zl = Nl("br_newline_selector"), jl = Nl("no_newline_selector"), Hl = Nl("keep_styles"), $l = Nl("end_container_on_empty_block"), ql = Nl("automatic_uploads"), Vl = Nl("images_reuse_filename"), Wl = Nl("images_replace_blob_uris"), Kl = Nl("icons"), Yl = Nl("icons_url"), Gl = Nl("images_upload_url"), Xl = Nl("images_upload_base_path"), Ql = Nl("images_upload_credentials"), Jl = Nl("images_upload_handler"), Zl = Nl("content_css_cors"), ed = Nl("referrer_policy"), td = Nl("language"), nd = Nl("language_url"), od = Nl("indent_use_margin"), rd = Nl("indentation"), sd = Nl("content_css"), ad = Nl("content_style"), id = Nl("font_css"), ld = Nl("directionality"), dd = Nl("inline_boundaries_selector"), cd = Nl("object_resizing"), ud = Nl("resize_img_proportional"), md = Nl("placeholder"), fd = Nl("event_root"), gd = Nl("service_message"), pd = Nl("theme"), hd = Nl("theme_url"), bd = Nl("model"), vd = Nl("model_url"), yd = Nl("inline_boundaries"), Cd = Nl("formats"), wd = Nl("preview_styles"), xd = Nl("format_empty_lines"), Ed = Nl("format_noneditable_selector"), _d = Nl("custom_ui_selector"), Sd = Nl("inline"), kd = Nl("hidden_input"), Nd = Nl("submit_patch"), Rd = Nl("add_form_submit_trigger"), Ad = Nl("add_unload_trigger"), Td = Nl("custom_undo_redo_levels"), Od = Nl("disable_nodechange"), Bd = Nl("readonly"), Pd = Nl("editable_root"), Dd = Nl("content_css_cors"), Ld = Nl("plugins"), Md = Nl("external_plugins"), Id = Nl("block_unsupported_drop"), Fd = Nl("visual"), Ud = Nl("visual_table_class"), zd = Nl("visual_anchor_class"), jd = Nl("iframe_aria_text"), Hd = Nl("setup"), $d = Nl("init_instance_callback"), qd = Nl("urlconverter_callback"), Vd = Nl("auto_focus"), Wd = Nl("browser_spellcheck"), Kd = Nl("protect"), Yd = Nl("paste_block_drop"), Gd = Nl("paste_data_images"), Xd = Nl("paste_preprocess"), Qd = Nl("paste_postprocess"), Jd = Nl("newdocument_content"), Zd = Nl("paste_webkit_styles"), ec = Nl("paste_remove_styles_if_webkit"), tc = Nl("paste_merge_formats"), nc = Nl("smart_paste"), oc = Nl("paste_as_text"), rc = Nl("paste_tab_spaces"), sc = Nl("allow_html_data_urls"), ac = Nl("text_patterns"), ic = Nl("text_patterns_lookup"), lc = Nl("noneditable_class"), dc = Nl("editable_class"), cc = Nl("noneditable_regexp"), uc = Nl("preserve_cdata"), mc = Nl("highlight_on_focus"), fc = Nl("xss_sanitization"), gc = Nl("init_content_sync"), pc = (e1)=>Pt.explode(e1.options.get("images_file_types")), hc = Nl("table_tab_navigation"), bc = Nl("details_initial_state"), vc = Nl("details_serialized_state"), yc = Nl("force_hex_color"), Cc = Nl("sandbox_iframes"), wc = qo, xc = er, Ec = (e1)=>{
        const t = e1.parentNode;
        t && t.removeChild(e1);
    }, _c = (e1)=>{
        const t = Dr(e1);
        return {
            count: e1.length - t.length,
            text: t
        };
    }, Sc = (e1)=>{
        let t;
        for(; -1 !== (t = e1.data.lastIndexOf(Br));)e1.deleteData(t, 1);
    }, kc = (e1, t)=>(Rc(e1), t), Nc = (e1, t)=>Vi.isTextPosition(t) ? ((e1, t)=>xc(e1) && t.container() === e1 ? ((e1, t)=>{
                const n = _c(e1.data.substr(0, t.offset())), o = _c(e1.data.substr(t.offset()));
                return (n.text + o.text).length > 0 ? (Sc(e1), Vi(e1, t.offset() - n.count)) : t;
            })(e1, t) : kc(e1, t))(e1, t) : ((e1, t)=>t.container() === e1.parentNode ? ((e1, t)=>{
                const n = t.container(), o = ((e1, t)=>{
                    const n = j(e1, t);
                    return -1 === n ? I.none() : I.some(n);
                })(ce(n.childNodes), e1).map((e1)=>e1 < t.offset() ? Vi(n, t.offset() - 1) : t).getOr(t);
                return Rc(e1), o;
            })(e1, t) : kc(e1, t))(e1, t), Rc = (e1)=>{
        wc(e1) && Ur(e1) && (zr(e1) ? e1.removeAttribute("data-mce-caret") : Ec(e1)), xc(e1) && (Sc(e1), 0 === e1.data.length && Ec(e1));
    }, Ac = dr, Tc = mr, Oc = cr, Bc = (e1, t, n)=>{
        const o = yi(t.getBoundingClientRect(), n);
        let r, s;
        if ("BODY" === e1.tagName) {
            const t = e1.ownerDocument.documentElement;
            r = e1.scrollLeft || t.scrollLeft, s = e1.scrollTop || t.scrollTop;
        } else {
            const t = e1.getBoundingClientRect();
            r = e1.scrollLeft - t.left, s = e1.scrollTop - t.top;
        }
        o.left += r, o.right += r, o.top += s, o.bottom += s, o.width = 1;
        let a = t.offsetWidth - t.clientWidth;
        return a > 0 && (n && (a *= -1), o.left += a, o.right += a), o;
    }, Pc = (e1, t, n, o)=>{
        const r = Xa();
        let s, a;
        const i = Il(e1), l = e1.dom, d = ()=>{
            ((e1)=>{
                var t, n;
                const o = Uo(yn(e1), "*[contentEditable=false],video,audio,embed,object");
                for(let e1 = 0; e1 < o.length; e1++){
                    const r = o[e1].dom;
                    let s = r.previousSibling;
                    if (qr(s)) {
                        const e1 = s.data;
                        1 === e1.length ? null === (t = s.parentNode) || void 0 === t || t.removeChild(s) : s.deleteData(e1.length - 1, 1);
                    }
                    s = r.nextSibling, $r(s) && (1 === s.data.length ? null === (n = s.parentNode) || void 0 === n || n.removeChild(s) : s.deleteData(0, 1));
                }
            })(t), a && (Rc(a), a = null), r.on((e1)=>{
                l.remove(e1.caret), r.clear();
            }), s && (clearInterval(s), s = void 0);
        };
        return {
            show: (e1, c)=>{
                let u;
                if (d(), Oc(c)) return null;
                if (!n(c)) return a = ((e1, t)=>{
                    var n;
                    const o = (null !== (n = e1.ownerDocument) && void 0 !== n ? n : document).createTextNode(Br), r = e1.parentNode;
                    if (t) {
                        const t = e1.previousSibling;
                        if (Mr(t)) {
                            if (Ur(t)) return t;
                            if (qr(t)) return t.splitText(t.data.length - 1);
                        }
                        null == r || r.insertBefore(o, e1);
                    } else {
                        const t = e1.nextSibling;
                        if (Mr(t)) {
                            if (Ur(t)) return t;
                            if ($r(t)) return t.splitText(1), t;
                        }
                        e1.nextSibling ? null == r || r.insertBefore(o, e1.nextSibling) : null == r || r.appendChild(o);
                    }
                    return o;
                })(c, e1), u = c.ownerDocument.createRange(), Lc(a.nextSibling) ? (u.setStart(a, 0), u.setEnd(a, 0)) : (u.setStart(a, 1), u.setEnd(a, 1)), u;
                {
                    const n = ((e1, t, n)=>{
                        var o;
                        const r = (null !== (o = t.ownerDocument) && void 0 !== o ? o : document).createElement(e1);
                        r.setAttribute("data-mce-caret", n ? "before" : "after"), r.setAttribute("data-mce-bogus", "all"), r.appendChild(Tr().dom);
                        const s = t.parentNode;
                        return n ? null == s || s.insertBefore(r, t) : t.nextSibling ? null == s || s.insertBefore(r, t.nextSibling) : null == s || s.appendChild(r), r;
                    })(i, c, e1), d = Bc(t, c, e1);
                    l.setStyle(n, "top", d.top), a = n;
                    const m = l.create("div", {
                        class: "mce-visual-caret",
                        "data-mce-bogus": "all"
                    });
                    l.setStyles(m, {
                        ...d
                    }), l.add(t, m), r.set({
                        caret: m,
                        element: c,
                        before: e1
                    }), e1 && l.addClass(m, "mce-visual-caret-before"), s = setInterval(()=>{
                        r.on((e1)=>{
                            o() ? l.toggleClass(e1.caret, "mce-visual-caret-hidden") : l.addClass(e1.caret, "mce-visual-caret-hidden");
                        });
                    }, 500), u = c.ownerDocument.createRange(), u.setStart(n, 0), u.setEnd(n, 0);
                }
                return u;
            },
            hide: d,
            getCss: ()=>".mce-visual-caret {position: absolute;background-color: black;background-color: currentcolor;}.mce-visual-caret-hidden {display: none;}*[data-mce-caret] {position: absolute;left: -1000px;right: auto;top: 0;margin: 0;padding: 0;}",
            reposition: ()=>{
                r.on((e1)=>{
                    const n = Bc(t, e1.element, e1.before);
                    l.setStyles(e1.caret, {
                        ...n
                    });
                });
            },
            destroy: ()=>clearInterval(s)
        };
    }, Dc = ()=>At.browser.isFirefox(), Lc = (e1)=>Ac(e1) || Tc(e1), Mc = (e1)=>(Lc(e1) || Qo(e1) && Dc()) && Tn(yn(e1)).exists(oo), Ic = lr, Fc = dr, Uc = mr, zc = Yo("display", "block table table-cell table-caption list-item"), jc = Ur, Hc = Ir, $c = qo, qc = er, Vc = ts, Wc = (e1)=>e1 > 0, Kc = (e1)=>e1 < 0, Yc = (e1, t)=>{
        let n;
        for(; n = e1(t);)if (!Hc(n)) return n;
        return null;
    }, Gc = (e1, t, n, o, r)=>{
        const s = new jo(e1, o), a = Fc(e1) || Hc(e1);
        let i;
        if (Kc(t)) {
            if (a && (i = Yc(s.prev.bind(s), !0), n(i))) return i;
            for(; i = Yc(s.prev.bind(s), r);)if (n(i)) return i;
        }
        if (Wc(t)) {
            if (a && (i = Yc(s.next.bind(s), !0), n(i))) return i;
            for(; i = Yc(s.next.bind(s), r);)if (n(i)) return i;
        }
        return null;
    }, Xc = (e1, t)=>{
        for(; e1 && e1 !== t;){
            if (zc(e1)) return e1;
            e1 = e1.parentNode;
        }
        return null;
    }, Qc = (e1, t, n)=>Xc(e1.container(), n) === Xc(t.container(), n), Jc = (e1, t)=>{
        if (!t) return I.none();
        const n = t.container(), o = t.offset();
        return $c(n) ? I.from(n.childNodes[o + e1]) : I.none();
    }, Zc = (e1, t)=>{
        var n;
        const o = (null !== (n = t.ownerDocument) && void 0 !== n ? n : document).createRange();
        return e1 ? (o.setStartBefore(t), o.setEndBefore(t)) : (o.setStartAfter(t), o.setEndAfter(t)), o;
    }, eu = (e1, t, n)=>Xc(t, e1) === Xc(n, e1), tu = (e1, t, n)=>{
        const o = e1 ? "previousSibling" : "nextSibling";
        let r = n;
        for(; r && r !== t;){
            let e1 = r[o];
            if (e1 && jc(e1) && (e1 = e1[o]), Fc(e1) || Uc(e1)) {
                if (eu(t, e1, r)) return e1;
                break;
            }
            if (Vc(e1)) break;
            r = r.parentNode;
        }
        return null;
    }, nu = T(Zc, !0), ou = T(Zc, !1), ru = (e1, t, n)=>{
        let o;
        const r = T(tu, !0, t), s = T(tu, !1, t), a = n.startContainer, i = n.startOffset;
        if (Ir(a)) {
            const e1 = qc(a) ? a.parentNode : a, t = e1.getAttribute("data-mce-caret");
            if ("before" === t && (o = e1.nextSibling, Mc(o))) return nu(o);
            if ("after" === t && (o = e1.previousSibling, Mc(o))) return ou(o);
        }
        if (!n.collapsed) return n;
        if (er(a)) {
            if (jc(a)) {
                if (1 === e1) {
                    if (o = s(a), o) return nu(o);
                    if (o = r(a), o) return ou(o);
                }
                if (-1 === e1) {
                    if (o = r(a), o) return ou(o);
                    if (o = s(a), o) return nu(o);
                }
                return n;
            }
            if (qr(a) && i >= a.data.length - 1) return 1 === e1 && (o = s(a), o) ? nu(o) : n;
            if ($r(a) && i <= 1) return -1 === e1 && (o = r(a), o) ? ou(o) : n;
            if (i === a.data.length) return o = s(a), o ? nu(o) : n;
            if (0 === i) return o = r(a), o ? ou(o) : n;
        }
        return n;
    }, su = (e1, t)=>Jc(e1 ? 0 : -1, t).filter(Fc), au = (e1, t, n)=>{
        const o = ru(e1, t, n);
        return -1 === e1 ? Vi.fromRangeStart(o) : Vi.fromRangeEnd(o);
    }, iu = (e1)=>I.from(e1.getNode()).map(yn), lu = (e1, t)=>{
        let n = t;
        for(; n = e1(n);)if (n.isVisible()) return n;
        return n;
    }, du = (e1, t)=>{
        const n = Qc(e1, t);
        return !(n || !ar(e1.getNode())) || n;
    };
    var cu;
    !function(e1) {
        e1[e1.Backwards = -1] = "Backwards", e1[e1.Forwards = 1] = "Forwards";
    }(cu || (cu = {}));
    const uu = dr, mu = er, fu = qo, gu = ar, pu = ts, hu = (e1)=>Jr(e1) || ((e1)=>!!ns(e1) && !X(ce(e1.getElementsByTagName("*")), (e1, t)=>e1 || Kr(t), !1))(e1), bu = os, vu = (e1, t)=>e1.hasChildNodes() && t < e1.childNodes.length ? e1.childNodes[t] : null, yu = (e1, t)=>{
        if (Wc(e1)) {
            if (pu(t.previousSibling) && !mu(t.previousSibling)) return Vi.before(t);
            if (mu(t)) return Vi(t, 0);
        }
        if (Kc(e1)) {
            if (pu(t.nextSibling) && !mu(t.nextSibling)) return Vi.after(t);
            if (mu(t)) return Vi(t, t.data.length);
        }
        return Kc(e1) ? gu(t) ? Vi.before(t) : Vi.after(t) : Vi.before(t);
    }, Cu = (e1, t, n)=>{
        let o, r, s, a;
        if (!fu(n) || !t) return null;
        if (t.isEqual(Vi.after(n)) && n.lastChild) {
            if (a = Vi.after(n.lastChild), Kc(e1) && pu(n.lastChild) && fu(n.lastChild)) return gu(n.lastChild) ? Vi.before(n.lastChild) : a;
        } else a = t;
        const i = a.container();
        let l = a.offset();
        if (mu(i)) {
            if (Kc(e1) && l > 0) return Vi(i, --l);
            if (Wc(e1) && l < i.length) return Vi(i, ++l);
            o = i;
        } else {
            if (Kc(e1) && l > 0 && (r = vu(i, l - 1), pu(r))) return !hu(r) && (s = Gc(r, e1, bu, r), s) ? mu(s) ? Vi(s, s.data.length) : Vi.after(s) : mu(r) ? Vi(r, r.data.length) : Vi.before(r);
            if (Wc(e1) && l < i.childNodes.length && (r = vu(i, l), pu(r))) return gu(r) ? ((e1, t)=>{
                const n = t.nextSibling;
                return n && pu(n) ? mu(n) ? Vi(n, 0) : Vi.before(n) : Cu(cu.Forwards, Vi.after(t), e1);
            })(n, r) : !hu(r) && (s = Gc(r, e1, bu, r), s) ? mu(s) ? Vi(s, 0) : Vi.before(s) : mu(r) ? Vi(r, 0) : Vi.after(r);
            o = r || a.getNode();
        }
        if (o && (Wc(e1) && a.isAtEnd() || Kc(e1) && a.isAtStart()) && (o = Gc(o, e1, M, n, !0), bu(o, n))) return yu(e1, o);
        r = o ? Gc(o, e1, bu, n) : o;
        const d = Pe(Y(((e1, t)=>{
            const n = [];
            let o = e1;
            for(; o && o !== t;)n.push(o), o = o.parentNode;
            return n;
        })(i, n), uu));
        return !d || r && d.contains(r) ? r ? yu(e1, r) : null : (a = Wc(e1) ? Vi.after(d) : Vi.before(d), a);
    }, wu = (e1)=>({
            next: (t)=>Cu(cu.Forwards, t, e1),
            prev: (t)=>Cu(cu.Backwards, t, e1)
        }), xu = (e1)=>Vi.isTextPosition(e1) ? 0 === e1.offset() : ts(e1.getNode()), Eu = (e1)=>{
        if (Vi.isTextPosition(e1)) {
            const t = e1.container();
            return e1.offset() === t.data.length;
        }
        return ts(e1.getNode(!0));
    }, _u = (e1, t)=>!Vi.isTextPosition(e1) && !Vi.isTextPosition(t) && e1.getNode() === t.getNode(!0), Su = (e1, t, n)=>{
        const o = wu(t);
        return I.from(e1 ? o.next(n) : o.prev(n));
    }, ku = (e1, t, n)=>Su(e1, t, n).bind((o)=>Qc(n, o, t) && ((e1, t, n)=>{
                var o;
                return e1 ? !_u(t, n) && (o = t, !(!Vi.isTextPosition(o) && ar(o.getNode()))) && Eu(t) && xu(n) : !_u(n, t) && xu(t) && Eu(n);
            })(e1, n, o) ? Su(e1, t, o) : I.some(o)), Nu = (e1, t, n, o)=>ku(e1, t, n).bind((n)=>o(n) ? Nu(e1, t, n, o) : I.some(n)), Ru = (e1, t)=>{
        const n = e1 ? t.firstChild : t.lastChild;
        var o;
        return er(n) ? I.some(Vi(n, e1 ? 0 : n.data.length)) : n ? ts(n) ? I.some(e1 ? Vi.before(n) : ar(o = n) ? Vi.before(o) : Vi.after(o)) : ((e1, t, n)=>{
            const o = e1 ? Vi.before(n) : Vi.after(n);
            return Su(e1, t, o);
        })(e1, t, n) : I.none();
    }, Au = T(Su, !0), Tu = T(Su, !1), Ou = T(Ru, !0), Bu = T(Ru, !1), Pu = "_mce_caret", Du = (e1)=>qo(e1) && e1.id === Pu, Lu = (e1, t)=>{
        let n = t;
        for(; n && n !== e1;){
            if (Du(n)) return n;
            n = n.parentNode;
        }
        return null;
    }, Mu = (e1)=>Ee(e1, "name"), Iu = (e1)=>Pt.isArray(e1.start), Fu = (e1)=>!(!Mu(e1) && b(e1.forward)) || e1.forward, Uu = (e1, t)=>(qo(t) && e1.isBlock(t) && !t.innerHTML && (t.innerHTML = '<br data-mce-bogus="1" />'), t), zu = (e1, t)=>Bu(e1).fold(L, (e1)=>(t.setStart(e1.container(), e1.offset()), t.setEnd(e1.container(), e1.offset()), !0)), ju = (e1, t, n)=>!(!((e1)=>!e1.hasChildNodes())(t) || !Lu(e1, t) || (((e1, t)=>{
            var n;
            const o = (null !== (n = e1.ownerDocument) && void 0 !== n ? n : document).createTextNode(Br);
            e1.appendChild(o), t.setStart(o, 0), t.setEnd(o, 0);
        })(t, n), 0)), Hu = (e1, t, n, o)=>{
        const r = n[t ? "start" : "end"], s = e1.getRoot();
        if (r) {
            let e1 = s, n = r[0];
            for(let t = r.length - 1; e1 && t >= 1; t--){
                const n = e1.childNodes;
                if (ju(s, e1, o)) return !0;
                if (r[t] > n.length - 1) return !!ju(s, e1, o) || zu(e1, o);
                e1 = n[r[t]];
            }
            er(e1) && (n = Math.min(r[0], e1.data.length)), qo(e1) && (n = Math.min(r[0], e1.childNodes.length)), t ? o.setStart(e1, n) : o.setEnd(e1, n);
        }
        return !0;
    }, $u = (e1)=>er(e1) && e1.data.length > 0, qu = (e1, t, n)=>{
        const o = e1.get(n.id + "_" + t), r = null == o ? void 0 : o.parentNode, s = n.keep;
        if (o && r) {
            let a, i;
            if ("start" === t ? s ? o.hasChildNodes() ? (a = o.firstChild, i = 1) : $u(o.nextSibling) ? (a = o.nextSibling, i = 0) : $u(o.previousSibling) ? (a = o.previousSibling, i = o.previousSibling.data.length) : (a = r, i = e1.nodeIndex(o) + 1) : (a = r, i = e1.nodeIndex(o)) : s ? o.hasChildNodes() ? (a = o.firstChild, i = 1) : $u(o.previousSibling) ? (a = o.previousSibling, i = o.previousSibling.data.length) : (a = r, i = e1.nodeIndex(o)) : (a = r, i = e1.nodeIndex(o)), !s) {
                const r = o.previousSibling, s = o.nextSibling;
                let l;
                for(Pt.each(Pt.grep(o.childNodes), (e1)=>{
                    er(e1) && (e1.data = e1.data.replace(/\uFEFF/g, ""));
                }); l = e1.get(n.id + "_" + t);)e1.remove(l, !0);
                if (er(s) && er(r) && !At.browser.isOpera()) {
                    const t = r.data.length;
                    r.appendData(s.data), e1.remove(s), a = r, i = t;
                }
            }
            return I.some(Vi(a, i));
        }
        return I.none();
    }, Vu = (e1, t, n)=>((e1, t, n = !1)=>2 === t ? dl(Dr, n, e1) : 3 === t ? ((e1)=>{
                const t = e1.getRng();
                return {
                    start: tl(e1.dom.getRoot(), Vi.fromRangeStart(t)),
                    end: tl(e1.dom.getRoot(), Vi.fromRangeEnd(t)),
                    forward: e1.isForward()
                };
            })(e1) : t ? ((e1)=>({
                    rng: e1.getRng(),
                    forward: e1.isForward()
                }))(e1) : ul(e1, !1))(e1, t, n), Wu = (e1, t)=>{
        ((e1, t)=>{
            const n = e1.dom;
            if (t) {
                if (Iu(t)) return ((e1, t)=>{
                    const n = e1.createRng();
                    return Hu(e1, !0, t, n) && Hu(e1, !1, t, n) ? I.some({
                        range: n,
                        forward: Fu(t)
                    }) : I.none();
                })(n, t);
                if (((e1)=>m(e1.start))(t)) return ((e1, t)=>{
                    const n = I.from(nl(e1.getRoot(), t.start)), o = I.from(nl(e1.getRoot(), t.end));
                    return Mt(n, o, (n, o)=>{
                        const r = e1.createRng();
                        return r.setStart(n.container(), n.offset()), r.setEnd(o.container(), o.offset()), {
                            range: r,
                            forward: Fu(t)
                        };
                    });
                })(n, t);
                if (((e1)=>Ee(e1, "id"))(t)) return ((e1, t)=>{
                    const n = qu(e1, "start", t), o = qu(e1, "end", t);
                    return Mt(n, o.or(n), (n, o)=>{
                        const r = e1.createRng();
                        return r.setStart(Uu(e1, n.container()), n.offset()), r.setEnd(Uu(e1, o.container()), o.offset()), {
                            range: r,
                            forward: Fu(t)
                        };
                    });
                })(n, t);
                if (Mu(t)) return ((e1, t)=>I.from(e1.select(t.name)[t.index]).map((t)=>{
                        const n = e1.createRng();
                        return n.selectNode(t), {
                            range: n,
                            forward: !0
                        };
                    }))(n, t);
                if (((e1)=>Ee(e1, "rng"))(t)) return I.some({
                    range: t.rng,
                    forward: Fu(t)
                });
            }
            return I.none();
        })(e1, t).each(({ range: t, forward: n })=>{
            e1.setRng(t, n);
        });
    }, Ku = (e1)=>qo(e1) && "SPAN" === e1.tagName && "bookmark" === e1.getAttribute("data-mce-type"), Yu = (Gu = br, (e1)=>Gu === e1);
    var Gu;
    const Xu = (e1)=>"" !== e1 && -1 !== " \f\n\r\t\v".indexOf(e1), Qu = (e1)=>!Xu(e1) && !Yu(e1) && !vr(e1), Ju = (e1)=>{
        const t = [];
        if (e1) for(let n = 0; n < e1.rangeCount; n++)t.push(e1.getRangeAt(n));
        return t;
    }, Zu = (e1, t)=>{
        const n = Uo(t, "td[data-mce-selected],th[data-mce-selected]");
        return n.length > 0 ? n : ((e1)=>Y(((e1)=>te(e1, (e1)=>{
                    const t = _i(e1);
                    return t ? [
                        yn(t)
                    ] : [];
                }))(e1), Rr))(e1);
    }, em = (e1)=>Zu(Ju(e1.selection.getSel()), yn(e1.getBody())), tm = (e1, t)=>eo(e1, "table", t), nm = (e1)=>Fn(e1).fold(N([
            e1
        ]), (t)=>[
                e1
            ].concat(nm(t))), om = (e1)=>Un(e1).fold(N([
            e1
        ]), (t)=>"br" === Ht(t) ? Bn(t).map((t)=>[
                    e1
                ].concat(om(t))).getOr([]) : [
                e1
            ].concat(om(t))), rm = (e1, t)=>Mt(((e1)=>{
            const t = e1.startContainer, n = e1.startOffset;
            return er(t) ? 0 === n ? I.some(yn(t)) : I.none() : I.from(t.childNodes[n]).map(yn);
        })(t), ((e1)=>{
            const t = e1.endContainer, n = e1.endOffset;
            return er(t) ? n === t.data.length ? I.some(yn(t)) : I.none() : I.from(t.childNodes[n - 1]).map(yn);
        })(t), (t, n)=>{
            const o = J(nm(e1), T(_n, t)), r = J(om(e1), T(_n, n));
            return o.isSome() && r.isSome();
        }).getOr(!1), sm = (e1, t, n, o)=>{
        const r = n, s = new jo(n, r), a = ye(e1.schema.getMoveCaretBeforeOnEnterElements(), (e1, t)=>!H([
                "td",
                "th",
                "table"
            ], t.toLowerCase()));
        let i = n;
        do {
            if (er(i) && 0 !== Pt.trim(i.data).length) return void (o ? t.setStart(i, 0) : t.setEnd(i, i.data.length));
            if (a[i.nodeName]) return void (o ? t.setStartBefore(i) : "BR" === i.nodeName ? t.setEndBefore(i) : t.setEndAfter(i));
        }while (i = o ? s.next() : s.prev());
        "BODY" === r.nodeName && (o ? t.setStart(r, 0) : t.setEnd(r, r.childNodes.length));
    }, am = (e1)=>{
        const t = e1.selection.getSel();
        return C(t) && t.rangeCount > 0;
    }, im = (e1, t)=>{
        const n = em(e1);
        n.length > 0 ? V(n, (n)=>{
            const o = n.dom, r = e1.dom.createRng();
            r.setStartBefore(o), r.setEndAfter(o), t(r, !0);
        }) : t(e1.selection.getRng(), !1);
    }, lm = (e1, t, n)=>{
        const o = ul(e1, t);
        n(o), e1.moveToBookmark(o);
    }, dm = (e1)=>x(null == e1 ? void 0 : e1.nodeType), cm = (e1)=>qo(e1) && !Ku(e1) && !Du(e1) && !Xo(e1), um = (e1, t, n)=>{
        const { selection: o, dom: r } = e1, s = o.getNode(), a = dr(s);
        lm(o, !0, ()=>{
            t();
        }), a && dr(s) && r.isChildOf(s, e1.getBody()) ? e1.selection.select(s) : n(o.getStart()) && mm(r, o);
    }, mm = (e1, t)=>{
        var n, o;
        const r = t.getRng(), { startContainer: s, startOffset: a } = r;
        if (!((e1, t)=>{
            if (cm(t) && !/^(TD|TH)$/.test(t.nodeName)) {
                const n = e1.getAttrib(t, "data-mce-selected"), o = parseInt(n, 10);
                return !isNaN(o) && o > 0;
            }
            return !1;
        })(e1, t.getNode()) && qo(s)) {
            const i = s.childNodes, l = e1.getRoot();
            let d;
            if (a < i.length) {
                const t = i[a];
                d = new jo(t, null !== (n = e1.getParent(t, e1.isBlock)) && void 0 !== n ? n : l);
            } else {
                const t = i[i.length - 1];
                d = new jo(t, null !== (o = e1.getParent(t, e1.isBlock)) && void 0 !== o ? o : l), d.next(!0);
            }
            for(let n = d.current(); n; n = d.next()){
                if ("false" === e1.getContentEditable(n)) return;
                if (er(n) && !hm(n)) return r.setStart(n, 0), void t.setRng(r);
            }
        }
    }, fm = (e1, t, n)=>{
        if (e1) {
            const o = t ? "nextSibling" : "previousSibling";
            for(e1 = n ? e1 : e1[o]; e1; e1 = e1[o])if (qo(e1) || !hm(e1)) return e1;
        }
    }, gm = (e1, t)=>!!e1.getTextBlockElements()[t.nodeName.toLowerCase()] || Ts(e1, t), pm = (e1, t, n)=>e1.schema.isValidChild(t, n), hm = (e1, t = !1)=>{
        if (C(e1) && er(e1)) {
            const n = t ? e1.data.replace(/ /g, "\xa0") : e1.data;
            return ss(n);
        }
        return !1;
    }, bm = (e1, t)=>{
        const n = e1.dom;
        return cm(t) && "false" === n.getContentEditable(t) && ((e1, t)=>{
            const n = "[data-mce-cef-wrappable]", o = Ed(e1), r = Ge(o) ? n : `${n},${o}`;
            return xn(yn(t), r);
        })(e1, t) && 0 === n.select('[contenteditable="true"]', t).length;
    }, vm = (e1, t)=>w(e1) ? e1(t) : (C(t) && (e1 = e1.replace(/%(\w+)/g, (e1, n)=>t[n] || e1)), e1), ym = (e1, t)=>(t = t || "", e1 = "" + ((e1 = e1 || "").nodeName || e1), t = "" + (t.nodeName || t), e1.toLowerCase() === t.toLowerCase()), Cm = (e1, t)=>{
        if (y(e1)) return null;
        {
            let n = String(e1);
            return "color" !== t && "backgroundColor" !== t || (n = Ca(n)), "fontWeight" === t && 700 === e1 && (n = "bold"), "fontFamily" === t && (n = n.replace(/[\'\"]/g, "").replace(/,\s+/g, ",")), n;
        }
    }, wm = (e1, t, n)=>{
        const o = e1.getStyle(t, n);
        return Cm(o, n);
    }, xm = (e1, t)=>{
        let n;
        return e1.getParent(t, (t)=>!!qo(t) && (n = e1.getStyle(t, "text-decoration"), !!n && "none" !== n)), n;
    }, Em = (e1, t, n)=>e1.getParents(t, n, e1.getRoot()), _m = (e1, t, n)=>{
        const o = e1.formatter.get(t);
        return C(o) && $(o, n);
    }, Sm = (e1)=>_e(e1, "block"), km = (e1)=>_e(e1, "selector"), Nm = (e1)=>_e(e1, "inline"), Rm = (e1)=>km(e1) && !1 !== e1.expand && !Nm(e1), Am = (e1)=>((e1)=>{
            const t = [];
            let n = e1;
            for(; n;){
                if (er(n) && n.data !== Br || n.childNodes.length > 1) return [];
                qo(n) && t.push(n), n = n.firstChild;
            }
            return t;
        })(e1).length > 0, Tm = (e1)=>Du(e1.dom) && Am(e1.dom), Om = Ku, Bm = Em, Pm = hm, Dm = gm, Lm = (e1, t)=>{
        let n = t;
        for(; n;){
            if (qo(n) && e1.getContentEditable(n)) return "false" === e1.getContentEditable(n) ? n : t;
            n = n.parentNode;
        }
        return t;
    }, Mm = (e1, t, n, o)=>{
        const r = t.data;
        if (e1) {
            for(let e1 = n; e1 > 0; e1--)if (o(r.charAt(e1 - 1))) return e1;
        } else for(let e1 = n; e1 < r.length; e1++)if (o(r.charAt(e1))) return e1;
        return -1;
    }, Im = (e1, t, n)=>Mm(e1, t, n, (e1)=>Yu(e1) || Xu(e1)), Fm = (e1, t, n)=>Mm(e1, t, n, Qu), Um = (e1, t, n, o, r, s)=>{
        let a;
        const i = e1.getParent(n, e1.isBlock) || t, l = (t, n, o)=>{
            const s = hi(e1), l = r ? s.backwards : s.forwards;
            return I.from(l(t, n, (e1, t)=>Om(e1.parentNode) ? -1 : (a = e1, o(r, e1, t)), i));
        };
        return l(n, o, Im).bind((e1)=>s ? l(e1.container, e1.offset + (r ? -1 : 0), Fm) : I.some(e1)).orThunk(()=>a ? I.some({
                container: a,
                offset: r ? 0 : a.length
            }) : I.none());
    }, zm = (e1, t, n, o, r)=>{
        const s = o[r];
        er(o) && Ge(o.data) && s && (o = s);
        const a = Bm(e1, o);
        for(let o = 0; o < a.length; o++)for(let r = 0; r < t.length; r++){
            const s = t[r];
            if ((!C(s.collapsed) || s.collapsed === n.collapsed) && km(s) && e1.is(a[o], s.selector)) return a[o];
        }
        return o;
    }, jm = (e1, t, n, o)=>{
        var r;
        let s = n;
        const a = e1.getRoot(), i = t[0];
        if (Sm(i) && (s = i.wrapper ? null : e1.getParent(n, i.block, a)), !s) {
            const t = null !== (r = e1.getParent(n, "LI,TD,TH,SUMMARY")) && void 0 !== r ? r : a;
            s = e1.getParent(er(n) ? n.parentNode : n, (t)=>t !== a && Dm(e1.schema, t), t);
        }
        if (s && Sm(i) && i.wrapper && (s = Bm(e1, s, "ul,ol").reverse()[0] || s), !s) for(s = n; s && s[o] && !e1.isBlock(s[o]) && (s = s[o], !ym(s, "br")););
        return s || n;
    }, Hm = (e1, t, n, o)=>{
        const r = n.parentNode;
        return !C(n[o]) && (!(r !== t && !y(r) && !e1.isBlock(r)) || Hm(e1, t, r, o));
    }, $m = (e1, t, n, o, r)=>{
        let s = n;
        const a = r ? "previousSibling" : "nextSibling", i = e1.getRoot();
        if (er(n) && !Pm(n) && (r ? o > 0 : o < n.data.length)) return n;
        for(; s;){
            if (!t[0].block_expand && e1.isBlock(s)) return s;
            for(let t = s[a]; t; t = t[a]){
                const n = er(t) && !Hm(e1, i, t, a);
                if (!Om(t) && (!ar(l = t) || !l.getAttribute("data-mce-bogus") || l.nextSibling) && !Pm(t, n)) return s;
            }
            if (s === i || s.parentNode === i) {
                n = s;
                break;
            }
            s = s.parentNode;
        }
        var l;
        return n;
    }, qm = (e1)=>Om(e1.parentNode) || Om(e1), Vm = (e1, t, n, o = !1)=>{
        let { startContainer: r, startOffset: s, endContainer: a, endOffset: i } = t;
        const l = n[0];
        return qo(r) && r.hasChildNodes() && (r = Si(r, s), er(r) && (s = 0)), qo(a) && a.hasChildNodes() && (a = Si(a, t.collapsed ? i : i - 1), er(a) && (i = a.data.length)), r = Lm(e1, r), a = Lm(e1, a), qm(r) && (r = Om(r) ? r : r.parentNode, r = t.collapsed ? r.previousSibling || r : r.nextSibling || r, er(r) && (s = t.collapsed ? r.length : 0)), qm(a) && (a = Om(a) ? a : a.parentNode, a = t.collapsed ? a.nextSibling || a : a.previousSibling || a, er(a) && (i = t.collapsed ? 0 : a.length)), t.collapsed && (Um(e1, e1.getRoot(), r, s, !0, o).each(({ container: e1, offset: t })=>{
            r = e1, s = t;
        }), Um(e1, e1.getRoot(), a, i, !1, o).each(({ container: e1, offset: t })=>{
            a = e1, i = t;
        })), (Nm(l) || l.block_expand) && (Nm(l) && er(r) && 0 !== s || (r = $m(e1, n, r, s, !0)), Nm(l) && er(a) && i !== a.data.length || (a = $m(e1, n, a, i, !1))), Rm(l) && (r = zm(e1, n, t, r, "previousSibling"), a = zm(e1, n, t, a, "nextSibling")), (Sm(l) || km(l)) && (r = jm(e1, n, r, "previousSibling"), a = jm(e1, n, a, "nextSibling"), Sm(l) && (e1.isBlock(r) || (r = $m(e1, n, r, s, !0)), e1.isBlock(a) || (a = $m(e1, n, a, i, !1)))), qo(r) && r.parentNode && (s = e1.nodeIndex(r), r = r.parentNode), qo(a) && a.parentNode && (i = e1.nodeIndex(a) + 1, a = a.parentNode), {
            startContainer: r,
            startOffset: s,
            endContainer: a,
            endOffset: i
        };
    }, Wm = (e1, t, n)=>{
        var o;
        const r = t.startOffset, s = Si(t.startContainer, r), a = t.endOffset, i = Si(t.endContainer, a - 1), l = (e1)=>{
            const t = e1[0];
            er(t) && t === s && r >= t.data.length && e1.splice(0, 1);
            const n = e1[e1.length - 1];
            return 0 === a && e1.length > 0 && n === i && er(n) && e1.splice(e1.length - 1, 1), e1;
        }, d = (e1, t, n)=>{
            const o = [];
            for(; e1 && e1 !== n; e1 = e1[t])o.push(e1);
            return o;
        }, c = (t, n)=>e1.getParent(t, (e1)=>e1.parentNode === n, n), u = (e1, t, o)=>{
            const r = o ? "nextSibling" : "previousSibling";
            for(let s = e1, a = s.parentNode; s && s !== t; s = a){
                a = s.parentNode;
                const t = d(s === e1 ? s : s[r], r);
                t.length && (o || t.reverse(), n(l(t)));
            }
        };
        if (s === i) return n(l([
            s
        ]));
        const m = null !== (o = e1.findCommonAncestor(s, i)) && void 0 !== o ? o : e1.getRoot();
        if (e1.isChildOf(s, i)) return u(s, m, !0);
        if (e1.isChildOf(i, s)) return u(i, m);
        const f = c(s, m) || s, g = c(i, m) || i;
        u(s, f, !0);
        const p = d(f === s ? f : f.nextSibling, "nextSibling", g === i ? g.nextSibling : g);
        p.length && n(l(p)), u(i, g);
    }, Km = [
        'pre[class*=language-][contenteditable="false"]',
        "figure.image",
        "div[data-ephox-embed-iri]",
        "div.tiny-pageembed",
        "div.mce-toc",
        "div[data-mce-toc]"
    ], Ym = (e1, t, n, o, r, s)=>{
        const { uid: a = t, ...i } = n;
        un(e1, Za()), Jt(e1, `${ti()}`, a), Jt(e1, `${ei()}`, o);
        const { attributes: l = {}, classes: d = [] } = r(a, i);
        if (Zt(e1, l), ((e1, t)=>{
            V(t, (t)=>{
                un(e1, t);
            });
        })(e1, d), s) {
            d.length > 0 && Jt(e1, `${oi()}`, d.join(","));
            const t = me(l);
            t.length > 0 && Jt(e1, `${ri()}`, t.join(","));
        }
    }, Gm = (e1, t, n, o, r)=>{
        const s = bn("span", e1);
        return Ym(s, t, n, o, r, !1), s;
    }, Xm = (e1, t, n, o, r, s)=>{
        const a = [], i = Gm(e1.getDoc(), n, s, o, r), l = Xa(), d = ()=>{
            l.clear();
        }, c = (e1)=>{
            V(e1, u);
        }, u = (t)=>{
            switch(((e1, t, n, o)=>An(t).fold(()=>"skipping", (r)=>"br" === o || ((e1)=>Kt(e1) && Cr(e1) === Br)(t) ? "valid" : ((e1)=>Wt(e1) && gn(e1, Za()))(t) ? "existing" : Du(t.dom) ? "caret" : $(Km, (e1)=>xn(t, e1)) ? "valid-block" : pm(e1, n, o) && pm(e1, Ht(r), n) ? "valid" : "invalid-child"))(e1, t, "span", Ht(t))){
                case "invalid-child":
                    {
                        d();
                        const e1 = Mn(t);
                        c(e1), d();
                        break;
                    }
                case "valid-block":
                    d(), Ym(t, n, s, o, r, !0);
                    break;
                case "valid":
                    {
                        const e1 = l.get().getOrThunk(()=>{
                            const e1 = fi(i);
                            return a.push(e1), l.set(e1), e1;
                        });
                        yo(t, e1);
                        break;
                    }
            }
        };
        return Wm(e1.dom, t, (e1)=>{
            d(), ((e1)=>{
                const t = q(e1, yn);
                c(t);
            })(e1);
        }), a;
    }, Qm = (e1)=>{
        const t = (()=>{
            const e1 = {};
            return {
                register: (t, n)=>{
                    e1[t] = {
                        name: t,
                        settings: n
                    };
                },
                lookup: (t)=>xe(e1, t).map((e1)=>e1.settings),
                getNames: ()=>me(e1)
            };
        })();
        ((e1, t)=>{
            const n = ei(), o = (e1)=>I.from(e1.attr(n)).bind(t.lookup), r = (e1)=>{
                var t, n;
                e1.attr(ti(), null), e1.attr(ei(), null), e1.attr(ni(), null);
                const o = I.from(e1.attr(ri())).map((e1)=>e1.split(",")).getOr([]), r = I.from(e1.attr(oi())).map((e1)=>e1.split(",")).getOr([]);
                V(o, (t)=>e1.attr(t, null));
                const s = null !== (n = null === (t = e1.attr("class")) || void 0 === t ? void 0 : t.split(" ")) && void 0 !== n ? n : [], a = re(s, [
                    Za()
                ].concat(r));
                e1.attr("class", a.length > 0 ? a.join(" ") : null), e1.attr(oi(), null), e1.attr(ri(), null);
            };
            e1.serializer.addTempAttr(ni()), e1.serializer.addAttributeFilter(n, (e1)=>{
                for (const t of e1)o(t).each((e1)=>{
                    !1 === e1.persistent && ("span" === t.name ? t.unwrap() : r(t));
                });
            });
        })(e1, t);
        const n = ((e1, t)=>{
            const n = $a({}), o = ()=>({
                    listeners: [],
                    previous: Xa()
                }), r = (e1, t)=>{
                s(e1, (e1)=>(t(e1), e1));
            }, s = (e1, t)=>{
                const r = n.get(), s = t(xe(r, e1).getOrThunk(o));
                r[e1] = s, n.set(r);
            }, a = (t, n)=>{
                V(li(e1, t), (e1)=>{
                    n ? Jt(e1, ni(), "true") : on(e1, ni());
                });
            }, i = Ja(()=>{
                const n = ae(t.getNames());
                V(n, (t)=>{
                    s(t, (n)=>{
                        const o = n.previous.get();
                        return ai(e1, I.some(t)).fold(()=>{
                            o.each((e1)=>{
                                ((e1)=>{
                                    r(e1, (t)=>{
                                        V(t.listeners, (t)=>t(!1, e1));
                                    });
                                })(t), n.previous.clear(), a(e1, !1);
                            });
                        }, ({ uid: e1, name: t, elements: s })=>{
                            Dt(o, e1) || (o.each((e1)=>a(e1, !1)), ((e1, t, n)=>{
                                r(e1, (o)=>{
                                    V(o.listeners, (o)=>o(!0, e1, {
                                            uid: t,
                                            nodes: q(n, (e1)=>e1.dom)
                                        }));
                                });
                            })(t, e1, s), n.previous.set(e1), a(e1, !0));
                        }), {
                            previous: n.previous,
                            listeners: n.listeners
                        };
                    });
                });
            }, 30);
            return e1.on("remove", ()=>{
                i.cancel();
            }), e1.on("NodeChange", ()=>{
                i.throttle();
            }), {
                addListener: (e1, t)=>{
                    s(e1, (e1)=>({
                            previous: e1.previous,
                            listeners: e1.listeners.concat([
                                t
                            ])
                        }));
                }
            };
        })(e1, t), o = Xt("span"), r = (e1)=>{
            V(e1, (e1)=>{
                o(e1) ? Eo(e1) : ((e1)=>{
                    fn(e1, Za()), on(e1, `${ti()}`), on(e1, `${ei()}`), on(e1, `${ni()}`);
                    const t = tn(e1, `${ri()}`).map((e1)=>e1.split(",")).getOr([]), n = tn(e1, `${oi()}`).map((e1)=>e1.split(",")).getOr([]);
                    var o;
                    V(t, (t)=>on(e1, t)), o = e1, V(n, (e1)=>{
                        fn(o, e1);
                    }), on(e1, `${oi()}`), on(e1, `${ri()}`);
                })(e1);
            });
        };
        return {
            register: (e1, n)=>{
                t.register(e1, n);
            },
            annotate: (n, o)=>{
                t.lookup(n).each((t)=>{
                    ((e1, t, n, o)=>{
                        e1.undoManager.transact(()=>{
                            const r = e1.selection, s = r.getRng(), a = em(e1).length > 0, i = ui("mce-annotation");
                            if (s.collapsed && !a && ((e1, t)=>{
                                const n = Vm(e1.dom, t, [
                                    {
                                        inline: "span"
                                    }
                                ]);
                                t.setStart(n.startContainer, n.startOffset), t.setEnd(n.endContainer, n.endOffset), e1.selection.setRng(t);
                            })(e1, s), r.getRng().collapsed && !a) {
                                const s = Gm(e1.getDoc(), i, o, t, n.decorate);
                                ko(s, br), r.getRng().insertNode(s.dom), r.select(s.dom);
                            } else lm(r, !1, ()=>{
                                im(e1, (r)=>{
                                    Xm(e1, r, i, t, n.decorate, o);
                                });
                            });
                        });
                    })(e1, n, t, o);
                });
            },
            annotationChanged: (e1, t)=>{
                n.addListener(e1, t);
            },
            remove: (t)=>{
                ai(e1, I.some(t)).each(({ elements: t })=>{
                    const n = e1.selection.getBookmark();
                    r(t), e1.selection.moveToBookmark(n);
                });
            },
            removeAll: (t)=>{
                const n = e1.selection.getBookmark();
                ge(di(e1, t), (e1, t)=>{
                    r(e1);
                }), e1.selection.moveToBookmark(n);
            },
            getAll: (t)=>{
                const n = di(e1, t);
                return pe(n, (e1)=>q(e1, (e1)=>e1.dom));
            }
        };
    }, Jm = (e1)=>({
            getBookmark: T(Vu, e1),
            moveToBookmark: T(Wu, e1)
        });
    Jm.isBookmarkNode = Ku;
    const Zm = (e1, t, n)=>!n.collapsed && $(n.getClientRects(), (n)=>((e1, t, n)=>t >= e1.left && t <= e1.right && n >= e1.top && n <= e1.bottom)(n, e1, t)), ef = (e1, t, n)=>{
        e1.dispatch(t, n);
    }, tf = (e1, t, n, o)=>{
        e1.dispatch("FormatApply", {
            format: t,
            node: n,
            vars: o
        });
    }, nf = (e1, t, n, o)=>{
        e1.dispatch("FormatRemove", {
            format: t,
            node: n,
            vars: o
        });
    }, of = (e1, t)=>e1.dispatch("SetContent", t), rf = (e1, t)=>e1.dispatch("GetContent", t), sf = (e1, t)=>e1.dispatch("PastePlainTextToggle", {
            state: t
        }), af = {
        BACKSPACE: 8,
        DELETE: 46,
        DOWN: 40,
        ENTER: 13,
        ESC: 27,
        LEFT: 37,
        RIGHT: 39,
        SPACEBAR: 32,
        TAB: 9,
        UP: 38,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        modifierPressed: (e1)=>e1.shiftKey || e1.ctrlKey || e1.altKey || af.metaKeyPressed(e1),
        metaKeyPressed: (e1)=>At.os.isMacOS() || At.os.isiOS() ? e1.metaKey : e1.ctrlKey && !e1.altKey
    }, lf = "data-mce-selected", df = Math.abs, cf = Math.round, uf = {
        nw: [
            0,
            0,
            -1,
            -1
        ],
        ne: [
            1,
            0,
            1,
            -1
        ],
        se: [
            1,
            1,
            1,
            1
        ],
        sw: [
            0,
            1,
            -1,
            1
        ]
    }, mf = (e1, t)=>{
        const n = t.dom, o = t.getDoc(), r = document, s = t.getBody();
        let a, i, l, d, c, u, m, f, g, p, h, b, v, y, w;
        const x = (e1)=>C(e1) && (ir(e1) || n.is(e1, "figure.image")), E = (e1)=>mr(e1) || n.hasClass(e1, "mce-preview-object"), _ = (e1)=>{
            const n = e1.target;
            ((e1, t)=>{
                if (((e1)=>"longpress" === e1.type || 0 === e1.type.indexOf("touch"))(e1)) {
                    const n = e1.touches[0];
                    return x(e1.target) && !Zm(n.clientX, n.clientY, t);
                }
                return x(e1.target) && !Zm(e1.clientX, e1.clientY, t);
            })(e1, t.selection.getRng()) && !e1.isDefaultPrevented() && t.selection.select(n);
        }, S = (e1)=>n.hasClass(e1, "mce-preview-object") && C(e1.firstElementChild) ? [
                e1,
                e1.firstElementChild
            ] : n.is(e1, "figure.image") ? [
                e1.querySelector("img")
            ] : [
                e1
            ], k = (e1)=>{
            const o = cd(t);
            return !!o && "false" !== e1.getAttribute("data-mce-resize") && e1 !== t.getBody() && (n.hasClass(e1, "mce-preview-object") && C(e1.firstElementChild) ? xn(yn(e1.firstElementChild), o) : xn(yn(e1), o));
        }, N = (e1, o, r)=>{
            if (C(r)) {
                const s = S(e1);
                V(s, (e1)=>{
                    e1.style[o] || !t.schema.isValid(e1.nodeName.toLowerCase(), o) ? n.setStyle(e1, o, r) : n.setAttrib(e1, o, "" + r);
                });
            }
        }, R = (e1, t, n)=>{
            N(e1, "width", t), N(e1, "height", n);
        }, A = (e1)=>{
            let o, r, c, C, _;
            o = e1.screenX - u, r = e1.screenY - m, b = o * d[2] + f, v = r * d[3] + g, b = b < 5 ? 5 : b, v = v < 5 ? 5 : v, c = (x(a) || E(a)) && !1 !== ud(t) ? !af.modifierPressed(e1) : af.modifierPressed(e1), c && (df(o) > df(r) ? (v = cf(b * p), b = cf(v / p)) : (b = cf(v / p), v = cf(b * p))), R(i, b, v), C = d.startPos.x + o, _ = d.startPos.y + r, C = C > 0 ? C : 0, _ = _ > 0 ? _ : 0, n.setStyles(l, {
                left: C,
                top: _,
                display: "block"
            }), l.innerHTML = b + " &times; " + v, d[2] < 0 && i.clientWidth <= b && n.setStyle(i, "left", (void 0) + (f - b)), d[3] < 0 && i.clientHeight <= v && n.setStyle(i, "top", (void 0) + (g - v)), o = s.scrollWidth - y, r = s.scrollHeight - w, o + r !== 0 && n.setStyles(l, {
                left: C - o,
                top: _ - r
            }), h || (((e1, t, n, o, r)=>{
                e1.dispatch("ObjectResizeStart", {
                    target: t,
                    width: n,
                    height: o,
                    origin: r
                });
            })(t, a, f, g, "corner-" + d.name), h = !0);
        }, T = ()=>{
            const e1 = h;
            h = !1, e1 && (N(a, "width", b), N(a, "height", v)), n.unbind(o, "mousemove", A), n.unbind(o, "mouseup", T), r !== o && (n.unbind(r, "mousemove", A), n.unbind(r, "mouseup", T)), n.remove(i), n.remove(l), n.remove(c), O(a), e1 && (((e1, t, n, o, r)=>{
                e1.dispatch("ObjectResized", {
                    target: t,
                    width: n,
                    height: o,
                    origin: r
                });
            })(t, a, b, v, "corner-" + d.name), n.setAttrib(a, "style", n.getAttrib(a, "style"))), t.nodeChanged();
        }, O = (e1)=>{
            M();
            const h = n.getPos(e1, s), C = h.x, x = h.y, _ = e1.getBoundingClientRect(), N = _.width || _.right - _.left, O = _.height || _.bottom - _.top;
            a !== e1 && (P(), a = e1, b = v = 0);
            const B = t.dispatch("ObjectSelected", {
                target: e1
            });
            k(e1) && !B.isDefaultPrevented() ? ge(uf, (e1, t)=>{
                let h = n.get("mceResizeHandle" + t);
                h && n.remove(h), h = n.add(s, "div", {
                    id: "mceResizeHandle" + t,
                    "data-mce-bogus": "all",
                    class: "mce-resizehandle",
                    unselectable: !0,
                    style: "cursor:" + t + "-resize; margin:0; padding:0"
                }), n.bind(h, "mousedown", (h)=>{
                    h.stopImmediatePropagation(), h.preventDefault(), ((h)=>{
                        const b = S(a)[0];
                        var v;
                        u = h.screenX, m = h.screenY, f = b.clientWidth, g = b.clientHeight, p = g / f, d = e1, d.name = t, d.startPos = {
                            x: N * e1[0] + C,
                            y: O * e1[1] + x
                        }, y = s.scrollWidth, w = s.scrollHeight, c = n.add(s, "div", {
                            class: "mce-resize-backdrop",
                            "data-mce-bogus": "all"
                        }), n.setStyles(c, {
                            position: "fixed",
                            left: "0",
                            top: "0",
                            width: "100%",
                            height: "100%"
                        }), i = E(v = a) ? n.create("img", {
                            src: At.transparentSrc
                        }) : v.cloneNode(!0), n.addClass(i, "mce-clonedresizable"), n.setAttrib(i, "data-mce-bogus", "all"), i.contentEditable = "false", n.setStyles(i, {
                            left: C,
                            top: x,
                            margin: 0
                        }), R(i, N, O), i.removeAttribute(lf), s.appendChild(i), n.bind(o, "mousemove", A), n.bind(o, "mouseup", T), r !== o && (n.bind(r, "mousemove", A), n.bind(r, "mouseup", T)), l = n.add(s, "div", {
                            class: "mce-resize-helper",
                            "data-mce-bogus": "all"
                        }, f + " &times; " + g);
                    })(h);
                }), e1.elm = h, n.setStyles(h, {
                    left: N * e1[0] + C - h.offsetWidth / 2,
                    top: O * e1[1] + x - h.offsetHeight / 2
                });
            }) : P(!1);
        }, B = Qa(O, 0), P = (e1 = !0)=>{
            B.cancel(), M(), a && e1 && a.removeAttribute(lf), ge(uf, (e1, t)=>{
                const o = n.get("mceResizeHandle" + t);
                o && (n.unbind(o), n.remove(o));
            });
        }, D = (e1, t)=>n.isChildOf(e1, t), L = (o)=>{
            if (h || t.removed || t.composing) return;
            const r = "mousedown" === o.type ? o.target : e1.getNode(), a = no(yn(r), "table,img,figure.image,hr,video,span.mce-preview-object,details").map((e1)=>e1.dom).filter((e1)=>n.isEditable(e1.parentElement) || "IMG" === e1.nodeName && n.isEditable(e1)).getOrUndefined(), i = C(a) ? n.getAttrib(a, lf, "1") : "1";
            if (V(n.select(`img[${lf}],hr[${lf}]`), (e1)=>{
                e1.removeAttribute(lf);
            }), C(a) && D(a, s) && t.hasFocus()) {
                I();
                const t = e1.getStart(!0);
                if (D(t, a) && D(e1.getEnd(!0), a)) return n.setAttrib(a, lf, i), void B.throttle(a);
            }
            P();
        }, M = ()=>{
            ge(uf, (e1)=>{
                e1.elm && (n.unbind(e1.elm), delete e1.elm);
            });
        }, I = ()=>{
            try {
                t.getDoc().execCommand("enableObjectResizing", !1, "false");
            } catch (e1) {}
        };
        return t.on("init", ()=>{
            I(), t.on("NodeChange ResizeEditor ResizeWindow ResizeContent drop", L), t.on("keyup compositionend", (e1)=>{
                a && "TABLE" === a.nodeName && L(e1);
            }), t.on("hide blur", P), t.on("contextmenu longpress", _, !0);
        }), t.on("remove", M), {
            isResizable: k,
            showResizeRect: O,
            hideResizeRect: P,
            updateResizeRect: L,
            destroy: ()=>{
                B.cancel(), a = i = c = null;
            }
        };
    }, ff = (e1, t, n)=>{
        const o = e1.document.createRange();
        var r;
        return r = o, t.fold((e1)=>{
            r.setStartBefore(e1.dom);
        }, (e1, t)=>{
            r.setStart(e1.dom, t);
        }, (e1)=>{
            r.setStartAfter(e1.dom);
        }), ((e1, t)=>{
            t.fold((t)=>{
                e1.setEndBefore(t.dom);
            }, (t, n)=>{
                e1.setEnd(t.dom, n);
            }, (t)=>{
                e1.setEndAfter(t.dom);
            });
        })(o, n), o;
    }, gf = (e1, t, n, o, r)=>{
        const s = e1.document.createRange();
        return s.setStart(t.dom, n), s.setEnd(o.dom, r), s;
    }, pf = hl([
        {
            ltr: [
                "start",
                "soffset",
                "finish",
                "foffset"
            ]
        },
        {
            rtl: [
                "start",
                "soffset",
                "finish",
                "foffset"
            ]
        }
    ]), hf = (e1, t, n)=>t(yn(n.startContainer), n.startOffset, yn(n.endContainer), n.endOffset);
    pf.ltr, pf.rtl;
    const bf = (e1, t, n, o)=>({
            start: e1,
            soffset: t,
            finish: n,
            foffset: o
        }), vf = document.caretPositionFromPoint ? (e1, t, n)=>{
        var o, r;
        return I.from(null === (r = (o = e1.dom).caretPositionFromPoint) || void 0 === r ? void 0 : r.call(o, t, n)).bind((t)=>{
            if (null === t.offsetNode) return I.none();
            const n = e1.dom.createRange();
            return n.setStart(t.offsetNode, t.offset), n.collapse(), I.some(n);
        });
    } : document.caretRangeFromPoint ? (e1, t, n)=>{
        var o, r;
        return I.from(null === (r = (o = e1.dom).caretRangeFromPoint) || void 0 === r ? void 0 : r.call(o, t, n));
    } : I.none, yf = hl([
        {
            before: [
                "element"
            ]
        },
        {
            on: [
                "element",
                "offset"
            ]
        },
        {
            after: [
                "element"
            ]
        }
    ]), Cf = {
        before: yf.before,
        on: yf.on,
        after: yf.after,
        cata: (e1, t, n, o)=>e1.fold(t, n, o),
        getStart: (e1)=>e1.fold(R, R, R)
    }, wf = hl([
        {
            domRange: [
                "rng"
            ]
        },
        {
            relative: [
                "startSitu",
                "finishSitu"
            ]
        },
        {
            exact: [
                "start",
                "soffset",
                "finish",
                "foffset"
            ]
        }
    ]), xf = {
        domRange: wf.domRange,
        relative: wf.relative,
        exact: wf.exact,
        exactFromRange: (e1)=>wf.exact(e1.start, e1.soffset, e1.finish, e1.foffset),
        getWin: (e1)=>{
            const t = ((e1)=>e1.match({
                    domRange: (e1)=>yn(e1.startContainer),
                    relative: (e1, t)=>Cf.getStart(e1),
                    exact: (e1, t, n, o)=>e1
                }))(e1);
            return Rn(t);
        },
        range: bf
    }, Ef = (e1, t)=>{
        const n = Ht(e1);
        return "input" === n ? Cf.after(e1) : H([
            "br",
            "img"
        ], n) ? 0 === t ? Cf.before(e1) : Cf.after(e1) : Cf.on(e1, t);
    }, _f = (e1, t)=>{
        const n = e1.fold(Cf.before, Ef, Cf.after), o = t.fold(Cf.before, Ef, Cf.after);
        return xf.relative(n, o);
    }, Sf = (e1, t, n, o)=>{
        const r = Ef(e1, t), s = Ef(n, o);
        return xf.relative(r, s);
    }, kf = (e1, t)=>{
        const n = (t || document).createDocumentFragment();
        return V(e1, (e1)=>{
            n.appendChild(e1.dom);
        }), yn(n);
    }, Nf = (e1)=>{
        const t = xf.getWin(e1).dom, n = (e1, n, o, r)=>gf(t, e1, n, o, r), o = ((e1)=>e1.match({
                domRange: (e1)=>{
                    const t = yn(e1.startContainer), n = yn(e1.endContainer);
                    return Sf(t, e1.startOffset, n, e1.endOffset);
                },
                relative: _f,
                exact: Sf
            }))(e1);
        return ((e1, t)=>{
            const n = ((e1, t)=>t.match({
                    domRange: (e1)=>({
                            ltr: N(e1),
                            rtl: I.none
                        }),
                    relative: (t, n)=>({
                            ltr: De(()=>ff(e1, t, n)),
                            rtl: De(()=>I.some(ff(e1, n, t)))
                        }),
                    exact: (t, n, o, r)=>({
                            ltr: De(()=>gf(e1, t, n, o, r)),
                            rtl: De(()=>I.some(gf(e1, o, r, t, n)))
                        })
                }))(e1, t);
            return ((e1, t)=>{
                const n = t.ltr();
                return n.collapsed ? t.rtl().filter((e1)=>!1 === e1.collapsed).map((e1)=>pf.rtl(yn(e1.endContainer), e1.endOffset, yn(e1.startContainer), e1.startOffset)).getOrThunk(()=>hf(0, pf.ltr, n)) : hf(0, pf.ltr, n);
            })(0, n);
        })(t, o).match({
            ltr: n,
            rtl: n
        });
    }, Rf = (e1, t, n)=>((e1, t, n)=>((e1, t, n)=>{
                const o = yn(e1.document);
                return vf(o, t, n).map((e1)=>bf(yn(e1.startContainer), e1.startOffset, yn(e1.endContainer), e1.endOffset));
            })(e1, t, n))(Rn(yn(n)).dom, e1, t).map((e1)=>{
            const t = n.createRange();
            return t.setStart(e1.start.dom, e1.soffset), t.setEnd(e1.finish.dom, e1.foffset), t;
        }).getOrUndefined(), Af = (e1, t)=>C(e1) && C(t) && e1.startContainer === t.startContainer && e1.startOffset === t.startOffset && e1.endContainer === t.endContainer && e1.endOffset === t.endOffset, Tf = (e1, t, n)=>null !== ((e1, t, n)=>{
            let o = e1;
            for(; o && o !== t;){
                if (n(o)) return o;
                o = o.parentNode;
            }
            return null;
        })(e1, t, n), Of = (e1, t, n)=>Tf(e1, t, (e1)=>e1.nodeName === n), Bf = (e1, t)=>Ur(e1) && !Tf(e1, t, Du), Pf = (e1, t, n)=>{
        const o = t.parentNode;
        if (o) {
            const r = new jo(t, e1.getParent(o, e1.isBlock) || e1.getRoot());
            let s;
            for(; s = r[n ? "prev" : "next"]();)if (ar(s)) return !0;
        }
        return !1;
    }, Df = (e1, t, n, o, r)=>{
        const s = e1.getRoot(), a = e1.schema.getNonEmptyElements(), i = r.parentNode;
        let l, d;
        if (!i) return I.none();
        const c = e1.getParent(i, e1.isBlock) || s;
        if (o && ar(r) && t && e1.isEmpty(c)) return I.some(Vi(i, e1.nodeIndex(r)));
        const u = new jo(r, c);
        for(; d = u[o ? "prev" : "next"]();){
            if ("false" === e1.getContentEditableParent(d) || Bf(d, s)) return I.none();
            if (er(d) && d.data.length > 0) return Of(d, s, "A") ? I.none() : I.some(Vi(d, o ? d.data.length : 0));
            if (e1.isBlock(d) || a[d.nodeName.toLowerCase()]) return I.none();
            l = d;
        }
        return or(l) ? I.none() : n && l ? I.some(Vi(l, 0)) : I.none();
    }, Lf = (e1, t, n, o)=>{
        const r = e1.getRoot();
        let s, a = !1, i = n ? o.startContainer : o.endContainer, l = n ? o.startOffset : o.endOffset;
        const d = qo(i) && l === i.childNodes.length, c = e1.schema.getNonEmptyElements();
        let u = n;
        if (Ur(i)) return I.none();
        if (qo(i) && l > i.childNodes.length - 1 && (u = !1), rr(i) && (i = r, l = 0), i === r) {
            if (u && (s = i.childNodes[l > 0 ? l - 1 : 0], s)) {
                if (Ur(s)) return I.none();
                if (c[s.nodeName] || Qo(s)) return I.none();
            }
            if (i.hasChildNodes()) {
                if (l = Math.min(!u && l > 0 ? l - 1 : l, i.childNodes.length - 1), i = i.childNodes[l], l = er(i) && d ? i.data.length : 0, !t && i === r.lastChild && Qo(i)) return I.none();
                if (((e1, t)=>{
                    let n = t;
                    for(; n && n !== e1;){
                        if (dr(n)) return !0;
                        n = n.parentNode;
                    }
                    return !1;
                })(r, i) || Ur(i)) return I.none();
                if (gr(i)) return I.none();
                if (i.hasChildNodes() && !Qo(i)) {
                    s = i;
                    const t = new jo(i, r);
                    do {
                        if (dr(s) || Ur(s)) {
                            a = !1;
                            break;
                        }
                        if (er(s) && s.data.length > 0) {
                            l = u ? 0 : s.data.length, i = s, a = !0;
                            break;
                        }
                        if (c[s.nodeName.toLowerCase()] && !ur(s)) {
                            l = e1.nodeIndex(s), i = s.parentNode, u || l++, a = !0;
                            break;
                        }
                    }while (s = u ? t.next() : t.prev());
                }
            }
        }
        return t && (er(i) && 0 === l && Df(e1, d, t, !0, i).each((e1)=>{
            i = e1.container(), l = e1.offset(), a = !0;
        }), qo(i) && (s = i.childNodes[l], s || (s = i.childNodes[l - 1]), !s || !ar(s) || ((e1, t)=>{
            var n;
            return "A" === (null === (n = e1.previousSibling) || void 0 === n ? void 0 : n.nodeName);
        })(s) || Pf(e1, s, !1) || Pf(e1, s, !0) || Df(e1, d, t, !0, s).each((e1)=>{
            i = e1.container(), l = e1.offset(), a = !0;
        }))), u && !t && er(i) && l === i.data.length && Df(e1, d, t, !1, i).each((e1)=>{
            i = e1.container(), l = e1.offset(), a = !0;
        }), a && i ? I.some(Vi(i, l)) : I.none();
    }, Mf = (e1, t)=>{
        const n = t.collapsed, o = t.cloneRange(), r = Vi.fromRangeStart(t);
        return Lf(e1, n, !0, o).each((e1)=>{
            n && Vi.isAbove(r, e1) || o.setStart(e1.container(), e1.offset());
        }), n || Lf(e1, n, !1, o).each((e1)=>{
            o.setEnd(e1.container(), e1.offset());
        }), n && o.collapse(!0), Af(t, o) ? I.none() : I.some(o);
    }, If = (e1, t)=>e1.splitText(t), Ff = (e1)=>{
        let t = e1.startContainer, n = e1.startOffset, o = e1.endContainer, r = e1.endOffset;
        if (t === o && er(t)) {
            if (n > 0 && n < t.data.length) {
                if (o = If(t, n), t = o.previousSibling, r > n) {
                    r -= n;
                    const e1 = If(o, r).previousSibling;
                    t = o = e1, r = e1.data.length, n = 0;
                } else r = 0;
            }
        } else if (er(t) && n > 0 && n < t.data.length && (t = If(t, n), n = 0), er(o) && r > 0 && r < o.data.length) {
            const e1 = If(o, r).previousSibling;
            o = e1, r = e1.data.length;
        }
        return {
            startContainer: t,
            startOffset: n,
            endContainer: o,
            endOffset: r
        };
    }, Uf = (e1)=>({
            walk: (t, n)=>Wm(e1, t, n),
            split: Ff,
            expand: (t, n = {
                type: "word"
            })=>{
                if ("word" === n.type) {
                    const n = Vm(e1, t, [
                        {
                            inline: "span"
                        }
                    ]), o = e1.createRng();
                    return o.setStart(n.startContainer, n.startOffset), o.setEnd(n.endContainer, n.endOffset), o;
                }
                return t;
            },
            normalize: (t)=>Mf(e1, t).fold(L, (e1)=>(t.setStart(e1.startContainer, e1.startOffset), t.setEnd(e1.endContainer, e1.endOffset), !0))
        });
    Uf.compareRanges = Af, Uf.getCaretRangeFromPoint = Rf, Uf.getSelectedNode = _i, Uf.getNode = Si;
    const zf = ((e1, t)=>{
        const n = (t)=>{
            const n = ((e1)=>{
                const t = e1.dom;
                return Gn(e1) ? t.getBoundingClientRect().height : t.offsetHeight;
            })(t);
            if (n <= 0 || null === n) {
                const n = co(t, e1);
                return parseFloat(n) || 0;
            }
            return n;
        }, o = (e1, t)=>X(t, (t, n)=>{
                const o = co(e1, n), r = void 0 === o ? 0 : parseInt(o, 10);
                return isNaN(r) ? t : t + r;
            }, 0);
        return {
            set: (t, n)=>{
                if (!x(n) && !n.match(/^[0-9]+$/)) throw new Error(e1 + ".set accepts only positive integer values. Value was " + n);
                const o = t.dom;
                so(o) && (o.style[e1] = n + "px");
            },
            get: n,
            getOuter: n,
            aggregate: o,
            max: (e1, t, n)=>{
                const r = o(e1, n);
                return t > r ? t - r : 0;
            }
        };
    })("height"), jf = ()=>yn(document), Hf = (e1, t)=>e1.view(t).fold(N([]), (t)=>{
            const n = e1.owner(t), o = Hf(e1, n);
            return [
                t
            ].concat(o);
        });
    var $f = Object.freeze({
        __proto__: null,
        view: (e1)=>{
            var t;
            return (e1.dom === document ? I.none() : I.from(null === (t = e1.dom.defaultView) || void 0 === t ? void 0 : t.frameElement)).map(yn);
        },
        owner: (e1)=>Nn(e1)
    });
    const qf = (e1)=>"textarea" === Ht(e1), Vf = (e1, t)=>{
        const n = ((e1)=>{
            const t = e1.dom.ownerDocument, n = t.body, o = t.defaultView, r = t.documentElement;
            if (n === e1.dom) return To(n.offsetLeft, n.offsetTop);
            const s = Oo(null == o ? void 0 : o.pageYOffset, r.scrollTop), a = Oo(null == o ? void 0 : o.pageXOffset, r.scrollLeft), i = Oo(r.clientTop, n.clientTop), l = Oo(r.clientLeft, n.clientLeft);
            return Bo(e1).translate(a - l, s - i);
        })(e1), o = ((e1)=>zf.get(e1))(e1);
        return {
            element: e1,
            bottom: n.top + o,
            height: o,
            pos: n,
            cleanup: t
        };
    }, Wf = (e1, t, n, o)=>{
        Xf(e1, (r, s)=>Yf(e1, t, n, o), n);
    }, Kf = (e1, t, n, o, r)=>{
        const s = {
            elm: o.element.dom,
            alignToTop: r
        };
        ((e1, t)=>e1.dispatch("ScrollIntoView", t).isDefaultPrevented())(e1, s) || (n(e1, t, Po(t).top, o, r), ((e1, t)=>{
            e1.dispatch("AfterScrollIntoView", t);
        })(e1, s));
    }, Yf = (e1, t, n, o)=>{
        const r = yn(e1.getBody()), s = yn(e1.getDoc());
        r.dom.offsetWidth;
        const a = ((e1, t)=>{
            const n = ((e1, t)=>{
                const n = Mn(e1);
                if (0 === n.length || qf(e1)) return {
                    element: e1,
                    offset: t
                };
                if (t < n.length && !qf(n[t])) return {
                    element: n[t],
                    offset: 0
                };
                {
                    const o = n[n.length - 1];
                    return qf(o) ? {
                        element: e1,
                        offset: t
                    } : "img" === Ht(o) ? {
                        element: o,
                        offset: 1
                    } : Kt(o) ? {
                        element: o,
                        offset: Cr(o).length
                    } : {
                        element: o,
                        offset: Mn(o).length
                    };
                }
            })(e1, t), o = hn('<span data-mce-bogus="all" style="display: inline-block;">\ufeff</span>');
            return po(n.element, o), Vf(o, ()=>xo(o));
        })(yn(n.startContainer), n.startOffset);
        Kf(e1, s, t, a, o), a.cleanup();
    }, Gf = (e1, t, n, o)=>{
        const r = yn(e1.getDoc());
        Kf(e1, r, n, ((e1)=>Vf(yn(e1), _))(t), o);
    }, Xf = (e1, t, n)=>{
        const o = n.startContainer, r = n.startOffset, s = n.endContainer, a = n.endOffset;
        t(yn(o), yn(s));
        const i = e1.dom.createRng();
        i.setStart(o, r), i.setEnd(s, a), e1.selection.setRng(n);
    }, Qf = (e1, t, n, o, r)=>{
        const s = t.pos;
        if (o) Do(s.left, s.top, r);
        else {
            const o = s.top - n + t.height;
            Do(-e1.getBody().getBoundingClientRect().left, o, r);
        }
    }, Jf = (e1, t, n, o, r, s)=>{
        const a = o + n, i = r.pos.top, l = r.bottom, d = l - i >= o;
        i < n ? Qf(e1, r, o, !1 !== s, t) : i > a ? Qf(e1, r, o, d ? !1 !== s : !0 === s, t) : l > a && !d && Qf(e1, r, o, !0 === s, t);
    }, Zf = (e1, t, n, o, r)=>{
        const s = Rn(t).dom.innerHeight;
        Jf(e1, t, n, s, o, r);
    }, eg = (e1, t, n, o, r)=>{
        const s = Rn(t).dom.innerHeight;
        Jf(e1, t, n, s, o, r);
        const a = ((e1)=>{
            const t = jf(), n = Po(t), o = ((e1, t)=>{
                const n = t.owner(e1);
                return Hf(t, n);
            })(e1, $f), r = Bo(e1), s = G(o, (e1, t)=>{
                const n = Bo(t);
                return {
                    left: e1.left + n.left,
                    top: e1.top + n.top
                };
            }, {
                left: 0,
                top: 0
            });
            return To(s.left + r.left + n.left, s.top + r.top + n.top);
        })(o.element), i = Io(window);
        a.top < i.y ? Lo(o.element, !1 !== r) : a.top > i.bottom && Lo(o.element, !0 === r);
    }, tg = (e1, t, n)=>Wf(e1, Zf, t, n), ng = (e1, t, n)=>Gf(e1, t, Zf, n), og = (e1, t, n)=>Wf(e1, eg, t, n), rg = (e1, t, n)=>Gf(e1, t, eg, n), sg = (e1, t, n)=>{
        (e1.inline ? tg : og)(e1, t, n);
    }, ag = (e1, t = !1)=>e1.dom.focus({
            preventScroll: t
        }), ig = (e1)=>{
        const t = qn(e1).dom;
        return e1.dom === t.activeElement;
    }, lg = (e1 = jf())=>I.from(e1.dom.activeElement).map(yn), dg = (e1, t)=>{
        const n = Kt(t) ? Cr(t).length : Mn(t).length + 1;
        return e1 > n ? n : e1 < 0 ? 0 : e1;
    }, cg = (e1)=>xf.range(e1.start, dg(e1.soffset, e1.start), e1.finish, dg(e1.foffset, e1.finish)), ug = (e1, t)=>!$o(t.dom) && (Sn(e1, t) || _n(e1, t)), mg = (e1)=>(t)=>ug(e1, t.start) && ug(e1, t.finish), fg = (e1)=>xf.range(yn(e1.startContainer), e1.startOffset, yn(e1.endContainer), e1.endOffset), gg = (e1)=>{
        const t = document.createRange();
        try {
            return t.setStart(e1.start.dom, e1.soffset), t.setEnd(e1.finish.dom, e1.foffset), I.some(t);
        } catch (e1) {
            return I.none();
        }
    }, pg = (e1)=>{
        const t = ((e1)=>e1.inline || At.browser.isFirefox())(e1) ? (n = yn(e1.getBody()), ((e1)=>{
            const t = e1.getSelection();
            return (t && 0 !== t.rangeCount ? I.from(t.getRangeAt(0)) : I.none()).map(fg);
        })(Rn(n).dom).filter(mg(n))) : I.none();
        var n;
        e1.bookmark = t.isSome() ? t : e1.bookmark;
    }, hg = (e1)=>(e1.bookmark ? e1.bookmark : I.none()).bind((t)=>{
            var n, o;
            return n = yn(e1.getBody()), o = t, I.from(o).filter(mg(n)).map(cg);
        }).bind(gg), bg = {
        isEditorUIElement: (e1)=>{
            const t = e1.className.toString();
            return -1 !== t.indexOf("tox-") || -1 !== t.indexOf("mce-");
        }
    }, vg = {
        setEditorTimeout: (e1, t, n)=>((e1, t)=>(x(t) || (t = 0), setTimeout(e1, t)))(()=>{
                e1.removed || t();
            }, n),
        setEditorInterval: (e1, t, n)=>{
            const o = ((e1, t)=>(x(t) || (t = 0), setInterval(e1, t)))(()=>{
                e1.removed ? clearInterval(o) : t();
            }, n);
            return o;
        }
    };
    let yg;
    const Cg = za.DOM, wg = (e1)=>{
        const t = e1.classList;
        return void 0 !== t && (t.contains("tox-edit-area") || t.contains("tox-edit-area__iframe") || t.contains("mce-content-body"));
    }, xg = (e1, t)=>{
        const n = _d(e1), o = Cg.getParent(t, (t)=>((e1)=>qo(e1) && bg.isEditorUIElement(e1))(t) || !!n && e1.dom.is(t, n));
        return null !== o;
    }, Eg = (e1)=>{
        try {
            const t = qn(yn(e1.getElement()));
            return lg(t).fold(()=>document.body, (e1)=>e1.dom);
        } catch (e1) {
            return document.body;
        }
    }, _g = (e1, t)=>{
        const n = t.editor;
        ((e1)=>{
            const t = Qa(()=>{
                pg(e1);
            }, 0);
            e1.on("init", ()=>{
                e1.inline && ((e1, t)=>{
                    const n = ()=>{
                        t.throttle();
                    };
                    za.DOM.bind(document, "mouseup", n), e1.on("remove", ()=>{
                        za.DOM.unbind(document, "mouseup", n);
                    });
                })(e1, t), ((e1, t)=>{
                    ((e1, t)=>{
                        e1.on("mouseup touchend", (e1)=>{
                            t.throttle();
                        });
                    })(e1, t), e1.on("keyup NodeChange AfterSetSelectionRange", (t)=>{
                        ((e1)=>"nodechange" === e1.type && e1.selectionChange)(t) || pg(e1);
                    });
                })(e1, t);
            }), e1.on("remove", ()=>{
                t.cancel();
            });
        })(n);
        const o = (e1, t)=>{
            mc(e1) && !0 !== e1.inline && t(yn(e1.getContainer()), "tox-edit-focus");
        };
        n.on("focusin", ()=>{
            const t = e1.focusedEditor;
            wg(Eg(n)) && o(n, un), t !== n && (t && t.dispatch("blur", {
                focusedEditor: n
            }), e1.setActive(n), e1.focusedEditor = n, n.dispatch("focus", {
                blurredEditor: t
            }), n.focus(!0));
        }), n.on("focusout", ()=>{
            vg.setEditorTimeout(n, ()=>{
                const t = e1.focusedEditor;
                wg(Eg(n)) && t === n || o(n, fn), xg(n, Eg(n)) || t !== n || (n.dispatch("blur", {
                    focusedEditor: null
                }), e1.focusedEditor = null);
            });
        }), yg || (yg = (t)=>{
            const n = e1.activeEditor;
            n && Kn(t).each((t)=>{
                const o = t;
                o.ownerDocument === document && (o === document.body || xg(n, o) || e1.focusedEditor !== n || (n.dispatch("blur", {
                    focusedEditor: null
                }), e1.focusedEditor = null));
            });
        }, Cg.bind(document, "focusin", yg));
    }, Sg = (e1, t)=>{
        e1.focusedEditor === t.editor && (e1.focusedEditor = null), !e1.activeEditor && yg && (Cg.unbind(document, "focusin", yg), yg = null);
    }, kg = (e1, t)=>{
        ((e1, t)=>((e1)=>e1.collapsed ? I.from(Si(e1.startContainer, e1.startOffset)).map(yn) : I.none())(t).bind((t)=>Nr(t) ? I.some(t) : Sn(e1, t) ? I.none() : I.some(e1)))(yn(e1.getBody()), t).bind((e1)=>Ou(e1.dom)).fold(()=>{
            e1.selection.normalize();
        }, (t)=>e1.selection.setRng(t.toRange()));
    }, Ng = (e1)=>{
        if (e1.setActive) try {
            e1.setActive();
        } catch (t) {
            e1.focus();
        }
        else e1.focus();
    }, Rg = (e1)=>e1.inline ? ((e1)=>{
            const t = e1.getBody();
            var n, o;
            return t && (n = yn(t), ig(n) || (o = n, lg(qn(o)).filter((e1)=>o.dom.contains(e1.dom))).isSome());
        })(e1) : ((e1)=>C(e1.iframeElement) && ig(yn(e1.iframeElement)))(e1), Ag = (e1)=>Rg(e1) || ((e1)=>{
            const t = qn(yn(e1.getElement()));
            return lg(t).filter((t)=>!wg(t.dom) && xg(e1, t.dom)).isSome();
        })(e1), Tg = (e1)=>e1.editorManager.setActive(e1), Og = (e1, t)=>t.collapsed ? e1.isEditable(t.startContainer) : e1.isEditable(t.startContainer) && e1.isEditable(t.endContainer), Bg = (e1, t, n, o, r)=>{
        const s = n ? t.startContainer : t.endContainer, a = n ? t.startOffset : t.endOffset;
        return I.from(s).map(yn).map((e1)=>o && t.collapsed ? e1 : In(e1, r(e1, a)).getOr(e1)).bind((e1)=>Wt(e1) ? I.some(e1) : An(e1).filter(Wt)).map((e1)=>e1.dom).getOr(e1);
    }, Pg = (e1, t, n = !1)=>Bg(e1, t, !0, n, (e1, t)=>Math.min(zn(e1), t)), Dg = (e1, t, n = !1)=>Bg(e1, t, !1, n, (e1, t)=>t > 0 ? t - 1 : t), Lg = (e1, t)=>{
        const n = e1;
        for(; e1 && er(e1) && 0 === e1.length;)e1 = t ? e1.nextSibling : e1.previousSibling;
        return e1 || n;
    }, Mg = (e1, t)=>q(t, (t)=>{
            const n = e1.dispatch("GetSelectionRange", {
                range: t
            });
            return n.range !== t ? n.range : t;
        }), Ig = [
        "img",
        "br"
    ], Fg = (e1)=>{
        const t = wr(e1).filter((e1)=>0 !== e1.trim().length || e1.indexOf(br) > -1).isSome();
        return t || H(Ig, Ht(e1)) || ((e1)=>Vt(e1) && "false" === en(e1, "contenteditable"))(e1);
    }, Ug = "[data-mce-autocompleter]", zg = (e1, t)=>{
        if (jg(yn(e1.getBody())).isNone()) {
            const o = hn('<span data-mce-autocompleter="1" data-mce-bogus="1"></span>', e1.getDoc());
            vo(o, yn(t.extractContents())), t.insertNode(o.dom), An(o).each((e1)=>e1.dom.normalize()), (n = o, ((e1, t)=>{
                const n = (e1)=>{
                    const o = Mn(e1);
                    for(let e1 = o.length - 1; e1 >= 0; e1--){
                        const r = o[e1];
                        if (t(r)) return I.some(r);
                        const s = n(r);
                        if (s.isSome()) return s;
                    }
                    return I.none();
                };
                return n(e1);
            })(n, Fg)).map((t)=>{
                e1.selection.setCursorLocation(t.dom, ((e1)=>"img" === Ht(e1) ? 1 : wr(e1).fold(()=>Mn(e1).length, (e1)=>e1.length))(t));
            });
        }
        var n;
    }, jg = (e1)=>to(e1, Ug), Hg = {
        "#text": 3,
        "#comment": 8,
        "#cdata": 4,
        "#pi": 7,
        "#doctype": 10,
        "#document-fragment": 11
    }, $g = (e1, t, n)=>{
        const o = n ? "lastChild" : "firstChild", r = n ? "prev" : "next";
        if (e1[o]) return e1[o];
        if (e1 !== t) {
            let n = e1[r];
            if (n) return n;
            for(let o = e1.parent; o && o !== t; o = o.parent)if (n = o[r], n) return n;
        }
    }, qg = (e1)=>{
        var t;
        const n = null !== (t = e1.value) && void 0 !== t ? t : "";
        if (!ss(n)) return !1;
        const o = e1.parent;
        return !o || "span" === o.name && !o.attr("style") || !/^[ ]+$/.test(n);
    }, Vg = (e1)=>{
        const t = "a" === e1.name && !e1.attr("href") && e1.attr("id");
        return e1.attr("name") || e1.attr("id") && !e1.firstChild || e1.attr("data-mce-bookmark") || t;
    };
    class Wg {
        static create(e1, t) {
            const n = new Wg(e1, Hg[e1] || 1);
            return t && ge(t, (e1, t)=>{
                n.attr(t, e1);
            }), n;
        }
        constructor(e1, t){
            this.name = e1, this.type = t, 1 === t && (this.attributes = [], this.attributes.map = {});
        }
        replace(e1) {
            const t = this;
            return e1.parent && e1.remove(), t.insert(e1, t), t.remove(), t;
        }
        attr(e1, t) {
            const n = this;
            if (!m(e1)) return C(e1) && ge(e1, (e1, t)=>{
                n.attr(t, e1);
            }), n;
            const o = n.attributes;
            if (o) {
                if (void 0 !== t) {
                    if (null === t) {
                        if (e1 in o.map) {
                            delete o.map[e1];
                            let t = o.length;
                            for(; t--;)if (o[t].name === e1) return o.splice(t, 1), n;
                        }
                        return n;
                    }
                    if (e1 in o.map) {
                        let n = o.length;
                        for(; n--;)if (o[n].name === e1) {
                            o[n].value = t;
                            break;
                        }
                    } else o.push({
                        name: e1,
                        value: t
                    });
                    return o.map[e1] = t, n;
                }
                return o.map[e1];
            }
        }
        clone() {
            const e1 = this, t = new Wg(e1.name, e1.type), n = e1.attributes;
            if (n) {
                const e1 = [];
                e1.map = {};
                for(let t = 0, o = n.length; t < o; t++){
                    const o = n[t];
                    "id" !== o.name && (e1[e1.length] = {
                        name: o.name,
                        value: o.value
                    }, e1.map[o.name] = o.value);
                }
                t.attributes = e1;
            }
            return t.value = e1.value, t;
        }
        wrap(e1) {
            const t = this;
            return t.parent && (t.parent.insert(e1, t), e1.append(t)), t;
        }
        unwrap() {
            const e1 = this;
            for(let t = e1.firstChild; t;){
                const n = t.next;
                e1.insert(t, e1, !0), t = n;
            }
            e1.remove();
        }
        remove() {
            const e1 = this, t = e1.parent, n = e1.next, o = e1.prev;
            return t && (t.firstChild === e1 ? (t.firstChild = n, n && (n.prev = null)) : o && (o.next = n), t.lastChild === e1 ? (t.lastChild = o, o && (o.next = null)) : n && (n.prev = o), e1.parent = e1.next = e1.prev = null), e1;
        }
        append(e1) {
            const t = this;
            e1.parent && e1.remove();
            const n = t.lastChild;
            return n ? (n.next = e1, e1.prev = n, t.lastChild = e1) : t.lastChild = t.firstChild = e1, e1.parent = t, e1;
        }
        insert(e1, t, n) {
            e1.parent && e1.remove();
            const o = t.parent || this;
            return n ? (t === o.firstChild ? o.firstChild = e1 : t.prev && (t.prev.next = e1), e1.prev = t.prev, e1.next = t, t.prev = e1) : (t === o.lastChild ? o.lastChild = e1 : t.next && (t.next.prev = e1), e1.next = t.next, e1.prev = t, t.next = e1), e1.parent = o, e1;
        }
        getAll(e1) {
            const t = this, n = [];
            for(let o = t.firstChild; o; o = $g(o, t))o.name === e1 && n.push(o);
            return n;
        }
        children() {
            const e1 = [];
            for(let t = this.firstChild; t; t = t.next)e1.push(t);
            return e1;
        }
        empty() {
            const e1 = this;
            if (e1.firstChild) {
                const t = [];
                for(let n = e1.firstChild; n; n = $g(n, e1))t.push(n);
                let n = t.length;
                for(; n--;){
                    const e1 = t[n];
                    e1.parent = e1.firstChild = e1.lastChild = e1.next = e1.prev = null;
                }
            }
            return e1.firstChild = e1.lastChild = null, e1;
        }
        isEmpty(e1, t = {}, n) {
            var o;
            const r = this;
            let s = r.firstChild;
            if (Vg(r)) return !1;
            if (s) do {
                if (1 === s.type) {
                    if (s.attr("data-mce-bogus")) continue;
                    if (e1[s.name]) return !1;
                    if (Vg(s)) return !1;
                }
                if (8 === s.type) return !1;
                if (3 === s.type && !qg(s)) return !1;
                if (3 === s.type && s.parent && t[s.parent.name] && ss(null !== (o = s.value) && void 0 !== o ? o : "")) return !1;
                if (n && n(s)) return !1;
            }while (s = $g(s, r));
            return !0;
        }
        walk(e1) {
            return $g(this, null, e1);
        }
    }
    const Kg = Pt.makeMap("NOSCRIPT STYLE SCRIPT XMP IFRAME NOEMBED NOFRAMES PLAINTEXT", " "), Yg = (e1)=>m(e1.nodeValue) && e1.nodeValue.includes(Br), Gg = (e1)=>(0 === e1.length ? "" : `${q(e1, (e1)=>`[${e1}]`).join(",")},`) + '[data-mce-bogus="all"]', Xg = (e1)=>document.createTreeWalker(e1, NodeFilter.SHOW_COMMENT, (e1)=>Yg(e1) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP), Qg = (e1)=>document.createTreeWalker(e1, NodeFilter.SHOW_TEXT, (e1)=>{
            if (Yg(e1)) {
                const t = e1.parentNode;
                return t && Ee(Kg, t.nodeName) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
            }
            return NodeFilter.FILTER_SKIP;
        }), Jg = (e1)=>null !== Xg(e1).nextNode(), Zg = (e1)=>null !== Qg(e1).nextNode(), ep = (e1, t)=>null !== t.querySelector(Gg(e1)), tp = (e1, t)=>{
        V(((e1, t)=>t.querySelectorAll(Gg(e1)))(e1, t), (t)=>{
            const n = yn(t);
            "all" === en(n, "data-mce-bogus") ? xo(n) : V(e1, (e1)=>{
                nn(n, e1) && on(n, e1);
            });
        });
    }, np = (e1)=>{
        let t = e1.nextNode();
        for(; null !== t;)t.nodeValue = null, t = e1.nextNode();
    }, op = S(np, Xg), rp = S(np, Qg), sp = (e1, t)=>{
        const n = [
            {
                condition: T(ep, t),
                action: T(tp, t)
            },
            {
                condition: Jg,
                action: op
            },
            {
                condition: Zg,
                action: rp
            }
        ];
        let o = e1, r = !1;
        return V(n, ({ condition: t, action: n })=>{
            t(o) && (r || (o = e1.cloneNode(!0), r = !0), n(o));
        }), o;
    }, ap = (e1)=>{
        const t = Uo(e1, "[data-mce-bogus]");
        V(t, (e1)=>{
            "all" === en(e1, "data-mce-bogus") ? xo(e1) : Er(e1) ? (po(e1, vn(hr)), xo(e1)) : Eo(e1);
        });
    }, ip = (e1)=>{
        const t = Uo(e1, "input");
        V(t, (e1)=>{
            on(e1, "name");
        });
    }, lp = (e1, t, n)=>{
        let o;
        return o = "raw" === t.format ? Pt.trim(Dr(sp(n, e1.serializer.getTempAttrs()).innerHTML)) : "text" === t.format ? ((e1, t)=>{
            const n = e1.getDoc(), o = qn(yn(e1.getBody())), r = bn("div", n);
            Jt(r, "data-mce-bogus", "all"), lo(r, {
                position: "fixed",
                left: "-9999999px",
                top: "0"
            }), ko(r, t.innerHTML), ap(r), ip(r);
            const s = ((e1)=>jn(e1) ? e1 : yn(Nn(e1).dom.body))(o);
            vo(s, r);
            const a = Dr(r.dom.innerText);
            return xo(r), a;
        })(e1, n) : "tree" === t.format ? e1.serializer.serialize(n, t) : ((e1, t)=>{
            const n = Il(e1), o = new RegExp(`^(<${n}[^>]*>(&nbsp;|&#160;|\\s|\xa0|<br \\/>|)<\\/${n}>[\r\n]*|<br \\/>[\r\n]*)$`);
            return t.replace(o, "");
        })(e1, e1.serializer.serialize(n, t)), "text" !== t.format && !Ar(yn(n)) && m(o) ? Pt.trim(o) : o;
    }, dp = Pt.makeMap, cp = (e1)=>{
        const t = [], n = (e1 = e1 || {}).indent, o = dp(e1.indent_before || ""), r = dp(e1.indent_after || ""), s = ea.getEncodeFunc(e1.entity_encoding || "raw", e1.entities), a = "xhtml" !== e1.element_format;
        return {
            start: (e1, i, l)=>{
                if (n && o[e1] && t.length > 0) {
                    const e1 = t[t.length - 1];
                    e1.length > 0 && "\n" !== e1 && t.push("\n");
                }
                if (t.push("<", e1), i) for(let e1 = 0, n = i.length; e1 < n; e1++){
                    const n = i[e1];
                    t.push(" ", n.name, '="', s(n.value, !0), '"');
                }
                if (t[t.length] = !l || a ? ">" : " />", l && n && r[e1] && t.length > 0) {
                    const e1 = t[t.length - 1];
                    e1.length > 0 && "\n" !== e1 && t.push("\n");
                }
            },
            end: (e1)=>{
                let o;
                t.push("</", e1, ">"), n && r[e1] && t.length > 0 && (o = t[t.length - 1], o.length > 0 && "\n" !== o && t.push("\n"));
            },
            text: (e1, n)=>{
                e1.length > 0 && (t[t.length] = n ? e1 : s(e1));
            },
            cdata: (e1)=>{
                t.push("<![CDATA[", e1, "]]>");
            },
            comment: (e1)=>{
                t.push("\x3c!--", e1, "--\x3e");
            },
            pi: (e1, o)=>{
                o ? t.push("<?", e1, " ", s(o), "?>") : t.push("<?", e1, "?>"), n && t.push("\n");
            },
            doctype: (e1)=>{
                t.push("<!DOCTYPE", e1, ">", n ? "\n" : "");
            },
            reset: ()=>{
                t.length = 0;
            },
            getContent: ()=>t.join("").replace(/\n$/, "")
        };
    }, up = (e1 = {}, t = ua())=>{
        const n = cp(e1);
        return e1.validate = !("validate" in e1) || e1.validate, {
            serialize: (o)=>{
                const r = e1.validate, s = {
                    3: (e1)=>{
                        var t;
                        n.text(null !== (t = e1.value) && void 0 !== t ? t : "", e1.raw);
                    },
                    8: (e1)=>{
                        var t;
                        n.comment(null !== (t = e1.value) && void 0 !== t ? t : "");
                    },
                    7: (e1)=>{
                        n.pi(e1.name, e1.value);
                    },
                    10: (e1)=>{
                        var t;
                        n.doctype(null !== (t = e1.value) && void 0 !== t ? t : "");
                    },
                    4: (e1)=>{
                        var t;
                        n.cdata(null !== (t = e1.value) && void 0 !== t ? t : "");
                    },
                    11: (e1)=>{
                        let t = e1;
                        if (t = t.firstChild) do a(t);
                        while (t = t.next);
                    }
                };
                n.reset();
                const a = (e1)=>{
                    var o;
                    const i = s[e1.type];
                    if (i) i(e1);
                    else {
                        const s = e1.name, i = s in t.getVoidElements();
                        let l = e1.attributes;
                        if (r && l && l.length > 1) {
                            const n = [];
                            n.map = {};
                            const o = t.getElementRule(e1.name);
                            if (o) {
                                for(let e1 = 0, t = o.attributesOrder.length; e1 < t; e1++){
                                    const t = o.attributesOrder[e1];
                                    if (t in l.map) {
                                        const e1 = l.map[t];
                                        n.map[t] = e1, n.push({
                                            name: t,
                                            value: e1
                                        });
                                    }
                                }
                                for(let e1 = 0, t = l.length; e1 < t; e1++){
                                    const t = l[e1].name;
                                    if (!(t in n.map)) {
                                        const e1 = l.map[t];
                                        n.map[t] = e1, n.push({
                                            name: t,
                                            value: e1
                                        });
                                    }
                                }
                                l = n;
                            }
                        }
                        if (n.start(s, l, i), ps(s)) m(e1.value) && n.text(e1.value, !0), n.end(s);
                        else if (!i) {
                            let t = e1.firstChild;
                            if (t) {
                                "pre" !== s && "textarea" !== s || 3 !== t.type || "\n" !== (null === (o = t.value) || void 0 === o ? void 0 : o[0]) || n.text("\n", !0);
                                do a(t);
                                while (t = t.next);
                            }
                            n.end(s);
                        }
                    }
                };
                return 1 !== o.type || e1.inner ? 3 === o.type ? s[3](o) : s[11](o) : a(o), n.getContent();
            }
        };
    }, mp = new Set;
    V([
        "margin",
        "margin-left",
        "margin-right",
        "margin-top",
        "margin-bottom",
        "padding",
        "padding-left",
        "padding-right",
        "padding-top",
        "padding-bottom",
        "border",
        "border-width",
        "border-style",
        "border-color",
        "background",
        "background-attachment",
        "background-clip",
        "background-color",
        "background-image",
        "background-origin",
        "background-position",
        "background-repeat",
        "background-size",
        "float",
        "position",
        "left",
        "right",
        "top",
        "bottom",
        "z-index",
        "display",
        "transform",
        "width",
        "max-width",
        "min-width",
        "height",
        "max-height",
        "min-height",
        "overflow",
        "overflow-x",
        "overflow-y",
        "text-overflow",
        "vertical-align",
        "transition",
        "transition-delay",
        "transition-duration",
        "transition-property",
        "transition-timing-function"
    ], (e1)=>{
        mp.add(e1);
    });
    const fp = [
        "font",
        "text-decoration",
        "text-emphasis"
    ], gp = (e1, t)=>me(e1.parseStyle(e1.getAttrib(t, "style"))), pp = (e1, t, n)=>{
        const o = gp(e1, t), r = gp(e1, n), s = (o)=>{
            var r, s;
            const a = null !== (r = e1.getStyle(t, o)) && void 0 !== r ? r : "", i = null !== (s = e1.getStyle(n, o)) && void 0 !== s ? s : "";
            return Ye(a) && Ye(i) && a !== i;
        };
        return $(o, (e1)=>{
            const t = (t)=>$(t, (t)=>t === e1);
            if (!t(r) && t(fp)) {
                const e1 = Y(r, (e1)=>$(fp, (t)=>He(e1, t)));
                return $(e1, s);
            }
            return s(e1);
        });
    }, hp = (e1, t, n)=>I.from(n.container()).filter(er).exists((o)=>{
            const r = e1 ? 0 : -1;
            return t(o.data.charAt(n.offset() + r));
        }), bp = T(hp, !0, Xu), vp = T(hp, !1, Xu), yp = (e1)=>{
        const t = e1.container();
        return er(t) && (0 === t.data.length || Pr(t.data) && Jm.isBookmarkNode(t.parentNode));
    }, Cp = (e1, t)=>(n)=>Jc(e1 ? 0 : -1, n).filter(t).isSome(), wp = (e1)=>ir(e1) && "block" === co(yn(e1), "display"), xp = (e1)=>dr(e1) && !((e1)=>qo(e1) && "all" === e1.getAttribute("data-mce-bogus"))(e1), Ep = Cp(!0, wp), _p = Cp(!1, wp), Sp = Cp(!0, mr), kp = Cp(!1, mr), Np = Cp(!0, Qo), Rp = Cp(!1, Qo), Ap = Cp(!0, xp), Tp = Cp(!1, xp), Op = (e1, t)=>((e1, t, n)=>Sn(t, e1) ? On(e1, (e1)=>n(e1) || _n(e1, t)).slice(0, -1) : [])(e1, t, L), Bp = (e1, t)=>[
            e1
        ].concat(Op(e1, t)), Pp = (e1, t, n)=>Nu(e1, t, n, yp), Dp = (e1, t, n)=>J(Bp(yn(t.container()), e1), ((e1)=>(t)=>e1.isBlock(Ht(t)))(n)), Lp = (e1, t, n, o)=>Pp(e1, t.dom, n).forall((e1)=>Dp(t, n, o).fold(()=>!Qc(e1, n, t.dom), (o)=>!Qc(e1, n, t.dom) && Sn(o, yn(e1.container())))), Mp = (e1, t, n, o)=>Dp(t, n, o).fold(()=>Pp(e1, t.dom, n).forall((e1)=>!Qc(e1, n, t.dom)), (t)=>Pp(e1, t.dom, n).isNone()), Ip = T(Mp, !1), Fp = T(Mp, !0), Up = T(Lp, !1), zp = T(Lp, !0), jp = (e1)=>iu(e1).exists(Er), Hp = (e1, t, n, o)=>{
        const r = Y(Bp(yn(n.container()), t), (e1)=>o.isBlock(Ht(e1))), s = le(r).getOr(t);
        return Su(e1, s.dom, n).filter(jp);
    }, $p = (e1, t, n)=>iu(t).exists(Er) || Hp(!0, e1, t, n).isSome(), qp = (e1, t, n)=>((e1)=>I.from(e1.getNode(!0)).map(yn))(t).exists(Er) || Hp(!1, e1, t, n).isSome(), Vp = T(Hp, !1), Wp = T(Hp, !0), Kp = (e1)=>Vi.isTextPosition(e1) && !e1.isAtStart() && !e1.isAtEnd(), Yp = (e1, t, n)=>{
        const o = Y(Bp(yn(t.container()), e1), (e1)=>n.isBlock(Ht(e1)));
        return le(o).getOr(e1);
    }, Gp = (e1, t, n)=>Kp(t) ? vp(t) : vp(t) || Tu(Yp(e1, t, n).dom, t).exists(vp), Xp = (e1, t, n)=>Kp(t) ? bp(t) : bp(t) || Au(Yp(e1, t, n).dom, t).exists(bp), Qp = (e1)=>iu(e1).bind((e1)=>Jn(e1, Wt)).exists((e1)=>((e1)=>H([
                    "pre",
                    "pre-wrap"
                ], e1))(co(e1, "white-space"))), Jp = (e1, t)=>(n)=>{
            var o;
            return o = new jo(n, e1)[t](), C(o) && dr(o) && zc(o);
        }, Zp = (e1, t, n)=>!Qp(t) && (((e1, t, n)=>((e1, t)=>Tu(e1.dom, t).isNone())(e1, t) || ((e1, t)=>Au(e1.dom, t).isNone())(e1, t) || Ip(e1, t, n) || Fp(e1, t, n) || qp(e1, t, n) || $p(e1, t, n))(e1, t, n) || Gp(e1, t, n) || Xp(e1, t, n)), eh = (e1, t, n)=>!Qp(t) && (Ip(e1, t, n) || Up(e1, t, n) || qp(e1, t, n) || Gp(e1, t, n) || ((e1, t)=>{
            const n = Tu(e1.dom, t).getOr(t), o = Jp(e1.dom, "prev");
            return t.isAtStart() && (o(t.container()) || o(n.container()));
        })(e1, t)), th = (e1, t, n)=>!Qp(t) && (Fp(e1, t, n) || zp(e1, t, n) || $p(e1, t, n) || Xp(e1, t, n) || ((e1, t)=>{
            const n = Au(e1.dom, t).getOr(t), o = Jp(e1.dom, "next");
            return t.isAtEnd() && (o(t.container()) || o(n.container()));
        })(e1, t)), nh = (e1, t, n)=>eh(e1, t, n) || th(e1, ((e1)=>{
            const t = e1.container(), n = e1.offset();
            return er(t) && n < t.data.length ? Vi(t, n + 1) : e1;
        })(t), n), oh = (e1, t)=>Yu(e1.charAt(t)), rh = (e1, t)=>Xu(e1.charAt(t)), sh = (e1, t, n, o)=>{
        const r = t.data, s = Vi(t, 0);
        return n || !oh(r, 0) || nh(e1, s, o) ? !!(n && rh(r, 0) && eh(e1, s, o)) && (t.data = br + r.slice(1), !0) : (t.data = " " + r.slice(1), !0);
    }, ah = (e1, t, n, o)=>{
        const r = t.data, s = Vi(t, r.length - 1);
        return n || !oh(r, r.length - 1) || nh(e1, s, o) ? !!(n && rh(r, r.length - 1) && th(e1, s, o)) && (t.data = r.slice(0, -1) + br, !0) : (t.data = r.slice(0, -1) + " ", !0);
    }, ih = (e1, t, n)=>{
        const o = t.container();
        if (!er(o)) return I.none();
        if (((e1)=>{
            const t = e1.container();
            return er(t) && je(t.data, br);
        })(t)) {
            const r = sh(e1, o, !1, n) || ((e1)=>{
                const t = e1.data, n = ((e1)=>{
                    const t = e1.split("");
                    return q(t, (e1, n)=>Yu(e1) && n > 0 && n < t.length - 1 && Qu(t[n - 1]) && Qu(t[n + 1]) ? " " : e1).join("");
                })(t);
                return n !== t && (e1.data = n, !0);
            })(o) || ah(e1, o, !1, n);
            return It(r, t);
        }
        if (nh(e1, t, n)) {
            const r = sh(e1, o, !0, n) || ah(e1, o, !0, n);
            return It(r, t);
        }
        return I.none();
    }, lh = (e1, t, n, o)=>{
        if (0 === n) return;
        const r = yn(e1), s = Qn(r, (e1)=>o.isBlock(Ht(e1))).getOr(r), a = e1.data.slice(t, t + n), i = t + n >= e1.data.length && th(s, Vi(e1, e1.data.length), o), l = 0 === t && eh(s, Vi(e1, 0), o);
        e1.replaceData(t, n, ls(a, 4, l, i));
    }, dh = (e1, t, n)=>{
        const o = e1.data.slice(t), r = o.length - We(o).length;
        lh(e1, t, r, n);
    }, ch = (e1, t, n)=>{
        const o = e1.data.slice(0, t), r = o.length - Ke(o).length;
        lh(e1, t - r, r, n);
    }, uh = (e1, t, n, o, r = !0)=>{
        const s = Ke(e1.data).length, a = r ? e1 : t, i = r ? t : e1;
        return r ? a.appendData(i.data) : a.insertData(0, i.data), xo(yn(i)), o && dh(a, s, n), a;
    }, mh = (e1, t)=>((e1, t)=>{
            const n = e1.container(), o = e1.offset();
            return !Vi.isTextPosition(e1) && n === t.parentNode && o > Vi.before(t).offset();
        })(t, e1) ? Vi(t.container(), t.offset() - 1) : t, fh = (e1)=>{
        var t;
        return ts(e1.previousSibling) ? I.some((t = e1.previousSibling, er(t) ? Vi(t, t.data.length) : Vi.after(t))) : e1.previousSibling ? Bu(e1.previousSibling) : I.none();
    }, gh = (e1)=>{
        var t;
        return ts(e1.nextSibling) ? I.some((t = e1.nextSibling, er(t) ? Vi(t, 0) : Vi.before(t))) : e1.nextSibling ? Ou(e1.nextSibling) : I.none();
    }, ph = (e1, t, n)=>((e1, t, n)=>e1 ? ((e1, t)=>gh(t).orThunk(()=>fh(t)).orThunk(()=>((e1, t)=>Au(e1, Vi.after(t)).orThunk(()=>Tu(e1, Vi.before(t))))(e1, t)))(t, n) : ((e1, t)=>fh(t).orThunk(()=>gh(t)).orThunk(()=>((e1, t)=>I.from(t.previousSibling ? t.previousSibling : t.parentNode).bind((t)=>Tu(e1, Vi.before(t))).orThunk(()=>Au(e1, Vi.after(t))))(e1, t)))(t, n))(e1, t, n).map(T(mh, n)), hh = (e1, t, n)=>{
        n.fold(()=>{
            e1.focus();
        }, (n)=>{
            e1.selection.setRng(n.toRange(), t);
        });
    }, bh = (e1, t)=>t && Ee(e1.schema.getBlockElements(), Ht(t)), vh = (e1, t, n, o = !0, r = !1)=>{
        const s = ph(t, e1.getBody(), n.dom), a = Qn(n, T(bh, e1), (i = e1.getBody(), (e1)=>e1.dom === i));
        var i;
        const l = ((e1, t, n, o)=>{
            const r = Bn(e1).filter(Kt), s = Pn(e1).filter(Kt);
            var a, i, l, d;
            return xo(e1), (a = r, i = s, l = t, d = (e1, t, r)=>{
                const s = e1.dom, a = t.dom, i = s.data.length;
                return uh(s, a, n, o), r.container() === a ? Vi(s, i) : r;
            }, a.isSome() && i.isSome() && l.isSome() ? I.some(d(a.getOrDie(), i.getOrDie(), l.getOrDie())) : I.none()).orThunk(()=>(o && (r.each((e1)=>ch(e1.dom, e1.dom.length, n)), s.each((e1)=>dh(e1.dom, 0, n))), t));
        })(n, s, e1.schema, ((e1, t)=>Ee(e1.schema.getTextInlineElements(), Ht(t)))(e1, n));
        e1.dom.isEmpty(e1.getBody()) ? (e1.setContent(""), e1.selection.setCursorLocation()) : a.bind((e1)=>((e1, t)=>{
                if (gs(e1)) {
                    const n = hn('<br data-mce-bogus="1">');
                    return t ? V(Mn(e1), (e1)=>{
                        Tm(e1) || xo(e1);
                    }) : wo(e1), vo(e1, n), I.some(Vi.before(n.dom));
                }
                return I.none();
            })(e1, r)).fold(()=>{
            o && hh(e1, t, l);
        }, (n)=>{
            o && hh(e1, t, I.some(n));
        });
    }, yh = /[\u0591-\u07FF\uFB1D-\uFDFF\uFE70-\uFEFC]/, Ch = (e1, t)=>xn(yn(t), dd(e1)) && !Ts(e1.schema, t) && e1.dom.isEditable(t), wh = (e1)=>{
        var t;
        return "rtl" === za.DOM.getStyle(e1, "direction", !0) || ((e1)=>yh.test(e1))(null !== (t = e1.textContent) && void 0 !== t ? t : "");
    }, xh = (e1, t, n)=>{
        const o = ((e1, t, n)=>Y(za.DOM.getParents(n.container(), "*", t), e1))(e1, t, n);
        return I.from(o[o.length - 1]);
    }, Eh = (e1, t)=>{
        const n = t.container(), o = t.offset();
        return e1 ? Fr(n) ? er(n.nextSibling) ? Vi(n.nextSibling, 0) : Vi.after(n) : jr(t) ? Vi(n, o + 1) : t : Fr(n) ? er(n.previousSibling) ? Vi(n.previousSibling, n.previousSibling.data.length) : Vi.before(n) : Hr(t) ? Vi(n, o - 1) : t;
    }, _h = T(Eh, !0), Sh = T(Eh, !1), kh = (e1, t)=>{
        const n = (e1)=>e1.stopImmediatePropagation();
        e1.on("beforeinput input", n, !0), e1.getDoc().execCommand(t), e1.off("beforeinput input", n);
    }, Nh = (e1)=>kh(e1, "Delete"), Rh = (e1)=>_r(e1) || kr(e1), Ah = (e1, t)=>Sn(e1, t) ? Jn(t, Rh, ((e1)=>(t)=>Dt(An(t), e1, _n))(e1)) : I.none(), Th = (e1, t = !0)=>{
        e1.dom.isEmpty(e1.getBody()) && e1.setContent("", {
            no_selection: !t
        });
    }, Oh = (e1, t, n)=>Mt(Ou(n), Bu(n), (o, r)=>{
            const s = Eh(!0, o), a = Eh(!1, r), i = Eh(!1, t);
            return e1 ? Au(n, i).exists((e1)=>e1.isEqual(a) && t.isEqual(s)) : Tu(n, i).exists((e1)=>e1.isEqual(s) && t.isEqual(a));
        }).getOr(!0), Bh = (e1)=>{
        var t;
        return (8 === $t(t = e1) || "#comment" === Ht(t) ? Bn(e1) : Un(e1)).bind(Bh).orThunk(()=>I.some(e1));
    }, Ph = (e1, t, n, o = !0)=>{
        var r;
        t.deleteContents();
        const s = Bh(n).getOr(n), a = yn(null !== (r = e1.dom.getParent(s.dom, e1.dom.isBlock)) && void 0 !== r ? r : n.dom);
        if (a.dom === e1.getBody() ? Th(e1, o) : gs(a) && (Or(a), o && e1.selection.setCursorLocation(a.dom, 0)), !_n(n, a)) {
            const e1 = Dt(An(a), n) ? [] : An(i = a).map(Mn).map((e1)=>Y(e1, (e1)=>!_n(i, e1))).getOr([]);
            V(e1.concat(Mn(n)), (e1)=>{
                _n(e1, a) || Sn(e1, a) || !gs(e1) || xo(e1);
            });
        }
        var i;
    }, Dh = (e1, t)=>((e1, t)=>{
            const n = e1.dom;
            return n.parentNode ? ((e1, t)=>J(e1.dom.childNodes, (e1)=>t(yn(e1))).map(yn))(yn(n.parentNode), (n)=>!_n(e1, n) && t(n)) : I.none();
        })(e1, t).isSome(), Lh = (e1, t)=>Zn(e1, t).isSome(), Mh = (e1)=>Uo(e1, "td,th"), Ih = (e1, t)=>tm(yn(e1), t), Fh = (e1, t)=>({
            start: e1,
            end: t
        }), Uh = hl([
        {
            singleCellTable: [
                "rng",
                "cell"
            ]
        },
        {
            fullTable: [
                "table"
            ]
        },
        {
            partialTable: [
                "cells",
                "outsideDetails"
            ]
        },
        {
            multiTable: [
                "startTableCells",
                "endTableCells",
                "betweenRng"
            ]
        }
    ]), zh = (e1, t)=>no(yn(e1), "td,th", t), jh = (e1)=>!_n(e1.start, e1.end), Hh = (e1, t)=>tm(e1.start, t).bind((n)=>tm(e1.end, t).bind((e1)=>It(_n(n, e1), n))), $h = (e1)=>(t)=>Hh(t, e1).map((e1)=>((e1, t, n)=>({
                        rng: e1,
                        table: t,
                        cells: n
                    }))(t, e1, Mh(e1))), qh = (e1, t, n, o)=>{
        if (n.collapsed || !e1.forall(jh)) return I.none();
        if (t.isSameTable) {
            const t = e1.bind($h(o));
            return I.some({
                start: t,
                end: t
            });
        }
        {
            const e1 = zh(n.startContainer, o), t = zh(n.endContainer, o), r = e1.bind(((e1)=>(t)=>tm(t, e1).bind((e1)=>de(Mh(e1)).map((e1)=>Fh(t, e1))))(o)).bind($h(o)), s = t.bind(((e1)=>(t)=>tm(t, e1).bind((e1)=>le(Mh(e1)).map((e1)=>Fh(e1, t))))(o)).bind($h(o));
            return I.some({
                start: r,
                end: s
            });
        }
    }, Vh = (e1, t)=>Z(e1, (e1)=>_n(e1, t)), Wh = (e1)=>Mt(Vh(e1.cells, e1.rng.start), Vh(e1.cells, e1.rng.end), (t, n)=>e1.cells.slice(t, n + 1)), Kh = (e1, t)=>{
        const { startTable: n, endTable: o } = t, r = e1.cloneRange();
        return n.each((e1)=>r.setStartAfter(e1.dom)), o.each((e1)=>r.setEndBefore(e1.dom)), r;
    }, Yh = (e1, t)=>{
        const n = ((e1)=>(t)=>_n(e1, t))(e1), o = ((e1, t)=>{
            const n = zh(e1.startContainer, t), o = zh(e1.endContainer, t);
            return Mt(n, o, Fh);
        })(t, n), r = ((e1, t)=>{
            const n = Ih(e1.startContainer, t), o = Ih(e1.endContainer, t), r = n.isSome(), s = o.isSome(), a = Mt(n, o, _n).getOr(!1);
            return ((e1)=>Mt(e1.startTable, e1.endTable, (t, n)=>{
                    const o = Lh(t, (e1)=>_n(e1, n)), r = Lh(n, (e1)=>_n(e1, t));
                    return o || r ? {
                        ...e1,
                        startTable: o ? I.none() : e1.startTable,
                        endTable: r ? I.none() : e1.endTable,
                        isSameTable: !1,
                        isMultiTable: !1
                    } : e1;
                }).getOr(e1))({
                startTable: n,
                endTable: o,
                isStartInTable: r,
                isEndInTable: s,
                isSameTable: a,
                isMultiTable: !a && r && s
            });
        })(t, n);
        return ((e1, t, n)=>e1.exists((e1)=>((e1, t)=>!jh(e1) && Hh(e1, t).exists((e1)=>{
                        const t = e1.dom.rows;
                        return 1 === t.length && 1 === t[0].cells.length;
                    }))(e1, n) && rm(e1.start, t)))(o, t, n) ? o.map((e1)=>Uh.singleCellTable(t, e1.start)) : r.isMultiTable ? ((e1, t, n, o)=>qh(e1, t, n, o).bind(({ start: e1, end: o })=>{
                const r = e1.bind(Wh).getOr([]), s = o.bind(Wh).getOr([]);
                if (r.length > 0 && s.length > 0) {
                    const e1 = Kh(n, t);
                    return I.some(Uh.multiTable(r, s, e1));
                }
                return I.none();
            }))(o, r, t, n) : ((e1, t, n, o)=>qh(e1, t, n, o).bind(({ start: e1, end: t })=>e1.or(t)).bind((e1)=>{
                const { isSameTable: o } = t, r = Wh(e1).getOr([]);
                if (o && e1.cells.length === r.length) return I.some(Uh.fullTable(e1.table));
                if (r.length > 0) {
                    if (o) return I.some(Uh.partialTable(r, I.none()));
                    {
                        const e1 = Kh(n, t);
                        return I.some(Uh.partialTable(r, I.some({
                            ...t,
                            rng: e1
                        })));
                    }
                }
                return I.none();
            }))(o, r, t, n);
    }, Gh = (e1)=>V(e1, (e1)=>{
            on(e1, "contenteditable"), Or(e1);
        }), Xh = (e1, t, n, o)=>{
        const r = n.cloneRange();
        o ? (r.setStart(n.startContainer, n.startOffset), r.setEndAfter(t.dom.lastChild)) : (r.setStartBefore(t.dom.firstChild), r.setEnd(n.endContainer, n.endOffset)), eb(e1, r, t, !1).each((e1)=>e1());
    }, Qh = (e1)=>{
        const t = em(e1), n = yn(e1.selection.getNode());
        cr(n.dom) && gs(n) ? e1.selection.setCursorLocation(n.dom, 0) : e1.selection.collapse(!0), t.length > 1 && $(t, (e1)=>_n(e1, n)) && Jt(n, "data-mce-selected", "1");
    }, Jh = (e1, t, n)=>I.some(()=>{
            const o = e1.selection.getRng(), r = n.bind(({ rng: n, isStartInTable: r })=>{
                const s = ((e1, t)=>I.from(e1.dom.getParent(t, e1.dom.isBlock)).map(yn))(e1, r ? n.endContainer : n.startContainer);
                n.deleteContents(), ((e1, t, n)=>{
                    n.each((n)=>{
                        t ? xo(n) : (Or(n), e1.selection.setCursorLocation(n.dom, 0));
                    });
                })(e1, r, s.filter(gs));
                const a = r ? t[0] : t[t.length - 1];
                return Xh(e1, a, o, r), gs(a) ? I.none() : I.some(r ? t.slice(1) : t.slice(0, -1));
            }).getOr(t);
            Gh(r), Qh(e1);
        }), Zh = (e1, t, n, o)=>I.some(()=>{
            const r = e1.selection.getRng(), s = t[0], a = n[n.length - 1];
            Xh(e1, s, r, !0), Xh(e1, a, r, !1);
            const i = gs(s) ? t : t.slice(1), l = gs(a) ? n : n.slice(0, -1);
            Gh(i.concat(l)), o.deleteContents(), Qh(e1);
        }), eb = (e1, t, n, o = !0)=>I.some(()=>{
            Ph(e1, t, n, o);
        }), tb = (e1, t)=>I.some(()=>vh(e1, !1, t)), nb = (e1, t)=>J(Bp(t, e1), Rr), ob = (e1, t)=>J(Bp(t, e1), Xt("caption")), rb = (e1, t)=>I.some(()=>{
            Or(t), e1.selection.setCursorLocation(t.dom, 0);
        }), sb = (e1, t)=>e1 ? Np(t) : Rp(t), ab = (e1, t, n)=>{
        const o = yn(e1.getBody());
        return ob(o, n).fold(()=>((e1, t, n, o)=>{
                const r = Vi.fromRangeStart(e1.selection.getRng());
                return nb(n, o).bind((o)=>gs(o) ? rb(e1, o) : ((e1, t, n, o, r)=>ku(n, e1.getBody(), r).bind((e1)=>nb(t, yn(e1.getNode())).bind((e1)=>_n(e1, o) ? I.none() : I.some(_))))(e1, n, t, o, r));
            })(e1, t, o, n).orThunk(()=>It(((e1, t)=>{
                    const n = Vi.fromRangeStart(e1.selection.getRng());
                    return sb(t, n) || Su(t, e1.getBody(), n).exists((e1)=>sb(t, e1));
                })(e1, t), _)), (n)=>((e1, t, n, o)=>{
                const r = Vi.fromRangeStart(e1.selection.getRng());
                return gs(o) ? rb(e1, o) : ((e1, t, n, o, r)=>ku(n, e1.getBody(), r).fold(()=>I.some(_), (s)=>((e1, t, n, o)=>Ou(e1.dom).bind((r)=>Bu(e1.dom).map((e1)=>t ? n.isEqual(r) && o.isEqual(e1) : n.isEqual(e1) && o.isEqual(r))).getOr(!0))(o, n, r, s) ? ((e1, t)=>rb(e1, t))(e1, o) : ((e1, t, n)=>ob(e1, yn(n.getNode())).fold(()=>I.some(_), (e1)=>It(!_n(e1, t), _)))(t, o, s)))(e1, n, t, o, r);
            })(e1, t, o, n));
    }, ib = (e1, t)=>{
        const n = yn(e1.selection.getStart(!0)), o = em(e1);
        return e1.selection.isCollapsed() && 0 === o.length ? ab(e1, t, n) : ((e1, t, n)=>{
            const o = yn(e1.getBody()), r = e1.selection.getRng();
            return 0 !== n.length ? Jh(e1, n, I.none()) : ((e1, t, n, o)=>ob(t, o).fold(()=>((e1, t, n)=>Yh(t, n).bind((t)=>t.fold(T(eb, e1), T(tb, e1), T(Jh, e1), T(Zh, e1))))(e1, t, n), (t)=>((e1, t)=>rb(e1, t))(e1, t)))(e1, o, r, t);
        })(e1, n, o);
    }, lb = (e1, t)=>{
        let n = t;
        for(; n && n !== e1;){
            if (lr(n) || dr(n)) return n;
            n = n.parentNode;
        }
        return null;
    }, db = [
        "data-ephox-",
        "data-mce-",
        "data-alloy-",
        "data-snooker-",
        "_"
    ], cb = Pt.each, ub = (e1)=>{
        const t = e1.dom, n = new Set(e1.serializer.getTempAttrs()), o = (e1)=>$(db, (t)=>He(e1, t)) || n.has(e1);
        return {
            compare: (e1, n)=>{
                if (e1.nodeName !== n.nodeName || e1.nodeType !== n.nodeType) return !1;
                const r = (e1)=>{
                    const n = {};
                    return cb(t.getAttribs(e1), (r)=>{
                        const s = r.nodeName.toLowerCase();
                        "style" === s || o(s) || (n[s] = t.getAttrib(e1, s));
                    }), n;
                }, s = (e1, t)=>{
                    for(const n in e1)if (Ee(e1, n)) {
                        const o = t[n];
                        if (v(o)) return !1;
                        if (e1[n] !== o) return !1;
                        delete t[n];
                    }
                    for(const e1 in t)if (Ee(t, e1)) return !1;
                    return !0;
                };
                if (qo(e1) && qo(n)) {
                    if (!s(r(e1), r(n))) return !1;
                    if (!s(t.parseStyle(t.getAttrib(e1, "style")), t.parseStyle(t.getAttrib(n, "style")))) return !1;
                }
                return !Ku(e1) && !Ku(n);
            },
            isAttributeInternal: o
        };
    }, mb = (e1)=>[
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6"
        ].includes(e1.name), fb = (e1, t, n, o)=>{
        const r = n.name;
        for(let t = 0, s = e1.length; t < s; t++){
            const s = e1[t];
            if (s.name === r) {
                const e1 = o.nodes[r];
                e1 ? e1.nodes.push(n) : o.nodes[r] = {
                    filter: s,
                    nodes: [
                        n
                    ]
                };
            }
        }
        if (n.attributes) for(let e1 = 0, r = t.length; e1 < r; e1++){
            const r = t[e1], s = r.name;
            if (s in n.attributes.map) {
                const e1 = o.attributes[s];
                e1 ? e1.nodes.push(n) : o.attributes[s] = {
                    filter: r,
                    nodes: [
                        n
                    ]
                };
            }
        }
    }, gb = (e1, t)=>{
        const n = (e1, n)=>{
            ge(e1, (e1)=>{
                const o = ce(e1.nodes);
                V(e1.filter.callbacks, (r)=>{
                    for(let t = o.length - 1; t >= 0; t--){
                        const r = o[t];
                        (n ? void 0 !== r.attr(e1.filter.name) : r.name === e1.filter.name) && !y(r.parent) || o.splice(t, 1);
                    }
                    o.length > 0 && r(o, e1.filter.name, t);
                });
            });
        };
        n(e1.nodes, !1), n(e1.attributes, !0);
    }, pb = (e1, t, n, o = {})=>{
        const r = ((e1, t, n)=>{
            const o = {
                nodes: {},
                attributes: {}
            };
            return n.firstChild && ((n, r)=>{
                let s = n;
                for(; s = s.walk();)fb(e1, t, s, o);
            })(n), o;
        })(e1, t, n);
        gb(r, o);
    }, hb = (e1, t, n, o)=>{
        if ((e1.pad_empty_with_br || t.insert) && n(o)) {
            const e1 = new Wg("br", 1);
            t.insert && e1.attr("data-mce-bogus", "1"), o.empty().append(e1);
        } else o.empty().append(new Wg("#text", 3)).value = br;
    }, bb = (e1, t)=>{
        const n = null == e1 ? void 0 : e1.firstChild;
        return C(n) && n === e1.lastChild && n.name === t;
    }, vb = (e1, t, n, o)=>o.isEmpty(t, n, (t)=>((e1, t)=>{
                const n = e1.getElementRule(t.name);
                return !0 === (null == n ? void 0 : n.paddEmpty);
            })(e1, t)), yb = (e1)=>{
        let t;
        for(let n = e1; n; n = n.parent){
            const e1 = n.attr("contenteditable");
            if ("false" === e1) break;
            "true" === e1 && (t = n);
        }
        return I.from(t);
    }, Cb = (e1, t, n = e1.parent)=>{
        if (t.getSpecialElements()[e1.name]) e1.empty().remove();
        else {
            const o = e1.children();
            for (const e1 of o)n && !t.isValidChild(n.name, e1.name) && Cb(e1, t, n);
            e1.unwrap();
        }
    }, wb = (e1, t, n, o = _)=>{
        const r = t.getTextBlockElements(), s = t.getNonEmptyElements(), a = t.getWhitespaceElements(), i = Pt.makeMap("tr,td,th,tbody,thead,tfoot,table,summary"), l = new Set, d = (e1)=>e1 !== n && !i[e1.name];
        for(let n = 0; n < e1.length; n++){
            const i = e1[n];
            let c, u, m;
            if (!i.parent || l.has(i)) continue;
            if (r[i.name] && "li" === i.parent.name) {
                let e1 = i.next;
                for(; e1 && r[e1.name];)e1.name = "li", l.add(e1), i.parent.insert(e1, i.parent), e1 = e1.next;
                i.unwrap();
                continue;
            }
            const f = [
                i
            ];
            for(c = i.parent; c && !t.isValidChild(c.name, i.name) && d(c); c = c.parent)f.push(c);
            if (c && f.length > 1) {
                if (xb(t, i, c)) Cb(i, t);
                else {
                    f.reverse(), u = f[0].clone(), o(u);
                    let e1 = u;
                    for(let n = 0; n < f.length - 1; n++){
                        t.isValidChild(e1.name, f[n].name) && n > 0 ? (m = f[n].clone(), o(m), e1.append(m)) : m = e1;
                        for(let e1 = f[n].firstChild; e1 && e1 !== f[n + 1];){
                            const t = e1.next;
                            m.append(e1), e1 = t;
                        }
                        e1 = m;
                    }
                    vb(t, s, a, u) ? c.insert(i, f[0], !0) : (c.insert(u, f[0], !0), c.insert(i, u)), c = f[0], (vb(t, s, a, c) || bb(c, "br")) && c.empty().remove();
                }
            } else if (i.parent) {
                if ("li" === i.name) {
                    let e1 = i.prev;
                    if (e1 && ("ul" === e1.name || "ol" === e1.name)) {
                        e1.append(i);
                        continue;
                    }
                    if (e1 = i.next, e1 && ("ul" === e1.name || "ol" === e1.name) && e1.firstChild) {
                        e1.insert(i, e1.firstChild, !0);
                        continue;
                    }
                    const t = new Wg("ul", 1);
                    o(t), i.wrap(t);
                    continue;
                }
                if (t.isValidChild(i.parent.name, "div") && t.isValidChild("div", i.name)) {
                    const e1 = new Wg("div", 1);
                    o(e1), i.wrap(e1);
                } else Cb(i, t);
            }
        }
    }, xb = (e1, t, n = t.parent)=>!(!n || (!e1.children[t.name] || e1.isValidChild(n.name, t.name)) && ("a" !== t.name || !((e1, t)=>{
            let n = e1;
            for(; n;){
                if ("a" === n.name) return !0;
                n = n.parent;
            }
            return !1;
        })(n)) && (!((e1)=>"summary" === e1.name)(n) || !mb(t) || (null == n ? void 0 : n.firstChild) === t && (null == n ? void 0 : n.lastChild) === t)), Eb = (e1)=>e1.collapsed ? e1 : ((e1)=>{
            const t = Vi.fromRangeStart(e1), n = Vi.fromRangeEnd(e1), o = e1.commonAncestorContainer;
            return Su(!1, o, n).map((r)=>!Qc(t, n, o) && Qc(t, r, o) ? ((e1, t, n, o)=>{
                    const r = document.createRange();
                    return r.setStart(e1, t), r.setEnd(n, o), r;
                })(t.container(), t.offset(), r.container(), r.offset()) : e1).getOr(e1);
        })(e1), _b = (e1, t)=>{
        let n = t.firstChild, o = t.lastChild;
        return n && "meta" === n.name && (n = n.next), o && "mce_marker" === o.attr("id") && (o = o.prev), ((e1, t)=>{
            const n = e1.getNonEmptyElements();
            return C(t) && (t.isEmpty(n) || ((e1, t)=>e1.getBlockElements()[t.name] && ((e1)=>C(e1.firstChild) && e1.firstChild === e1.lastChild)(t) && ((e1)=>"br" === e1.name || e1.value === br)(t.firstChild))(e1, t));
        })(e1, o) && (o = null == o ? void 0 : o.prev), !(!n || n !== o || "ul" !== n.name && "ol" !== n.name);
    }, Sb = (e1)=>{
        var t, n;
        return e1.length > 0 && (!(n = e1[e1.length - 1]).firstChild || C(null == (t = n) ? void 0 : t.firstChild) && t.firstChild === t.lastChild && ((e1)=>e1.data === br || ar(e1))(t.firstChild)) ? e1.slice(0, -1) : e1;
    }, kb = (e1, t)=>{
        const n = e1.getParent(t, e1.isBlock);
        return n && "LI" === n.nodeName ? n : null;
    }, Nb = (e1, t)=>{
        const n = Vi.after(e1), o = wu(t).prev(n);
        return o ? o.toRange() : null;
    }, Rb = (e1, t, n, o)=>{
        const r = ((e1, t, n)=>{
            const o = t.serialize(n);
            return ((e1)=>{
                var t, n;
                const o = e1.firstChild, r = e1.lastChild;
                return o && "META" === o.nodeName && (null === (t = o.parentNode) || void 0 === t || t.removeChild(o)), r && "mce_marker" === r.id && (null === (n = r.parentNode) || void 0 === n || n.removeChild(r)), e1;
            })(e1.createFragment(o));
        })(t, e1, o), s = kb(t, n.startContainer), a = Sb((i = r.firstChild, Y(null !== (l = null == i ? void 0 : i.childNodes) && void 0 !== l ? l : [], (e1)=>"LI" === e1.nodeName)));
        var i, l;
        const d = t.getRoot(), c = (e1)=>{
            const o = Vi.fromRangeStart(n), r = wu(t.getRoot()), a = 1 === e1 ? r.prev(o) : r.next(o), i = null == a ? void 0 : a.getNode();
            return !i || kb(t, i) !== s;
        };
        return s ? c(1) ? ((e1, t, n)=>{
            const o = e1.parentNode;
            return o && Pt.each(t, (t)=>{
                o.insertBefore(t, e1);
            }), ((e1, t)=>{
                const n = Vi.before(e1), o = wu(t).next(n);
                return o ? o.toRange() : null;
            })(e1, n);
        })(s, a, d) : c(2) ? ((e1, t, n, o)=>(o.insertAfter(t.reverse(), e1), Nb(t[0], n)))(s, a, d, t) : ((e1, t, n, o)=>{
            const r = ((e1, t)=>{
                const n = t.cloneRange(), o = t.cloneRange();
                return n.setStartBefore(e1), o.setEndAfter(e1), [
                    n.cloneContents(),
                    o.cloneContents()
                ];
            })(e1, o), s = e1.parentNode;
            return s && (s.insertBefore(r[0], e1), Pt.each(t, (t)=>{
                s.insertBefore(t, e1);
            }), s.insertBefore(r[1], e1), s.removeChild(e1)), Nb(t[t.length - 1], n);
        })(s, a, d, n) : null;
    }, Ab = [
        "pre"
    ], Tb = cr, Ob = (e1, t, n)=>{
        var o, r;
        const s = e1.selection, a = e1.dom, i = e1.parser, l = n.merge, d = up({
            validate: !0
        }, e1.schema), c = '<span id="mce_marker" data-mce-type="bookmark">&#xFEFF;</span>';
        n.preserve_zwsp || (t = Dr(t)), -1 === t.indexOf("{$caret}") && (t += "{$caret}"), t = t.replace(/\{\$caret\}/, c);
        let u = s.getRng();
        const m = u.startContainer, f = e1.getBody();
        m === f && s.isCollapsed() && a.isBlock(f.firstChild) && ((e1, t)=>C(t) && !e1.schema.getVoidElements()[t.nodeName])(e1, f.firstChild) && a.isEmpty(f.firstChild) && (u = a.createRng(), u.setStart(f.firstChild, 0), u.setEnd(f.firstChild, 0), s.setRng(u)), s.isCollapsed() || ((e1)=>{
            const t = e1.dom, n = Eb(e1.selection.getRng());
            e1.selection.setRng(n);
            const o = t.getParent(n.startContainer, Tb);
            ((e1, t, n)=>!!C(n) && n === e1.getParent(t.endContainer, Tb) && rm(yn(n), t))(t, n, o) ? eb(e1, n, yn(o)) : n.startContainer === n.endContainer && n.endOffset - n.startOffset == 1 && er(n.startContainer.childNodes[n.startOffset]) ? n.deleteContents() : e1.getDoc().execCommand("Delete", !1);
        })(e1);
        const g = s.getNode(), p = {
            context: g.nodeName.toLowerCase(),
            data: n.data,
            insert: !0
        }, h = i.parse(t, p);
        if (!0 === n.paste && _b(e1.schema, h) && ((e1, t)=>!!kb(e1, t))(a, g)) return u = Rb(d, a, s.getRng(), h), u && s.setRng(u), t;
        !0 === n.paste && ((e1, t, n, o)=>{
            var r;
            const s = t.firstChild, a = t.lastChild, i = s === ("bookmark" === a.attr("data-mce-type") ? a.prev : a), l = H(Ab, s.name);
            if (i && l) {
                const t = "false" !== s.attr("contenteditable"), a = (null === (r = e1.getParent(n, e1.isBlock)) || void 0 === r ? void 0 : r.nodeName.toLowerCase()) === s.name, i = I.from(lb(o, n)).forall(lr);
                return t && a && i;
            }
            return !1;
        })(a, h, g, e1.getBody()) && (null === (o = h.firstChild) || void 0 === o || o.unwrap()), ((e1)=>{
            let t = e1;
            for(; t = t.walk();)1 === t.type && t.attr("data-mce-fragment", "1");
        })(h);
        let b = h.lastChild;
        if (b && "mce_marker" === b.attr("id")) {
            const t = b;
            for(b = b.prev; b; b = b.walk(!0))if (3 === b.type || !a.isBlock(b.name)) {
                b.parent && e1.schema.isValidChild(b.parent.name, "span") && b.parent.insert(t, b, "br" === b.name);
                break;
            }
        }
        if (e1._selectionOverrides.showBlockCaretContainer(g), p.invalid || ((e1, t, n)=>{
            var o;
            return $(n.children(), mb) && "SUMMARY" === (null === (o = e1.getParent(t, e1.isBlock)) || void 0 === o ? void 0 : o.nodeName);
        })(a, g, h)) {
            e1.selection.setContent(c);
            let n, o = s.getNode();
            const l = e1.getBody();
            for(rr(o) ? o = n = l : n = o; n && n !== l;)o = n, n = n.parentNode;
            t = o === l ? l.innerHTML : a.getOuterHTML(o);
            const u = i.parse(t), m = ((e1)=>{
                for(let t = e1; t; t = t.walk())if ("mce_marker" === t.attr("id")) return I.some(t);
                return I.none();
            })(u), f = m.bind(yb).getOr(u);
            m.each((e1)=>e1.replace(h));
            const g = h.children(), p = null !== (r = h.parent) && void 0 !== r ? r : u;
            h.unwrap();
            const b = Y(g, (t)=>xb(e1.schema, t, p));
            wb(b, e1.schema, f), pb(i.getNodeFilters(), i.getAttributeFilters(), u), t = d.serialize(u), o === l ? a.setHTML(l, t) : a.setOuterHTML(o, t);
        } else t = d.serialize(h), ((e1, t, n)=>{
            var o;
            if ("all" === n.getAttribute("data-mce-bogus")) null === (o = n.parentNode) || void 0 === o || o.insertBefore(e1.dom.createFragment(t), n);
            else {
                const o = n.firstChild, r = n.lastChild;
                !o || o === r && "BR" === o.nodeName ? e1.dom.setHTML(n, t) : e1.selection.setContent(t, {
                    no_events: !0
                });
            }
        })(e1, t, g);
        var v;
        return ((e1, t)=>{
            const n = e1.schema.getTextInlineElements(), o = e1.dom;
            if (t) {
                const t = e1.getBody(), r = ub(e1);
                Pt.each(o.select("*[data-mce-fragment]"), (e1)=>{
                    if (C(n[e1.nodeName.toLowerCase()]) && ((e1, t)=>ne(gp(e1, t), (e1)=>!((e1)=>mp.has(e1))(e1)))(o, e1)) {
                        for(let n = e1.parentElement; C(n) && n !== t && !pp(o, e1, n); n = n.parentElement)if (r.compare(n, e1)) {
                            o.remove(e1, !0);
                            break;
                        }
                    }
                });
            }
        })(e1, l), ((e1, t)=>{
            var n, o, r;
            let s;
            const a = e1.dom, i = e1.selection;
            if (!t) return;
            i.scrollIntoView(t);
            const l = lb(e1.getBody(), t);
            if (l && "false" === a.getContentEditable(l)) return a.remove(t), void i.select(l);
            let d = a.createRng();
            const c = t.previousSibling;
            if (er(c)) {
                d.setStart(c, null !== (o = null === (n = c.nodeValue) || void 0 === n ? void 0 : n.length) && void 0 !== o ? o : 0);
                const e1 = t.nextSibling;
                er(e1) && (c.appendData(e1.data), null === (r = e1.parentNode) || void 0 === r || r.removeChild(e1));
            } else d.setStartBefore(t), d.setEndBefore(t);
            const u = a.getParent(t, a.isBlock);
            if (a.remove(t), u && a.isEmpty(u)) {
                const t = Tb(u);
                wo(yn(u)), d.setStart(u, 0), d.setEnd(u, 0), t || ((e1)=>!!e1.getAttribute("data-mce-fragment"))(u) || !(s = ((t)=>{
                    let n = Vi.fromRangeStart(t);
                    return n = wu(e1.getBody()).next(n), null == n ? void 0 : n.toRange();
                })(d)) ? a.add(u, a.create("br", t ? {} : {
                    "data-mce-bogus": "1"
                })) : (d = s, a.remove(u));
            }
            i.setRng(d);
        })(e1, a.get("mce_marker")), v = e1.getBody(), Pt.each(v.getElementsByTagName("*"), (e1)=>{
            e1.removeAttribute("data-mce-fragment");
        }), ((e1, t, n)=>{
            I.from(e1.getParent(t, "td,th")).map(yn).each((e1)=>((e1, t)=>{
                    Un(e1).each((n)=>{
                        Bn(n).each((o)=>{
                            t.isBlock(Ht(e1)) && Er(n) && t.isBlock(Ht(o)) && xo(n);
                        });
                    });
                })(e1, n));
        })(a, s.getStart(), e1.schema), ((e1, t, n)=>{
            const o = On(yn(n), (e1)=>_n(e1, yn(t)));
            ie(o, o.length - 2).filter(Wt).fold(()=>Ss(e1, t), (t)=>Ss(e1, t.dom));
        })(e1.schema, e1.getBody(), s.getStart()), t;
    }, Bb = (e1)=>e1 instanceof Wg, Pb = (e1, t, n)=>{
        e1.dom.setHTML(e1.getBody(), t), !0 !== n && ((e1)=>{
            Rg(e1) && Ou(e1.getBody()).each((t)=>{
                const n = t.getNode(), o = Qo(n) ? Ou(n).getOr(t) : t;
                e1.selection.setRng(o.toRange());
            });
        })(e1);
    }, Db = (e1)=>w(e1) ? e1 : L, Lb = (e1, t, n)=>{
        const o = t(e1), r = Db(n);
        return o.orThunk(()=>r(e1) ? I.none() : ((e1, t, n)=>{
                let o = e1.dom;
                const r = Db(n);
                for(; o.parentNode;){
                    o = o.parentNode;
                    const e1 = yn(o), n = t(e1);
                    if (n.isSome()) return n;
                    if (r(e1)) break;
                }
                return I.none();
            })(e1, t, r));
    }, Mb = ym, Ib = (e1, t, n)=>{
        const o = e1.formatter.get(n);
        if (o) for(let n = 0; n < o.length; n++){
            const r = o[n];
            if (km(r) && !1 === r.inherit && e1.dom.is(t, r.selector)) return !0;
        }
        return !1;
    }, Fb = (e1, t, n, o, r)=>{
        const s = e1.dom.getRoot();
        if (t === s) return !1;
        const a = e1.dom.getParent(t, (t)=>!!Ib(e1, t, n) || t.parentNode === s || !!jb(e1, t, n, o, !0));
        return !!jb(e1, a, n, o, r);
    }, Ub = (e1, t, n)=>!(!Nm(n) || !Mb(t, n.inline)) || !(!Sm(n) || !Mb(t, n.block)) || !!km(n) && qo(t) && e1.is(t, n.selector), zb = (e1, t, n, o, r, s)=>{
        const a = n[o], i = "attributes" === o;
        if (w(n.onmatch)) return n.onmatch(t, n, o);
        if (a) {
            if (ke(a)) {
                for(let n = 0; n < a.length; n++)if (i ? e1.getAttrib(t, a[n]) : wm(e1, t, a[n])) return !0;
            } else for(const o in a)if (Ee(a, o)) {
                const l = i ? e1.getAttrib(t, o) : wm(e1, t, o), d = vm(a[o], s), c = y(l) || Ge(l);
                if (c && y(d)) continue;
                if (r && c && !n.exact) return !1;
                if ((!r || n.exact) && !Mb(l, Cm(d, o))) return !1;
            }
        }
        return !0;
    }, jb = (e1, t, n, o, r)=>{
        const s = e1.formatter.get(n), a = e1.dom;
        if (s && qo(t)) for(let n = 0; n < s.length; n++){
            const i = s[n];
            if (Ub(e1.dom, t, i) && zb(a, t, i, "attributes", r, o) && zb(a, t, i, "styles", r, o)) {
                const n = i.classes;
                if (n) {
                    for(let r = 0; r < n.length; r++)if (!e1.dom.hasClass(t, vm(n[r], o))) return;
                }
                return i;
            }
        }
    }, Hb = (e1, t, n, o, r)=>{
        if (o) return Fb(e1, o, t, n, r);
        if (o = e1.selection.getNode(), Fb(e1, o, t, n, r)) return !0;
        const s = e1.selection.getStart();
        return !(s === o || !Fb(e1, s, t, n, r));
    }, $b = Br, qb = (e1)=>{
        if (e1) {
            const t = new jo(e1, e1);
            for(let e1 = t.current(); e1; e1 = t.next())if (er(e1)) return e1;
        }
        return null;
    }, Vb = (e1)=>{
        const t = bn("span");
        return Zt(t, {
            id: Pu,
            "data-mce-bogus": "1",
            "data-mce-type": "format-caret"
        }), e1 && vo(t, vn($b)), t;
    }, Wb = (e1, t, n)=>{
        const o = e1.dom, r = e1.selection;
        if (Am(t)) vh(e1, !1, yn(t), n, !0);
        else {
            const e1 = r.getRng(), n = o.getParent(t, o.isBlock), s = e1.startContainer, a = e1.startOffset, i = e1.endContainer, l = e1.endOffset, d = ((e1)=>{
                const t = qb(e1);
                return t && t.data.charAt(0) === $b && t.deleteData(0, 1), t;
            })(t);
            o.remove(t, !0), s === d && a > 0 && e1.setStart(d, a - 1), i === d && l > 0 && e1.setEnd(d, l - 1), n && o.isEmpty(n) && Or(yn(n)), r.setRng(e1);
        }
    }, Kb = (e1, t, n)=>{
        const o = e1.dom, r = e1.selection;
        if (t) Wb(e1, t, n);
        else if (!(t = Lu(e1.getBody(), r.getStart()))) for(; t = o.get(Pu);)Wb(e1, t, n);
    }, Yb = (e1, t)=>(e1.appendChild(t), t), Gb = (e1, t)=>{
        var n;
        const o = G(e1, (e1, t)=>Yb(e1, t.cloneNode(!1)), t), r = null !== (n = o.ownerDocument) && void 0 !== n ? n : document;
        return Yb(o, r.createTextNode($b));
    }, Xb = (e1, t, n, o)=>{
        const a = e1.dom, i = e1.selection;
        let l = !1;
        const d = e1.formatter.get(t);
        if (!d) return;
        const c = i.getRng(), u = c.startContainer, m = c.startOffset;
        let f = u;
        er(u) && (m !== u.data.length && (l = !0), f = f.parentNode);
        const g = [];
        let h;
        for(; f;){
            if (jb(e1, f, t, n, o)) {
                h = f;
                break;
            }
            f.nextSibling && (l = !0), g.push(f), f = f.parentNode;
        }
        if (h) {
            if (l) {
                const r = i.getBookmark();
                c.collapse(!0);
                let s = Vm(a, c, d, !0);
                s = Ff(s), e1.formatter.remove(t, n, s, o), i.moveToBookmark(r);
            } else {
                const l = Lu(e1.getBody(), h), d = C(l) ? a.getParents(h.parentNode, M, l) : [], c = Vb(!1).dom;
                ((e1, t, n)=>{
                    var o, r;
                    const s = e1.dom, a = s.getParent(n, T(gm, e1.schema));
                    a && s.isEmpty(a) ? null === (o = n.parentNode) || void 0 === o || o.replaceChild(t, n) : (((e1)=>{
                        const t = Uo(e1, "br"), n = Y(((e1)=>{
                            const t = [];
                            let n = e1.dom;
                            for(; n;)t.push(yn(n)), n = n.lastChild;
                            return t;
                        })(e1).slice(-1), Er);
                        t.length === n.length && V(n, xo);
                    })(yn(n)), s.isEmpty(n) ? null === (r = n.parentNode) || void 0 === r || r.replaceChild(t, n) : s.insertAfter(t, n));
                })(e1, c, null != l ? l : h);
                const u = ((e1, t, n, o, a, i)=>{
                    const l = e1.formatter, d = e1.dom, c = Y(me(l.get()), (e1)=>e1 !== o && !je(e1, "removeformat")), u = ((e1, t, n)=>X(n, (n, o)=>{
                            const r = ((e1, t)=>_m(e1, t, (e1)=>{
                                    const t = (e1)=>w(e1) || e1.length > 1 && "%" === e1.charAt(0);
                                    return $([
                                        "styles",
                                        "attributes"
                                    ], (n)=>xe(e1, n).exists((e1)=>{
                                            const n = p(e1) ? e1 : we(e1);
                                            return $(n, t);
                                        }));
                                }))(e1, o);
                            return e1.formatter.matchNode(t, o, {}, r) ? n.concat([
                                o
                            ]) : n;
                        }, []))(e1, n, c);
                    if (Y(u, (t)=>!((e1, t, n)=>{
                            const o = [
                                "inline",
                                "block",
                                "selector",
                                "attributes",
                                "styles",
                                "classes"
                            ], a = (e1)=>ye(e1, (e1, t)=>$(o, (e1)=>e1 === t));
                            return _m(e1, t, (t)=>{
                                const o = a(t);
                                return _m(e1, n, (e1)=>{
                                    const t = a(e1);
                                    return ((e1, t, n = s)=>r(n).eq(e1, t))(o, t);
                                });
                            });
                        })(e1, t, o)).length > 0) {
                        const e1 = n.cloneNode(!1);
                        return d.add(t, e1), l.remove(o, a, e1, i), d.remove(e1), I.some(e1);
                    }
                    return I.none();
                })(e1, c, h, t, n, o), m = Gb([
                    ...g,
                    ...u.toArray(),
                    ...d
                ], c);
                l && Wb(e1, l, C(l)), i.setCursorLocation(m, 1), a.isEmpty(h) && a.remove(h);
            }
        }
    }, Qb = (e1)=>{
        const t = Vb(!1), n = Gb(e1, t.dom);
        return {
            caretContainer: t,
            caretPosition: Vi(n, 0)
        };
    }, Jb = (e1, t)=>{
        const { caretContainer: n, caretPosition: o } = Qb(t);
        return po(yn(e1), n), xo(yn(e1)), o;
    }, Zb = (e1, t)=>{
        if (Du(t.dom)) return !1;
        const n = e1.schema.getTextInlineElements();
        return Ee(n, Ht(t)) && !Du(t.dom) && !Xo(t.dom);
    }, ev = {}, tv = Ko([
        "pre"
    ]);
    ((e1, t)=>{
        ev[e1] || (ev[e1] = []), ev[e1].push((e1)=>{
            if (!e1.selection.getRng().collapsed) {
                const t = e1.selection.getSelectedBlocks(), n = Y(Y(t, tv), ((e1)=>(t)=>{
                        const n = t.previousSibling;
                        return tv(n) && H(e1, n);
                    })(t));
                V(n, (e1)=>{
                    ((e1, t)=>{
                        const n = yn(t), o = Nn(n).dom;
                        xo(n), Co(yn(e1), [
                            bn("br", o),
                            bn("br", o),
                            ...Mn(n)
                        ]);
                    })(e1.previousSibling, e1);
                });
            }
        });
    })("pre");
    const nv = [
        "fontWeight",
        "fontStyle",
        "color",
        "fontSize",
        "fontFamily"
    ], ov = (e1, t)=>{
        const n = e1.get(t);
        return p(n) ? J(n, (e1)=>Nm(e1) && "span" === e1.inline && ((e1)=>f(e1.styles) && $(me(e1.styles), (e1)=>H(nv, e1)))(e1)) : I.none();
    }, rv = (e1, t)=>Tu(t, Vi.fromRangeStart(e1)).isNone(), sv = (e1, t)=>!1 === Au(t, Vi.fromRangeEnd(e1)).exists((e1)=>!ar(e1.getNode()) || Au(t, e1).isSome()), av = (e1)=>(t)=>fr(t) && e1.isEditable(t), iv = (e1)=>Y(e1.getSelectedBlocks(), av(e1.dom)), lv = Pt.each, dv = (e1)=>qo(e1) && !Ku(e1) && !Du(e1) && !Xo(e1), cv = (e1, t)=>{
        for(let n = e1; n; n = n[t]){
            if (er(n) && Ye(n.data)) return e1;
            if (qo(n) && !Ku(n)) return n;
        }
        return e1;
    }, uv = (e1, t, n)=>{
        const o = ub(e1), r = Vo(t) && e1.dom.isEditable(t), s = Vo(n) && e1.dom.isEditable(n);
        if (r && s) {
            const r = cv(t, "previousSibling"), s = cv(n, "nextSibling");
            if (o.compare(r, s)) {
                for(let e1 = r.nextSibling; e1 && e1 !== s;){
                    const t = e1;
                    e1 = e1.nextSibling, r.appendChild(t);
                }
                return e1.dom.remove(s), Pt.each(Pt.grep(s.childNodes), (e1)=>{
                    r.appendChild(e1);
                }), r;
            }
        }
        return n;
    }, mv = (e1, t, n, o)=>{
        var r;
        if (o && !1 !== t.merge_siblings) {
            const t = null !== (r = uv(e1, fm(o), o)) && void 0 !== r ? r : o;
            uv(e1, t, fm(t, !0));
        }
    }, fv = (e1, t, n)=>{
        lv(e1.childNodes, (e1)=>{
            dv(e1) && (t(e1) && n(e1), e1.hasChildNodes() && fv(e1, t, n));
        });
    }, gv = (e1, t)=>(n)=>!(!n || !wm(e1, n, t)), pv = (e1, t, n)=>(o)=>{
            e1.setStyle(o, t, n), "" === o.getAttribute("style") && o.removeAttribute("style"), ((e1, t)=>{
                "SPAN" === t.nodeName && 0 === e1.getAttribs(t).length && e1.remove(t, !0);
            })(e1, o);
        }, hv = hl([
        {
            keep: []
        },
        {
            rename: [
                "name"
            ]
        },
        {
            removed: []
        }
    ]), bv = /^(src|href|style)$/, vv = Pt.each, yv = ym, Cv = (e1, t, n)=>e1.isChildOf(t, n) && t !== n && !e1.isBlock(n), wv = (e1, t, n)=>{
        let o = t[n ? "startContainer" : "endContainer"], r = t[n ? "startOffset" : "endOffset"];
        if (qo(o)) {
            const e1 = o.childNodes.length - 1;
            !n && r && r--, o = o.childNodes[r > e1 ? e1 : r];
        }
        return er(o) && n && r >= o.data.length && (o = new jo(o, e1.getBody()).next() || o), er(o) && !n && 0 === r && (o = new jo(o, e1.getBody()).prev() || o), o;
    }, xv = (e1, t)=>{
        const n = t ? "firstChild" : "lastChild", o = e1[n];
        return ((e1)=>/^(TR|TH|TD)$/.test(e1.nodeName))(e1) && o ? "TR" === e1.nodeName && o[n] || o : e1;
    }, Ev = (e1, t, n, o)=>{
        var r;
        const s = e1.create(n, o);
        return null === (r = t.parentNode) || void 0 === r || r.insertBefore(s, t), s.appendChild(t), s;
    }, _v = (e1, t, n, o, r)=>{
        const s = yn(t), a = yn(e1.create(o, r)), i = n ? Ln(s) : Dn(s);
        return Co(a, i), n ? (po(s, a), bo(a, s)) : (ho(s, a), vo(a, s)), a.dom;
    }, Sv = (e1, t, n)=>{
        const o = t.parentNode;
        let r;
        const s = e1.dom, a = Il(e1);
        Sm(n) && o === s.getRoot() && (n.list_block && yv(t, n.list_block) || V(ce(t.childNodes), (t)=>{
            pm(e1, a, t.nodeName.toLowerCase()) ? r ? r.appendChild(t) : (r = Ev(s, t, a), s.setAttribs(r, Fl(e1))) : r = null;
        })), ((e1)=>km(e1) && Nm(e1) && Dt(xe(e1, "mixed"), !0))(n) && !yv(n.inline, t) || s.remove(t, !0);
    }, kv = (e1, t, n)=>x(e1) ? {
            name: t,
            value: null
        } : {
            name: e1,
            value: vm(t, n)
        }, Nv = (e1, t)=>{
        "" === e1.getAttrib(t, "style") && (t.removeAttribute("style"), t.removeAttribute("data-mce-style"));
    }, Rv = (e1, t, n, o, r)=>{
        let s = !1;
        vv(n.styles, (a, i)=>{
            const { name: l, value: d } = kv(i, a, o), c = Cm(d, l);
            (n.remove_similar || h(d) || !qo(r) || yv(wm(e1, r, l), c)) && e1.setStyle(t, l, ""), s = !0;
        }), s && Nv(e1, t);
    }, Av = (e1, t, n, o, r)=>{
        const s = e1.dom, a = ub(e1), i = e1.schema;
        if (Nm(t) && Rs(i, t.inline) && Ts(i, o) && o.parentElement === e1.getBody()) return Sv(e1, o, t), hv.removed();
        if (!t.ceFalseOverride && o && "false" === s.getContentEditableParent(o)) return hv.keep();
        if (o && !Ub(s, o, t) && !((e1, t)=>t.links && "A" === e1.nodeName)(o, t)) return hv.keep();
        const l = o, d = t.preserve_attributes;
        if (Nm(t) && "all" === t.remove && p(d)) {
            const e1 = Y(s.getAttribs(l), (e1)=>H(d, e1.name.toLowerCase()));
            if (s.removeAllAttribs(l), V(e1, (e1)=>s.setAttrib(l, e1.name, e1.value)), e1.length > 0) return hv.rename("span");
        }
        if ("all" !== t.remove) {
            Rv(s, l, t, n, r), vv(t.attributes, (e1, o)=>{
                const { name: a, value: i } = kv(o, e1, n);
                if (t.remove_similar || h(i) || !qo(r) || yv(s.getAttrib(r, a), i)) {
                    if ("class" === a) {
                        const e1 = s.getAttrib(l, a);
                        if (e1) {
                            let t = "";
                            if (V(e1.split(/\s+/), (e1)=>{
                                /mce\-\w+/.test(e1) && (t += (t ? " " : "") + e1);
                            }), t) return void s.setAttrib(l, a, t);
                        }
                    }
                    if (bv.test(a) && l.removeAttribute("data-mce-" + a), "style" === a && Ko([
                        "li"
                    ])(l) && "none" === s.getStyle(l, "list-style-type")) return l.removeAttribute(a), void s.setStyle(l, "list-style-type", "none");
                    "class" === a && l.removeAttribute("className"), l.removeAttribute(a);
                }
            }), vv(t.classes, (e1)=>{
                e1 = vm(e1, n), qo(r) && !s.hasClass(r, e1) || s.removeClass(l, e1);
            });
            const e1 = s.getAttribs(l);
            for(let t = 0; t < e1.length; t++){
                const n = e1[t].nodeName;
                if (!a.isAttributeInternal(n)) return hv.keep();
            }
        }
        return "none" !== t.remove ? (Sv(e1, l, t), hv.removed()) : hv.keep();
    }, Tv = (e1, t, n, o)=>Av(e1, t, n, o, o).fold(N(o), (t)=>(e1.dom.createFragment().appendChild(o), e1.dom.rename(o, t)), N(null)), Ov = (e1, t, n, o, r)=>{
        (o || e1.selection.isEditable()) && ((e1, t, n, o, r)=>{
            const s = e1.formatter.get(t), a = s[0], i = e1.dom, l = e1.selection, d = (o)=>{
                const i = ((e1, t, n, o, r)=>{
                    let s;
                    return t.parentNode && V(Em(e1.dom, t.parentNode).reverse(), (t)=>{
                        if (!s && qo(t) && "_start" !== t.id && "_end" !== t.id) {
                            const a = jb(e1, t, n, o, r);
                            a && !1 !== a.split && (s = t);
                        }
                    }), s;
                })(e1, o, t, n, r);
                return ((e1, t, n, o, r, s, a, i)=>{
                    var l, d;
                    let c, u;
                    const m = e1.dom;
                    if (n) {
                        const s = n.parentNode;
                        for(let n = o.parentNode; n && n !== s; n = n.parentNode){
                            let o = m.clone(n, !1);
                            for(let n = 0; n < t.length && (o = Tv(e1, t[n], i, o), null !== o); n++);
                            o && (c && o.appendChild(c), u || (u = o), c = o);
                        }
                        a.mixed && m.isBlock(n) || (o = null !== (l = m.split(n, o)) && void 0 !== l ? l : o), c && u && (null === (d = r.parentNode) || void 0 === d || d.insertBefore(c, r), u.appendChild(r), Nm(a) && mv(e1, a, 0, c));
                    }
                    return o;
                })(e1, s, i, o, o, 0, a, n);
            }, c = (t)=>$(s, (o)=>Bv(e1, o, n, t, t)), u = (t)=>{
                const n = ce(t.childNodes), o = c(t) || $(s, (e1)=>Ub(i, t, e1)), r = t.parentNode;
                if (!o && C(r) && Rm(a) && c(r), a.deep && n.length) for(let e1 = 0; e1 < n.length; e1++)u(n[e1]);
                V([
                    "underline",
                    "line-through",
                    "overline"
                ], (n)=>{
                    qo(t) && e1.dom.getStyle(t, "text-decoration") === n && t.parentNode && xm(i, t.parentNode) === n && Bv(e1, {
                        deep: !1,
                        exact: !0,
                        inline: "span",
                        styles: {
                            textDecoration: n
                        }
                    }, void 0, t);
                });
            }, m = (e1)=>{
                const t = i.get(e1 ? "_start" : "_end");
                if (t) {
                    let n = t[e1 ? "firstChild" : "lastChild"];
                    return ((e1)=>Ku(e1) && qo(e1) && ("_start" === e1.id || "_end" === e1.id))(n) && (n = n[e1 ? "firstChild" : "lastChild"]), er(n) && 0 === n.data.length && (n = e1 ? t.previousSibling || t.nextSibling : t.nextSibling || t.previousSibling), i.remove(t, !0), n;
                }
                return null;
            }, f = (t)=>{
                let n, o, r = Vm(i, t, s, t.collapsed);
                if (a.split) {
                    if (r = Ff(r), n = wv(e1, r, !0), o = wv(e1, r), n !== o) {
                        if (n = xv(n, !0), o = xv(o, !1), Cv(i, n, o)) {
                            const e1 = I.from(n.firstChild).getOr(n);
                            return d(_v(i, e1, !0, "span", {
                                id: "_start",
                                "data-mce-type": "bookmark"
                            })), void m(!0);
                        }
                        if (Cv(i, o, n)) {
                            const e1 = I.from(o.lastChild).getOr(o);
                            return d(_v(i, e1, !1, "span", {
                                id: "_end",
                                "data-mce-type": "bookmark"
                            })), void m(!1);
                        }
                        n = Ev(i, n, "span", {
                            id: "_start",
                            "data-mce-type": "bookmark"
                        }), o = Ev(i, o, "span", {
                            id: "_end",
                            "data-mce-type": "bookmark"
                        });
                        const e1 = i.createRng();
                        e1.setStartAfter(n), e1.setEndBefore(o), Wm(i, e1, (e1)=>{
                            V(e1, (e1)=>{
                                Ku(e1) || Ku(e1.parentNode) || d(e1);
                            });
                        }), d(n), d(o), n = m(!0), o = m();
                    } else n = o = d(n);
                    r.startContainer = n.parentNode ? n.parentNode : n, r.startOffset = i.nodeIndex(n), r.endContainer = o.parentNode ? o.parentNode : o, r.endOffset = i.nodeIndex(o) + 1;
                }
                Wm(i, r, (e1)=>{
                    V(e1, u);
                });
            };
            if (o) {
                if (dm(o)) {
                    const e1 = i.createRng();
                    e1.setStartBefore(o), e1.setEndAfter(o), f(e1);
                } else f(o);
                nf(e1, t, o, n);
            } else l.isCollapsed() && Nm(a) && !em(e1).length ? Xb(e1, t, n, r) : (um(e1, ()=>im(e1, f), (o)=>Nm(a) && Hb(e1, t, n, o)), e1.nodeChanged()), ((e1, t, n)=>{
                "removeformat" === t ? V(iv(e1.selection), (t)=>{
                    V(nv, (n)=>e1.dom.setStyle(t, n, "")), Nv(e1.dom, t);
                }) : ov(e1.formatter, t).each((t)=>{
                    V(iv(e1.selection), (o)=>Rv(e1.dom, o, t, n, null));
                });
            })(e1, t, n), nf(e1, t, o, n);
        })(e1, t, n, o, r);
    }, Bv = (e1, t, n, o, r)=>Av(e1, t, n, o, r).fold(L, (t)=>(e1.dom.rename(o, t), !0), M), Pv = Pt.each, Dv = Pt.each, Lv = (e1, t, n, o)=>{
        if (Dv(n.styles, (n, r)=>{
            e1.setStyle(t, r, vm(n, o));
        }), n.styles) {
            const n = e1.getAttrib(t, "style");
            n && e1.setAttrib(t, "data-mce-style", n);
        }
    }, Mv = (e1, t, n, o)=>{
        const r = e1.formatter.get(t), s = r[0], a = !o && e1.selection.isCollapsed(), i = e1.dom, l = e1.selection, d = (e1, t = s)=>{
            w(t.onformat) && t.onformat(e1, t, n, o), Lv(i, e1, t, n), Dv(t.attributes, (t, o)=>{
                i.setAttrib(e1, o, vm(t, n));
            }), Dv(t.classes, (t)=>{
                const o = vm(t, n);
                i.hasClass(e1, o) || i.addClass(e1, o);
            });
        }, c = (e1, t)=>{
            let n = !1;
            return Dv(e1, (e1)=>!(!km(e1) || ("false" !== i.getContentEditable(t) || e1.ceFalseOverride) && (!C(e1.collapsed) || e1.collapsed === a) && i.is(t, e1.selector) && !Du(t) && (d(t, e1), n = !0, 1))), n;
        }, u = (e1)=>{
            if (m(e1)) {
                const t = i.create(e1);
                return d(t), t;
            }
            return null;
        }, f = (o, a, i)=>{
            const l = [];
            let m = !0;
            const f = s.inline || s.block, g = u(f);
            Wm(o, a, (a)=>{
                let u;
                const p = (a)=>{
                    let h = !1, b = m, v = !1;
                    const y = a.parentNode, w = y.nodeName.toLowerCase(), x = o.getContentEditable(a);
                    C(x) && (b = m, m = "true" === x, h = !0, v = bm(e1, a));
                    const E = m && !h;
                    if (ar(a) && !((e1, t, n, o)=>{
                        if (xd(e1) && Nm(t) && n.parentNode) {
                            const t = da(e1.schema), r = Dh(yn(n), (e1)=>Du(e1.dom));
                            return _e(t, o) && gs(yn(n.parentNode), !1) && !r;
                        }
                        return !1;
                    })(e1, s, a, w)) return u = null, void (Sm(s) && o.remove(a));
                    if (((o)=>((e1)=>Sm(e1) && !0 === e1.wrapper)(s) && jb(e1, o, t, n))(a)) u = null;
                    else {
                        if (((t, n, o)=>{
                            const r = ((e1)=>Sm(e1) && !0 !== e1.wrapper)(s) && gm(e1.schema, t) && pm(e1, n, f);
                            return o && r;
                        })(a, w, E)) {
                            const e1 = o.rename(a, f);
                            return d(e1), l.push(e1), void (u = null);
                        }
                        if (km(s)) {
                            let e1 = c(r, a);
                            if (!e1 && C(y) && Rm(s) && (e1 = c(r, y)), !Nm(s) || e1) return void (u = null);
                        }
                        C(g) && ((t, n, r, a)=>{
                            const l = t.nodeName.toLowerCase(), d = pm(e1, f, l) && pm(e1, n, f), c = !i && er(t) && Pr(t.data), u = Du(t), m = !Nm(s) || !o.isBlock(t);
                            return (r || a) && d && !c && !u && m;
                        })(a, w, E, v) ? (u || (u = o.clone(g, !1), y.insertBefore(u, a), l.push(u)), v && h && (m = b), u.appendChild(a)) : (u = null, V(ce(a.childNodes), p), h && (m = b), u = null);
                    }
                };
                V(a, p);
            }), !0 === s.links && V(l, (e1)=>{
                const t = (e1)=>{
                    "A" === e1.nodeName && d(e1, s), V(ce(e1.childNodes), t);
                };
                t(e1);
            }), V(l, (a)=>{
                const i = ((e1)=>{
                    let t = 0;
                    return V(e1.childNodes, (e1)=>{
                        ((e1)=>C(e1) && er(e1) && 0 === e1.length)(e1) || Ku(e1) || t++;
                    }), t;
                })(a);
                !(l.length > 1) && o.isBlock(a) || 0 !== i ? (Nm(s) || Sm(s) && s.wrapper) && (s.exact || 1 !== i || (a = ((e1)=>{
                    const t = J(e1.childNodes, cm).filter((e1)=>"false" !== o.getContentEditable(e1) && Ub(o, e1, s));
                    return t.map((t)=>{
                        const n = o.clone(t, !1);
                        return d(n), o.replace(n, e1, !0), o.remove(t, !0), n;
                    }).getOr(e1);
                })(a)), ((e1, t, n, o)=>{
                    Pv(t, (t)=>{
                        Nm(t) && Pv(e1.dom.select(t.inline, o), (o)=>{
                            dv(o) && Bv(e1, t, n, o, t.exact ? o : null);
                        }), ((e1, t, n)=>{
                            if (t.clear_child_styles) {
                                const o = t.links ? "*:not(a)" : "*";
                                lv(e1.select(o, n), (n)=>{
                                    dv(n) && e1.isEditable(n) && lv(t.styles, (t, o)=>{
                                        e1.setStyle(n, o, "");
                                    });
                                });
                            }
                        })(e1.dom, t, o);
                    });
                })(e1, r, n, a), ((e1, t, n, o, r)=>{
                    const s = r.parentNode;
                    jb(e1, s, n, o) && Bv(e1, t, o, r) || t.merge_with_parents && s && e1.dom.getParent(s, (s)=>!!jb(e1, s, n, o) && (Bv(e1, t, o, r), !0));
                })(e1, s, t, n, a), ((e1, t, n, o)=>{
                    if (t.styles && t.styles.backgroundColor) {
                        const r = gv(e1, "fontSize");
                        fv(o, (t)=>r(t) && e1.isEditable(t), pv(e1, "backgroundColor", vm(t.styles.backgroundColor, n)));
                    }
                })(o, s, n, a), ((e1, t, n, o)=>{
                    const r = (t)=>{
                        if (Vo(t) && qo(t.parentNode) && e1.isEditable(t)) {
                            const n = xm(e1, t.parentNode);
                            e1.getStyle(t, "color") && n ? e1.setStyle(t, "text-decoration", n) : e1.getStyle(t, "text-decoration") === n && e1.setStyle(t, "text-decoration", null);
                        }
                    };
                    t.styles && (t.styles.color || t.styles.textDecoration) && (Pt.walk(o, r, "childNodes"), r(o));
                })(o, s, 0, a), ((e1, t, n, o)=>{
                    if (Nm(t) && ("sub" === t.inline || "sup" === t.inline)) {
                        const n = gv(e1, "fontSize");
                        fv(o, (t)=>n(t) && e1.isEditable(t), pv(e1, "fontSize", ""));
                        const r = Y(e1.select("sup" === t.inline ? "sub" : "sup", o), e1.isEditable);
                        e1.remove(r, !0);
                    }
                })(o, s, 0, a), mv(e1, s, 0, a)) : o.remove(a, !0);
            });
        }, g = dm(o) ? o : l.getNode();
        if ("false" === i.getContentEditable(g) && !bm(e1, g)) return c(r, o = g), void tf(e1, t, o, n);
        if (s) {
            if (o) {
                if (dm(o)) {
                    if (!c(r, o)) {
                        const e1 = i.createRng();
                        e1.setStartBefore(o), e1.setEndAfter(o), f(i, Vm(i, e1, r), !0);
                    }
                } else f(i, o, !0);
            } else a && Nm(s) && !em(e1).length ? ((e1, t, n)=>{
                let o;
                const r = e1.selection, s = e1.formatter.get(t);
                if (!s) return;
                const a = r.getRng();
                let i = a.startOffset;
                const l = a.startContainer.nodeValue;
                o = Lu(e1.getBody(), r.getStart());
                const d = /[^\s\u00a0\u00ad\u200b\ufeff]/;
                if (l && i > 0 && i < l.length && d.test(l.charAt(i)) && d.test(l.charAt(i - 1))) {
                    const o = r.getBookmark();
                    a.collapse(!0);
                    let i = Vm(e1.dom, a, s);
                    i = Ff(i), e1.formatter.apply(t, n, i), r.moveToBookmark(o);
                } else {
                    let s = o ? qb(o) : null;
                    o && (null == s ? void 0 : s.data) === $b || (c = e1.getDoc(), u = Vb(!0).dom, o = c.importNode(u, !0), s = o.firstChild, a.insertNode(o), i = 1), e1.formatter.apply(t, n, o), r.setCursorLocation(s, i);
                }
                var c, u;
            })(e1, t, n) : (l.setRng(Eb(l.getRng())), um(e1, ()=>{
                im(e1, (e1, t)=>{
                    const n = t ? e1 : Vm(i, e1, r);
                    f(i, n, !1);
                });
            }, M), e1.nodeChanged()), ov(e1.formatter, t).each((t)=>{
                V(((e1)=>Y(((e1)=>{
                        const t = e1.getSelectedBlocks(), n = e1.getRng();
                        if (e1.isCollapsed()) return [];
                        if (1 === t.length) return rv(n, t[0]) && sv(n, t[0]) ? t : [];
                        {
                            const e1 = le(t).filter((e1)=>rv(n, e1)).toArray(), o = de(t).filter((e1)=>sv(n, e1)).toArray(), r = t.slice(1, -1);
                            return e1.concat(r).concat(o);
                        }
                    })(e1), av(e1.dom)))(e1.selection), (e1)=>Lv(i, e1, t, n));
            });
            ((e1, t)=>{
                Ee(ev, e1) && V(ev[e1], (e1)=>{
                    e1(t);
                });
            })(t, e1);
        }
        tf(e1, t, o, n);
    }, Iv = (e1, t, n, o)=>{
        (o || e1.selection.isEditable()) && Mv(e1, t, n, o);
    }, Fv = (e1)=>Ee(e1, "vars"), Uv = (e1)=>e1.selection.getStart(), zv = (e1, t, n, o, r)=>Q(t, (t)=>{
            const s = e1.formatter.matchNode(t, n, null != r ? r : {}, o);
            return !v(s);
        }, (t)=>!!Ib(e1, t, n) || !o && C(e1.formatter.matchNode(t, n, r, !0))), jv = (e1, t)=>{
        const n = null != t ? t : Uv(e1);
        return Y(Em(e1.dom, n), (e1)=>qo(e1) && !Xo(e1));
    }, Hv = (e1, t, n)=>{
        const o = jv(e1, t);
        ge(n, (n, r)=>{
            const s = (n)=>{
                const s = zv(e1, o, r, n.similar, Fv(n) ? n.vars : void 0), a = s.isSome();
                if (n.state.get() !== a) {
                    n.state.set(a);
                    const e1 = s.getOr(t);
                    Fv(n) ? n.callback(a, {
                        node: e1,
                        format: r,
                        parents: o
                    }) : V(n.callbacks, (t)=>t(a, {
                            node: e1,
                            format: r,
                            parents: o
                        }));
                }
            };
            V([
                n.withSimilar,
                n.withoutSimilar
            ], s), V(n.withVars, s);
        });
    }, $v = Pt.explode, qv = ()=>{
        const e1 = {};
        return {
            addFilter: (t, n)=>{
                V($v(t), (t)=>{
                    Ee(e1, t) || (e1[t] = {
                        name: t,
                        callbacks: []
                    }), e1[t].callbacks.push(n);
                });
            },
            getFilters: ()=>we(e1),
            removeFilter: (t, n)=>{
                V($v(t), (t)=>{
                    if (Ee(e1, t)) {
                        if (C(n)) {
                            const o = e1[t], r = Y(o.callbacks, (e1)=>e1 !== n);
                            r.length > 0 ? o.callbacks = r : delete e1[t];
                        } else delete e1[t];
                    }
                });
            }
        };
    }, Vv = (e1, t, n)=>{
        var o;
        const r = wa();
        t.convert_fonts_to_spans && ((e1, t, n)=>{
            e1.addNodeFilter("font", (e1)=>{
                V(e1, (e1)=>{
                    const o = t.parse(e1.attr("style")), r = e1.attr("color"), s = e1.attr("face"), a = e1.attr("size");
                    r && (o.color = r), s && (o["font-family"] = s), a && Xe(a).each((e1)=>{
                        o["font-size"] = n[e1 - 1];
                    }), e1.name = "span", e1.attr("style", t.serialize(o)), ((e1, t)=>{
                        V([
                            "color",
                            "face",
                            "size"
                        ], (t)=>{
                            e1.attr(t, null);
                        });
                    })(e1);
                });
            });
        })(e1, r, Pt.explode(null !== (o = t.font_size_legacy_values) && void 0 !== o ? o : "")), ((e1, t, n)=>{
            e1.addNodeFilter("strike", (e1)=>{
                const o = "html4" !== t.type;
                V(e1, (e1)=>{
                    if (o) e1.name = "s";
                    else {
                        const t = n.parse(e1.attr("style"));
                        t["text-decoration"] = "line-through", e1.name = "span", e1.attr("style", n.serialize(t));
                    }
                });
            });
        })(e1, n, r);
    }, Wv = (e1, t, n)=>{
        t.addNodeFilter("br", (t, o, r)=>{
            const s = Pt.extend({}, n.getBlockElements()), a = n.getNonEmptyElements(), i = n.getWhitespaceElements();
            s.body = 1;
            const l = (e1)=>e1.name in s || Bs(n, e1);
            for(let o = 0, d = t.length; o < d; o++){
                let d = t[o], c = d.parent;
                if (c && l(c) && d === c.lastChild) {
                    let t = d.prev;
                    for(; t;){
                        const e1 = t.name;
                        if ("span" !== e1 || "bookmark" !== t.attr("data-mce-type")) {
                            "br" === e1 && (d = null);
                            break;
                        }
                        t = t.prev;
                    }
                    if (d && (d.remove(), vb(n, a, i, c))) {
                        const t = n.getElementRule(c.name);
                        t && (t.removeEmpty ? c.remove() : t.paddEmpty && hb(e1, r, l, c));
                    }
                } else {
                    let e1 = d;
                    for(; c && c.firstChild === e1 && c.lastChild === e1 && (e1 = c, !s[c.name]);)c = c.parent;
                    if (e1 === c) {
                        const e1 = new Wg("#text", 3);
                        e1.value = br, d.replace(e1);
                    }
                }
            }
        });
    }, Kv = (e1)=>{
        const [t, ...n] = e1.split(","), o = n.join(","), r = /data:([^/]+\/[^;]+)(;.+)?/.exec(t);
        if (r) {
            const e1 = ";base64" === r[2], t = e1 ? ((e1)=>{
                const t = /([a-z0-9+\/=\s]+)/i.exec(e1);
                return t ? t[1] : "";
            })(o) : decodeURIComponent(o);
            return I.some({
                type: r[1],
                data: t,
                base64Encoded: e1
            });
        }
        return I.none();
    }, Yv = (e1, t, n = !0)=>{
        let o = t;
        if (n) try {
            o = atob(t);
        } catch (e1) {
            return I.none();
        }
        const r = new Uint8Array(o.length);
        for(let e1 = 0; e1 < r.length; e1++)r[e1] = o.charCodeAt(e1);
        return I.some(new Blob([
            r
        ], {
            type: e1
        }));
    }, Gv = (e1)=>new Promise((t, n)=>{
            const o = new FileReader;
            o.onloadend = ()=>{
                t(o.result);
            }, o.onerror = ()=>{
                var e1;
                n(null === (e1 = o.error) || void 0 === e1 ? void 0 : e1.message);
            }, o.readAsDataURL(e1);
        });
    let Xv = 0;
    const Qv = (e1, t, n)=>Kv(e1).bind(({ data: e1, type: o, base64Encoded: r })=>{
            if (t && !r) return I.none();
            {
                const t = r ? e1 : btoa(e1);
                return n(t, o);
            }
        }), Jv = (e1, t, n)=>{
        const o = e1.create("blobid" + Xv++, t, n);
        return e1.add(o), o;
    }, Zv = (e1, t, n = !1)=>Qv(t, n, (t, n)=>I.from(e1.getByData(t, n)).orThunk(()=>Yv(n, t).map((n)=>Jv(e1, n, t)))), ey = (e1, t)=>He(e1, `${t}/`), ty = (e1, t)=>{
        const n = e1.schema;
        t.remove_trailing_brs && Wv(t, e1, n), e1.addAttributeFilter("href", (e1)=>{
            let n = e1.length;
            const o = (e1)=>{
                const t = e1 ? Pt.trim(e1) : "";
                return /\b(noopener)\b/g.test(t) ? t : ((e1)=>e1.split(" ").filter((e1)=>e1.length > 0).concat([
                        "noopener"
                    ]).sort().join(" "))(t);
            };
            if (!t.allow_unsafe_link_target) for(; n--;){
                const t = e1[n];
                "a" === t.name && "_blank" === t.attr("target") && t.attr("rel", o(t.attr("rel")));
            }
        }), t.allow_html_in_named_anchor || e1.addAttributeFilter("id,name", (e1)=>{
            let t, n, o, r, s = e1.length;
            for(; s--;)if (r = e1[s], "a" === r.name && r.firstChild && !r.attr("href")) for(o = r.parent, t = r.lastChild; t && o;)n = t.prev, o.insert(t, r), t = n;
        }), t.fix_list_elements && e1.addNodeFilter("ul,ol", (e1)=>{
            let t, n, o = e1.length;
            for(; o--;)if (t = e1[o], n = t.parent, n && ("ul" === n.name || "ol" === n.name)) {
                if (t.prev && "li" === t.prev.name) t.prev.append(t);
                else {
                    const e1 = new Wg("li", 1);
                    e1.attr("style", "list-style-type: none"), t.wrap(e1);
                }
            }
        });
        const o = n.getValidClasses();
        t.validate && o && e1.addAttributeFilter("class", (e1)=>{
            var t;
            let n = e1.length;
            for(; n--;){
                const r = e1[n], s = null !== (t = r.attr("class")) && void 0 !== t ? t : "", a = Pt.explode(s, " ");
                let i = "";
                for(let e1 = 0; e1 < a.length; e1++){
                    const t = a[e1];
                    let n = !1, s = o["*"];
                    s && s[t] && (n = !0), s = o[r.name], !n && s && s[t] && (n = !0), n && (i && (i += " "), i += t);
                }
                i.length || (i = null), r.attr("class", i);
            }
        }), ((e1, t)=>{
            const { blob_cache: n } = t;
            if (n) {
                const t = (e1)=>{
                    const t = e1.attr("src");
                    ((e1)=>e1.attr("src") === At.transparentSrc || C(e1.attr("data-mce-placeholder")))(e1) || ((e1)=>C(e1.attr("data-mce-bogus")))(e1) || y(t) || Zv(n, t, !0).each((t)=>{
                        e1.attr("src", t.blobUri());
                    });
                };
                e1.addAttributeFilter("src", (e1)=>V(e1, t));
            }
        })(e1, t), t.convert_unsafe_embeds && e1.addNodeFilter("object,embed", (e1)=>V(e1, (e1)=>{
                e1.replace(((e1, t, n, o, r)=>{
                    let s;
                    s = v(e1) ? "iframe" : ey(e1, "image") ? "img" : ey(e1, "video") ? "video" : ey(e1, "audio") ? "audio" : "iframe";
                    const a = new Wg(s, 1);
                    return a.attr("audio" === s ? {
                        src: t
                    } : {
                        src: t,
                        width: n,
                        height: o
                    }), "audio" !== s && "video" !== s || a.attr("controls", ""), "iframe" === s && r && a.attr("sandbox", ""), a;
                })(e1.attr("type"), "object" === e1.name ? e1.attr("data") : e1.attr("src"), e1.attr("width"), e1.attr("height"), t.sandbox_iframes));
            })), t.sandbox_iframes && e1.addNodeFilter("iframe", (e1)=>V(e1, (e1)=>e1.attr("sandbox", "")));
    }, { entries: ny, setPrototypeOf: oy, isFrozen: ry, getPrototypeOf: sy, getOwnPropertyDescriptor: ay } = Object;
    let { freeze: iy, seal: ly, create: dy } = Object, { apply: cy, construct: uy } = "undefined" != typeof Reflect && Reflect;
    iy || (iy = function(e1) {
        return e1;
    }), ly || (ly = function(e1) {
        return e1;
    }), cy || (cy = function(e1, t, n) {
        return e1.apply(t, n);
    }), uy || (uy = function(e1, t) {
        return new e1(...t);
    });
    const my = Sy(Array.prototype.forEach), fy = Sy(Array.prototype.pop), gy = Sy(Array.prototype.push), py = Sy(String.prototype.toLowerCase), hy = Sy(String.prototype.toString), by = Sy(String.prototype.match), vy = Sy(String.prototype.replace), yy = Sy(String.prototype.indexOf), Cy = Sy(String.prototype.trim), wy = Sy(Object.prototype.hasOwnProperty), xy = Sy(RegExp.prototype.test), Ey = (_y = TypeError, function() {
        for(var e1 = arguments.length, t = new Array(e1), n = 0; n < e1; n++)t[n] = arguments[n];
        return uy(_y, t);
    });
    var _y;
    function Sy(e1) {
        return function(t) {
            for(var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)o[r - 1] = arguments[r];
            return cy(e1, t, o);
        };
    }
    function ky(e1, t) {
        let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : py;
        oy && oy(e1, null);
        let o = t.length;
        for(; o--;){
            let r = t[o];
            if ("string" == typeof r) {
                const e1 = n(r);
                e1 !== r && (ry(t) || (t[o] = e1), r = e1);
            }
            e1[r] = !0;
        }
        return e1;
    }
    function Ny(e1) {
        for(let t = 0; t < e1.length; t++)wy(e1, t) || (e1[t] = null);
        return e1;
    }
    function Ry(e1) {
        const t = dy(null);
        for (const [n, o] of ny(e1))wy(e1, n) && (Array.isArray(o) ? t[n] = Ny(o) : o && "object" == typeof o && o.constructor === Object ? t[n] = Ry(o) : t[n] = o);
        return t;
    }
    function Ay(e1, t) {
        for(; null !== e1;){
            const n = ay(e1, t);
            if (n) {
                if (n.get) return Sy(n.get);
                if ("function" == typeof n.value) return Sy(n.value);
            }
            e1 = sy(e1);
        }
        return function() {
            return null;
        };
    }
    const Ty = iy([
        "a",
        "abbr",
        "acronym",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "blink",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "content",
        "data",
        "datalist",
        "dd",
        "decorator",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "element",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meter",
        "nav",
        "nobr",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "section",
        "select",
        "shadow",
        "small",
        "source",
        "spacer",
        "span",
        "strike",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr"
    ]), Oy = iy([
        "svg",
        "a",
        "altglyph",
        "altglyphdef",
        "altglyphitem",
        "animatecolor",
        "animatemotion",
        "animatetransform",
        "circle",
        "clippath",
        "defs",
        "desc",
        "ellipse",
        "filter",
        "font",
        "g",
        "glyph",
        "glyphref",
        "hkern",
        "image",
        "line",
        "lineargradient",
        "marker",
        "mask",
        "metadata",
        "mpath",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialgradient",
        "rect",
        "stop",
        "style",
        "switch",
        "symbol",
        "text",
        "textpath",
        "title",
        "tref",
        "tspan",
        "view",
        "vkern"
    ]), By = iy([
        "feBlend",
        "feColorMatrix",
        "feComponentTransfer",
        "feComposite",
        "feConvolveMatrix",
        "feDiffuseLighting",
        "feDisplacementMap",
        "feDistantLight",
        "feDropShadow",
        "feFlood",
        "feFuncA",
        "feFuncB",
        "feFuncG",
        "feFuncR",
        "feGaussianBlur",
        "feImage",
        "feMerge",
        "feMergeNode",
        "feMorphology",
        "feOffset",
        "fePointLight",
        "feSpecularLighting",
        "feSpotLight",
        "feTile",
        "feTurbulence"
    ]), Py = iy([
        "animate",
        "color-profile",
        "cursor",
        "discard",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "foreignobject",
        "hatch",
        "hatchpath",
        "mesh",
        "meshgradient",
        "meshpatch",
        "meshrow",
        "missing-glyph",
        "script",
        "set",
        "solidcolor",
        "unknown",
        "use"
    ]), Dy = iy([
        "math",
        "menclose",
        "merror",
        "mfenced",
        "mfrac",
        "mglyph",
        "mi",
        "mlabeledtr",
        "mmultiscripts",
        "mn",
        "mo",
        "mover",
        "mpadded",
        "mphantom",
        "mroot",
        "mrow",
        "ms",
        "mspace",
        "msqrt",
        "mstyle",
        "msub",
        "msup",
        "msubsup",
        "mtable",
        "mtd",
        "mtext",
        "mtr",
        "munder",
        "munderover",
        "mprescripts"
    ]), Ly = iy([
        "maction",
        "maligngroup",
        "malignmark",
        "mlongdiv",
        "mscarries",
        "mscarry",
        "msgroup",
        "mstack",
        "msline",
        "msrow",
        "semantics",
        "annotation",
        "annotation-xml",
        "mprescripts",
        "none"
    ]), My = iy([
        "#text"
    ]), Iy = iy([
        "accept",
        "action",
        "align",
        "alt",
        "autocapitalize",
        "autocomplete",
        "autopictureinpicture",
        "autoplay",
        "background",
        "bgcolor",
        "border",
        "capture",
        "cellpadding",
        "cellspacing",
        "checked",
        "cite",
        "class",
        "clear",
        "color",
        "cols",
        "colspan",
        "controls",
        "controlslist",
        "coords",
        "crossorigin",
        "datetime",
        "decoding",
        "default",
        "dir",
        "disabled",
        "disablepictureinpicture",
        "disableremoteplayback",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "face",
        "for",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "id",
        "inputmode",
        "integrity",
        "ismap",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "loop",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "multiple",
        "muted",
        "name",
        "nonce",
        "noshade",
        "novalidate",
        "nowrap",
        "open",
        "optimum",
        "pattern",
        "placeholder",
        "playsinline",
        "popover",
        "popovertarget",
        "popovertargetaction",
        "poster",
        "preload",
        "pubdate",
        "radiogroup",
        "readonly",
        "rel",
        "required",
        "rev",
        "reversed",
        "role",
        "rows",
        "rowspan",
        "spellcheck",
        "scope",
        "selected",
        "shape",
        "size",
        "sizes",
        "span",
        "srclang",
        "start",
        "src",
        "srcset",
        "step",
        "style",
        "summary",
        "tabindex",
        "title",
        "translate",
        "type",
        "usemap",
        "valign",
        "value",
        "width",
        "wrap",
        "xmlns",
        "slot"
    ]), Fy = iy([
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "amplitude",
        "ascent",
        "attributename",
        "attributetype",
        "azimuth",
        "basefrequency",
        "baseline-shift",
        "begin",
        "bias",
        "by",
        "class",
        "clip",
        "clippathunits",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "cx",
        "cy",
        "d",
        "dx",
        "dy",
        "diffuseconstant",
        "direction",
        "display",
        "divisor",
        "dur",
        "edgemode",
        "elevation",
        "end",
        "exponent",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterunits",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyphref",
        "gradientunits",
        "gradienttransform",
        "height",
        "href",
        "id",
        "image-rendering",
        "in",
        "in2",
        "intercept",
        "k",
        "k1",
        "k2",
        "k3",
        "k4",
        "kerning",
        "keypoints",
        "keysplines",
        "keytimes",
        "lang",
        "lengthadjust",
        "letter-spacing",
        "kernelmatrix",
        "kernelunitlength",
        "lighting-color",
        "local",
        "marker-end",
        "marker-mid",
        "marker-start",
        "markerheight",
        "markerunits",
        "markerwidth",
        "maskcontentunits",
        "maskunits",
        "max",
        "mask",
        "media",
        "method",
        "mode",
        "min",
        "name",
        "numoctaves",
        "offset",
        "operator",
        "opacity",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "paint-order",
        "path",
        "pathlength",
        "patterncontentunits",
        "patterntransform",
        "patternunits",
        "points",
        "preservealpha",
        "preserveaspectratio",
        "primitiveunits",
        "r",
        "rx",
        "ry",
        "radius",
        "refx",
        "refy",
        "repeatcount",
        "repeatdur",
        "restart",
        "result",
        "rotate",
        "scale",
        "seed",
        "shape-rendering",
        "slope",
        "specularconstant",
        "specularexponent",
        "spreadmethod",
        "startoffset",
        "stddeviation",
        "stitchtiles",
        "stop-color",
        "stop-opacity",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke",
        "stroke-width",
        "style",
        "surfacescale",
        "systemlanguage",
        "tabindex",
        "tablevalues",
        "targetx",
        "targety",
        "transform",
        "transform-origin",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "textlength",
        "type",
        "u1",
        "u2",
        "unicode",
        "values",
        "viewbox",
        "visibility",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "width",
        "word-spacing",
        "wrap",
        "writing-mode",
        "xchannelselector",
        "ychannelselector",
        "x",
        "x1",
        "x2",
        "xmlns",
        "y",
        "y1",
        "y2",
        "z",
        "zoomandpan"
    ]), Uy = iy([
        "accent",
        "accentunder",
        "align",
        "bevelled",
        "close",
        "columnsalign",
        "columnlines",
        "columnspan",
        "denomalign",
        "depth",
        "dir",
        "display",
        "displaystyle",
        "encoding",
        "fence",
        "frame",
        "height",
        "href",
        "id",
        "largeop",
        "length",
        "linethickness",
        "lspace",
        "lquote",
        "mathbackground",
        "mathcolor",
        "mathsize",
        "mathvariant",
        "maxsize",
        "minsize",
        "movablelimits",
        "notation",
        "numalign",
        "open",
        "rowalign",
        "rowlines",
        "rowspacing",
        "rowspan",
        "rspace",
        "rquote",
        "scriptlevel",
        "scriptminsize",
        "scriptsizemultiplier",
        "selection",
        "separator",
        "separators",
        "stretchy",
        "subscriptshift",
        "supscriptshift",
        "symmetric",
        "voffset",
        "width",
        "xmlns"
    ]), zy = iy([
        "xlink:href",
        "xml:id",
        "xlink:title",
        "xml:space",
        "xmlns:xlink"
    ]), jy = ly(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Hy = ly(/<%[\w\W]*|[\w\W]*%>/gm), $y = ly(/\${[\w\W]*}/gm), qy = ly(/^data-[\-\w.\u00B7-\uFFFF]/), Vy = ly(/^aria-[\-\w]+$/), Wy = ly(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), Ky = ly(/^(?:\w+script|data):/i), Yy = ly(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), Gy = ly(/^html$/i), Xy = ly(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var Qy = Object.freeze({
        __proto__: null,
        MUSTACHE_EXPR: jy,
        ERB_EXPR: Hy,
        TMPLIT_EXPR: $y,
        DATA_ATTR: qy,
        ARIA_ATTR: Vy,
        IS_ALLOWED_URI: Wy,
        IS_SCRIPT_OR_DATA: Ky,
        ATTR_WHITESPACE: Yy,
        DOCTYPE_NAME: Gy,
        CUSTOM_ELEMENT: Xy
    });
    const Jy = function() {
        return "undefined" == typeof window ? null : window;
    };
    var Zy = function e1() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Jy();
        const n = (t)=>e1(t);
        if (n.version = "3.1.7", n.removed = [], !t || !t.document || 9 !== t.document.nodeType) return n.isSupported = !1, n;
        let { document: o } = t;
        const r = o, s = r.currentScript, { DocumentFragment: a, HTMLTemplateElement: i, Node: l, Element: d, NodeFilter: c, NamedNodeMap: u = t.NamedNodeMap || t.MozNamedAttrMap, HTMLFormElement: m, DOMParser: f, trustedTypes: g } = t, p = d.prototype, h = Ay(p, "cloneNode"), b = Ay(p, "remove"), v = Ay(p, "nextSibling"), y = Ay(p, "childNodes"), C = Ay(p, "parentNode");
        if ("function" == typeof i) {
            const e1 = o.createElement("template");
            e1.content && e1.content.ownerDocument && (o = e1.content.ownerDocument);
        }
        let w, x = "";
        const { implementation: E, createNodeIterator: _, createDocumentFragment: S, getElementsByTagName: k } = o, { importNode: N } = r;
        let R = {};
        n.isSupported = "function" == typeof ny && "function" == typeof C && E && void 0 !== E.createHTMLDocument;
        const { MUSTACHE_EXPR: A, ERB_EXPR: T, TMPLIT_EXPR: O, DATA_ATTR: B, ARIA_ATTR: P, IS_SCRIPT_OR_DATA: D, ATTR_WHITESPACE: L, CUSTOM_ELEMENT: M } = Qy;
        let { IS_ALLOWED_URI: I } = Qy, F = null;
        const U = ky({}, [
            ...Ty,
            ...Oy,
            ...By,
            ...Dy,
            ...My
        ]);
        let z = null;
        const j = ky({}, [
            ...Iy,
            ...Fy,
            ...Uy,
            ...zy
        ]);
        let H = Object.seal(dy(null, {
            tagNameCheck: {
                writable: !0,
                configurable: !1,
                enumerable: !0,
                value: null
            },
            attributeNameCheck: {
                writable: !0,
                configurable: !1,
                enumerable: !0,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: !0,
                configurable: !1,
                enumerable: !0,
                value: !1
            }
        })), $ = null, q = null, V = !0, W = !0, K = !1, Y = !0, G = !1, X = !0, Q = !1, J = !1, Z = !1, ee = !1, te = !1, ne = !1, oe = !0, re = !1, se = !0, ae = !1, ie = {}, le = null;
        const de = ky({}, [
            "annotation-xml",
            "audio",
            "colgroup",
            "desc",
            "foreignobject",
            "head",
            "iframe",
            "math",
            "mi",
            "mn",
            "mo",
            "ms",
            "mtext",
            "noembed",
            "noframes",
            "noscript",
            "plaintext",
            "script",
            "style",
            "svg",
            "template",
            "thead",
            "title",
            "video",
            "xmp"
        ]);
        let ce = null;
        const ue = ky({}, [
            "audio",
            "video",
            "img",
            "source",
            "image",
            "track"
        ]);
        let me = null;
        const fe = ky({}, [
            "alt",
            "class",
            "for",
            "id",
            "label",
            "name",
            "pattern",
            "placeholder",
            "role",
            "summary",
            "title",
            "value",
            "style",
            "xmlns"
        ]), ge = "http://www.w3.org/1998/Math/MathML", pe = "http://www.w3.org/2000/svg", he = "http://www.w3.org/1999/xhtml";
        let be = he, ve = !1, ye = null;
        const Ce = ky({}, [
            ge,
            pe,
            he
        ], hy);
        let we = null;
        const xe = [
            "application/xhtml+xml",
            "text/html"
        ];
        let Ee = null, _e = null;
        const Se = o.createElement("form"), ke = function(e1) {
            return e1 instanceof RegExp || e1 instanceof Function;
        }, Ne = function() {
            let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (!_e || _e !== e1) {
                if (e1 && "object" == typeof e1 || (e1 = {}), e1 = Ry(e1), we = -1 === xe.indexOf(e1.PARSER_MEDIA_TYPE) ? "text/html" : e1.PARSER_MEDIA_TYPE, Ee = "application/xhtml+xml" === we ? hy : py, F = wy(e1, "ALLOWED_TAGS") ? ky({}, e1.ALLOWED_TAGS, Ee) : U, z = wy(e1, "ALLOWED_ATTR") ? ky({}, e1.ALLOWED_ATTR, Ee) : j, ye = wy(e1, "ALLOWED_NAMESPACES") ? ky({}, e1.ALLOWED_NAMESPACES, hy) : Ce, me = wy(e1, "ADD_URI_SAFE_ATTR") ? ky(Ry(fe), e1.ADD_URI_SAFE_ATTR, Ee) : fe, ce = wy(e1, "ADD_DATA_URI_TAGS") ? ky(Ry(ue), e1.ADD_DATA_URI_TAGS, Ee) : ue, le = wy(e1, "FORBID_CONTENTS") ? ky({}, e1.FORBID_CONTENTS, Ee) : de, $ = wy(e1, "FORBID_TAGS") ? ky({}, e1.FORBID_TAGS, Ee) : {}, q = wy(e1, "FORBID_ATTR") ? ky({}, e1.FORBID_ATTR, Ee) : {}, ie = !!wy(e1, "USE_PROFILES") && e1.USE_PROFILES, V = !1 !== e1.ALLOW_ARIA_ATTR, W = !1 !== e1.ALLOW_DATA_ATTR, K = e1.ALLOW_UNKNOWN_PROTOCOLS || !1, Y = !1 !== e1.ALLOW_SELF_CLOSE_IN_ATTR, G = e1.SAFE_FOR_TEMPLATES || !1, X = !1 !== e1.SAFE_FOR_XML, Q = e1.WHOLE_DOCUMENT || !1, ee = e1.RETURN_DOM || !1, te = e1.RETURN_DOM_FRAGMENT || !1, ne = e1.RETURN_TRUSTED_TYPE || !1, Z = e1.FORCE_BODY || !1, oe = !1 !== e1.SANITIZE_DOM, re = e1.SANITIZE_NAMED_PROPS || !1, se = !1 !== e1.KEEP_CONTENT, ae = e1.IN_PLACE || !1, I = e1.ALLOWED_URI_REGEXP || Wy, be = e1.NAMESPACE || he, H = e1.CUSTOM_ELEMENT_HANDLING || {}, e1.CUSTOM_ELEMENT_HANDLING && ke(e1.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (H.tagNameCheck = e1.CUSTOM_ELEMENT_HANDLING.tagNameCheck), e1.CUSTOM_ELEMENT_HANDLING && ke(e1.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (H.attributeNameCheck = e1.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), e1.CUSTOM_ELEMENT_HANDLING && "boolean" == typeof e1.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (H.allowCustomizedBuiltInElements = e1.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), G && (W = !1), te && (ee = !0), ie && (F = ky({}, My), z = [], !0 === ie.html && (ky(F, Ty), ky(z, Iy)), !0 === ie.svg && (ky(F, Oy), ky(z, Fy), ky(z, zy)), !0 === ie.svgFilters && (ky(F, By), ky(z, Fy), ky(z, zy)), !0 === ie.mathMl && (ky(F, Dy), ky(z, Uy), ky(z, zy))), e1.ADD_TAGS && (F === U && (F = Ry(F)), ky(F, e1.ADD_TAGS, Ee)), e1.ADD_ATTR && (z === j && (z = Ry(z)), ky(z, e1.ADD_ATTR, Ee)), e1.ADD_URI_SAFE_ATTR && ky(me, e1.ADD_URI_SAFE_ATTR, Ee), e1.FORBID_CONTENTS && (le === de && (le = Ry(le)), ky(le, e1.FORBID_CONTENTS, Ee)), se && (F["#text"] = !0), Q && ky(F, [
                    "html",
                    "head",
                    "body"
                ]), F.table && (ky(F, [
                    "tbody"
                ]), delete $.tbody), e1.TRUSTED_TYPES_POLICY) {
                    if ("function" != typeof e1.TRUSTED_TYPES_POLICY.createHTML) throw Ey('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                    if ("function" != typeof e1.TRUSTED_TYPES_POLICY.createScriptURL) throw Ey('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                    w = e1.TRUSTED_TYPES_POLICY, x = w.createHTML("");
                } else void 0 === w && (w = function(e1, t) {
                    if ("object" != typeof e1 || "function" != typeof e1.createPolicy) return null;
                    let n = null;
                    const o = "data-tt-policy-suffix";
                    t && t.hasAttribute(o) && (n = t.getAttribute(o));
                    const r = "dompurify" + (n ? "#" + n : "");
                    try {
                        return e1.createPolicy(r, {
                            createHTML: (e1)=>e1,
                            createScriptURL: (e1)=>e1
                        });
                    } catch (e1) {
                        return console.warn("TrustedTypes policy " + r + " could not be created."), null;
                    }
                }(g, s)), null !== w && "string" == typeof x && (x = w.createHTML(""));
                iy && iy(e1), _e = e1;
            }
        }, Re = ky({}, [
            "mi",
            "mo",
            "mn",
            "ms",
            "mtext"
        ]), Ae = ky({}, [
            "annotation-xml"
        ]), Te = ky({}, [
            "title",
            "style",
            "font",
            "a",
            "script"
        ]), Oe = ky({}, [
            ...Oy,
            ...By,
            ...Py
        ]), Be = ky({}, [
            ...Dy,
            ...Ly
        ]), Pe = function(e1) {
            gy(n.removed, {
                element: e1
            });
            try {
                C(e1).removeChild(e1);
            } catch (t) {
                b(e1);
            }
        }, De = function(e1, t) {
            try {
                gy(n.removed, {
                    attribute: t.getAttributeNode(e1),
                    from: t
                });
            } catch (e1) {
                gy(n.removed, {
                    attribute: null,
                    from: t
                });
            }
            if (t.removeAttribute(e1), "is" === e1 && !z[e1]) {
                if (ee || te) try {
                    Pe(t);
                } catch (e1) {}
                else try {
                    t.setAttribute(e1, "");
                } catch (e1) {}
            }
        }, Le = function(e1) {
            let t = null, n = null;
            if (Z) e1 = "<remove></remove>" + e1;
            else {
                const t = by(e1, /^[\r\n\t ]+/);
                n = t && t[0];
            }
            "application/xhtml+xml" === we && be === he && (e1 = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + e1 + "</body></html>");
            const r = w ? w.createHTML(e1) : e1;
            if (be === he) try {
                t = (new f).parseFromString(r, we);
            } catch (e1) {}
            if (!t || !t.documentElement) {
                t = E.createDocument(be, "template", null);
                try {
                    t.documentElement.innerHTML = ve ? x : r;
                } catch (e1) {}
            }
            const s = t.body || t.documentElement;
            return e1 && n && s.insertBefore(o.createTextNode(n), s.childNodes[0] || null), be === he ? k.call(t, Q ? "html" : "body")[0] : Q ? t.documentElement : s;
        }, Me = function(e1) {
            return _.call(e1.ownerDocument || e1, e1, c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION, null);
        }, Ie = function(e1) {
            return e1 instanceof m && ("string" != typeof e1.nodeName || "string" != typeof e1.textContent || "function" != typeof e1.removeChild || !(e1.attributes instanceof u) || "function" != typeof e1.removeAttribute || "function" != typeof e1.setAttribute || "string" != typeof e1.namespaceURI || "function" != typeof e1.insertBefore || "function" != typeof e1.hasChildNodes);
        }, Fe = function(e1) {
            return "function" == typeof l && e1 instanceof l;
        }, Ue = function(e1, t, o) {
            R[e1] && my(R[e1], (e1)=>{
                e1.call(n, t, o, _e);
            });
        }, ze = function(e1) {
            let t = null;
            if (Ue("beforeSanitizeElements", e1, null), Ie(e1)) return Pe(e1), !0;
            const o = Ee(e1.nodeName);
            if (Ue("uponSanitizeElement", e1, {
                tagName: o,
                allowedTags: F
            }), e1.hasChildNodes() && !Fe(e1.firstElementChild) && xy(/<[/\w]/g, e1.innerHTML) && xy(/<[/\w]/g, e1.textContent)) return Pe(e1), !0;
            if (7 === e1.nodeType) return Pe(e1), !0;
            if (X && 8 === e1.nodeType && xy(/<[/\w]/g, e1.data)) return Pe(e1), !0;
            if (!F[o] || $[o]) {
                if (!$[o] && He(o)) {
                    if (H.tagNameCheck instanceof RegExp && xy(H.tagNameCheck, o)) return !1;
                    if (H.tagNameCheck instanceof Function && H.tagNameCheck(o)) return !1;
                }
                if (se && !le[o]) {
                    const t = C(e1) || e1.parentNode, n = y(e1) || e1.childNodes;
                    if (n && t) for(let o = n.length - 1; o >= 0; --o){
                        const r = h(n[o], !0);
                        r.__removalCount = (e1.__removalCount || 0) + 1, t.insertBefore(r, v(e1));
                    }
                }
                return Pe(e1), !0;
            }
            return e1 instanceof d && !function(e1) {
                let t = C(e1);
                t && t.tagName || (t = {
                    namespaceURI: be,
                    tagName: "template"
                });
                const n = py(e1.tagName), o = py(t.tagName);
                return !!ye[e1.namespaceURI] && (e1.namespaceURI === pe ? t.namespaceURI === he ? "svg" === n : t.namespaceURI === ge ? "svg" === n && ("annotation-xml" === o || Re[o]) : Boolean(Oe[n]) : e1.namespaceURI === ge ? t.namespaceURI === he ? "math" === n : t.namespaceURI === pe ? "math" === n && Ae[o] : Boolean(Be[n]) : e1.namespaceURI === he ? !(t.namespaceURI === pe && !Ae[o]) && !(t.namespaceURI === ge && !Re[o]) && !Be[n] && (Te[n] || !Oe[n]) : !("application/xhtml+xml" !== we || !ye[e1.namespaceURI]));
            }(e1) ? (Pe(e1), !0) : "noscript" !== o && "noembed" !== o && "noframes" !== o || !xy(/<\/no(script|embed|frames)/i, e1.innerHTML) ? (G && 3 === e1.nodeType && (t = e1.textContent, my([
                A,
                T,
                O
            ], (e1)=>{
                t = vy(t, e1, " ");
            }), e1.textContent !== t && (gy(n.removed, {
                element: e1.cloneNode()
            }), e1.textContent = t)), Ue("afterSanitizeElements", e1, null), !1) : (Pe(e1), !0);
        }, je = function(e1, t, n) {
            if (oe && ("id" === t || "name" === t) && (n in o || n in Se)) return !1;
            if (W && !q[t] && xy(B, t)) ;
            else if (V && xy(P, t)) ;
            else if (!z[t] || q[t]) {
                if (!(He(e1) && (H.tagNameCheck instanceof RegExp && xy(H.tagNameCheck, e1) || H.tagNameCheck instanceof Function && H.tagNameCheck(e1)) && (H.attributeNameCheck instanceof RegExp && xy(H.attributeNameCheck, t) || H.attributeNameCheck instanceof Function && H.attributeNameCheck(t)) || "is" === t && H.allowCustomizedBuiltInElements && (H.tagNameCheck instanceof RegExp && xy(H.tagNameCheck, n) || H.tagNameCheck instanceof Function && H.tagNameCheck(n)))) return !1;
            } else if (me[t]) ;
            else if (xy(I, vy(n, L, ""))) ;
            else if ("src" !== t && "xlink:href" !== t && "href" !== t || "script" === e1 || 0 !== yy(n, "data:") || !ce[e1]) {
                if (K && !xy(D, vy(n, L, ""))) ;
                else if (n) return !1;
            }
            return !0;
        }, He = function(e1) {
            return "annotation-xml" !== e1 && by(e1, M);
        }, $e = function(e1) {
            Ue("beforeSanitizeAttributes", e1, null);
            const { attributes: t } = e1;
            if (!t) return;
            const o = {
                attrName: "",
                attrValue: "",
                keepAttr: !0,
                allowedAttributes: z
            };
            let r = t.length;
            for(; r--;){
                const s = t[r], { name: a, namespaceURI: i, value: l } = s, d = Ee(a);
                let c = "value" === a ? l : Cy(l);
                const u = c;
                if (o.attrName = d, o.attrValue = c, o.keepAttr = !0, o.forceKeepAttr = void 0, Ue("uponSanitizeAttribute", e1, o), c = o.attrValue, o.forceKeepAttr) continue;
                if (!o.keepAttr) {
                    De(a, e1);
                    continue;
                }
                if (!Y && xy(/\/>/i, c)) {
                    De(a, e1);
                    continue;
                }
                G && my([
                    A,
                    T,
                    O
                ], (e1)=>{
                    c = vy(c, e1, " ");
                });
                const m = Ee(e1.nodeName);
                if (je(m, d, c)) {
                    if (!re || "id" !== d && "name" !== d || (De(a, e1), c = "user-content-" + c), X && xy(/((--!?|])>)|<\/(style|title)/i, c)) De(a, e1);
                    else {
                        if (w && "object" == typeof g && "function" == typeof g.getAttributeType) {
                            if (i) ;
                            else switch(g.getAttributeType(m, d)){
                                case "TrustedHTML":
                                    c = w.createHTML(c);
                                    break;
                                case "TrustedScriptURL":
                                    c = w.createScriptURL(c);
                            }
                        }
                        if (c !== u) try {
                            i ? e1.setAttributeNS(i, a, c) : e1.setAttribute(a, c), Ie(e1) ? Pe(e1) : fy(n.removed);
                        } catch (e1) {}
                    }
                } else De(a, e1);
            }
            Ue("afterSanitizeAttributes", e1, null);
        }, qe = function e1(t) {
            let n = null;
            const o = Me(t);
            for(Ue("beforeSanitizeShadowDOM", t, null); n = o.nextNode();)Ue("uponSanitizeShadowNode", n, null), ze(n) || (n.content instanceof a && e1(n.content), $e(n));
            Ue("afterSanitizeShadowDOM", t, null);
        };
        return n.sanitize = function(e1) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, o = null, s = null, i = null, d = null;
            if (ve = !e1, ve && (e1 = "\x3c!--\x3e"), "string" != typeof e1 && !Fe(e1)) {
                if ("function" != typeof e1.toString) throw Ey("toString is not a function");
                if ("string" != typeof (e1 = e1.toString())) throw Ey("dirty is not a string, aborting");
            }
            if (!n.isSupported) return e1;
            if (J || Ne(t), n.removed = [], "string" == typeof e1 && (ae = !1), ae) {
                if (e1.nodeName) {
                    const t = Ee(e1.nodeName);
                    if (!F[t] || $[t]) throw Ey("root node is forbidden and cannot be sanitized in-place");
                }
            } else if (e1 instanceof l) o = Le("\x3c!----\x3e"), s = o.ownerDocument.importNode(e1, !0), 1 === s.nodeType && "BODY" === s.nodeName || "HTML" === s.nodeName ? o = s : o.appendChild(s);
            else {
                if (!ee && !G && !Q && -1 === e1.indexOf("<")) return w && ne ? w.createHTML(e1) : e1;
                if (o = Le(e1), !o) return ee ? null : ne ? x : "";
            }
            o && Z && Pe(o.firstChild);
            const c = Me(ae ? e1 : o);
            for(; i = c.nextNode();)ze(i) || (i.content instanceof a && qe(i.content), $e(i));
            if (ae) return e1;
            if (ee) {
                if (te) for(d = S.call(o.ownerDocument); o.firstChild;)d.appendChild(o.firstChild);
                else d = o;
                return (z.shadowroot || z.shadowrootmode) && (d = N.call(r, d, !0)), d;
            }
            let u = Q ? o.outerHTML : o.innerHTML;
            return Q && F["!doctype"] && o.ownerDocument && o.ownerDocument.doctype && o.ownerDocument.doctype.name && xy(Gy, o.ownerDocument.doctype.name) && (u = "<!DOCTYPE " + o.ownerDocument.doctype.name + ">\n" + u), G && my([
                A,
                T,
                O
            ], (e1)=>{
                u = vy(u, e1, " ");
            }), w && ne ? w.createHTML(u) : u;
        }, n.setConfig = function() {
            Ne(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), J = !0;
        }, n.clearConfig = function() {
            _e = null, J = !1;
        }, n.isValidAttribute = function(e1, t, n) {
            _e || Ne({});
            const o = Ee(e1), r = Ee(t);
            return je(o, r, n);
        }, n.addHook = function(e1, t) {
            "function" == typeof t && (R[e1] = R[e1] || [], gy(R[e1], t));
        }, n.removeHook = function(e1) {
            if (R[e1]) return fy(R[e1]);
        }, n.removeHooks = function(e1) {
            R[e1] && (R[e1] = []);
        }, n.removeAllHooks = function() {
            R = {};
        }, n;
    }();
    const eC = Pt.each, tC = Pt.trim, nC = [
        "source",
        "protocol",
        "authority",
        "userInfo",
        "user",
        "password",
        "host",
        "port",
        "relative",
        "path",
        "directory",
        "file",
        "query",
        "anchor"
    ], oC = {
        ftp: 21,
        http: 80,
        https: 443,
        mailto: 25
    }, rC = [
        "img",
        "video"
    ], sC = (e1, t, n)=>{
        const o = ((e1)=>{
            try {
                return decodeURIComponent(e1);
            } catch (t) {
                return unescape(e1);
            }
        })(t).replace(/\s/g, "");
        return !e1.allow_script_urls && (!!/((java|vb)script|mhtml):/i.test(o) || !e1.allow_html_data_urls && (/^data:image\//i.test(o) ? ((e1, t)=>C(e1) ? !e1 : !C(t) || !H(rC, t))(e1.allow_svg_data_urls, n) && /^data:image\/svg\+xml/i.test(o) : /^data:/i.test(o)));
    };
    class aC {
        static parseDataUri(e1) {
            let t;
            const n = decodeURIComponent(e1).split(","), o = /data:([^;]+)/.exec(n[0]);
            return o && (t = o[1]), {
                type: t,
                data: n[1]
            };
        }
        static isDomSafe(e1, t, n = {}) {
            if (n.allow_script_urls) return !0;
            {
                const o = ea.decode(e1).replace(/[\s\u0000-\u001F]+/g, "");
                return !sC(n, o, t);
            }
        }
        static getDocumentBaseUrl(e1) {
            var t;
            let n;
            return n = 0 !== e1.protocol.indexOf("http") && "file:" !== e1.protocol ? null !== (t = e1.href) && void 0 !== t ? t : "" : e1.protocol + "//" + e1.host + e1.pathname, /^[^:]+:\/\/\/?[^\/]+\//.test(n) && (n = n.replace(/[\?#].*$/, "").replace(/[\/\\][^\/]+$/, ""), /[\/\\]$/.test(n) || (n += "/")), n;
        }
        constructor(e1, t = {}){
            this.path = "", this.directory = "", e1 = tC(e1), this.settings = t;
            const n = t.base_uri, o = this;
            if (/^([\w\-]+):([^\/]{2})/i.test(e1) || /^\s*#/.test(e1)) return void (o.source = e1);
            const r = 0 === e1.indexOf("//");
            if (0 !== e1.indexOf("/") || r || (e1 = (n && n.protocol || "http") + "://mce_host" + e1), !/^[\w\-]*:?\/\//.test(e1)) {
                const t = n ? n.path : new aC(document.location.href).directory;
                if ("" === (null == n ? void 0 : n.protocol)) e1 = "//mce_host" + o.toAbsPath(t, e1);
                else {
                    const r = /([^#?]*)([#?]?.*)/.exec(e1);
                    r && (e1 = (n && n.protocol || "http") + "://mce_host" + o.toAbsPath(t, r[1]) + r[2]);
                }
            }
            e1 = e1.replace(/@@/g, "(mce_at)");
            const s = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@\/]*):?([^:@\/]*))?@)?(\[[a-zA-Z0-9:.%]+\]|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/.exec(e1);
            s && eC(nC, (e1, t)=>{
                let n = s[t];
                n && (n = n.replace(/\(mce_at\)/g, "@@")), o[e1] = n;
            }), n && (o.protocol || (o.protocol = n.protocol), o.userInfo || (o.userInfo = n.userInfo), o.port || "mce_host" !== o.host || (o.port = n.port), o.host && "mce_host" !== o.host || (o.host = n.host), o.source = ""), r && (o.protocol = "");
        }
        setPath(e1) {
            const t = /^(.*?)\/?(\w+)?$/.exec(e1);
            t && (this.path = t[0], this.directory = t[1], this.file = t[2]), this.source = "", this.getURI();
        }
        toRelative(e1) {
            if ("./" === e1) return e1;
            const t = new aC(e1, {
                base_uri: this
            });
            if ("mce_host" !== t.host && this.host !== t.host && t.host || this.port !== t.port || this.protocol !== t.protocol && "" !== t.protocol) return t.getURI();
            const n = this.getURI(), o = t.getURI();
            if (n === o || "/" === n.charAt(n.length - 1) && n.substr(0, n.length - 1) === o) return n;
            let r = this.toRelPath(this.path, t.path);
            return t.query && (r += "?" + t.query), t.anchor && (r += "#" + t.anchor), r;
        }
        toAbsolute(e1, t) {
            const n = new aC(e1, {
                base_uri: this
            });
            return n.getURI(t && this.isSameOrigin(n));
        }
        isSameOrigin(e1) {
            if (this.host == e1.host && this.protocol == e1.protocol) {
                if (this.port == e1.port) return !0;
                const t = this.protocol ? oC[this.protocol] : null;
                if (t && (this.port || t) == (e1.port || t)) return !0;
            }
            return !1;
        }
        toRelPath(e1, t) {
            let n, o, r = 0, s = "";
            const a = e1.substring(0, e1.lastIndexOf("/")).split("/"), i = t.split("/");
            if (a.length >= i.length) {
                for(n = 0, o = a.length; n < o; n++)if (n >= i.length || a[n] !== i[n]) {
                    r = n + 1;
                    break;
                }
            }
            if (a.length < i.length) {
                for(n = 0, o = i.length; n < o; n++)if (n >= a.length || a[n] !== i[n]) {
                    r = n + 1;
                    break;
                }
            }
            if (1 === r) return t;
            for(n = 0, o = a.length - (r - 1); n < o; n++)s += "../";
            for(n = r - 1, o = i.length; n < o; n++)s += n !== r - 1 ? "/" + i[n] : i[n];
            return s;
        }
        toAbsPath(e1, t) {
            let n = 0;
            const o = /\/$/.test(t) ? "/" : "", r = e1.split("/"), s = t.split("/"), a = [];
            eC(r, (e1)=>{
                e1 && a.push(e1);
            });
            const i = [];
            for(let e1 = s.length - 1; e1 >= 0; e1--)0 !== s[e1].length && "." !== s[e1] && (".." !== s[e1] ? n > 0 ? n-- : i.push(s[e1]) : n++);
            const l = a.length - n;
            let d;
            return d = l <= 0 ? oe(i).join("/") : a.slice(0, l).join("/") + "/" + oe(i).join("/"), 0 !== d.indexOf("/") && (d = "/" + d), o && d.lastIndexOf("/") !== d.length - 1 && (d += o), d;
        }
        getURI(e1 = !1) {
            let t;
            return this.source && !e1 || (t = "", e1 || (this.protocol ? t += this.protocol + "://" : t += "//", this.userInfo && (t += this.userInfo + "@"), this.host && (t += this.host), this.port && (t += ":" + this.port)), this.path && (t += this.path), this.query && (t += "?" + this.query), this.anchor && (t += "#" + this.anchor), this.source = t), this.source;
        }
    }
    const iC = Pt.makeMap("src,href,data,background,action,formaction,poster,xlink:href"), lC = "data-mce-type";
    let dC = 0;
    const cC = (e1, t, n, o, r)=>{
        var s, a, i, l;
        const d = t.validate, c = n.getSpecialElements();
        8 === e1.nodeType && !t.allow_conditional_comments && /^\[if/i.test(null !== (s = e1.nodeValue) && void 0 !== s ? s : "") && (e1.nodeValue = " " + e1.nodeValue);
        const u = null !== (a = null == r ? void 0 : r.tagName) && void 0 !== a ? a : e1.nodeName.toLowerCase();
        if ("html" !== o && n.isValid(o)) return void (C(r) && (r.allowedTags[u] = !0));
        if (1 !== e1.nodeType || "body" === u) return;
        const f = yn(e1), g = nn(f, lC), p = en(f, "data-mce-bogus");
        if (!g && m(p)) return void ("all" === p ? xo(f) : Eo(f));
        const h = n.getElementRule(u);
        if (!d || h) {
            if (C(r) && (r.allowedTags[u] = !0), d && h && !g) {
                if (V(null !== (i = h.attributesForced) && void 0 !== i ? i : [], (e1)=>{
                    Jt(f, e1.name, "{$uid}" === e1.value ? "mce_" + dC++ : e1.value);
                }), V(null !== (l = h.attributesDefault) && void 0 !== l ? l : [], (e1)=>{
                    nn(f, e1.name) || Jt(f, e1.name, "{$uid}" === e1.value ? "mce_" + dC++ : e1.value);
                }), h.attributesRequired && !$(h.attributesRequired, (e1)=>nn(f, e1))) return void Eo(f);
                if (h.removeEmptyAttrs && ((e1)=>{
                    const t = e1.dom.attributes;
                    return null == t || 0 === t.length;
                })(f)) return void Eo(f);
                h.outputName && h.outputName !== u && ((e1, t)=>{
                    const n = ((e1, t)=>{
                        const n = bn(t), o = rn(e1);
                        return Zt(n, o), n;
                    })(e1, t);
                    ho(e1, n);
                    const o = Mn(e1);
                    Co(n, o), xo(e1);
                })(f, h.outputName);
            }
        } else Ee(c, u) ? xo(f) : Eo(f);
    }, uC = (e1, t, n, o, r, s)=>"html" !== n && !ps(o) || !(r in iC && sC(e1, s, o)) && (!e1.validate || t.isValid(o, r) || He(r, "data-") || He(r, "aria-")), mC = (e1, t)=>e1.hasAttribute(lC) && ("id" === t || "class" === t || "style" === t), fC = (e1, t)=>e1 in t.getBoolAttrs(), gC = (e1, t, n, o)=>{
        const { attributes: r } = e1;
        for(let s = r.length - 1; s >= 0; s--){
            const a = r[s], i = a.name, l = a.value;
            uC(t, n, o, e1.tagName.toLowerCase(), i, l) || mC(e1, i) ? fC(i, n) && e1.setAttribute(i, i) : e1.removeAttribute(i);
        }
    }, pC = (e1, t, n)=>{
        const o = Zy();
        return o.addHook("uponSanitizeElement", (o, r)=>{
            cC(o, e1, t, n.track(o), r);
        }), o.addHook("uponSanitizeAttribute", (o, r)=>{
            ((e1, t, n, o, r)=>{
                const s = e1.tagName.toLowerCase(), { attrName: a, attrValue: i } = r;
                r.keepAttr = uC(t, n, o, s, a, i), r.keepAttr ? (r.allowedAttributes[a] = !0, fC(a, n) && (r.attrValue = a), t.allow_svg_data_urls && He(i, "data:image/svg+xml") && (r.forceKeepAttr = !0)) : mC(e1, a) && (r.forceKeepAttr = !0);
            })(o, e1, t, n.current(), r);
        }), o;
    }, hC = (e1)=>{
        const t = [
            "type",
            "href",
            "role",
            "arcrole",
            "title",
            "show",
            "actuate",
            "label",
            "from",
            "to"
        ].map((e1)=>`xlink:${e1}`), n = {
            IN_PLACE: !0,
            USE_PROFILES: {
                html: !0,
                svg: !0,
                svgFilters: !0
            },
            ALLOWED_ATTR: t
        };
        return Zy().sanitize(e1, n), e1.innerHTML;
    }, bC = Pt.makeMap, vC = Pt.extend, yC = (e1, t, n, o)=>{
        const r = e1.name, s = r in n && "title" !== r && "textarea" !== r && "noscript" !== r, a = t.childNodes;
        for(let t = 0, r = a.length; t < r; t++){
            const r = a[t], i = new Wg(r.nodeName.toLowerCase(), r.nodeType);
            if (qo(r)) {
                const e1 = r.attributes;
                for(let t = 0, n = e1.length; t < n; t++){
                    const n = e1[t];
                    i.attr(n.name, n.value);
                }
                ps(i.name) && (o(r), i.value = r.innerHTML);
            } else er(r) ? (i.value = r.data, s && (i.raw = !0)) : (or(r) || tr(r) || nr(r)) && (i.value = r.data);
            ps(i.name) || yC(i, r, n, o), e1.append(i);
        }
    }, CC = (e1 = {}, t = ua())=>{
        const n = qv(), o = qv(), r = {
            validate: !0,
            root_name: "body",
            sanitize: !0,
            ...e1
        }, s = new DOMParser, a = ((e1, t)=>{
            const n = (()=>{
                let e1 = [];
                const t = ()=>e1[e1.length - 1];
                return {
                    track: (n)=>{
                        hs(n) && e1.push(n);
                        let o = t();
                        return o && !o.contains(n) && (e1.pop(), o = t()), bs(o);
                    },
                    current: ()=>bs(t()),
                    reset: ()=>{
                        e1 = [];
                    }
                };
            })();
            if (e1.sanitize) {
                const o = pC(e1, t, n), r = (t, r)=>{
                    o.sanitize(t, ((e1, t)=>{
                        const n = {
                            IN_PLACE: !0,
                            ALLOW_UNKNOWN_PROTOCOLS: !0,
                            ALLOWED_TAGS: [
                                "#comment",
                                "#cdata-section",
                                "body"
                            ],
                            ALLOWED_ATTR: [],
                            SAFE_FOR_XML: !1
                        };
                        return n.PARSER_MEDIA_TYPE = t, e1.allow_script_urls ? n.ALLOWED_URI_REGEXP = /.*/ : e1.allow_html_data_urls && (n.ALLOWED_URI_REGEXP = /^(?!(\w+script|mhtml):)/i), n;
                    })(e1, r)), o.removed = [], n.reset();
                };
                return {
                    sanitizeHtmlElement: r,
                    sanitizeNamespaceElement: hC
                };
            }
            return {
                sanitizeHtmlElement: (o, r)=>{
                    const s = document.createNodeIterator(o, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT);
                    let a;
                    for(; a = s.nextNode();){
                        const o = n.track(a);
                        cC(a, e1, t, o), qo(a) && gC(a, e1, t, o);
                    }
                    n.reset();
                },
                sanitizeNamespaceElement: _
            };
        })(r, t), i = n.addFilter, l = n.getFilters, d = n.removeFilter, c = o.addFilter, u = o.getFilters, f = o.removeFilter, g = (e1, n)=>{
            const o = m(n.attr(lC)), r = 1 === n.type && !Ee(e1, n.name) && !Bs(t, n) && !ps(n.name);
            return 3 === n.type || r && !o;
        }, p = {
            schema: t,
            addAttributeFilter: c,
            getAttributeFilters: u,
            removeAttributeFilter: f,
            addNodeFilter: i,
            getNodeFilters: l,
            removeNodeFilter: d,
            parse: (e1, n = {})=>{
                var o;
                const i = r.validate, d = null !== (o = n.context) && void 0 !== o ? o : r.root_name, c = ((e1, n, o = "html")=>{
                    const r = "xhtml" === o ? "application/xhtml+xml" : "text/html", i = Ee(t.getSpecialElements(), n.toLowerCase()), l = i ? `<${n}>${e1}</${n}>` : e1, d = "xhtml" === o ? `<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>${l}</body></html>` : `<body>${l}</body>`, c = s.parseFromString(d, r).body;
                    return a.sanitizeHtmlElement(c, r), i ? c.firstChild : c;
                })(e1, d, n.format);
                Ss(t, c);
                const m = new Wg(d, 11);
                yC(m, c, t.getSpecialElements(), a.sanitizeNamespaceElement), c.innerHTML = "";
                const [f, p] = ((e1, t, n, o)=>{
                    const r = n.validate, s = t.getNonEmptyElements(), a = t.getWhitespaceElements(), i = vC(bC("script,style,head,html,body,title,meta,param"), t.getBlockElements()), l = da(t), d = /[ \t\r\n]+/g, c = /^[ \t\r\n]+/, u = /[ \t\r\n]+$/, m = (e1)=>{
                        let t = e1.parent;
                        for(; C(t);){
                            if (t.name in a) return !0;
                            t = t.parent;
                        }
                        return !1;
                    }, f = (n)=>n.name in i || Bs(t, n) || ps(n.name) && n.parent === e1, g = (t, n)=>{
                        const r = n ? t.prev : t.next;
                        return !C(r) && !y(t.parent) && f(t.parent) && (t.parent !== e1 || !0 === o.isRootContent);
                    };
                    return [
                        (e1)=>{
                            var t;
                            if (3 === e1.type && !m(e1)) {
                                let n = null !== (t = e1.value) && void 0 !== t ? t : "";
                                n = n.replace(d, " "), (((e1, t)=>C(e1) && (t(e1) || "br" === e1.name))(e1.prev, f) || g(e1, !0)) && (n = n.replace(c, "")), 0 === n.length ? e1.remove() : e1.value = n;
                            }
                        },
                        (e1)=>{
                            var i;
                            if (1 === e1.type) {
                                const i = t.getElementRule(e1.name);
                                if (r && i) {
                                    const r = vb(t, s, a, e1);
                                    i.paddInEmptyBlock && r && ((e1)=>{
                                        let n = e1;
                                        for(; C(n);){
                                            if (n.name in l) return vb(t, s, a, n);
                                            n = n.parent;
                                        }
                                        return !1;
                                    })(e1) ? hb(n, o, f, e1) : i.removeEmpty && r ? f(e1) ? e1.remove() : e1.unwrap() : i.paddEmpty && (r || ((e1)=>{
                                        var t;
                                        return bb(e1, "#text") && (null === (t = null == e1 ? void 0 : e1.firstChild) || void 0 === t ? void 0 : t.value) === br;
                                    })(e1)) && hb(n, o, f, e1);
                                }
                            } else if (3 === e1.type && !m(e1)) {
                                let t = null !== (i = e1.value) && void 0 !== i ? i : "";
                                (e1.next && f(e1.next) || g(e1, !1)) && (t = t.replace(u, "")), 0 === t.length ? e1.remove() : e1.value = t;
                            }
                        }
                    ];
                })(m, t, r, n), h = [], b = i ? (e1)=>((e1, n)=>{
                        xb(t, e1) && n.push(e1);
                    })(e1, h) : _, v = {
                    nodes: {},
                    attributes: {}
                }, w = (e1)=>fb(l(), u(), e1, v);
                if (((e1, t, n)=>{
                    const o = [];
                    for(let n = e1, r = n; n; r = n, n = n.walk()){
                        const s = n;
                        V(t, (e1)=>e1(s)), y(s.parent) && s !== e1 ? n = r : o.push(s);
                    }
                    for(let e1 = o.length - 1; e1 >= 0; e1--){
                        const t = o[e1];
                        V(n, (e1)=>e1(t));
                    }
                })(m, [
                    f,
                    w
                ], [
                    p,
                    b
                ]), h.reverse(), i && h.length > 0) {
                    if (n.context) {
                        const { pass: e1, fail: o } = K(h, (e1)=>e1.parent === m);
                        wb(o, t, m, w), n.invalid = e1.length > 0;
                    } else wb(h, t, m, w);
                }
                const x = ((e1, t)=>{
                    var n;
                    const o = null !== (n = t.forced_root_block) && void 0 !== n ? n : e1.forced_root_block;
                    return !1 === o ? "" : !0 === o ? "p" : o;
                })(r, n);
                return x && ("body" === m.name || n.isRootContent) && ((e1, n)=>{
                    const o = vC(bC("script,style,head,html,body,title,meta,param"), t.getBlockElements()), s = /^[ \t\r\n]+/, a = /[ \t\r\n]+$/;
                    let i = e1.firstChild, l = null;
                    const d = (e1)=>{
                        var t, n;
                        e1 && (i = e1.firstChild, i && 3 === i.type && (i.value = null === (t = i.value) || void 0 === t ? void 0 : t.replace(s, "")), i = e1.lastChild, i && 3 === i.type && (i.value = null === (n = i.value) || void 0 === n ? void 0 : n.replace(a, "")));
                    };
                    if (t.isValidChild(e1.name, n.toLowerCase())) {
                        for(; i;){
                            const t = i.next;
                            g(o, i) ? (l || (l = new Wg(n, 1), l.attr(r.forced_root_block_attrs), e1.insert(l, i)), l.append(i)) : (d(l), l = null), i = t;
                        }
                        d(l);
                    }
                })(m, x), n.invalid || gb(v, n), m;
            }
        };
        return ty(p, r), ((e1, t, n)=>{
            t.inline_styles && Vv(e1, t, n);
        })(p, r, t), p;
    }, wC = (e1, t, n)=>{
        const o = ((e1)=>Bb(e1) ? up({
                validate: !1
            }).serialize(e1) : e1)(e1), r = t(o);
        if (r.isDefaultPrevented()) return r;
        if (Bb(e1)) {
            if (r.content !== o) {
                const t = CC({
                    validate: !1,
                    forced_root_block: !1,
                    ...n
                }).parse(r.content, {
                    context: e1.name
                });
                return {
                    ...r,
                    content: t
                };
            }
            return {
                ...r,
                content: e1
            };
        }
        return r;
    }, xC = (e1, t)=>{
        if (t.no_events) return pl.value(t);
        {
            const n = ((e1, t)=>e1.dispatch("BeforeGetContent", t))(e1, t);
            return n.isDefaultPrevented() ? pl.error(rf(e1, {
                content: "",
                ...n
            }).content) : pl.value(n);
        }
    }, EC = (e1, t, n)=>{
        if (n.no_events) return t;
        {
            const o = wC(t, (t)=>rf(e1, {
                    ...n,
                    content: t
                }), {
                sanitize: fc(e1),
                sandbox_iframes: Cc(e1)
            });
            return o.content;
        }
    }, _C = (e1, t)=>{
        if (t.no_events) return pl.value(t);
        {
            const n = wC(t.content, (n)=>((e1, t)=>e1.dispatch("BeforeSetContent", t))(e1, {
                    ...t,
                    content: n
                }), {
                sanitize: fc(e1),
                sandbox_iframes: Cc(e1)
            });
            return n.isDefaultPrevented() ? (of(e1, n), pl.error(void 0)) : pl.value(n);
        }
    }, SC = (e1, t, n)=>{
        n.no_events || of(e1, {
            ...n,
            content: t
        });
    }, kC = (e1, t, n)=>({
            element: e1,
            width: t,
            rows: n
        }), NC = (e1, t)=>({
            element: e1,
            cells: t
        }), RC = (e1, t)=>({
            x: e1,
            y: t
        }), AC = (e1, t)=>tn(e1, t).bind(Xe).getOr(1), TC = (e1, t, n)=>{
        const o = e1.rows;
        return !!(o[n] ? o[n].cells : [])[t];
    }, OC = (e1)=>X(e1, (e1, t)=>t.cells.length > e1 ? t.cells.length : e1, 0), BC = (e1, t)=>{
        const n = e1.rows;
        for(let e1 = 0; e1 < n.length; e1++){
            const o = n[e1].cells;
            for(let n = 0; n < o.length; n++)if (_n(o[n], t)) return I.some(RC(n, e1));
        }
        return I.none();
    }, PC = (e1, t, n, o, r)=>{
        const s = [], a = e1.rows;
        for(let e1 = n; e1 <= r; e1++){
            const n = a[e1].cells, r = t < o ? n.slice(t, o + 1) : n.slice(o, t + 1);
            s.push(NC(a[e1].element, r));
        }
        return s;
    }, DC = (e1)=>((e1, t)=>{
            const n = fi(e1.element), o = bn("tbody");
            return Co(o, t), vo(n, o), n;
        })(e1, ((e1)=>q(e1.rows, (e1)=>{
                const t = q(e1.cells, (e1)=>{
                    const t = gi(e1);
                    return on(t, "colspan"), on(t, "rowspan"), t;
                }), n = fi(e1.element);
                return Co(n, t), n;
            }))(e1)), LC = (e1, t, n)=>{
        const o = yn(t.commonAncestorContainer), r = Bp(o, e1), s = Y(r, (e1)=>n.isWrapper(Ht(e1))), a = ((e1, t)=>J(e1, (e1)=>"li" === Ht(e1) && rm(e1, t)).fold(N([]), (t)=>((e1)=>J(e1, (e1)=>"ul" === Ht(e1) || "ol" === Ht(e1)))(e1).map((e1)=>{
                    const t = bn(Ht(e1)), n = ye(fo(e1), (e1, t)=>He(t, "list-style"));
                    return lo(t, n), [
                        bn("li"),
                        t
                    ];
                }).getOr([])))(r, t), i = s.concat(a.length ? a : ((e1)=>kr(e1) ? An(e1).filter(Sr).fold(N([]), (t)=>[
                    e1,
                    t
                ]) : Sr(e1) ? [
                e1
            ] : [])(o));
        return q(i, fi);
    }, MC = ()=>kf([]), IC = (e1, t)=>((e1, t)=>eo(t, "table", T(_n, e1)))(e1, t[0]).bind((e1)=>{
            const n = t[0], o = t[t.length - 1], r = ((e1)=>{
                const t = kC(fi(e1), 0, []);
                return V(Uo(e1, "tr"), (e1, n)=>{
                    V(Uo(e1, "td,th"), (o, r)=>{
                        ((e1, t, n, o, r)=>{
                            const s = AC(r, "rowspan"), a = AC(r, "colspan"), i = e1.rows;
                            for(let e1 = n; e1 < n + s; e1++){
                                i[e1] || (i[e1] = NC(gi(o), []));
                                for(let o = t; o < t + a; o++)i[e1].cells[o] = e1 === n && o === t ? r : fi(r);
                            }
                        })(t, ((e1, t, n)=>{
                            for(; TC(e1, t, n);)t++;
                            return t;
                        })(t, r, n), n, e1, o);
                    });
                }), kC(t.element, OC(t.rows), t.rows);
            })(e1);
            return ((e1, t, n)=>BC(e1, t).bind((t)=>BC(e1, n).map((n)=>((e1, t, n)=>{
                            const o = t.x, r = t.y, s = n.x, a = n.y, i = r < a ? PC(e1, o, r, s, a) : PC(e1, o, a, s, r);
                            return kC(e1.element, OC(i), i);
                        })(e1, t, n))))(r, n, o).map((e1)=>kf([
                    DC(e1)
                ]));
        }).getOrThunk(MC), FC = (e1, t, n)=>{
        const o = Zu(t, e1);
        return o.length > 0 ? IC(e1, o) : ((e1, t, n)=>t.length > 0 && t[0].collapsed ? MC() : ((e1, t, n)=>((e1, t)=>{
                    const n = X(t, (e1, t)=>(vo(t, e1), t), e1);
                    return t.length > 0 ? kf([
                        n
                    ]) : n;
                })(yn(t.cloneContents()), LC(e1, t, n)))(e1, t[0], n))(e1, t, n);
    }, UC = (e1, t)=>t >= 0 && t < e1.length && Xu(e1.charAt(t)), zC = (e1)=>Dr(e1.innerText), jC = (e1)=>qo(e1) ? e1.outerHTML : er(e1) ? ea.encodeRaw(e1.data, !1) : or(e1) ? "\x3c!--" + e1.data + "--\x3e" : "", HC = (e1, t)=>(((e1, t)=>{
            let n = 0;
            V(e1, (e1)=>{
                0 === e1[0] ? n++ : 1 === e1[0] ? (((e1, t, n)=>{
                    const o = ((e1)=>{
                        let t;
                        const n = document.createElement("div"), o = document.createDocumentFragment();
                        for(e1 && (n.innerHTML = e1); t = n.firstChild;)o.appendChild(t);
                        return o;
                    })(t);
                    if (e1.hasChildNodes() && n < e1.childNodes.length) {
                        const t = e1.childNodes[n];
                        e1.insertBefore(o, t);
                    } else e1.appendChild(o);
                })(t, e1[1], n), n++) : 2 === e1[0] && ((e1, t)=>{
                    if (e1.hasChildNodes() && t < e1.childNodes.length) {
                        const n = e1.childNodes[t];
                        e1.removeChild(n);
                    }
                })(t, n);
            });
        })(((e1, t)=>{
            const n = e1.length + t.length + 2, o = new Array(n), r = new Array(n), s = (n, o, r, a, l)=>{
                const d = i(n, o, r, a);
                if (null === d || d.start === o && d.diag === o - a || d.end === n && d.diag === n - r) {
                    let s = n, i = r;
                    for(; s < o || i < a;)s < o && i < a && e1[s] === t[i] ? (l.push([
                        0,
                        e1[s]
                    ]), ++s, ++i) : o - n > a - r ? (l.push([
                        2,
                        e1[s]
                    ]), ++s) : (l.push([
                        1,
                        t[i]
                    ]), ++i);
                } else {
                    s(n, d.start, r, d.start - d.diag, l);
                    for(let t = d.start; t < d.end; ++t)l.push([
                        0,
                        e1[t]
                    ]);
                    s(d.end, o, d.end - d.diag, a, l);
                }
            }, a = (n, o, r, s)=>{
                let a = n;
                for(; a - o < s && a < r && e1[a] === t[a - o];)++a;
                return ((e1, t, n)=>({
                        start: e1,
                        end: t,
                        diag: n
                    }))(n, a, o);
            }, i = (n, s, i, l)=>{
                const d = s - n, c = l - i;
                if (0 === d || 0 === c) return null;
                const u = d - c, m = c + d, f = (m % 2 == 0 ? m : m + 1) / 2;
                let g, p, h, b, v;
                for(o[1 + f] = n, r[1 + f] = s + 1, g = 0; g <= f; ++g){
                    for(p = -g; p <= g; p += 2){
                        for(h = p + f, p === -g || p !== g && o[h - 1] < o[h + 1] ? o[h] = o[h + 1] : o[h] = o[h - 1] + 1, b = o[h], v = b - n + i - p; b < s && v < l && e1[b] === t[v];)o[h] = ++b, ++v;
                        if (u % 2 != 0 && u - g <= p && p <= u + g && r[h - u] <= o[h]) return a(r[h - u], p + n - i, s, l);
                    }
                    for(p = u - g; p <= u + g; p += 2){
                        for(h = p + f - u, p === u - g || p !== u + g && r[h + 1] <= r[h - 1] ? r[h] = r[h + 1] - 1 : r[h] = r[h - 1], b = r[h] - 1, v = b - n + i - p; b >= n && v >= i && e1[b] === t[v];)r[h] = b--, v--;
                        if (u % 2 == 0 && -g <= p && p <= g && r[h] <= o[h + u]) return a(r[h], p + n - i, s, l);
                    }
                }
                return null;
            }, l = [];
            return s(0, e1.length, 0, t.length, l), l;
        })(q(ce(t.childNodes), jC), e1), t), t), $C = De(()=>document.implementation.createHTMLDocument("undo")), qC = (e1)=>{
        const t = e1.serializer.getTempAttrs(), n = sp(e1.getBody(), t);
        return ((e1)=>null !== e1.querySelector("iframe"))(n) ? {
            type: "fragmented",
            fragments: Y(q(ce(n.childNodes), S(Dr, jC)), (e1)=>e1.length > 0),
            content: "",
            bookmark: null,
            beforeBookmark: null
        } : {
            type: "complete",
            fragments: null,
            content: Dr(n.innerHTML),
            bookmark: null,
            beforeBookmark: null
        };
    }, VC = (e1, t, n)=>{
        const o = n ? t.beforeBookmark : t.bookmark;
        "fragmented" === t.type ? HC(t.fragments, e1.getBody()) : e1.setContent(t.content, {
            format: "raw",
            no_selection: !C(o) || !Iu(o) || !o.isFakeCaret
        }), o && (e1.selection.moveToBookmark(o), e1.selection.scrollIntoView());
    }, WC = (e1)=>"fragmented" === e1.type ? e1.fragments.join("") : e1.content, KC = (e1)=>{
        const t = bn("body", $C());
        return ko(t, WC(e1)), V(Uo(t, "*[data-mce-bogus]"), Eo), So(t);
    }, YC = (e1, t)=>!(!e1 || !t) && (!!((e1, t)=>WC(e1) === WC(t))(e1, t) || ((e1, t)=>KC(e1) === KC(t))(e1, t)), GC = (e1)=>0 === e1.get(), XC = (e1, t, n)=>{
        GC(n) && (e1.typing = t);
    }, QC = (e1, t)=>{
        e1.typing && (XC(e1, !1, t), e1.add());
    }, JC = (e1)=>({
            init: {
                bindEvents: _
            },
            undoManager: {
                beforeChange: (t, n)=>((e1, t, n)=>{
                        GC(t) && n.set(ml(e1.selection));
                    })(e1, t, n),
                add: (t, n, o, r, s, a)=>((e1, t, n, o, r, s, a)=>{
                        const i = qC(e1), l = Pt.extend(s || {}, i);
                        if (!GC(o) || e1.removed) return null;
                        const d = t.data[n.get()];
                        if (e1.dispatch("BeforeAddUndo", {
                            level: l,
                            lastLevel: d,
                            originalEvent: a
                        }).isDefaultPrevented()) return null;
                        if (d && YC(d, l)) return null;
                        t.data[n.get()] && r.get().each((e1)=>{
                            t.data[n.get()].beforeBookmark = e1;
                        });
                        const c = Td(e1);
                        if (c && t.data.length > c) {
                            for(let e1 = 0; e1 < t.data.length - 1; e1++)t.data[e1] = t.data[e1 + 1];
                            t.data.length--, n.set(t.data.length);
                        }
                        l.bookmark = ml(e1.selection), n.get() < t.data.length - 1 && (t.data.length = n.get() + 1), t.data.push(l), n.set(t.data.length - 1);
                        const u = {
                            level: l,
                            lastLevel: d,
                            originalEvent: a
                        };
                        return n.get() > 0 ? (e1.setDirty(!0), e1.dispatch("AddUndo", u), e1.dispatch("change", u)) : e1.dispatch("AddUndo", u), l;
                    })(e1, t, n, o, r, s, a),
                undo: (t, n, o)=>((e1, t, n, o)=>{
                        let r;
                        return t.typing && (t.add(), t.typing = !1, XC(t, !1, n)), o.get() > 0 && (o.set(o.get() - 1), r = t.data[o.get()], VC(e1, r, !0), e1.setDirty(!0), e1.dispatch("Undo", {
                            level: r
                        })), r;
                    })(e1, t, n, o),
                redo: (t, n)=>((e1, t, n)=>{
                        let o;
                        return t.get() < n.length - 1 && (t.set(t.get() + 1), o = n[t.get()], VC(e1, o, !1), e1.setDirty(!0), e1.dispatch("Redo", {
                            level: o
                        })), o;
                    })(e1, t, n),
                clear: (t, n)=>((e1, t, n)=>{
                        t.data = [], n.set(0), t.typing = !1, e1.dispatch("ClearUndos");
                    })(e1, t, n),
                reset: (e1)=>((e1)=>{
                        e1.clear(), e1.add();
                    })(e1),
                hasUndo: (t, n)=>((e1, t, n)=>n.get() > 0 || t.typing && t.data[0] && !YC(qC(e1), t.data[0]))(e1, t, n),
                hasRedo: (e1, t)=>((e1, t)=>t.get() < e1.data.length - 1 && !e1.typing)(e1, t),
                transact: (e1, t, n)=>((e1, t, n)=>(QC(e1, t), e1.beforeChange(), e1.ignore(n), e1.add()))(e1, t, n),
                ignore: (e1, t)=>((e1, t)=>{
                        try {
                            e1.set(e1.get() + 1), t();
                        } finally{
                            e1.set(e1.get() - 1);
                        }
                    })(e1, t),
                extra: (t, n, o, r)=>((e1, t, n, o, r)=>{
                        if (t.transact(o)) {
                            const o = t.data[n.get()].bookmark, s = t.data[n.get() - 1];
                            VC(e1, s, !0), t.transact(r) && (t.data[n.get() - 1].beforeBookmark = o);
                        }
                    })(e1, t, n, o, r)
            },
            formatter: {
                match: (t, n, o, r)=>Hb(e1, t, n, o, r),
                matchAll: (t, n)=>((e1, t, n)=>{
                        const o = [], r = {}, s = e1.selection.getStart();
                        return e1.dom.getParent(s, (s)=>{
                            for(let a = 0; a < t.length; a++){
                                const i = t[a];
                                !r[i] && jb(e1, s, i, n) && (r[i] = !0, o.push(i));
                            }
                        }, e1.dom.getRoot()), o;
                    })(e1, t, n),
                matchNode: (t, n, o, r)=>jb(e1, t, n, o, r),
                canApply: (t)=>((e1, t)=>{
                        const n = e1.formatter.get(t), o = e1.dom;
                        if (n && e1.selection.isEditable()) {
                            const t = e1.selection.getStart(), r = Em(o, t);
                            for(let e1 = n.length - 1; e1 >= 0; e1--){
                                const t = n[e1];
                                if (!km(t)) return !0;
                                for(let e1 = r.length - 1; e1 >= 0; e1--)if (o.is(r[e1], t.selector)) return !0;
                            }
                        }
                        return !1;
                    })(e1, t),
                closest: (t)=>((e1, t)=>{
                        const n = (t)=>_n(t, yn(e1.getBody()));
                        return I.from(e1.selection.getStart(!0)).bind((o)=>Lb(yn(o), (n)=>ue(t, (t)=>((t, n)=>jb(e1, t.dom, n) ? I.some(n) : I.none())(n, t)), n)).getOrNull();
                    })(e1, t),
                apply: (t, n, o)=>Iv(e1, t, n, o),
                remove: (t, n, o, r)=>Ov(e1, t, n, o, r),
                toggle: (t, n, o)=>((e1, t, n, o)=>{
                        const r = e1.formatter.get(t);
                        r && (!Hb(e1, t, n, o) || "toggle" in r[0] && !r[0].toggle ? Iv(e1, t, n, o) : Ov(e1, t, n, o));
                    })(e1, t, n, o),
                formatChanged: (t, n, o, r, s)=>((e1, t, n, o, r, s)=>(((e1, t, n, o, r, s)=>{
                            const a = t.get();
                            V(n.split(","), (t)=>{
                                const n = xe(a, t).getOrThunk(()=>{
                                    const e1 = {
                                        withSimilar: {
                                            state: $a(!1),
                                            similar: !0,
                                            callbacks: []
                                        },
                                        withoutSimilar: {
                                            state: $a(!1),
                                            similar: !1,
                                            callbacks: []
                                        },
                                        withVars: []
                                    };
                                    return a[t] = e1, e1;
                                }), i = ()=>{
                                    const n = jv(e1);
                                    return zv(e1, n, t, r, s).isSome();
                                };
                                if (v(s)) {
                                    const e1 = r ? n.withSimilar : n.withoutSimilar;
                                    e1.callbacks.push(o), 1 === e1.callbacks.length && e1.state.set(i());
                                } else n.withVars.push({
                                    state: $a(i()),
                                    similar: r,
                                    vars: s,
                                    callback: o
                                });
                            }), t.set(a);
                        })(e1, t, n, o, r, s), {
                            unbind: ()=>((e1, t, n)=>{
                                    const o = e1.get();
                                    V(t.split(","), (e1)=>xe(o, e1).each((t)=>{
                                            o[e1] = {
                                                withSimilar: {
                                                    ...t.withSimilar,
                                                    callbacks: Y(t.withSimilar.callbacks, (e1)=>e1 !== n)
                                                },
                                                withoutSimilar: {
                                                    ...t.withoutSimilar,
                                                    callbacks: Y(t.withoutSimilar.callbacks, (e1)=>e1 !== n)
                                                },
                                                withVars: Y(t.withVars, (e1)=>e1.callback !== n)
                                            };
                                        })), e1.set(o);
                                })(t, n, o)
                        }))(e1, t, n, o, r, s)
            },
            editor: {
                getContent: (t)=>((e1, t)=>I.from(e1.getBody()).fold(N("tree" === t.format ? new Wg("body", 11) : ""), (n)=>lp(e1, t, n)))(e1, t),
                setContent: (t, n)=>((e1, t, n)=>I.from(e1.getBody()).map((o)=>Bb(t) ? ((e1, t, n, o)=>{
                                pb(e1.parser.getNodeFilters(), e1.parser.getAttributeFilters(), n);
                                const r = up({
                                    validate: !1
                                }, e1.schema).serialize(n), s = Dr(Ar(yn(t)) ? r : Pt.trim(r));
                                return Pb(e1, s, o.no_selection), {
                                    content: n,
                                    html: s
                                };
                            })(e1, o, t, n) : ((e1, t, n, o)=>{
                                if (0 === (n = Dr(n)).length || /^\s+$/.test(n)) {
                                    const r = '<br data-mce-bogus="1">';
                                    "TABLE" === t.nodeName ? n = "<tr><td>" + r + "</td></tr>" : /^(UL|OL)$/.test(t.nodeName) && (n = "<li>" + r + "</li>");
                                    const s = Il(e1);
                                    return e1.schema.isValidChild(t.nodeName.toLowerCase(), s.toLowerCase()) ? (n = r, n = e1.dom.createHTML(s, Fl(e1), n)) : n || (n = r), Pb(e1, n, o.no_selection), {
                                        content: n,
                                        html: n
                                    };
                                }
                                {
                                    "raw" !== o.format && (n = up({
                                        validate: !1
                                    }, e1.schema).serialize(e1.parser.parse(n, {
                                        isRootContent: !0,
                                        insert: !0
                                    })));
                                    const r = Ar(yn(t)) ? n : Pt.trim(n);
                                    return Pb(e1, r, o.no_selection), {
                                        content: r,
                                        html: r
                                    };
                                }
                            })(e1, o, t, n)).getOr({
                            content: t,
                            html: Bb(n.content) ? "" : n.content
                        }))(e1, t, n),
                insertContent: (t, n)=>Ob(e1, t, n),
                addVisual: (t)=>((e1, t)=>{
                        const n = e1.dom, o = C(t) ? t : e1.getBody();
                        V(n.select("table,a", o), (t)=>{
                            switch(t.nodeName){
                                case "TABLE":
                                    const o = Ud(e1), r = n.getAttrib(t, "border");
                                    r && "0" !== r || !e1.hasVisual ? n.removeClass(t, o) : n.addClass(t, o);
                                    break;
                                case "A":
                                    if (!n.getAttrib(t, "href")) {
                                        const o = n.getAttrib(t, "name") || t.id, r = zd(e1);
                                        o && e1.hasVisual ? n.addClass(t, r) : n.removeClass(t, r);
                                    }
                            }
                        }), e1.dispatch("VisualAid", {
                            element: t,
                            hasVisual: e1.hasVisual
                        });
                    })(e1, t)
            },
            selection: {
                getContent: (t, n)=>((e1, t, n = {})=>{
                        const o = ((e1, t)=>({
                                ...e1,
                                format: t,
                                get: !0,
                                selection: !0,
                                getInner: !0
                            }))(n, t);
                        return xC(e1, o).fold(R, (t)=>{
                            const n = ((e1, t)=>{
                                if ("text" === t.format) return ((e1)=>I.from(e1.selection.getRng()).map((t)=>{
                                        var n;
                                        const o = I.from(e1.dom.getParent(t.commonAncestorContainer, e1.dom.isBlock)), r = e1.getBody(), s = ((e1)=>e1.map((e1)=>e1.nodeName).getOr("div").toLowerCase())(o), a = yn(t.cloneContents());
                                        ap(a), ip(a);
                                        const i = e1.dom.add(r, s, {
                                            "data-mce-bogus": "all",
                                            style: "overflow: hidden; opacity: 0;"
                                        }, a.dom), l = zC(i), d = Dr(null !== (n = i.textContent) && void 0 !== n ? n : "");
                                        if (e1.dom.remove(i), UC(d, 0) || UC(d, d.length - 1)) {
                                            const e1 = o.getOr(r), t = zC(e1), n = t.indexOf(l);
                                            return -1 === n ? l : (UC(t, n - 1) ? " " : "") + l + (UC(t, n + l.length) ? " " : "");
                                        }
                                        return l;
                                    }).getOr(""))(e1);
                                {
                                    const n = ((e1, t)=>{
                                        const n = e1.selection.getRng(), o = e1.dom.create("body"), r = e1.selection.getSel(), s = Mg(e1, Ju(r)), a = t.contextual ? FC(yn(e1.getBody()), s, e1.schema).dom : n.cloneContents();
                                        return a && o.appendChild(a), e1.selection.serializer.serialize(o, t);
                                    })(e1, t);
                                    return "tree" === t.format ? n : e1.selection.isCollapsed() ? "" : n;
                                }
                            })(e1, t);
                            return EC(e1, n, t);
                        });
                    })(e1, t, n)
            },
            autocompleter: {
                addDecoration: (t)=>zg(e1, t),
                removeDecoration: ()=>((e1, t)=>jg(t).each((t)=>{
                            const n = e1.selection.getBookmark();
                            Eo(t), e1.selection.moveToBookmark(n);
                        }))(e1, yn(e1.getBody()))
            },
            raw: {
                getModel: ()=>I.none()
            }
        }), ZC = (e1)=>Ee(e1.plugins, "rtc"), ew = (e1)=>e1.rtcInstance ? e1.rtcInstance : JC(e1), tw = (e1)=>{
        const t = e1.rtcInstance;
        if (t) return t;
        throw new Error("Failed to get RTC instance not yet initialized.");
    }, nw = (e1)=>tw(e1).init.bindEvents(), ow = (e1)=>0 === e1.dom.length ? (xo(e1), I.none()) : I.some(e1), rw = (e1, t, n, o, r)=>{
        e1.bind((e1)=>((o ? ch : dh)(e1.dom, o ? e1.dom.length : 0, r), t.filter(Kt).map((t)=>((e1, t, n, o, r)=>{
                    const s = e1.dom, a = t.dom, i = o ? s.length : a.length;
                    o ? (uh(s, a, r, !1, !o), n.setStart(a, i)) : (uh(a, s, r, !1, !o), n.setEnd(a, i));
                })(e1, t, n, o, r)))).orThunk(()=>{
            const e1 = ((e1, t)=>e1.filter((e1)=>Jm.isBookmarkNode(e1.dom)).bind(t ? Pn : Bn))(t, o).or(t).filter(Kt);
            return e1.map((e1)=>((e1, t, n)=>{
                    An(e1).each((o)=>{
                        const r = e1.dom;
                        t && eh(o, Vi(r, 0), n) ? dh(r, 0, n) : !t && th(o, Vi(r, r.length), n) && ch(r, r.length, n);
                    });
                })(e1, o, r));
        });
    }, sw = (e1, t, n)=>{
        if (Ee(e1, t)) {
            const o = Y(e1[t], (e1)=>e1 !== n);
            0 === o.length ? delete e1[t] : e1[t] = o;
        }
    };
    const aw = (e1)=>!(!e1 || !e1.ownerDocument) && Sn(yn(e1.ownerDocument), yn(e1)), iw = (e1, t, n, o)=>{
        let r, s;
        const { selectorChangedWithUnbind: a } = ((e1, t)=>{
            let n, o;
            const r = (t, n)=>J(n, (n)=>e1.is(n, t)), s = (t)=>e1.getParents(t, void 0, e1.getRoot());
            return {
                selectorChangedWithUnbind: (e1, a)=>(n || (n = {}, o = {}, t.on("NodeChange", (e1)=>{
                        const t = e1.element, a = s(t), i = {};
                        ge(n, (e1, t)=>{
                            r(t, a).each((n)=>{
                                o[t] || (V(e1, (e1)=>{
                                    e1(!0, {
                                        node: n,
                                        selector: t,
                                        parents: a
                                    });
                                }), o[t] = e1), i[t] = e1;
                            });
                        }), ge(o, (e1, n)=>{
                            i[n] || (delete o[n], V(e1, (e1)=>{
                                e1(!1, {
                                    node: t,
                                    selector: n,
                                    parents: a
                                });
                            }));
                        });
                    })), n[e1] || (n[e1] = []), n[e1].push(a), r(e1, s(t.selection.getStart())).each(()=>{
                        o[e1] = n[e1];
                    }), {
                        unbind: ()=>{
                            sw(n, e1, a), sw(o, e1, a);
                        }
                    })
            };
        })(e1, o), i = (e1, t)=>((e1, t, n = {})=>{
                const o = ((e1, t)=>({
                        format: "html",
                        ...e1,
                        set: !0,
                        selection: !0,
                        content: t
                    }))(n, t);
                _C(e1, o).each((t)=>{
                    const n = ((e1, t)=>{
                        if ("raw" !== t.format) {
                            const n = e1.selection.getRng(), o = e1.dom.getParent(n.commonAncestorContainer, e1.dom.isBlock), r = o ? {
                                context: o.nodeName.toLowerCase()
                            } : {}, s = e1.parser.parse(t.content, {
                                forced_root_block: !1,
                                ...r,
                                ...t
                            });
                            return up({
                                validate: !1
                            }, e1.schema).serialize(s);
                        }
                        return t.content;
                    })(e1, t), o = e1.selection.getRng();
                    ((e1, t, n)=>{
                        const o = I.from(t.firstChild).map(yn), r = I.from(t.lastChild).map(yn);
                        e1.deleteContents(), e1.insertNode(t);
                        const s = o.bind(Bn).filter(Kt).bind(ow), a = r.bind(Pn).filter(Kt).bind(ow);
                        rw(s, o, e1, !0, n), rw(a, r, e1, !1, n), e1.collapse(!1);
                    })(o, o.createContextualFragment(n), e1.schema), e1.selection.setRng(o), sg(e1, o), SC(e1, n, t);
                });
            })(o, e1, t), l = (e1)=>{
            const t = c();
            t.collapse(!!e1), u(t);
        }, d = ()=>t.getSelection ? t.getSelection() : t.document.selection, c = ()=>{
            let n;
            const a = (e1, t, n)=>{
                try {
                    return t.compareBoundaryPoints(e1, n);
                } catch (e1) {
                    return -1;
                }
            }, i = t.document;
            if (C(o.bookmark) && !Rg(o)) {
                const e1 = hg(o);
                if (e1.isSome()) return e1.map((e1)=>Mg(o, [
                        e1
                    ])[0]).getOr(i.createRange());
            }
            try {
                const e1 = d();
                e1 && !$o(e1.anchorNode) && (n = e1.rangeCount > 0 ? e1.getRangeAt(0) : i.createRange(), n = Mg(o, [
                    n
                ])[0]);
            } catch (e1) {}
            if (n || (n = i.createRange()), rr(n.startContainer) && n.collapsed) {
                const t = e1.getRoot();
                n.setStart(t, 0), n.setEnd(t, 0);
            }
            return r && s && (0 === a(n.START_TO_START, n, r) && 0 === a(n.END_TO_END, n, r) ? n = s : (r = null, s = null)), n;
        }, u = (e1, t)=>{
            if (!((e1)=>!!e1 && aw(e1.startContainer) && aw(e1.endContainer))(e1)) return;
            const n = d();
            if (e1 = o.dispatch("SetSelectionRange", {
                range: e1,
                forward: t
            }).range, n) {
                s = e1;
                try {
                    n.removeAllRanges(), n.addRange(e1);
                } catch (e1) {}
                !1 === t && n.extend && (n.collapse(e1.endContainer, e1.endOffset), n.extend(e1.startContainer, e1.startOffset)), r = n.rangeCount > 0 ? n.getRangeAt(0) : null;
            }
            if (!e1.collapsed && e1.startContainer === e1.endContainer && (null == n ? void 0 : n.setBaseAndExtent) && e1.endOffset - e1.startOffset < 2 && e1.startContainer.hasChildNodes()) {
                const t = e1.startContainer.childNodes[e1.startOffset];
                t && "IMG" === t.nodeName && (n.setBaseAndExtent(e1.startContainer, e1.startOffset, e1.endContainer, e1.endOffset), n.anchorNode === e1.startContainer && n.focusNode === e1.endContainer || n.setBaseAndExtent(t, 0, t, 1));
            }
            o.dispatch("AfterSetSelectionRange", {
                range: e1,
                forward: t
            });
        }, m = ()=>{
            const t = d(), n = null == t ? void 0 : t.anchorNode, o = null == t ? void 0 : t.focusNode;
            if (!t || !n || !o || $o(n) || $o(o)) return !0;
            const r = e1.createRng(), s = e1.createRng();
            try {
                r.setStart(n, t.anchorOffset), r.collapse(!0), s.setStart(o, t.focusOffset), s.collapse(!0);
            } catch (e1) {
                return !0;
            }
            return r.compareBoundaryPoints(r.START_TO_START, s) <= 0;
        }, f = {
            dom: e1,
            win: t,
            serializer: n,
            editor: o,
            expand: (t = {
                type: "word"
            })=>u(Uf(e1).expand(c(), t)),
            collapse: l,
            setCursorLocation: (t, n)=>{
                const r = e1.createRng();
                C(t) && C(n) ? (r.setStart(t, n), r.setEnd(t, n), u(r), l(!1)) : (sm(e1, r, o.getBody(), !0), u(r));
            },
            getContent: (e1)=>((e1, t = {})=>((e1, t, n)=>tw(e1).selection.getContent(t, n))(e1, t.format ? t.format : "html", t))(o, e1),
            setContent: i,
            getBookmark: (e1, t)=>g.getBookmark(e1, t),
            moveToBookmark: (e1)=>g.moveToBookmark(e1),
            select: (t, n)=>(((e1, t, n)=>I.from(t).bind((t)=>I.from(t.parentNode).map((o)=>{
                            const r = e1.nodeIndex(t), s = e1.createRng();
                            return s.setStart(o, r), s.setEnd(o, r + 1), n && (sm(e1, s, t, !0), sm(e1, s, t, !1)), s;
                        })))(e1, t, n).each(u), t),
            isCollapsed: ()=>{
                const e1 = c(), t = d();
                return !(!e1 || e1.item) && (e1.compareEndPoints ? 0 === e1.compareEndPoints("StartToEnd", e1) : !t || e1.collapsed);
            },
            isEditable: ()=>{
                const t = c(), n = o.getBody().querySelectorAll('[data-mce-selected="1"]');
                return n.length > 0 ? ne(n, (t)=>e1.isEditable(t.parentElement)) : Og(e1, t);
            },
            isForward: m,
            setNode: (t)=>(i(e1.getOuterHTML(t)), t),
            getNode: ()=>((e1, t)=>{
                    if (!t) return e1;
                    let n = t.startContainer, o = t.endContainer;
                    const r = t.startOffset, s = t.endOffset;
                    let a = t.commonAncestorContainer;
                    t.collapsed || (n === o && s - r < 2 && n.hasChildNodes() && (a = n.childNodes[r]), er(n) && er(o) && (n = n.length === r ? Lg(n.nextSibling, !0) : n.parentNode, o = 0 === s ? Lg(o.previousSibling, !1) : o.parentNode, n && n === o && (a = n)));
                    const i = er(a) ? a.parentNode : a;
                    return Vo(i) ? i : e1;
                })(o.getBody(), c()),
            getSel: d,
            setRng: u,
            getRng: c,
            getStart: (e1)=>Pg(o.getBody(), c(), e1),
            getEnd: (e1)=>Dg(o.getBody(), c(), e1),
            getSelectedBlocks: (t, n)=>((e1, t, n, o)=>{
                    const r = [], s = e1.getRoot(), a = e1.getParent(n || Pg(s, t, t.collapsed), e1.isBlock), i = e1.getParent(o || Dg(s, t, t.collapsed), e1.isBlock);
                    if (a && a !== s && r.push(a), a && i && a !== i) {
                        let t;
                        const n = new jo(a, s);
                        for(; (t = n.next()) && t !== i;)e1.isBlock(t) && r.push(t);
                    }
                    return i && a !== i && i !== s && r.push(i), r;
                })(e1, c(), t, n),
            normalize: ()=>{
                const t = c(), n = d();
                if (!(Ju(n).length > 1) && am(o)) {
                    const n = Mf(e1, t);
                    return n.each((e1)=>{
                        u(e1, m());
                    }), n.getOr(t);
                }
                return t;
            },
            selectorChanged: (e1, t)=>(a(e1, t), f),
            selectorChangedWithUnbind: a,
            getScrollContainer: ()=>{
                let t, n = e1.getRoot();
                for(; n && "BODY" !== n.nodeName;){
                    if (n.scrollHeight > n.clientHeight) {
                        t = n;
                        break;
                    }
                    n = n.parentNode;
                }
                return t;
            },
            scrollIntoView: (e1, t)=>{
                C(e1) ? ((e1, t, n)=>{
                    (e1.inline ? ng : rg)(e1, t, n);
                })(o, e1, t) : sg(o, c(), t);
            },
            placeCaretAt: (e1, t)=>u(Rf(e1, t, o.getDoc())),
            getBoundingClientRect: ()=>{
                const e1 = c();
                return e1.collapsed ? Vi.fromRangeStart(e1).getClientRects()[0] : e1.getBoundingClientRect();
            },
            destroy: ()=>{
                t = r = s = null, p.destroy();
            }
        }, g = Jm(f), p = mf(f, o);
        return f.bookmarkManager = g, f.controlSelection = p, f;
    }, lw = (e1, t, n)=>{
        -1 === Pt.inArray(t, n) && (e1.addAttributeFilter(n, (e1, t)=>{
            let n = e1.length;
            for(; n--;)e1[n].attr(t, null);
        }), t.push(n));
    }, dw = (e1, t)=>{
        const n = [
            "data-mce-selected"
        ], o = {
            entity_encoding: "named",
            remove_trailing_brs: !0,
            pad_empty_with_br: !1,
            ...e1
        }, r = t && t.dom ? t.dom : za.DOM, s = t && t.schema ? t.schema : ua(o), a = CC(o, s);
        return ((e1, t, n)=>{
            e1.addAttributeFilter("data-mce-tabindex", (e1, t)=>{
                let n = e1.length;
                for(; n--;){
                    const o = e1[n];
                    o.attr("tabindex", o.attr("data-mce-tabindex")), o.attr(t, null);
                }
            }), e1.addAttributeFilter("src,href,style", (e1, o)=>{
                const r = "data-mce-" + o, s = t.url_converter, a = t.url_converter_scope;
                let i = e1.length;
                for(; i--;){
                    const t = e1[i];
                    let l = t.attr(r);
                    void 0 !== l ? (t.attr(o, l.length > 0 ? l : null), t.attr(r, null)) : (l = t.attr(o), "style" === o ? l = n.serializeStyle(n.parseStyle(l), t.name) : s && (l = s.call(a, l, o, t.name)), t.attr(o, l.length > 0 ? l : null));
                }
            }), e1.addAttributeFilter("class", (e1)=>{
                let t = e1.length;
                for(; t--;){
                    const n = e1[t];
                    let o = n.attr("class");
                    o && (o = o.replace(/(?:^|\s)mce-item-\w+(?!\S)/g, ""), n.attr("class", o.length > 0 ? o : null));
                }
            }), e1.addAttributeFilter("data-mce-type", (e1, t, n)=>{
                let o = e1.length;
                for(; o--;){
                    const t = e1[o];
                    if ("bookmark" === t.attr("data-mce-type") && !n.cleanup) {
                        const e1 = I.from(t.firstChild).exists((e1)=>{
                            var t;
                            return !Pr(null !== (t = e1.value) && void 0 !== t ? t : "");
                        });
                        e1 ? t.unwrap() : t.remove();
                    }
                }
            }), e1.addNodeFilter("script,style", (e1, n)=>{
                var o;
                const r = (e1)=>e1.replace(/(<!--\[CDATA\[|\]\]-->)/g, "\n").replace(/^[\r\n]*|[\r\n]*$/g, "").replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi, "").replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g, "");
                let s = e1.length;
                for(; s--;){
                    const a = e1[s], i = a.firstChild, l = null !== (o = null == i ? void 0 : i.value) && void 0 !== o ? o : "";
                    if ("script" === n) {
                        const e1 = a.attr("type");
                        e1 && a.attr("type", "mce-no/type" === e1 ? null : e1.replace(/^mce\-/, "")), "xhtml" === t.element_format && i && l.length > 0 && (i.value = "// <![CDATA[\n" + r(l) + "\n// ]]>");
                    } else "xhtml" === t.element_format && i && l.length > 0 && (i.value = "\x3c!--\n" + r(l) + "\n--\x3e");
                }
            }), e1.addNodeFilter("#comment", (e1)=>{
                let o = e1.length;
                for(; o--;){
                    const r = e1[o], s = r.value;
                    t.preserve_cdata && 0 === (null == s ? void 0 : s.indexOf("[CDATA[")) ? (r.name = "#cdata", r.type = 4, r.value = n.decode(s.replace(/^\[CDATA\[|\]\]$/g, ""))) : 0 === (null == s ? void 0 : s.indexOf("mce:protected ")) && (r.name = "#text", r.type = 3, r.raw = !0, r.value = unescape(s).substr(14));
                }
            }), e1.addNodeFilter("xml:namespace,input", (e1, t)=>{
                let n = e1.length;
                for(; n--;){
                    const o = e1[n];
                    7 === o.type ? o.remove() : 1 === o.type && ("input" !== t || o.attr("type") || o.attr("type", "text"));
                }
            }), e1.addAttributeFilter("data-mce-type", (t)=>{
                V(t, (t)=>{
                    "format-caret" === t.attr("data-mce-type") && (t.isEmpty(e1.schema.getNonEmptyElements()) ? t.remove() : t.unwrap());
                });
            }), e1.addAttributeFilter("data-mce-src,data-mce-href,data-mce-style,data-mce-selected,data-mce-expando,data-mce-block,data-mce-type,data-mce-resize,data-mce-placeholder", (e1, t)=>{
                let n = e1.length;
                for(; n--;)e1[n].attr(t, null);
            }), t.remove_trailing_brs && Wv(t, e1, e1.schema);
        })(a, o, r), {
            schema: s,
            addNodeFilter: a.addNodeFilter,
            addAttributeFilter: a.addAttributeFilter,
            serialize: (e1, n = {})=>{
                const i = {
                    format: "html",
                    ...n
                }, l = ((e1, t, n)=>((e1, t)=>C(e1) && e1.hasEventListeners("PreProcess") && !t.no_events)(e1, n) ? ((e1, t, n)=>{
                        let o;
                        const r = e1.dom;
                        let s = t.cloneNode(!0);
                        const a = document.implementation;
                        if (a.createHTMLDocument) {
                            const e1 = a.createHTMLDocument("");
                            Pt.each("BODY" === s.nodeName ? s.childNodes : [
                                s
                            ], (t)=>{
                                e1.body.appendChild(e1.importNode(t, !0));
                            }), s = "BODY" !== s.nodeName ? e1.body.firstChild : e1.body, o = r.doc, r.doc = e1;
                        }
                        return ((e1, t)=>{
                            e1.dispatch("PreProcess", t);
                        })(e1, {
                            ...n,
                            node: s
                        }), o && (r.doc = o), s;
                    })(e1, t, n) : t)(t, e1, i), d = ((e1, t, n)=>{
                    const o = Dr(n.getInner ? t.innerHTML : e1.getOuterHTML(t));
                    return n.selection || Ar(yn(t)) ? o : Pt.trim(o);
                })(r, l, i), c = ((e1, t, n)=>{
                    const o = n.selection ? {
                        forced_root_block: !1,
                        ...n
                    } : n, r = e1.parse(t, o);
                    return ((e1)=>{
                        const t = (e1)=>"br" === (null == e1 ? void 0 : e1.name), n = e1.lastChild;
                        if (t(n)) {
                            const e1 = n.prev;
                            t(e1) && (n.remove(), e1.remove());
                        }
                    })(r), r;
                })(a, d, i);
                return "tree" === i.format ? c : ((e1, t, n, o, r)=>{
                    const s = ((e1, t, n)=>up(e1, t).serialize(n))(t, n, o);
                    return ((e1, t, n)=>{
                        if (!t.no_events && e1) {
                            const o = ((e1, t)=>e1.dispatch("PostProcess", t))(e1, {
                                ...t,
                                content: n
                            });
                            return o.content;
                        }
                        return n;
                    })(e1, r, s);
                })(t, o, s, c, i);
            },
            addRules: s.addValidElements,
            setRules: s.setValidElements,
            addTempAttr: T(lw, a, n),
            getTempAttrs: N(n),
            getNodeFilters: a.getNodeFilters,
            getAttributeFilters: a.getAttributeFilters,
            removeNodeFilter: a.removeNodeFilter,
            removeAttributeFilter: a.removeAttributeFilter
        };
    }, cw = (e1, t)=>{
        const n = dw(e1, t);
        return {
            schema: n.schema,
            addNodeFilter: n.addNodeFilter,
            addAttributeFilter: n.addAttributeFilter,
            serialize: n.serialize,
            addRules: n.addRules,
            setRules: n.setRules,
            addTempAttr: n.addTempAttr,
            getTempAttrs: n.getTempAttrs,
            getNodeFilters: n.getNodeFilters,
            getAttributeFilters: n.getAttributeFilters,
            removeNodeFilter: n.removeNodeFilter,
            removeAttributeFilter: n.removeAttributeFilter
        };
    }, uw = (e1, t, n = {})=>{
        const o = ((e1, t)=>({
                format: "html",
                ...e1,
                set: !0,
                content: t
            }))(n, t);
        return _C(e1, o).map((t)=>{
            const n = ((e1, t, n)=>ew(e1).editor.setContent(t, n))(e1, t.content, t);
            return SC(e1, n.html, t), n.content;
        }).getOr(t);
    }, mw = "autoresize_on_init,content_editable_state,padd_empty_with_br,block_elements,boolean_attributes,editor_deselector,editor_selector,elements,file_browser_callback_types,filepicker_validator_handler,force_hex_style_colors,force_p_newlines,gecko_spellcheck,images_dataimg_filter,media_scripts,mode,move_caret_before_on_enter_elements,non_empty_elements,self_closing_elements,short_ended_elements,special,spellchecker_select_languages,spellchecker_whitelist,tab_focus,tabfocus_elements,table_responsive_width,text_block_elements,text_inline_elements,toolbar_drawer,types,validate,whitespace_elements,paste_enable_default_filters,paste_filter_drop,paste_word_valid_elements,paste_retain_style_properties,paste_convert_word_fake_lists".split(","), fw = "template_cdate_classes,template_mdate_classes,template_selected_content_classes,template_preview_replace_values,template_replace_values,templates,template_cdate_format,template_mdate_format".split(","), gw = "bbcode,colorpicker,contextmenu,fullpage,legacyoutput,spellchecker,textcolor".split(","), pw = [
        {
            name: "template",
            replacedWith: "Advanced Template"
        },
        {
            name: "rtc"
        }
    ], hw = (e1, t)=>{
        const n = Y(t, (t)=>Ee(e1, t));
        return ae(n);
    }, bw = (e1)=>{
        const t = hw(e1, mw), n = e1.forced_root_block;
        return !1 !== n && "" !== n || t.push("forced_root_block (false only)"), ae(t);
    }, vw = (e1)=>hw(e1, fw), yw = (e1, t)=>{
        const n = Pt.makeMap(e1.plugins, " "), o = Y(t, (e1)=>Ee(n, e1));
        return ae(o);
    }, Cw = (e1)=>yw(e1, gw), ww = (e1)=>yw(e1, pw.map((e1)=>e1.name)), xw = (e1)=>J(pw, (t)=>t.name === e1).fold(()=>e1, (t)=>t.replacedWith ? `${e1}, replaced by ${t.replacedWith}` : e1), Ew = za.DOM, _w = (e1)=>I.from(e1).each((e1)=>e1.destroy()), Sw = (()=>{
        const e1 = {};
        return {
            add: (t, n)=>{
                e1[t] = n;
            },
            get: (t)=>e1[t] ? e1[t] : {
                    icons: {}
                },
            has: (t)=>Ee(e1, t)
        };
    })(), kw = Ya.ModelManager, Nw = (e1, t)=>t.dom[e1], Rw = (e1, t)=>parseInt(co(t, e1), 10), Aw = T(Nw, "clientWidth"), Tw = T(Nw, "clientHeight"), Ow = T(Rw, "margin-top"), Bw = T(Rw, "margin-left"), Pw = (e1)=>{
        const t = [], n = ()=>{
            const t = e1.theme;
            return t && t.getNotificationManagerImpl ? t.getNotificationManagerImpl() : (()=>{
                const e1 = ()=>{
                    throw new Error("Theme did not provide a NotificationManager implementation.");
                };
                return {
                    open: e1,
                    close: e1,
                    getArgs: e1
                };
            })();
        }, o = ()=>I.from(t[0]), r = ()=>{
            V(t, (e1)=>{
                e1.reposition();
            });
        }, s = (e1)=>{
            Z(t, (t)=>t === e1).each((e1)=>{
                t.splice(e1, 1);
            });
        }, a = (a, i = !0)=>e1.removed || !((e1)=>{
                var t;
                return (t = e1.inline ? e1.getBody() : e1.getContentAreaContainer(), I.from(t).map(yn)).map(Gn).getOr(!1);
            })(e1) ? {} : (i && e1.dispatch("BeforeOpenNotification", {
                notification: a
            }), J(t, (e1)=>{
                var t, o;
                return t = n().getArgs(e1), o = a, !(t.type !== o.type || t.text !== o.text || t.progressBar || t.timeout || o.progressBar || o.timeout);
            }).getOrThunk(()=>{
                e1.editorManager.setActive(e1);
                const i = n().open(a, ()=>{
                    s(i), r(), Ag(e1) && o().fold(()=>e1.focus(), (e1)=>ag(yn(e1.getEl())));
                });
                return ((e1)=>{
                    t.push(e1);
                })(i), r(), e1.dispatch("OpenNotification", {
                    notification: {
                        ...i
                    }
                }), i;
            })), i = N(t);
        return ((e1)=>{
            e1.on("SkinLoaded", ()=>{
                const t = gd(e1);
                t && a({
                    text: t,
                    type: "warning",
                    timeout: 0
                }, !1), r();
            }), e1.on("show ResizeEditor ResizeWindow NodeChange", ()=>{
                requestAnimationFrame(r);
            }), e1.on("remove", ()=>{
                V(t.slice(), (e1)=>{
                    n().close(e1);
                });
            });
        })(e1), {
            open: a,
            close: ()=>{
                o().each((e1)=>{
                    n().close(e1), s(e1), r();
                });
            },
            getNotifications: i
        };
    }, Dw = Ya.PluginManager, Lw = Ya.ThemeManager, Mw = (e1)=>{
        let t = [];
        const n = ()=>{
            const t = e1.theme;
            return t && t.getWindowManagerImpl ? t.getWindowManagerImpl() : (()=>{
                const e1 = ()=>{
                    throw new Error("Theme did not provide a WindowManager implementation.");
                };
                return {
                    open: e1,
                    openUrl: e1,
                    alert: e1,
                    confirm: e1,
                    close: e1
                };
            })();
        }, o = (e1, t)=>(...n)=>t ? t.apply(e1, n) : void 0, r = (n)=>{
            ((t)=>{
                e1.dispatch("CloseWindow", {
                    dialog: t
                });
            })(n), t = Y(t, (e1)=>e1 !== n), 0 === t.length && e1.focus();
        }, s = (n)=>{
            e1.editorManager.setActive(e1), pg(e1), e1.ui.show();
            const o = n();
            return ((n)=>{
                t.push(n), ((t)=>{
                    e1.dispatch("OpenWindow", {
                        dialog: t
                    });
                })(n);
            })(o), o;
        };
        return e1.on("remove", ()=>{
            V(t, (e1)=>{
                n().close(e1);
            });
        }), {
            open: (e1, t)=>s(()=>n().open(e1, t, r)),
            openUrl: (e1)=>s(()=>n().openUrl(e1, r)),
            alert: (e1, t, r)=>{
                const s = n();
                s.alert(e1, o(r || s, t));
            },
            confirm: (e1, t, r)=>{
                const s = n();
                s.confirm(e1, o(r || s, t));
            },
            close: ()=>{
                I.from(t[t.length - 1]).each((e1)=>{
                    n().close(e1), r(e1);
                });
            }
        };
    }, Iw = (e1, t)=>{
        e1.notificationManager.open({
            type: "error",
            text: t
        });
    }, Fw = (e1, t)=>{
        e1._skinLoaded ? Iw(e1, t) : e1.on("SkinLoaded", ()=>{
            Iw(e1, t);
        });
    }, Uw = (e1, t, n)=>{
        ef(e1, t, {
            message: n
        }), console.error(n);
    }, zw = (e1, t, n)=>n ? `Failed to load ${e1}: ${n} from url ${t}` : `Failed to load ${e1} url: ${t}`, jw = (e1, ...t)=>{
        const n = window.console;
        n && (n.error ? n.error(e1, ...t) : n.log(e1, ...t));
    }, Hw = (e1)=>"content/" + e1 + "/content.css", $w = (e1, t)=>{
        const n = e1.editorManager.baseURL + "/skins/content", o = `content${e1.editorManager.suffix}.css`;
        return q(t, (t)=>((e1)=>tinymce.Resource.has(Hw(e1)))(t) ? t : ((e1)=>/^[a-z0-9\-]+$/i.test(e1))(t) && !e1.inline ? `${n}/${t}/${o}` : e1.documentBaseURI.toAbsolute(t));
    }, qw = (e1, t)=>{
        const n = {};
        return {
            findAll: (o, r = M)=>{
                const s = Y(((e1)=>e1 ? ce(e1.getElementsByTagName("img")) : [])(o), (t)=>{
                    const n = t.src;
                    return !t.hasAttribute("data-mce-bogus") && !t.hasAttribute("data-mce-placeholder") && !(!n || n === At.transparentSrc) && (He(n, "blob:") ? !e1.isUploaded(n) && r(t) : !!He(n, "data:") && r(t));
                }), a = q(s, (e1)=>{
                    const o = e1.src;
                    if (Ee(n, o)) return n[o].then((t)=>m(t) ? t : {
                            image: e1,
                            blobInfo: t.blobInfo
                        });
                    {
                        const r = ((e1, t)=>{
                            const n = ()=>Promise.reject("Invalid data URI");
                            if (He(t, "blob:")) {
                                const s = e1.getByUri(t);
                                return C(s) ? Promise.resolve(s) : (o = t, He(o, "blob:") ? ((e1)=>fetch(e1).then((e1)=>e1.ok ? e1.blob() : Promise.reject()).catch(()=>Promise.reject({
                                            message: `Cannot convert ${e1} to Blob. Resource might not exist or is inaccessible.`,
                                            uriType: "blob"
                                        })))(o) : He(o, "data:") ? (r = o, new Promise((e1, t)=>{
                                    Kv(r).bind(({ type: e1, data: t, base64Encoded: n })=>Yv(e1, t, n)).fold(()=>t("Invalid data URI"), e1);
                                })) : Promise.reject("Unknown URI format")).then((t)=>Gv(t).then((o)=>Qv(o, !1, (n)=>I.some(Jv(e1, t, n))).getOrThunk(n)));
                            }
                            var o, r;
                            return He(t, "data:") ? Zv(e1, t).fold(n, (e1)=>Promise.resolve(e1)) : Promise.reject("Unknown image data format");
                        })(t, o).then((t)=>(delete n[o], {
                                image: e1,
                                blobInfo: t
                            })).catch((e1)=>(delete n[o], e1));
                        return n[o] = r, r;
                    }
                });
                return Promise.all(a);
            }
        };
    }, Vw = ()=>{
        let e1 = {};
        const t = (e1, t)=>({
                status: e1,
                resultUri: t
            }), n = (t)=>t in e1;
        return {
            hasBlobUri: n,
            getResultUri: (t)=>{
                const n = e1[t];
                return n ? n.resultUri : null;
            },
            isPending: (t)=>!!n(t) && 1 === e1[t].status,
            isUploaded: (t)=>!!n(t) && 2 === e1[t].status,
            markPending: (n)=>{
                e1[n] = t(1, null);
            },
            markUploaded: (n, o)=>{
                e1[n] = t(2, o);
            },
            removeFailed: (t)=>{
                delete e1[t];
            },
            destroy: ()=>{
                e1 = {};
            }
        };
    };
    let Ww = 0;
    const Kw = (e1, t)=>{
        const n = {}, o = (e1, n)=>new Promise((o, r)=>{
                const s = new XMLHttpRequest;
                s.open("POST", t.url), s.withCredentials = t.credentials, s.upload.onprogress = (e1)=>{
                    n(e1.loaded / e1.total * 100);
                }, s.onerror = ()=>{
                    r("Image upload failed due to a XHR Transport error. Code: " + s.status);
                }, s.onload = ()=>{
                    if (s.status < 200 || s.status >= 300) return void r("HTTP Error: " + s.status);
                    const e1 = JSON.parse(s.responseText);
                    var n, a;
                    e1 && m(e1.location) ? o((n = t.basePath, a = e1.location, n ? n.replace(/\/$/, "") + "/" + a.replace(/^\//, "") : a)) : r("Invalid JSON: " + s.responseText);
                };
                const a = new FormData;
                a.append("file", e1.blob(), e1.filename()), s.send(a);
            }), r = w(t.handler) ? t.handler : o, s = (e1, t)=>({
                url: t,
                blobInfo: e1,
                status: !0
            }), a = (e1, t)=>({
                url: "",
                blobInfo: e1,
                status: !1,
                error: t
            }), i = (e1, t)=>{
            Pt.each(n[e1], (e1)=>{
                e1(t);
            }), delete n[e1];
        };
        return {
            upload: (l, d)=>t.url || r !== o ? ((t, o)=>(t = Pt.grep(t, (t)=>!e1.isUploaded(t.blobUri())), Promise.all(Pt.map(t, (t)=>e1.isPending(t.blobUri()) ? ((e1)=>{
                            const t = e1.blobUri();
                            return new Promise((e1)=>{
                                n[t] = n[t] || [], n[t].push(e1);
                            });
                        })(t) : ((t, n, o)=>(e1.markPending(t.blobUri()), new Promise((r)=>{
                                let l, d;
                                try {
                                    const c = ()=>{
                                        l && (l.close(), d = _);
                                    }, u = (n)=>{
                                        c(), e1.markUploaded(t.blobUri(), n), i(t.blobUri(), s(t, n)), r(s(t, n));
                                    }, f = (n)=>{
                                        c(), e1.removeFailed(t.blobUri()), i(t.blobUri(), a(t, n)), r(a(t, n));
                                    };
                                    d = (e1)=>{
                                        e1 < 0 || e1 > 100 || I.from(l).orThunk(()=>I.from(o).map(P)).each((t)=>{
                                            l = t, t.progressBar.value(e1);
                                        });
                                    }, n(t, d).then(u, (e1)=>{
                                        f(m(e1) ? {
                                            message: e1
                                        } : e1);
                                    });
                                } catch (e1) {
                                    r(a(t, e1));
                                }
                            })))(t, r, o)))))(l, d) : new Promise((e1)=>{
                    e1([]);
                })
        };
    }, Yw = (e1)=>()=>e1.notificationManager.open({
                text: e1.translate("Image uploading..."),
                type: "info",
                timeout: -1,
                progressBar: !0
            }), Gw = (e1, t)=>Kw(t, {
            url: Gl(e1),
            basePath: Xl(e1),
            credentials: Ql(e1),
            handler: Jl(e1)
        }), Xw = (e1)=>{
        const t = (()=>{
            let e1 = [];
            const t = (e1)=>{
                if (!e1.blob || !e1.base64) throw new Error("blob and base64 representations of the image are required for BlobInfo to be created");
                const t = e1.id || "blobid" + Ww++ + (()=>{
                    const e1 = ()=>Math.round(4294967295 * Math.random()).toString(36);
                    return "s" + (new Date).getTime().toString(36) + e1() + e1() + e1();
                })(), n = e1.name || t, o = e1.blob;
                var r;
                return {
                    id: N(t),
                    name: N(n),
                    filename: N(e1.filename || n + "." + (r = o.type, ({
                        "image/jpeg": "jpg",
                        "image/jpg": "jpg",
                        "image/gif": "gif",
                        "image/png": "png",
                        "image/apng": "apng",
                        "image/avif": "avif",
                        "image/svg+xml": "svg",
                        "image/webp": "webp",
                        "image/bmp": "bmp",
                        "image/tiff": "tiff"
                    })[r.toLowerCase()] || "dat")),
                    blob: N(o),
                    base64: N(e1.base64),
                    blobUri: N(e1.blobUri || URL.createObjectURL(o)),
                    uri: N(e1.uri)
                };
            }, n = (t)=>J(e1, t).getOrUndefined(), o = (e1)=>n((t)=>t.id() === e1);
            return {
                create: (e1, n, o, r, s)=>{
                    if (m(e1)) return t({
                        id: e1,
                        name: r,
                        filename: s,
                        blob: n,
                        base64: o
                    });
                    if (f(e1)) return t(e1);
                    throw new Error("Unknown input type");
                },
                add: (t)=>{
                    o(t.id()) || e1.push(t);
                },
                get: o,
                getByUri: (e1)=>n((t)=>t.blobUri() === e1),
                getByData: (e1, t)=>n((n)=>n.base64() === e1 && n.blob().type === t),
                findFirst: n,
                removeByUri: (t)=>{
                    e1 = Y(e1, (e1)=>e1.blobUri() !== t || (URL.revokeObjectURL(e1.blobUri()), !1));
                },
                destroy: ()=>{
                    V(e1, (e1)=>{
                        URL.revokeObjectURL(e1.blobUri());
                    }), e1 = [];
                }
            };
        })();
        let n, o;
        const r = Vw(), s = [], a = (t)=>(n)=>e1.selection ? t(n) : [], i = (e1, t, n)=>{
            let o = 0;
            do o = e1.indexOf(t, o), -1 !== o && (e1 = e1.substring(0, o) + n + e1.substr(o + t.length), o += n.length - t.length + 1);
            while (-1 !== o);
            return e1;
        }, l = (e1, t, n)=>{
            const o = `src="${n}"${n === At.transparentSrc ? ' data-mce-placeholder="1"' : ""}`;
            return e1 = i(e1, `src="${t}"`, o), i(e1, 'data-mce-src="' + t + '"', 'data-mce-src="' + n + '"');
        }, d = (t, n)=>{
            V(e1.undoManager.data, (e1)=>{
                "fragmented" === e1.type ? e1.fragments = q(e1.fragments, (e1)=>l(e1, t, n)) : e1.content = l(e1.content, t, n);
            });
        }, c = ()=>(n || (n = Gw(e1, r)), p().then(a((o)=>{
                const r = q(o, (e1)=>e1.blobInfo);
                return n.upload(r, Yw(e1)).then(a((n)=>{
                    const r = [];
                    let s = !1;
                    const a = q(n, (n, a)=>{
                        const { blobInfo: i, image: l } = o[a];
                        let c = !1;
                        return n.status && Wl(e1) ? (n.url && !je(l.src, n.url) && (s = !0), t.removeByUri(l.src), ZC(e1) || ((t, n)=>{
                            const o = e1.convertURL(n, "src");
                            var r;
                            d(t.src, n), Zt(yn(t), {
                                src: Vl(e1) ? (r = n, r + (-1 === r.indexOf("?") ? "?" : "&") + (new Date).getTime()) : n,
                                "data-mce-src": o
                            });
                        })(l, n.url)) : n.error && (n.error.remove && (d(l.src, At.transparentSrc), r.push(l), c = !0), ((e1, t)=>{
                            Fw(e1, Ka.translate([
                                "Failed to upload image: {0}",
                                t
                            ]));
                        })(e1, n.error.message)), {
                            element: l,
                            status: n.status,
                            uploadUri: n.url,
                            blobInfo: i,
                            removed: c
                        };
                    });
                    return r.length > 0 && !ZC(e1) ? e1.undoManager.transact(()=>{
                        V(_o(r), (n)=>{
                            const o = An(n);
                            xo(n), o.each(((e1)=>(t)=>{
                                    ((e1, t)=>e1.dom.isEmpty(t.dom) && C(e1.schema.getTextBlockElements()[Ht(t)]))(e1, t) && vo(t, hn('<br data-mce-bogus="1" />'));
                                })(e1)), t.removeByUri(n.dom.src);
                        });
                    }) : s && e1.undoManager.dispatchChange(), a;
                }));
            }))), u = ()=>ql(e1) ? c() : Promise.resolve([]), g = (e1)=>ne(s, (t)=>t(e1)), p = ()=>(o || (o = qw(r, t)), o.findAll(e1.getBody(), g).then(a((t)=>{
                const n = Y(t, (t)=>m(t) ? (Fw(e1, t), !1) : "blob" !== t.uriType);
                return ZC(e1) || V(n, (e1)=>{
                    d(e1.image.src, e1.blobInfo.blobUri()), e1.image.src = e1.blobInfo.blobUri(), e1.image.removeAttribute("data-mce-src");
                }), n;
            }))), h = (n)=>n.replace(/src="(blob:[^"]+)"/g, (n, o)=>{
                const s = r.getResultUri(o);
                if (s) return 'src="' + s + '"';
                let a = t.getByUri(o);
                return a || (a = X(e1.editorManager.get(), (e1, t)=>e1 || t.editorUpload && t.editorUpload.blobCache.getByUri(o), void 0)), a ? 'src="data:' + a.blob().type + ";base64," + a.base64() + '"' : n;
            });
        return e1.on("SetContent", ()=>{
            ql(e1) ? u() : p();
        }), e1.on("RawSaveContent", (e1)=>{
            e1.content = h(e1.content);
        }), e1.on("GetContent", (e1)=>{
            e1.source_view || "raw" === e1.format || "tree" === e1.format || (e1.content = h(e1.content));
        }), e1.on("PostRender", ()=>{
            e1.parser.addNodeFilter("img", (e1)=>{
                V(e1, (e1)=>{
                    const n = e1.attr("src");
                    if (!n || t.getByUri(n)) return;
                    const o = r.getResultUri(n);
                    o && e1.attr("src", o);
                });
            });
        }), {
            blobCache: t,
            addFilter: (e1)=>{
                s.push(e1);
            },
            uploadImages: c,
            uploadImagesAuto: u,
            scanForImages: p,
            destroy: ()=>{
                t.destroy(), r.destroy(), o = n = null;
            }
        };
    }, Qw = {
        remove_similar: !0,
        inherit: !1
    }, Jw = {
        selector: "td,th",
        ...Qw
    }, Zw = {
        tablecellbackgroundcolor: {
            styles: {
                backgroundColor: "%value"
            },
            ...Jw
        },
        tablecellverticalalign: {
            styles: {
                "vertical-align": "%value"
            },
            ...Jw
        },
        tablecellbordercolor: {
            styles: {
                borderColor: "%value"
            },
            ...Jw
        },
        tablecellclass: {
            classes: [
                "%value"
            ],
            ...Jw
        },
        tableclass: {
            selector: "table",
            classes: [
                "%value"
            ],
            ...Qw
        },
        tablecellborderstyle: {
            styles: {
                borderStyle: "%value"
            },
            ...Jw
        },
        tablecellborderwidth: {
            styles: {
                borderWidth: "%value"
            },
            ...Jw
        }
    }, ex = N(Zw), tx = Pt.each, nx = za.DOM, ox = (e1)=>C(e1) && f(e1), rx = (e1, t)=>{
        const n = t && t.schema || ua({}), o = (e1)=>{
            const t = m(e1) ? {
                name: e1,
                classes: [],
                attrs: {}
            } : e1, n = nx.create(t.name);
            return ((e1, t)=>{
                t.classes.length > 0 && nx.addClass(e1, t.classes.join(" ")), nx.setAttribs(e1, t.attrs);
            })(n, t), n;
        }, r = (e1, t, s)=>{
            let a;
            const i = t[0], l = ox(i) ? i.name : void 0, d = ((e1, t)=>{
                const o = n.getElementRule(e1.nodeName.toLowerCase()), r = null == o ? void 0 : o.parentsRequired;
                return !(!r || !r.length) && (t && H(r, t) ? t : r[0]);
            })(e1, l);
            if (d) l === d ? (a = i, t = t.slice(1)) : a = d;
            else if (i) a = i, t = t.slice(1);
            else if (!s) return e1;
            const c = a ? o(a) : nx.create("div");
            c.appendChild(e1), s && Pt.each(s, (t)=>{
                const n = o(t);
                c.insertBefore(n, e1);
            });
            const u = ox(a) ? a.siblings : void 0;
            return r(c, t, u);
        }, s = nx.create("div");
        if (e1.length > 0) {
            const t = e1[0], n = o(t), a = ox(t) ? t.siblings : void 0;
            s.appendChild(r(n, e1.slice(1), a));
        }
        return s;
    }, sx = (e1)=>{
        let t = "div";
        const n = {
            name: t,
            classes: [],
            attrs: {},
            selector: e1 = Pt.trim(e1)
        };
        return "*" !== e1 && (t = e1.replace(/(?:([#\.]|::?)([\w\-]+)|(\[)([^\]]+)\]?)/g, (e1, t, o, r, s)=>{
            switch(t){
                case "#":
                    n.attrs.id = o;
                    break;
                case ".":
                    n.classes.push(o);
                    break;
                case ":":
                    -1 !== Pt.inArray("checked disabled enabled read-only required".split(" "), o) && (n.attrs[o] = o);
            }
            if ("[" === r) {
                const e1 = s.match(/([\w\-]+)(?:\=\"([^\"]+))?/);
                e1 && (n.attrs[e1[1]] = e1[2]);
            }
            return "";
        })), n.name = t || "div", n;
    }, ax = (e1, t)=>{
        let n = "", o = wd(e1);
        if ("" === o) return "";
        const r = (e1)=>m(e1) ? e1.replace(/%(\w+)/g, "") : "", s = (t, n)=>nx.getStyle(null != n ? n : e1.getBody(), t, !0);
        if (m(t)) {
            const n = e1.formatter.get(t);
            if (!n) return "";
            t = n[0];
        }
        if ("preview" in t) {
            const e1 = t.preview;
            if (!1 === e1) return "";
            o = e1 || o;
        }
        let a, i = t.block || t.inline || "span";
        const l = (d = t.selector, m(d) ? (d = (d = d.split(/\s*,\s*/)[0]).replace(/\s*(~\+|~|\+|>)\s*/g, "$1"), Pt.map(d.split(/(?:>|\s+(?![^\[\]]+\]))/), (e1)=>{
            const t = Pt.map(e1.split(/(?:~\+|~|\+)/), sx), n = t.pop();
            return t.length && (n.siblings = t), n;
        }).reverse()) : []);
        var d;
        l.length > 0 ? (l[0].name || (l[0].name = i), i = t.selector, a = rx(l, e1)) : a = rx([
            i
        ], e1);
        const c = nx.select(i, a)[0] || a.firstChild;
        tx(t.styles, (e1, t)=>{
            const n = r(e1);
            n && nx.setStyle(c, t, n);
        }), tx(t.attributes, (e1, t)=>{
            const n = r(e1);
            n && nx.setAttrib(c, t, n);
        }), tx(t.classes, (e1)=>{
            const t = r(e1);
            nx.hasClass(c, t) || nx.addClass(c, t);
        }), e1.dispatch("PreviewFormats"), nx.setStyles(a, {
            position: "absolute",
            left: -65535
        }), e1.getBody().appendChild(a);
        const u = s("fontSize"), f = /px$/.test(u) ? parseInt(u, 10) : 0;
        return tx(o.split(" "), (e1)=>{
            let t = s(e1, c);
            if (!("background-color" === e1 && /transparent|rgba\s*\([^)]+,\s*0\)/.test(t) && (t = s(e1), "#ffffff" === Ca(t).toLowerCase()) || "color" === e1 && "#000000" === Ca(t).toLowerCase())) {
                if ("font-size" === e1 && /em|%$/.test(t)) {
                    if (0 === f) return;
                    t = parseFloat(t) / (/%$/.test(t) ? 100 : 1) * f + "px";
                }
                "border" === e1 && t && (n += "padding:0 2px;"), n += e1 + ":" + t + ";";
            }
        }), e1.dispatch("AfterPreviewFormats"), nx.remove(a), n;
    }, ix = (e1)=>{
        const t = ((e1)=>{
            const t = {}, n = (e1, o)=>{
                e1 && (m(e1) ? (p(o) || (o = [
                    o
                ]), V(o, (e1)=>{
                    v(e1.deep) && (e1.deep = !km(e1)), v(e1.split) && (e1.split = !km(e1) || Nm(e1)), v(e1.remove) && km(e1) && !Nm(e1) && (e1.remove = "none"), km(e1) && Nm(e1) && (e1.mixed = !0, e1.block_expand = !0), m(e1.classes) && (e1.classes = e1.classes.split(/\s+/));
                }), t[e1] = o) : ge(e1, (e1, t)=>{
                    n(t, e1);
                }));
            };
            return n(((e1)=>{
                const t = e1.dom, n = e1.schema.type, o = {
                    valigntop: [
                        {
                            selector: "td,th",
                            styles: {
                                verticalAlign: "top"
                            }
                        }
                    ],
                    valignmiddle: [
                        {
                            selector: "td,th",
                            styles: {
                                verticalAlign: "middle"
                            }
                        }
                    ],
                    valignbottom: [
                        {
                            selector: "td,th",
                            styles: {
                                verticalAlign: "bottom"
                            }
                        }
                    ],
                    alignleft: [
                        {
                            selector: "figure.image",
                            collapsed: !1,
                            classes: "align-left",
                            ceFalseOverride: !0,
                            preview: "font-family font-size"
                        },
                        {
                            selector: "figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li,pre",
                            styles: {
                                textAlign: "left"
                            },
                            inherit: !1,
                            preview: !1
                        },
                        {
                            selector: "img,audio,video",
                            collapsed: !1,
                            styles: {
                                float: "left"
                            },
                            preview: "font-family font-size"
                        },
                        {
                            selector: "table",
                            collapsed: !1,
                            styles: {
                                marginLeft: "0px",
                                marginRight: "auto"
                            },
                            onformat: (e1)=>{
                                t.setStyle(e1, "float", null);
                            },
                            preview: "font-family font-size"
                        },
                        {
                            selector: ".mce-preview-object,[data-ephox-embed-iri]",
                            ceFalseOverride: !0,
                            styles: {
                                float: "left"
                            }
                        }
                    ],
                    aligncenter: [
                        {
                            selector: "figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li,pre",
                            styles: {
                                textAlign: "center"
                            },
                            inherit: !1,
                            preview: "font-family font-size"
                        },
                        {
                            selector: "figure.image",
                            collapsed: !1,
                            classes: "align-center",
                            ceFalseOverride: !0,
                            preview: "font-family font-size"
                        },
                        {
                            selector: "img,audio,video",
                            collapsed: !1,
                            styles: {
                                display: "block",
                                marginLeft: "auto",
                                marginRight: "auto"
                            },
                            preview: !1
                        },
                        {
                            selector: "table",
                            collapsed: !1,
                            styles: {
                                marginLeft: "auto",
                                marginRight: "auto"
                            },
                            preview: "font-family font-size"
                        },
                        {
                            selector: ".mce-preview-object",
                            ceFalseOverride: !0,
                            styles: {
                                display: "table",
                                marginLeft: "auto",
                                marginRight: "auto"
                            },
                            preview: !1
                        },
                        {
                            selector: "[data-ephox-embed-iri]",
                            ceFalseOverride: !0,
                            styles: {
                                marginLeft: "auto",
                                marginRight: "auto"
                            },
                            preview: !1
                        }
                    ],
                    alignright: [
                        {
                            selector: "figure.image",
                            collapsed: !1,
                            classes: "align-right",
                            ceFalseOverride: !0,
                            preview: "font-family font-size"
                        },
                        {
                            selector: "figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li,pre",
                            styles: {
                                textAlign: "right"
                            },
                            inherit: !1,
                            preview: "font-family font-size"
                        },
                        {
                            selector: "img,audio,video",
                            collapsed: !1,
                            styles: {
                                float: "right"
                            },
                            preview: "font-family font-size"
                        },
                        {
                            selector: "table",
                            collapsed: !1,
                            styles: {
                                marginRight: "0px",
                                marginLeft: "auto"
                            },
                            onformat: (e1)=>{
                                t.setStyle(e1, "float", null);
                            },
                            preview: "font-family font-size"
                        },
                        {
                            selector: ".mce-preview-object,[data-ephox-embed-iri]",
                            ceFalseOverride: !0,
                            styles: {
                                float: "right"
                            },
                            preview: !1
                        }
                    ],
                    alignjustify: [
                        {
                            selector: "figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li,pre",
                            styles: {
                                textAlign: "justify"
                            },
                            inherit: !1,
                            preview: "font-family font-size"
                        }
                    ],
                    bold: [
                        {
                            inline: "strong",
                            remove: "all",
                            preserve_attributes: [
                                "class",
                                "style"
                            ]
                        },
                        {
                            inline: "span",
                            styles: {
                                fontWeight: "bold"
                            }
                        },
                        {
                            inline: "b",
                            remove: "all",
                            preserve_attributes: [
                                "class",
                                "style"
                            ]
                        }
                    ],
                    italic: [
                        {
                            inline: "em",
                            remove: "all",
                            preserve_attributes: [
                                "class",
                                "style"
                            ]
                        },
                        {
                            inline: "span",
                            styles: {
                                fontStyle: "italic"
                            }
                        },
                        {
                            inline: "i",
                            remove: "all",
                            preserve_attributes: [
                                "class",
                                "style"
                            ]
                        }
                    ],
                    underline: [
                        {
                            inline: "span",
                            styles: {
                                textDecoration: "underline"
                            },
                            exact: !0
                        },
                        {
                            inline: "u",
                            remove: "all",
                            preserve_attributes: [
                                "class",
                                "style"
                            ]
                        }
                    ],
                    strikethrough: (()=>{
                        const e1 = {
                            inline: "span",
                            styles: {
                                textDecoration: "line-through"
                            },
                            exact: !0
                        }, t = {
                            inline: "strike",
                            remove: "all",
                            preserve_attributes: [
                                "class",
                                "style"
                            ]
                        }, o = {
                            inline: "s",
                            remove: "all",
                            preserve_attributes: [
                                "class",
                                "style"
                            ]
                        };
                        return "html4" !== n ? [
                            o,
                            e1,
                            t
                        ] : [
                            e1,
                            o,
                            t
                        ];
                    })(),
                    forecolor: {
                        inline: "span",
                        styles: {
                            color: "%value"
                        },
                        links: !0,
                        remove_similar: !0,
                        clear_child_styles: !0
                    },
                    hilitecolor: {
                        inline: "span",
                        styles: {
                            backgroundColor: "%value"
                        },
                        links: !0,
                        remove_similar: !0,
                        clear_child_styles: !0
                    },
                    fontname: {
                        inline: "span",
                        toggle: !1,
                        styles: {
                            fontFamily: "%value"
                        },
                        clear_child_styles: !0
                    },
                    fontsize: {
                        inline: "span",
                        toggle: !1,
                        styles: {
                            fontSize: "%value"
                        },
                        clear_child_styles: !0
                    },
                    lineheight: {
                        selector: "h1,h2,h3,h4,h5,h6,p,li,td,th,div",
                        styles: {
                            lineHeight: "%value"
                        }
                    },
                    fontsize_class: {
                        inline: "span",
                        attributes: {
                            class: "%value"
                        }
                    },
                    blockquote: {
                        block: "blockquote",
                        wrapper: !0,
                        remove: "all"
                    },
                    subscript: {
                        inline: "sub"
                    },
                    superscript: {
                        inline: "sup"
                    },
                    code: {
                        inline: "code"
                    },
                    link: {
                        inline: "a",
                        selector: "a",
                        remove: "all",
                        split: !0,
                        deep: !0,
                        onmatch: (e1, t, n)=>qo(e1) && e1.hasAttribute("href"),
                        onformat: (e1, n, o)=>{
                            Pt.each(o, (n, o)=>{
                                t.setAttrib(e1, o, n);
                            });
                        }
                    },
                    lang: {
                        inline: "span",
                        clear_child_styles: !0,
                        remove_similar: !0,
                        attributes: {
                            lang: "%value",
                            "data-mce-lang": (e1)=>{
                                var t;
                                return null !== (t = null == e1 ? void 0 : e1.customValue) && void 0 !== t ? t : null;
                            }
                        }
                    },
                    removeformat: [
                        {
                            selector: "b,strong,em,i,font,u,strike,s,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins,small",
                            remove: "all",
                            split: !0,
                            expand: !1,
                            block_expand: !0,
                            deep: !0
                        },
                        {
                            selector: "span",
                            attributes: [
                                "style",
                                "class"
                            ],
                            remove: "empty",
                            split: !0,
                            expand: !1,
                            deep: !0
                        },
                        {
                            selector: "*",
                            attributes: [
                                "style",
                                "class"
                            ],
                            split: !1,
                            expand: !1,
                            deep: !0
                        }
                    ]
                };
                return Pt.each("p h1 h2 h3 h4 h5 h6 div address pre dt dd samp".split(/\s/), (e1)=>{
                    o[e1] = {
                        block: e1,
                        remove: "all"
                    };
                }), o;
            })(e1)), n(ex()), n(Cd(e1)), {
                get: (e1)=>C(e1) ? t[e1] : t,
                has: (e1)=>Ee(t, e1),
                register: n,
                unregister: (e1)=>(e1 && t[e1] && delete t[e1], t)
            };
        })(e1), n = $a({});
        return ((e1)=>{
            e1.addShortcut("meta+b", "", "Bold"), e1.addShortcut("meta+i", "", "Italic"), e1.addShortcut("meta+u", "", "Underline");
            for(let t = 1; t <= 6; t++)e1.addShortcut("access+" + t, "", [
                "FormatBlock",
                !1,
                "h" + t
            ]);
            e1.addShortcut("access+7", "", [
                "FormatBlock",
                !1,
                "p"
            ]), e1.addShortcut("access+8", "", [
                "FormatBlock",
                !1,
                "div"
            ]), e1.addShortcut("access+9", "", [
                "FormatBlock",
                !1,
                "address"
            ]);
        })(e1), ((e1)=>{
            e1.on("mouseup keydown", (t)=>{
                var n;
                ((e1, t, n)=>{
                    const o = e1.selection, r = e1.getBody();
                    Kb(e1, null, n), 8 !== t && 46 !== t || !o.isCollapsed() || o.getStart().innerHTML !== $b || Kb(e1, Lu(r, o.getStart()), !0), 37 !== t && 39 !== t || Kb(e1, Lu(r, o.getStart()), !0);
                })(e1, t.keyCode, (n = e1.selection.getRng().endContainer, er(n) && $e(n.data, br)));
            });
        })(e1), ZC(e1) || ((e1, t)=>{
            e1.set({}), t.on("NodeChange", (n)=>{
                Hv(t, n.element, e1.get());
            }), t.on("FormatApply FormatRemove", (n)=>{
                const o = I.from(n.node).map((e1)=>dm(e1) ? e1 : e1.startContainer).bind((e1)=>qo(e1) ? I.some(e1) : I.from(e1.parentElement)).getOrThunk(()=>Uv(t));
                Hv(t, o, e1.get());
            });
        })(n, e1), {
            get: t.get,
            has: t.has,
            register: t.register,
            unregister: t.unregister,
            apply: (t, n, o)=>{
                ((e1, t, n, o)=>{
                    tw(e1).formatter.apply(t, n, o);
                })(e1, t, n, o);
            },
            remove: (t, n, o, r)=>{
                ((e1, t, n, o, r)=>{
                    tw(e1).formatter.remove(t, n, o, r);
                })(e1, t, n, o, r);
            },
            toggle: (t, n, o)=>{
                ((e1, t, n, o)=>{
                    tw(e1).formatter.toggle(t, n, o);
                })(e1, t, n, o);
            },
            match: (t, n, o, r)=>((e1, t, n, o, r)=>tw(e1).formatter.match(t, n, o, r))(e1, t, n, o, r),
            closest: (t)=>((e1, t)=>tw(e1).formatter.closest(t))(e1, t),
            matchAll: (t, n)=>((e1, t, n)=>tw(e1).formatter.matchAll(t, n))(e1, t, n),
            matchNode: (t, n, o, r)=>((e1, t, n, o, r)=>tw(e1).formatter.matchNode(t, n, o, r))(e1, t, n, o, r),
            canApply: (t)=>((e1, t)=>tw(e1).formatter.canApply(t))(e1, t),
            formatChanged: (t, o, r, s)=>((e1, t, n, o, r, s)=>tw(e1).formatter.formatChanged(t, n, o, r, s))(e1, n, t, o, r, s),
            getCssText: T(ax, e1)
        };
    }, lx = (e1)=>{
        switch(e1.toLowerCase()){
            case "undo":
            case "redo":
            case "mcefocus":
                return !0;
            default:
                return !1;
        }
    }, dx = (e1)=>{
        const t = Xa(), n = $a(0), o = $a(0), r = {
            data: [],
            typing: !1,
            beforeChange: ()=>{
                ((e1, t, n)=>{
                    tw(e1).undoManager.beforeChange(t, n);
                })(e1, n, t);
            },
            add: (s, a)=>((e1, t, n, o, r, s, a)=>tw(e1).undoManager.add(t, n, o, r, s, a))(e1, r, o, n, t, s, a),
            dispatchChange: ()=>{
                e1.setDirty(!0);
                const t = qC(e1);
                t.bookmark = ml(e1.selection), e1.dispatch("change", {
                    level: t,
                    lastLevel: ie(r.data, o.get()).getOrUndefined()
                });
            },
            undo: ()=>((e1, t, n, o)=>tw(e1).undoManager.undo(t, n, o))(e1, r, n, o),
            redo: ()=>((e1, t, n)=>tw(e1).undoManager.redo(t, n))(e1, o, r.data),
            clear: ()=>{
                ((e1, t, n)=>{
                    tw(e1).undoManager.clear(t, n);
                })(e1, r, o);
            },
            reset: ()=>{
                ((e1, t)=>{
                    tw(e1).undoManager.reset(t);
                })(e1, r);
            },
            hasUndo: ()=>((e1, t, n)=>tw(e1).undoManager.hasUndo(t, n))(e1, r, o),
            hasRedo: ()=>((e1, t, n)=>tw(e1).undoManager.hasRedo(t, n))(e1, r, o),
            transact: (t)=>((e1, t, n, o)=>tw(e1).undoManager.transact(t, n, o))(e1, r, n, t),
            ignore: (t)=>{
                ((e1, t, n)=>{
                    tw(e1).undoManager.ignore(t, n);
                })(e1, n, t);
            },
            extra: (t, n)=>{
                ((e1, t, n, o, r)=>{
                    tw(e1).undoManager.extra(t, n, o, r);
                })(e1, r, o, t, n);
            }
        };
        return ZC(e1) || ((e1, t, n)=>{
            const o = $a(!1), r = (e1)=>{
                XC(t, !1, n), t.add({}, e1);
            };
            e1.on("init", ()=>{
                t.add();
            }), e1.on("BeforeExecCommand", (e1)=>{
                const o = e1.command;
                lx(o) || (QC(t, n), t.beforeChange());
            }), e1.on("ExecCommand", (e1)=>{
                const t = e1.command;
                lx(t) || r(e1);
            }), e1.on("ObjectResizeStart cut", ()=>{
                t.beforeChange();
            }), e1.on("SaveContent ObjectResized blur", r), e1.on("dragend", r), e1.on("keyup", (n)=>{
                const s = n.keyCode;
                if (n.isDefaultPrevented()) return;
                const a = At.os.isMacOS() && "Meta" === n.key;
                (s >= 33 && s <= 36 || s >= 37 && s <= 40 || 45 === s || n.ctrlKey || a) && (r(), e1.nodeChanged()), 46 !== s && 8 !== s || e1.nodeChanged(), o.get() && t.typing && !YC(qC(e1), t.data[0]) && (e1.isDirty() || e1.setDirty(!0), e1.dispatch("TypingUndo"), o.set(!1), e1.nodeChanged());
            }), e1.on("keydown", (e1)=>{
                const s = e1.keyCode;
                if (e1.isDefaultPrevented()) return;
                if (s >= 33 && s <= 36 || s >= 37 && s <= 40 || 45 === s) return void (t.typing && r(e1));
                const a = e1.ctrlKey && !e1.altKey || e1.metaKey;
                if ((s < 16 || s > 20) && 224 !== s && 91 !== s && !t.typing && !a) return t.beforeChange(), XC(t, !0, n), t.add({}, e1), void o.set(!0);
                (At.os.isMacOS() ? e1.metaKey : e1.ctrlKey && !e1.altKey) && t.beforeChange();
            }), e1.on("mousedown", (e1)=>{
                t.typing && r(e1);
            }), e1.on("input", (e1)=>{
                var t;
                e1.inputType && ("insertReplacementText" === e1.inputType || "insertText" === (t = e1).inputType && null === t.data || ((e1)=>"insertFromPaste" === e1.inputType || "insertFromDrop" === e1.inputType)(e1)) && r(e1);
            }), e1.on("AddUndo Undo Redo ClearUndos", (t)=>{
                t.isDefaultPrevented() || e1.nodeChanged();
            });
        })(e1, r, n), ((e1)=>{
            e1.addShortcut("meta+z", "", "Undo"), e1.addShortcut("meta+y,meta+shift+z", "", "Redo");
        })(e1), r;
    }, cx = [
        9,
        27,
        af.HOME,
        af.END,
        19,
        20,
        44,
        144,
        145,
        33,
        34,
        45,
        16,
        17,
        18,
        91,
        92,
        93,
        af.DOWN,
        af.UP,
        af.LEFT,
        af.RIGHT
    ].concat(At.browser.isFirefox() ? [
        224
    ] : []), ux = "data-mce-placeholder", mx = (e1)=>"keydown" === e1.type || "keyup" === e1.type, fx = (e1)=>{
        const t = e1.keyCode;
        return t === af.BACKSPACE || t === af.DELETE;
    }, gx = (e1, t)=>({
            from: e1,
            to: t
        }), px = (e1, t)=>{
        const n = yn(e1), o = yn(t.container());
        return Ah(n, o).map((e1)=>((e1, t)=>({
                    block: e1,
                    position: t
                }))(e1, t));
    }, hx = (e1, t)=>Jn(t, (e1)=>Rr(e1) || lr(e1.dom), (t)=>_n(t, e1)).filter(Wt).getOr(e1), bx = (e1, t)=>{
        const n = ((e1, t)=>{
            const n = Mn(e1);
            return Z(n, (e1)=>t.isBlock(Ht(e1))).fold(N(n), (e1)=>n.slice(0, e1));
        })(e1, t);
        return V(n, xo), n;
    }, vx = (e1, t)=>{
        const n = Bp(t, e1);
        return J(n.reverse(), (e1)=>gs(e1)).each(xo);
    }, yx = (e1, t, n, o, r)=>{
        if (gs(n)) return Or(n), Ou(n.dom);
        0 === Y(Dn(r), (e1)=>!gs(e1)).length && gs(t) && po(r, bn("br"));
        const s = Tu(n.dom, Vi.before(r.dom));
        return V(bx(t, o), (e1)=>{
            po(r, e1);
        }), vx(e1, t), s;
    }, Cx = (e1, t, n, o)=>{
        if (gs(n)) {
            if (gs(t)) {
                const e1 = (e1)=>{
                    const t = (e1, n)=>Fn(e1).fold(()=>n, (e1)=>((e1, t)=>e1.isInline(Ht(t)))(o, e1) ? t(e1, n.concat(fi(e1))) : n);
                    return t(e1, []);
                }, r = G(e1(n), (e1, t)=>(yo(e1, t), t), Tr());
                wo(t), vo(t, r);
            }
            return xo(n), Ou(t.dom);
        }
        const r = Bu(n.dom);
        return V(bx(t, o), (e1)=>{
            vo(n, e1);
        }), vx(e1, t), r;
    }, wx = (e1, t)=>{
        Ru(e1, t.dom).bind((e1)=>I.from(e1.getNode())).map(yn).filter(Er).each(xo);
    }, xx = (e1, t, n, o)=>(wx(!0, t), wx(!1, n), ((e1, t)=>Sn(t, e1) ? ((e1, t)=>{
                const n = Bp(t, e1);
                return I.from(n[n.length - 1]);
            })(t, e1) : I.none())(t, n).fold(T(Cx, e1, t, n, o), T(yx, e1, t, n, o))), Ex = (e1, t, n, o, r)=>t ? xx(e1, o, n, r) : xx(e1, n, o, r), _x = (e1, t)=>{
        const n = yn(e1.getBody()), o = ((e1, t, n)=>n.collapsed ? ((e1, t, n)=>{
                const o = px(e1, Vi.fromRangeStart(n)), r = o.bind((n)=>Su(t, e1, n.position).bind((n)=>px(e1, n).map((n)=>((e1, t, n)=>ar(n.position.getNode()) && !gs(n.block) ? Ru(!1, n.block.dom).bind((o)=>o.isEqual(n.position) ? Su(t, e1, o).bind((t)=>px(e1, t)) : I.some(n)).getOr(n) : n)(e1, t, n))));
                return Mt(o, r, gx).filter((t)=>((e1)=>!_n(e1.from.block, e1.to.block))(t) && ((e1, t)=>{
                        const n = yn(e1);
                        return _n(hx(n, t.from.block), hx(n, t.to.block));
                    })(e1, t) && ((e1)=>!1 === dr(e1.from.block.dom) && !1 === dr(e1.to.block.dom))(t) && ((e1)=>{
                        const t = (e1)=>_r(e1) || Ns(e1.dom);
                        return t(e1.from.block) && t(e1.to.block);
                    })(t));
            })(e1, t, n) : I.none())(n.dom, t, e1.selection.getRng()).map((o)=>()=>{
                Ex(n, t, o.from.block, o.to.block, e1.schema).each((t)=>{
                    e1.selection.setRng(t.toRange());
                });
            });
        return o;
    }, Sx = (e1, t)=>{
        const n = yn(t), o = T(_n, e1);
        return Qn(n, Rr, o).isSome();
    }, kx = (e1)=>{
        const t = yn(e1.getBody());
        return ((e1, t)=>{
            const n = Tu(e1.dom, Vi.fromRangeStart(t)).isNone(), o = Au(e1.dom, Vi.fromRangeEnd(t)).isNone();
            return !((e1, t)=>Sx(e1, t.startContainer) || Sx(e1, t.endContainer))(e1, t) && n && o;
        })(t, e1.selection.getRng()) ? ((e1)=>I.some(()=>{
                e1.setContent(""), e1.selection.setCursorLocation();
            }))(e1) : ((e1, t, n)=>{
            const o = t.getRng();
            return Mt(Ah(e1, yn(o.startContainer)), Ah(e1, yn(o.endContainer)), (r, s)=>_n(r, s) ? I.none() : I.some(()=>{
                    o.deleteContents(), Ex(e1, !0, r, s, n).each((e1)=>{
                        t.setRng(e1.toRange());
                    });
                })).getOr(I.none());
        })(t, e1.selection, e1.schema);
    }, Nx = (e1, t)=>e1.selection.isCollapsed() ? I.none() : kx(e1), Rx = (e1, t, n, o, r)=>I.from(t._selectionOverrides.showCaret(e1, n, o, r)), Ax = (e1, t)=>e1.dispatch("BeforeObjectSelected", {
            target: t
        }).isDefaultPrevented() ? I.none() : I.some(((e1)=>{
            const t = e1.ownerDocument.createRange();
            return t.selectNode(e1), t;
        })(t)), Tx = (e1, t, n)=>t.collapsed ? ((e1, t, n)=>{
            const o = ru(1, e1.getBody(), t), r = Vi.fromRangeStart(o), s = r.getNode();
            if (Lc(s)) return Rx(1, e1, s, !r.isAtEnd(), !1);
            const a = r.getNode(!0);
            if (Lc(a)) return Rx(1, e1, a, !1, !1);
            const i = lb(e1.dom.getRoot(), r.getNode());
            return Lc(i) ? Rx(1, e1, i, !1, n) : I.none();
        })(e1, t, n).getOr(t) : t, Ox = (e1)=>Ap(e1) || Sp(e1), Bx = (e1)=>Tp(e1) || kp(e1), Px = (e1, t, n, o, r, s)=>{
        Rx(o, e1, s.getNode(!r), r, !0).each((n)=>{
            if (t.collapsed) {
                const e1 = t.cloneRange();
                r ? e1.setEnd(n.startContainer, n.startOffset) : e1.setStart(n.endContainer, n.endOffset), e1.deleteContents();
            } else t.deleteContents();
            e1.selection.setRng(n);
        }), ((e1, t)=>{
            er(t) && 0 === t.data.length && e1.remove(t);
        })(e1.dom, n);
    }, Dx = (e1, t)=>((e1, t)=>{
            const n = e1.selection.getRng();
            if (!er(n.commonAncestorContainer)) return I.none();
            const o = t ? cu.Forwards : cu.Backwards, r = wu(e1.getBody()), s = T(lu, t ? r.next : r.prev), a = t ? Ox : Bx, i = au(o, e1.getBody(), n), l = s(i), d = l ? Eh(t, l) : l;
            if (!d || !du(i, d)) return I.none();
            if (a(d)) return I.some(()=>Px(e1, n, i.getNode(), o, t, d));
            const c = s(d);
            return c && a(c) && du(d, c) ? I.some(()=>Px(e1, n, i.getNode(), o, t, c)) : I.none();
        })(e1, t), Lx = (e1, t)=>{
        const n = e1.getBody();
        return t ? Ou(n).filter(Ap) : Bu(n).filter(Tp);
    }, Mx = (e1)=>{
        const t = e1.selection.getRng();
        return !t.collapsed && (Lx(e1, !0).exists((e1)=>e1.isEqual(Vi.fromRangeStart(t))) || Lx(e1, !1).exists((e1)=>e1.isEqual(Vi.fromRangeEnd(t))));
    }, Ix = hl([
        {
            remove: [
                "element"
            ]
        },
        {
            moveToElement: [
                "element"
            ]
        },
        {
            moveToPosition: [
                "position"
            ]
        }
    ]), Fx = (e1, t, n, o)=>Su(t, e1, n).bind((r)=>{
            var s;
            return s = r.getNode(), C(s) && (Rr(yn(s)) || kr(yn(s))) || ((e1, t, n, o, r)=>{
                const s = (t)=>r.isInline(t.nodeName.toLowerCase()) && !Qc(n, o, e1);
                return su(!t, n).fold(()=>su(t, o).fold(L, s), s);
            })(e1, t, n, r, o) ? I.none() : t && dr(r.getNode()) || !t && dr(r.getNode(!0)) ? ((e1, t, n, o)=>{
                const r = o.getNode(!t);
                return Ah(yn(e1), yn(n.getNode())).map((e1)=>gs(e1) ? Ix.remove(e1.dom) : Ix.moveToElement(r)).orThunk(()=>I.some(Ix.moveToElement(r)));
            })(e1, t, n, r) : t && Tp(n) || !t && Ap(n) ? I.some(Ix.moveToPosition(r)) : I.none();
        }), Ux = (e1, t)=>I.from(lb(e1.getBody(), t)), zx = (e1, t)=>{
        const n = e1.selection.getNode();
        return Ux(e1, n).filter(dr).fold(()=>((e1, t, n, o)=>{
                const r = ru(t ? 1 : -1, e1, n), s = Vi.fromRangeStart(r), a = yn(e1);
                return !t && Tp(s) ? I.some(Ix.remove(s.getNode(!0))) : t && Ap(s) ? I.some(Ix.remove(s.getNode())) : !t && Ap(s) && qp(a, s, o) ? Vp(a, s, o).map((e1)=>Ix.remove(e1.getNode())) : t && Tp(s) && $p(a, s, o) ? Wp(a, s, o).map((e1)=>Ix.remove(e1.getNode())) : ((e1, t, n, o)=>((e1, t)=>{
                        const n = t.getNode(!e1), o = e1 ? "after" : "before";
                        return qo(n) && n.getAttribute("data-mce-caret") === o;
                    })(t, n) ? ((e1, t)=>y(t) ? I.none() : e1 && dr(t.nextSibling) ? I.some(Ix.moveToElement(t.nextSibling)) : !e1 && dr(t.previousSibling) ? I.some(Ix.moveToElement(t.previousSibling)) : I.none())(t, n.getNode(!t)).orThunk(()=>Fx(e1, t, n, o)) : Fx(e1, t, n, o).bind((t)=>((e1, t, n)=>n.fold((e1)=>I.some(Ix.remove(e1)), (e1)=>I.some(Ix.moveToElement(e1)), (n)=>Qc(t, n, e1) ? I.none() : I.some(Ix.moveToPosition(n))))(e1, n, t)))(e1, t, s, o);
            })(e1.getBody(), t, e1.selection.getRng(), e1.schema).map((n)=>()=>n.fold(((e1, t)=>(n)=>(e1._selectionOverrides.hideFakeCaret(), vh(e1, t, yn(n)), !0))(e1, t), ((e1, t)=>(n)=>{
                            const o = t ? Vi.before(n) : Vi.after(n);
                            return e1.selection.setRng(o.toRange()), !0;
                        })(e1, t), ((e1)=>(t)=>(e1.selection.setRng(t.toRange()), !0))(e1))), ()=>I.some(_));
    }, jx = (e1)=>{
        const t = e1.dom, n = e1.selection, o = lb(e1.getBody(), n.getNode());
        if (lr(o) && t.isBlock(o) && t.isEmpty(o)) {
            const e1 = t.create("br", {
                "data-mce-bogus": "1"
            });
            t.setHTML(o, ""), o.appendChild(e1), n.setRng(Vi.before(e1).toRange());
        }
        return !0;
    }, Hx = (e1, t)=>e1.selection.isCollapsed() ? zx(e1, t) : ((e1, t)=>{
            const n = e1.selection.getNode();
            return dr(n) && !cr(n) ? Ux(e1, n.parentNode).filter(dr).fold(()=>I.some(()=>{
                    var n;
                    n = yn(e1.getBody()), V(Uo(n, ".mce-offscreen-selection"), xo), vh(e1, t, yn(e1.selection.getNode())), Th(e1);
                }), ()=>I.some(_)) : Mx(e1) ? I.some(()=>{
                Ph(e1, e1.selection.getRng(), yn(e1.getBody()));
            }) : I.none();
        })(e1, t), $x = (e1, t)=>e1.selection.isCollapsed() ? ((e1, t)=>{
            const n = Vi.fromRangeStart(e1.selection.getRng());
            return Su(t, e1.getBody(), n).filter((e1)=>t ? Ep(e1) : _p(e1)).bind((e1)=>Jc(t ? 0 : -1, e1)).map((t)=>()=>e1.selection.select(t));
        })(e1, t) : I.none(), qx = er, Vx = (e1)=>qx(e1) && e1.data[0] === Br, Wx = (e1)=>qx(e1) && e1.data[e1.data.length - 1] === Br, Kx = (e1)=>{
        var t;
        return (null !== (t = e1.ownerDocument) && void 0 !== t ? t : document).createTextNode(Br);
    }, Yx = (e1, t)=>e1 ? ((e1)=>{
            var t;
            if (qx(e1.previousSibling)) return Wx(e1.previousSibling) || e1.previousSibling.appendData(Br), e1.previousSibling;
            if (qx(e1)) return Vx(e1) || e1.insertData(0, Br), e1;
            {
                const n = Kx(e1);
                return null === (t = e1.parentNode) || void 0 === t || t.insertBefore(n, e1), n;
            }
        })(t) : ((e1)=>{
            var t, n;
            if (qx(e1.nextSibling)) return Vx(e1.nextSibling) || e1.nextSibling.insertData(0, Br), e1.nextSibling;
            if (qx(e1)) return Wx(e1) || e1.appendData(Br), e1;
            {
                const o = Kx(e1);
                return e1.nextSibling ? null === (t = e1.parentNode) || void 0 === t || t.insertBefore(o, e1.nextSibling) : null === (n = e1.parentNode) || void 0 === n || n.appendChild(o), o;
            }
        })(t), Gx = T(Yx, !0), Xx = T(Yx, !1), Qx = (e1, t)=>er(e1.container()) ? Yx(t, e1.container()) : Yx(t, e1.getNode()), Jx = (e1, t)=>{
        const n = t.get();
        return n && e1.container() === n && Fr(n);
    }, Zx = (e1, t)=>t.fold((t)=>{
            Rc(e1.get());
            const n = Gx(t);
            return e1.set(n), I.some(Vi(n, n.length - 1));
        }, (t)=>Ou(t).map((t)=>{
                if (Jx(t, e1)) {
                    const t = e1.get();
                    return Vi(t, 1);
                }
                {
                    Rc(e1.get());
                    const n = Qx(t, !0);
                    return e1.set(n), Vi(n, 1);
                }
            }), (t)=>Bu(t).map((t)=>{
                if (Jx(t, e1)) {
                    const t = e1.get();
                    return Vi(t, t.length - 1);
                }
                {
                    Rc(e1.get());
                    const n = Qx(t, !1);
                    return e1.set(n), Vi(n, n.length - 1);
                }
            }), (t)=>{
            Rc(e1.get());
            const n = Xx(t);
            return e1.set(n), I.some(Vi(n, 1));
        }), eE = (e1, t)=>{
        for(let n = 0; n < e1.length; n++){
            const o = e1[n].apply(null, t);
            if (o.isSome()) return o;
        }
        return I.none();
    }, tE = hl([
        {
            before: [
                "element"
            ]
        },
        {
            start: [
                "element"
            ]
        },
        {
            end: [
                "element"
            ]
        },
        {
            after: [
                "element"
            ]
        }
    ]), nE = (e1, t)=>Xc(t, e1) || e1, oE = (e1, t, n)=>{
        const o = _h(n), r = nE(t, o.container());
        return xh(e1, r, o).fold(()=>Au(r, o).bind(T(xh, e1, r)).map((e1)=>tE.before(e1)), I.none);
    }, rE = (e1, t)=>null === Lu(e1, t), sE = (e1, t, n)=>xh(e1, t, n).filter(T(rE, t)), aE = (e1, t, n)=>{
        const o = Sh(n);
        return sE(e1, t, o).bind((e1)=>Tu(e1, o).isNone() ? I.some(tE.start(e1)) : I.none());
    }, iE = (e1, t, n)=>{
        const o = _h(n);
        return sE(e1, t, o).bind((e1)=>Au(e1, o).isNone() ? I.some(tE.end(e1)) : I.none());
    }, lE = (e1, t, n)=>{
        const o = Sh(n), r = nE(t, o.container());
        return xh(e1, r, o).fold(()=>Tu(r, o).bind(T(xh, e1, r)).map((e1)=>tE.after(e1)), I.none);
    }, dE = (e1)=>!wh(uE(e1)), cE = (e1, t, n)=>eE([
            oE,
            aE,
            iE,
            lE
        ], [
            e1,
            t,
            n
        ]).filter(dE), uE = (e1)=>e1.fold(R, R, R, R), mE = (e1)=>e1.fold(N("before"), N("start"), N("end"), N("after")), fE = (e1)=>e1.fold(tE.before, tE.before, tE.after, tE.after), gE = (e1)=>e1.fold(tE.start, tE.start, tE.end, tE.end), pE = (e1, t, n, o, r, s)=>Mt(xh(t, n, o), xh(t, n, r), (t, o)=>t !== o && ((e1, t, n)=>{
                const o = Xc(t, e1), r = Xc(n, e1);
                return C(o) && o === r;
            })(n, t, o) ? tE.after(e1 ? t : o) : s).getOr(s), hE = (e1, t)=>e1.fold(M, (e1)=>{
            var n, o;
            return o = t, !(mE(n = e1) === mE(o) && uE(n) === uE(o));
        }), bE = (e1, t)=>e1 ? t.fold(S(I.some, tE.start), I.none, S(I.some, tE.after), I.none) : t.fold(I.none, S(I.some, tE.before), I.none, S(I.some, tE.end)), vE = (e1, t, n)=>{
        const o = e1 ? 1 : -1;
        return t.setRng(Vi(n.container(), n.offset() + o).toRange()), t.getSel().modify("move", e1 ? "forward" : "backward", "word"), !0;
    };
    var yE;
    !function(e1) {
        e1[e1.Br = 0] = "Br", e1[e1.Block = 1] = "Block", e1[e1.Wrap = 2] = "Wrap", e1[e1.Eol = 3] = "Eol";
    }(yE || (yE = {}));
    const CE = (e1, t)=>e1 === cu.Backwards ? oe(t) : t, wE = (e1, t, n)=>e1 === cu.Forwards ? t.next(n) : t.prev(n), xE = (e1, t, n, o)=>ar(o.getNode(t === cu.Forwards)) ? yE.Br : !1 === Qc(n, o) ? yE.Block : yE.Wrap, EE = (e1, t, n, o)=>{
        const r = wu(n);
        let s = o;
        const a = [];
        for(; s;){
            const n = wE(t, r, s);
            if (!n) break;
            if (ar(n.getNode(!1))) return t === cu.Forwards ? {
                positions: CE(t, a).concat([
                    n
                ]),
                breakType: yE.Br,
                breakAt: I.some(n)
            } : {
                positions: CE(t, a),
                breakType: yE.Br,
                breakAt: I.some(n)
            };
            if (n.isVisible()) {
                if (e1(s, n)) {
                    const e1 = xE(0, t, s, n);
                    return {
                        positions: CE(t, a),
                        breakType: e1,
                        breakAt: I.some(n)
                    };
                }
                a.push(n), s = n;
            } else s = n;
        }
        return {
            positions: CE(t, a),
            breakType: yE.Eol,
            breakAt: I.none()
        };
    }, _E = (e1, t, n, o)=>t(n, o).breakAt.map((o)=>{
            const r = t(n, o).positions;
            return e1 === cu.Backwards ? r.concat(o) : [
                o
            ].concat(r);
        }).getOr([]), SE = (e1, t)=>X(e1, (e1, n)=>e1.fold(()=>I.some(n), (o)=>Mt(le(o.getClientRects()), le(n.getClientRects()), (e1, r)=>{
                    const s = Math.abs(t - e1.left);
                    return Math.abs(t - r.left) <= s ? n : o;
                }).or(e1)), I.none()), kE = (e1, t)=>le(t.getClientRects()).bind((t)=>SE(e1, t.left)), NE = T(EE, Vi.isAbove, -1), RE = T(EE, Vi.isBelow, 1), AE = T(_E, -1, NE), TE = T(_E, 1, RE), OE = (e1, t)=>NE(e1, t).breakAt.isNone(), BE = (e1, t)=>RE(e1, t).breakAt.isNone(), PE = (e1, t)=>kE(AE(e1, t), t), DE = (e1, t)=>kE(TE(e1, t), t), LE = dr, ME = (e1, t)=>Math.abs(e1.left - t), IE = (e1, t)=>Math.abs(e1.right - t), FE = (e1, t)=>Oe(e1, (e1, n)=>{
            const o = Math.min(ME(e1, t), IE(e1, t)), r = Math.min(ME(n, t), IE(n, t));
            return r === o && _e(n, "node") && LE(n.node) || r < o ? n : e1;
        }), UE = (e1)=>{
        const t = (t)=>q(t, (t)=>{
                const n = vi(t);
                return n.node = e1, n;
            });
        if (qo(e1)) return t(e1.getClientRects());
        if (er(e1)) {
            const n = e1.ownerDocument.createRange();
            return n.setStart(e1, 0), n.setEnd(e1, e1.data.length), t(n.getClientRects());
        }
        return [];
    }, zE = (e1)=>te(e1, UE);
    var jE;
    !function(e1) {
        e1[e1.Up = -1] = "Up", e1[e1.Down = 1] = "Down";
    }(jE || (jE = {}));
    const HE = (e1, t, n, o, r, s)=>{
        let a = 0;
        const i = [], l = (o)=>{
            let s = zE([
                o
            ]);
            -1 === e1 && (s = s.reverse());
            for(let e1 = 0; e1 < s.length; e1++){
                const o = s[e1];
                if (!n(o, d)) {
                    if (i.length > 0 && t(o, Pe(i)) && a++, o.line = a, r(o)) return !0;
                    i.push(o);
                }
            }
            return !1;
        }, d = Pe(s.getClientRects());
        if (!d) return i;
        const c = s.getNode();
        return c && (l(c), ((e1, t, n, o)=>{
            let r = o;
            for(; r = Gc(r, e1, os, t);)if (n(r)) return;
        })(e1, o, l, c)), i;
    }, $E = T(HE, jE.Up, wi, xi), qE = T(HE, jE.Down, xi, wi), VE = (e1)=>Pe(e1.getClientRects()), WE = (e1)=>(t)=>((e1, t)=>t.line > e1)(e1, t), KE = (e1)=>(t)=>((e1, t)=>t.line === e1)(e1, t), YE = (e1, t)=>{
        e1.selection.setRng(t), sg(e1, e1.selection.getRng());
    }, GE = (e1, t, n)=>I.some(Tx(e1, t, n)), XE = (e1, t, n, o, r, s)=>{
        const a = t === cu.Forwards, i = wu(e1.getBody()), l = T(lu, a ? i.next : i.prev), d = a ? o : r;
        if (!n.collapsed) {
            const o = _i(n);
            if (s(o)) return Rx(t, e1, o, t === cu.Backwards, !1);
            if (Mx(e1)) {
                const e1 = n.cloneRange();
                return e1.collapse(t === cu.Backwards), I.from(e1);
            }
        }
        const c = au(t, e1.getBody(), n);
        if (d(c)) return Ax(e1, c.getNode(!a));
        let u = l(c);
        const m = Wr(n);
        if (!u) return m ? I.some(n) : I.none();
        if (u = Eh(a, u), d(u)) return Rx(t, e1, u.getNode(!a), a, !1);
        const f = l(u);
        return f && d(f) && du(u, f) ? Rx(t, e1, f.getNode(!a), a, !1) : m ? GE(e1, u.toRange(), !1) : I.none();
    }, QE = (e1, t, n, o, r, s)=>{
        const a = au(t, e1.getBody(), n), i = Pe(a.getClientRects()), l = t === jE.Down, d = e1.getBody();
        if (!i) return I.none();
        if (Mx(e1)) {
            const e1 = l ? Vi.fromRangeEnd(n) : Vi.fromRangeStart(n);
            return (l ? DE : PE)(d, e1).orThunk(()=>I.from(e1)).map((e1)=>e1.toRange());
        }
        const c = (l ? qE : $E)(d, WE(1), a), u = Y(c, KE(1)), m = i.left, f = FE(u, m);
        if (f && s(f.node)) {
            const n = Math.abs(m - f.left), o = Math.abs(m - f.right);
            return Rx(t, e1, f.node, n < o, !1);
        }
        let g;
        if (g = o(a) ? a.getNode() : r(a) ? a.getNode(!0) : _i(n), g) {
            const n = ((e1, t, n, o)=>{
                const r = wu(t);
                let s, a, i, l;
                const d = [];
                let c = 0;
                1 === e1 ? (s = r.next, a = xi, i = wi, l = Vi.after(o)) : (s = r.prev, a = wi, i = xi, l = Vi.before(o));
                const u = VE(l);
                do {
                    if (!l.isVisible()) continue;
                    const e1 = VE(l);
                    if (i(e1, u)) continue;
                    d.length > 0 && a(e1, Pe(d)) && c++;
                    const t = vi(e1);
                    if (t.position = l, t.line = c, n(t)) return d;
                    d.push(t);
                }while (l = s(l));
                return d;
            })(t, d, WE(1), g);
            let o = FE(Y(n, KE(1)), m);
            if (o) return GE(e1, o.position.toRange(), !1);
            if (o = Pe(Y(n, KE(0))), o) return GE(e1, o.position.toRange(), !1);
        }
        return 0 === u.length ? JE(e1, l).filter(l ? r : o).map((t)=>Tx(e1, t.toRange(), !1)) : I.none();
    }, JE = (e1, t)=>{
        const n = e1.selection.getRng(), o = t ? Vi.fromRangeEnd(n) : Vi.fromRangeStart(n), r = (s = o.container(), a = e1.getBody(), Qn(yn(s), (e1)=>Ic(e1.dom), (e1)=>e1.dom === a).map((e1)=>e1.dom).getOr(a));
        var s, a;
        if (t) {
            const e1 = RE(r, o);
            return de(e1.positions);
        }
        {
            const e1 = NE(r, o);
            return le(e1.positions);
        }
    }, ZE = (e1, t, n)=>JE(e1, t).filter(n).exists((t)=>(e1.selection.setRng(t.toRange()), !0)), e_ = (e1, t)=>{
        const n = e1.dom.createRng();
        n.setStart(t.container(), t.offset()), n.setEnd(t.container(), t.offset()), e1.selection.setRng(n);
    }, t_ = (e1, t)=>{
        e1 ? t.setAttribute("data-mce-selected", "inline-boundary") : t.removeAttribute("data-mce-selected");
    }, n_ = (e1, t, n)=>Zx(t, n).map((t)=>(e_(e1, t), n)), o_ = (e1, t, n)=>{
        const o = e1.getBody(), r = ((e1, t, n)=>{
            const o = Vi.fromRangeStart(e1);
            if (e1.collapsed) return o;
            {
                const r = Vi.fromRangeEnd(e1);
                return n ? Tu(t, r).getOr(r) : Au(t, o).getOr(o);
            }
        })(e1.selection.getRng(), o, n);
        return ((e1, t, n, o)=>{
            const r = Eh(e1, o), s = cE(t, n, r);
            return cE(t, n, r).bind(T(bE, e1)).orThunk(()=>((e1, t, n, o, r)=>{
                    const s = Eh(e1, r);
                    return Su(e1, n, s).map(T(Eh, e1)).fold(()=>o.map(fE), (r)=>cE(t, n, r).map(T(pE, e1, t, n, s, r)).filter(T(hE, o))).filter(dE);
                })(e1, t, n, s, o));
        })(n, T(Ch, e1), o, r).bind((n)=>n_(e1, t, n));
    }, r_ = (e1, t, n)=>!!yd(e1) && o_(e1, t, n).isSome(), s_ = (e1, t, n)=>!!yd(t) && ((e1, t)=>{
            const n = t.selection.getRng(), o = e1 ? Vi.fromRangeEnd(n) : Vi.fromRangeStart(n);
            return !!((e1)=>w(e1.selection.getSel().modify))(t) && (e1 && jr(o) ? vE(!0, t.selection, o) : !(e1 || !Hr(o)) && vE(!1, t.selection, o));
        })(e1, t), a_ = (e1)=>{
        const t = $a(null), n = T(Ch, e1);
        return e1.on("NodeChange", (o)=>{
            yd(e1) && (((e1, t, n)=>{
                const o = q(Uo(yn(t.getRoot()), '*[data-mce-selected="inline-boundary"]'), (e1)=>e1.dom), r = Y(o, e1), s = Y(n, e1);
                V(re(r, s), T(t_, !1)), V(re(s, r), T(t_, !0));
            })(n, e1.dom, o.parents), ((e1, t)=>{
                const n = t.get();
                if (e1.selection.isCollapsed() && !e1.composing && n) {
                    const o = Vi.fromRangeStart(e1.selection.getRng());
                    Vi.isTextPosition(o) && !((e1)=>jr(e1) || Hr(e1))(o) && (e_(e1, Nc(n, o)), t.set(null));
                }
            })(e1, t), ((e1, t, n, o)=>{
                if (t.selection.isCollapsed()) {
                    const r = Y(o, e1);
                    V(r, (o)=>{
                        const r = Vi.fromRangeStart(t.selection.getRng());
                        cE(e1, t.getBody(), r).bind((e1)=>n_(t, n, e1));
                    });
                }
            })(n, e1, t, o.parents));
        }), t;
    }, i_ = T(s_, !0), l_ = T(s_, !1), d_ = (e1, t, n)=>{
        if (yd(e1)) {
            const o = JE(e1, t).getOrThunk(()=>{
                const n = e1.selection.getRng();
                return t ? Vi.fromRangeEnd(n) : Vi.fromRangeStart(n);
            });
            return cE(T(Ch, e1), e1.getBody(), o).exists((t)=>{
                const o = fE(t);
                return Zx(n, o).exists((t)=>(e_(e1, t), !0));
            });
        }
        return !1;
    }, c_ = (e1, t)=>(n)=>Zx(t, n).map((t)=>()=>e_(e1, t)), u_ = (e1, t, n, o)=>{
        const r = e1.getBody(), s = T(Ch, e1);
        e1.undoManager.ignore(()=>{
            e1.selection.setRng(((e1, t)=>{
                const n = document.createRange();
                return n.setStart(e1.container(), e1.offset()), n.setEnd(t.container(), t.offset()), n;
            })(n, o)), Nh(e1), cE(s, r, Vi.fromRangeStart(e1.selection.getRng())).map(gE).bind(c_(e1, t)).each(D);
        }), e1.nodeChanged();
    }, m_ = (e1, t, n)=>{
        if (e1.selection.isCollapsed() && yd(e1)) {
            const o = Vi.fromRangeStart(e1.selection.getRng());
            return ((e1, t, n, o)=>{
                const r = ((e1, t)=>Xc(t, e1) || e1)(e1.getBody(), o.container()), s = T(Ch, e1), a = cE(s, r, o);
                return a.bind((e1)=>n ? e1.fold(N(I.some(gE(e1))), I.none, N(I.some(fE(e1))), I.none) : e1.fold(I.none, N(I.some(fE(e1))), I.none, N(I.some(gE(e1))))).map(c_(e1, t)).getOrThunk(()=>{
                    const i = ku(n, r, o), l = i.bind((e1)=>cE(s, r, e1));
                    return Mt(a, l, ()=>xh(s, r, o).bind((t)=>((e1)=>Mt(Ou(e1), Bu(e1), (t, n)=>{
                                    const o = Eh(!0, t), r = Eh(!1, n);
                                    return Au(e1, o).forall((e1)=>e1.isEqual(r));
                                }).getOr(!0))(t) ? I.some(()=>{
                                vh(e1, n, yn(t));
                            }) : I.none())).getOrThunk(()=>l.bind(()=>i.map((r)=>()=>{
                                    n ? u_(e1, t, o, r) : u_(e1, t, r, o);
                                })));
                });
            })(e1, t, n, o);
        }
        return I.none();
    }, f_ = (e1, t)=>{
        const n = yn(e1.getBody()), o = yn(e1.selection.getStart()), r = Bp(o, n);
        return Z(r, t).fold(N(r), (e1)=>r.slice(0, e1));
    }, g_ = (e1)=>1 === zn(e1), p_ = (e1, t)=>{
        const n = T(Zb, e1);
        return te(t, (e1)=>n(e1) ? [
                e1.dom
            ] : []);
    }, h_ = (e1)=>{
        const t = ((e1)=>f_(e1, (t)=>e1.schema.isBlock(Ht(t))))(e1);
        return p_(e1, t);
    }, b_ = (e1, t)=>{
        const n = Y(((e1)=>f_(e1, (t)=>e1.schema.isBlock(Ht(t)) || ((e1)=>zn(e1) > 1)(t)))(e1), g_);
        return de(n).bind((o)=>{
            const r = Vi.fromRangeStart(e1.selection.getRng());
            return Oh(t, r, o.dom) && !Tm(o) ? I.some(()=>((e1, t, n, o)=>{
                    const r = p_(t, o);
                    if (0 === r.length) vh(t, e1, n);
                    else {
                        const e1 = Jb(n.dom, r);
                        t.selection.setRng(e1.toRange());
                    }
                })(t, e1, o, n)) : I.none();
        });
    }, v_ = (e1, t)=>{
        const n = e1.selection.getStart(), o = ((e1, t)=>{
            const n = t.parentElement;
            return ar(t) && !h(n) && e1.dom.isEmpty(n);
        })(e1, n) || Tm(yn(n)) ? Jb(n, t) : ((e1, t)=>{
            const { caretContainer: n, caretPosition: o } = Qb(t);
            return e1.insertNode(n.dom), o;
        })(e1.selection.getRng(), t);
        e1.selection.setRng(o.toRange());
    }, y_ = (e1)=>er(e1.startContainer), C_ = (e1)=>{
        const t = e1.selection.getRng();
        return ((e1)=>0 === e1.startOffset && y_(e1))(t) && ((e1, t)=>{
            const n = t.startContainer.parentElement;
            return !h(n) && Zb(e1, yn(n));
        })(e1, t) && ((e1)=>((e1)=>((e1)=>{
                    const t = e1.startContainer.parentNode, n = e1.endContainer.parentNode;
                    return !h(t) && !h(n) && t.isEqualNode(n);
                })(e1) && ((e1)=>{
                    const t = e1.endContainer;
                    return e1.endOffset === (er(t) ? t.length : t.childNodes.length);
                })(e1))(e1) || ((e1)=>!e1.endContainer.isEqualNode(e1.commonAncestorContainer))(e1))(t);
    }, w_ = (e1, t)=>e1.selection.isCollapsed() ? b_(e1, t) : ((e1)=>{
            if (C_(e1)) {
                const t = h_(e1);
                return I.some(()=>{
                    Nh(e1), ((e1, t)=>{
                        const n = re(t, h_(e1));
                        n.length > 0 && v_(e1, n);
                    })(e1, t);
                });
            }
            return I.none();
        })(e1), x_ = (e1, t)=>Qn(e1, (e1)=>Du(e1.dom), (e1)=>t.isBlock(Ht(e1))).isSome(), E_ = (e1)=>(((e1)=>{
            const t = e1.selection.getRng();
            return t.collapsed && (y_(t) || e1.dom.isEmpty(t.startContainer)) && !((e1)=>x_(yn(e1.selection.getStart()), e1.schema))(e1);
        })(e1) && v_(e1, []), !0), __ = (e1, t, n)=>C(n) ? I.some(()=>{
            e1._selectionOverrides.hideFakeCaret(), vh(e1, t, yn(n));
        }) : I.none(), S_ = (e1, t)=>e1.selection.isCollapsed() ? ((e1, t)=>{
            const n = t ? Sp : kp, o = t ? cu.Forwards : cu.Backwards, r = au(o, e1.getBody(), e1.selection.getRng());
            return n(r) ? __(e1, t, r.getNode(!t)) : I.from(Eh(t, r)).filter((e1)=>n(e1) && du(r, e1)).bind((n)=>__(e1, t, n.getNode(!t)));
        })(e1, t) : ((e1, t)=>{
            const n = e1.selection.getNode();
            return mr(n) ? __(e1, t, n) : I.none();
        })(e1, t), k_ = (e1)=>Xe(null != e1 ? e1 : "").getOr(0), N_ = (e1, t)=>(e1 || "table" === Ht(t) ? "margin" : "padding") + ("rtl" === co(t, "direction") ? "-right" : "-left"), R_ = (e1)=>{
        const t = T_(e1);
        return !e1.mode.isReadOnly() && (t.length > 1 || ((e1, t)=>ne(t, (t)=>{
                const n = N_(od(e1), t), o = mo(t, n).map(k_).getOr(0);
                return "false" !== e1.dom.getContentEditable(t.dom) && o > 0;
            }))(e1, t));
    }, A_ = (e1)=>Sr(e1) || kr(e1), T_ = (e1)=>Y(_o(e1.selection.getSelectedBlocks()), (e1)=>!A_(e1) && !((e1)=>An(e1).exists(A_))(e1) && Jn(e1, (e1)=>lr(e1.dom) || dr(e1.dom)).exists((e1)=>lr(e1.dom))), O_ = (e1, t)=>{
        var n, o;
        const { dom: r } = e1, s = rd(e1), a = null !== (o = null === (n = /[a-z%]+$/i.exec(s)) || void 0 === n ? void 0 : n[0]) && void 0 !== o ? o : "px", i = k_(s), l = od(e1);
        V(T_(e1), (e1)=>{
            ((e1, t, n, o, r, s)=>{
                const a = N_(n, yn(s)), i = k_(e1.getStyle(s, a));
                if ("outdent" === t) {
                    const t = Math.max(0, i - o);
                    e1.setStyle(s, a, t ? t + r : "");
                } else {
                    const t = i + o + r;
                    e1.setStyle(s, a, t);
                }
            })(r, t, l, i, a, e1.dom);
        });
    }, B_ = (e1)=>O_(e1, "outdent"), P_ = (e1)=>{
        if (e1.selection.isCollapsed() && R_(e1)) {
            const t = e1.dom, n = e1.selection.getRng(), o = Vi.fromRangeStart(n), r = t.getParent(n.startContainer, t.isBlock);
            if (null !== r && Ip(yn(r), o, e1.schema)) return I.some(()=>B_(e1));
        }
        return I.none();
    }, D_ = (e1, t, n)=>ue([
            P_,
            Hx,
            Dx,
            (e1, n)=>m_(e1, t, n),
            _x,
            ib,
            $x,
            S_,
            Nx,
            w_
        ], (t)=>t(e1, n)).filter((t)=>e1.selection.isEditable()), L_ = (e1, t)=>{
        e1.addCommand("delete", ()=>{
            ((e1, t)=>{
                D_(e1, t, !1).fold(()=>{
                    e1.selection.isEditable() && (Nh(e1), Th(e1));
                }, D);
            })(e1, t);
        }), e1.addCommand("forwardDelete", ()=>{
            ((e1, t)=>{
                D_(e1, t, !0).fold(()=>{
                    e1.selection.isEditable() && ((e1)=>{
                        kh(e1, "ForwardDelete");
                    })(e1);
                }, D);
            })(e1, t);
        });
    }, M_ = (e1)=>void 0 === e1.touches || 1 !== e1.touches.length ? I.none() : I.some(e1.touches[0]), I_ = (e1, t)=>Ee(e1, t.nodeName), F_ = (e1, t)=>!!er(t) || !!qo(t) && !(I_(e1.getBlockElements(), t) || Ku(t) || Ts(e1, t) || hs(t)), U_ = (e1, t)=>{
        if (er(t)) {
            if (0 === t.data.length) return !0;
            if (/^\s+$/.test(t.data)) return !t.nextSibling || I_(e1, t.nextSibling) || hs(t.nextSibling);
        }
        return !1;
    }, z_ = (e1)=>e1.dom.create(Il(e1), Fl(e1)), j_ = (e1)=>{
        const t = e1.dom, n = e1.selection, o = e1.schema, r = o.getBlockElements(), s = n.getStart(), a = e1.getBody();
        let i, l, d = !1;
        const c = Il(e1);
        if (!s || !qo(s)) return;
        const u = a.nodeName.toLowerCase();
        if (!o.isValidChild(u, c.toLowerCase()) || ((e1, t, n)=>$(Op(yn(n), yn(t)), (t)=>I_(e1, t.dom)))(r, a, s)) return;
        const m = n.getRng(), { startContainer: f, startOffset: g, endContainer: p, endOffset: h } = m, b = Rg(e1);
        let v = a.firstChild;
        for(; v;)if (qo(v) && ks(o, v), F_(o, v)) {
            if (U_(r, v)) {
                l = v, v = v.nextSibling, t.remove(l);
                continue;
            }
            i || (i = z_(e1), a.insertBefore(i, v), d = !0), l = v, v = v.nextSibling, i.appendChild(l);
        } else i = null, v = v.nextSibling;
        d && b && (m.setStart(f, g), m.setEnd(p, h), n.setRng(m), e1.nodeChanged());
    }, H_ = (e1, t, n)=>{
        const o = yn(z_(e1)), r = Tr();
        vo(o, r), n(t, o);
        const s = document.createRange();
        return s.setStartBefore(r.dom), s.setEndBefore(r.dom), s;
    }, $_ = (e1)=>(t)=>-1 !== (" " + t.attr("class") + " ").indexOf(e1), q_ = (e1, t, n)=>function(o) {
            const r = arguments, s = r[r.length - 2], a = s > 0 ? t.charAt(s - 1) : "";
            if ('"' === a) return o;
            if (">" === a) {
                const e1 = t.lastIndexOf("<", s);
                if (-1 !== e1 && -1 !== t.substring(e1, s).indexOf('contenteditable="false"')) return o;
            }
            return '<span class="' + n + '" data-mce-content="' + e1.dom.encode(r[0]) + '">' + e1.dom.encode("string" == typeof r[1] ? r[1] : r[0]) + "</span>";
        }, V_ = (e1, t)=>ne(e1, (e1)=>{
            const n = t.match(e1);
            return null !== n && n[0].length === t.length;
        }), W_ = (e1, t)=>{
        t.hasAttribute("data-mce-caret") && (Vr(t), e1.selection.setRng(e1.selection.getRng()), e1.selection.scrollIntoView(t));
    }, K_ = (e1, t)=>{
        const n = ((e1)=>to(yn(e1.getBody()), "*[data-mce-caret]").map((e1)=>e1.dom).getOrNull())(e1);
        if (n) return "compositionstart" === t.type ? (t.preventDefault(), t.stopPropagation(), void W_(e1, n)) : void (zr(n) && (W_(e1, n), e1.undoManager.add()));
    }, Y_ = dr, G_ = (e1, t, n)=>{
        const o = wu(e1.getBody()), r = T(lu, 1 === t ? o.next : o.prev);
        if (n.collapsed) {
            const o = e1.dom.getParent(n.startContainer, "PRE");
            if (!o) return;
            if (!r(Vi.fromRangeStart(n))) {
                const n = yn(((e1)=>{
                    const t = e1.dom.create(Il(e1));
                    return t.innerHTML = '<br data-mce-bogus="1">', t;
                })(e1));
                1 === t ? ho(yn(o), n) : po(yn(o), n), e1.selection.select(n.dom, !0), e1.selection.collapse();
            }
        }
    }, X_ = (e1, t)=>((e1, t)=>{
            const n = t ? cu.Forwards : cu.Backwards, o = e1.selection.getRng();
            return ((e1, t, n)=>XE(t, e1, n, Ap, Tp, Y_))(n, e1, o).orThunk(()=>(G_(e1, n, o), I.none()));
        })(e1, ((e1, t)=>{
            const n = t ? e1.getEnd(!0) : e1.getStart(!0);
            return wh(n) ? !t : t;
        })(e1.selection, t)).exists((t)=>(YE(e1, t), !0)), Q_ = (e1, t)=>((e1, t)=>{
            const n = t ? 1 : -1, o = e1.selection.getRng();
            return ((e1, t, n)=>QE(t, e1, n, (e1)=>Ap(e1) || Np(e1), (e1)=>Tp(e1) || Rp(e1), Y_))(n, e1, o).orThunk(()=>(G_(e1, n, o), I.none()));
        })(e1, t).exists((t)=>(YE(e1, t), !0)), J_ = (e1, t)=>ZE(e1, t, t ? Tp : Ap), Z_ = (e1, t)=>Lx(e1, !t).map((n)=>{
            const o = n.toRange(), r = e1.selection.getRng();
            return t ? o.setStart(r.startContainer, r.startOffset) : o.setEnd(r.endContainer, r.endOffset), o;
        }).exists((t)=>(YE(e1, t), !0)), eS = (e1)=>H([
            "figcaption"
        ], Ht(e1)), tS = (e1, t)=>!!e1.selection.isCollapsed() && ((e1, t)=>{
            const n = yn(e1.getBody()), o = Vi.fromRangeStart(e1.selection.getRng());
            return ((e1, t, n)=>{
                const o = T(_n, t);
                return Jn(yn(e1.container()), (e1)=>n.isBlock(Ht(e1)), o).filter(eS);
            })(o, n, e1.schema).exists(()=>{
                if (((e1, t, n)=>t ? BE(e1.dom, n) : OE(e1.dom, n))(n, t, o)) {
                    const o = H_(e1, n, t ? vo : bo);
                    return e1.selection.setRng(o), !0;
                }
                return !1;
            });
        })(e1, t), nS = (e1, t)=>((e1, t)=>t ? I.from(e1.dom.getParent(e1.selection.getNode(), "details")).map((t)=>((e1, t)=>{
                    const n = e1.selection.getRng(), o = Vi.fromRangeStart(n);
                    return !(e1.getBody().lastChild !== t || !BE(t, o) || (e1.execCommand("InsertNewBlockAfter"), 0));
                })(e1, t)).getOr(!1) : I.from(e1.dom.getParent(e1.selection.getNode(), "summary")).bind((t)=>I.from(e1.dom.getParent(t, "details")).map((n)=>((e1, t, n)=>{
                        const o = e1.selection.getRng(), r = Vi.fromRangeStart(o);
                        return !(e1.getBody().firstChild !== t || !OE(n, r) || (e1.execCommand("InsertNewBlockBefore"), 0));
                    })(e1, n, t))).getOr(!1))(e1, t), oS = {
        shiftKey: !1,
        altKey: !1,
        ctrlKey: !1,
        metaKey: !1,
        keyCode: 0
    }, rS = (e1, t)=>t.keyCode === e1.keyCode && t.shiftKey === e1.shiftKey && t.altKey === e1.altKey && t.ctrlKey === e1.ctrlKey && t.metaKey === e1.metaKey, sS = (e1, ...t)=>()=>e1.apply(null, t), aS = (e1, t)=>J(((e1, t)=>te(((e1)=>q(e1, (e1)=>({
                        ...oS,
                        ...e1
                    })))(e1), (e1)=>rS(e1, t) ? [
                    e1
                ] : []))(e1, t), (e1)=>e1.action()), iS = (e1, t)=>ue(((e1, t)=>te(((e1)=>q(e1, (e1)=>({
                        ...oS,
                        ...e1
                    })))(e1), (e1)=>rS(e1, t) ? [
                    e1
                ] : []))(e1, t), (e1)=>e1.action()), lS = (e1, t)=>{
        const n = t ? cu.Forwards : cu.Backwards, o = e1.selection.getRng();
        return XE(e1, n, o, Sp, kp, mr).exists((t)=>(YE(e1, t), !0));
    }, dS = (e1, t)=>{
        const n = t ? 1 : -1, o = e1.selection.getRng();
        return QE(e1, n, o, Sp, kp, mr).exists((t)=>(YE(e1, t), !0));
    }, cS = (e1, t)=>ZE(e1, t, t ? kp : Sp), uS = hl([
        {
            none: [
                "current"
            ]
        },
        {
            first: [
                "current"
            ]
        },
        {
            middle: [
                "current",
                "target"
            ]
        },
        {
            last: [
                "current"
            ]
        }
    ]), mS = {
        ...uS,
        none: (e1)=>uS.none(e1)
    }, fS = (e1, t, n)=>te(Mn(e1), (e1)=>xn(e1, t) ? n(e1) ? [
                e1
            ] : [] : fS(e1, t, n)), gS = (e1, t)=>no(e1, "table", t), pS = (e1, t, n, o, r = M)=>{
        const s = 1 === o;
        if (!s && n <= 0) return mS.first(e1[0]);
        if (s && n >= e1.length - 1) return mS.last(e1[e1.length - 1]);
        {
            const s = n + o, a = e1[s];
            return r(a) ? mS.middle(t, a) : pS(e1, t, s, o, r);
        }
    }, hS = (e1, t)=>gS(e1, t).bind((t)=>{
            const n = fS(t, "th,td", M);
            return Z(n, (t)=>_n(e1, t)).map((e1)=>({
                    index: e1,
                    all: n
                }));
        }), bS = (e1, t, n, o, r)=>{
        const s = Uo(yn(n), "td,th,caption").map((e1)=>e1.dom), a = Y(((e1, t)=>te(t, (t)=>{
                const n = ((e1, t)=>({
                        left: e1.left - t,
                        top: e1.top - t,
                        right: e1.right + -2,
                        bottom: e1.bottom + -2,
                        width: e1.width + t,
                        height: e1.height + t
                    }))(vi(t.getBoundingClientRect()), -1);
                return [
                    {
                        x: n.left,
                        y: e1(n),
                        cell: t
                    },
                    {
                        x: n.right,
                        y: e1(n),
                        cell: t
                    }
                ];
            }))(e1, s), (e1)=>t(e1, r));
        return ((e1, t, n)=>X(e1, (e1, o)=>e1.fold(()=>I.some(o), (e1)=>{
                    const r = Math.sqrt(Math.abs(e1.x - t) + Math.abs(e1.y - n)), s = Math.sqrt(Math.abs(o.x - t) + Math.abs(o.y - n));
                    return I.some(s < r ? o : e1);
                }), I.none()))(a, o, r).map((e1)=>e1.cell);
    }, vS = T(bS, (e1)=>e1.bottom, (e1, t)=>e1.y < t), yS = T(bS, (e1)=>e1.top, (e1, t)=>e1.y > t), CS = (e1, t, n)=>{
        const o = e1(t, n);
        return ((e1)=>e1.breakType === yE.Wrap && 0 === e1.positions.length)(o) || !ar(n.getNode()) && ((e1)=>e1.breakType === yE.Br && 1 === e1.positions.length)(o) ? !((e1, t, n)=>n.breakAt.exists((n)=>e1(t, n).breakAt.isSome()))(e1, t, o) : o.breakAt.isNone();
    }, wS = T(CS, NE), xS = T(CS, RE), ES = (e1, t, n, o)=>{
        const r = e1.selection.getRng(), s = t ? 1 : -1;
        return !(!Dc() || !((e1, t, n)=>{
            const o = Vi.fromRangeStart(t);
            return Ru(!e1, n).exists((e1)=>e1.isEqual(o));
        })(t, r, n) || (Rx(s, e1, n, !t, !1).each((t)=>{
            YE(e1, t);
        }), 0));
    }, _S = (e1, t, n)=>{
        const o = ((e1, t)=>{
            const n = t.getNode(e1);
            return Qo(n) ? I.some(n) : I.none();
        })(!!t, n), r = !1 === t;
        o.fold(()=>YE(e1, n.toRange()), (o)=>Ru(r, e1.getBody()).filter((e1)=>e1.isEqual(n)).fold(()=>YE(e1, n.toRange()), (n)=>((e1, t, n)=>{
                    t.undoManager.transact(()=>{
                        const o = e1 ? ho : po, r = H_(t, yn(n), o);
                        YE(t, r);
                    });
                })(t, e1, o)));
    }, SS = (e1, t, n, o)=>{
        const r = e1.selection.getRng(), s = Vi.fromRangeStart(r), a = e1.getBody();
        if (!t && wS(o, s)) {
            const o = ((e1, t, n)=>((e1, t)=>le(t.getClientRects()).bind((t)=>vS(e1, t.left, t.top)).bind((e1)=>{
                        var n;
                        return kE(Bu(n = e1).map((e1)=>NE(n, e1).positions.concat(e1)).getOr([]), t);
                    }))(t, n).orThunk(()=>le(n.getClientRects()).bind((n)=>SE(AE(e1, Vi.before(t)), n.left))).getOr(Vi.before(t)))(a, n, s);
            return _S(e1, t, o), !0;
        }
        if (t && xS(o, s)) {
            const o = ((e1, t, n)=>((e1, t)=>de(t.getClientRects()).bind((t)=>yS(e1, t.left, t.top)).bind((e1)=>{
                        var n;
                        return kE(Ou(n = e1).map((e1)=>[
                                e1
                            ].concat(RE(n, e1).positions)).getOr([]), t);
                    }))(t, n).orThunk(()=>le(n.getClientRects()).bind((n)=>SE(TE(e1, Vi.after(t)), n.left))).getOr(Vi.after(t)))(a, n, s);
            return _S(e1, t, o), !0;
        }
        return !1;
    }, kS = (e1, t, n)=>I.from(e1.dom.getParent(e1.selection.getNode(), "td,th")).bind((o)=>I.from(e1.dom.getParent(o, "table")).map((r)=>n(e1, t, r, o))).getOr(!1), NS = (e1, t)=>kS(e1, t, ES), RS = (e1, t)=>kS(e1, t, SS), AS = (e1, t, n)=>n.fold(I.none, I.none, (e1, t)=>{
            var n;
            return (n = t, Zn(n, Fg)).map((e1)=>((e1)=>{
                    const t = xf.exact(e1, 0, e1, 0);
                    return Nf(t);
                })(e1));
        }, (n)=>(e1.execCommand("mceTableInsertRowAfter"), TS(e1, t, n))), TS = (e1, t, n)=>{
        var o, r;
        return AS(e1, t, (r = oo, hS(o = n, void 0).fold(()=>mS.none(o), (e1)=>pS(e1.all, o, e1.index, 1, r))));
    }, OS = (e1, t, n)=>{
        var o, r;
        return AS(e1, t, (r = oo, hS(o = n, void 0).fold(()=>mS.none(), (e1)=>pS(e1.all, o, e1.index, -1, r))));
    }, BS = (e1, t)=>{
        const n = [
            "table",
            "li",
            "dl"
        ], o = yn(e1.getBody()), r = (e1)=>{
            const t = Ht(e1);
            return _n(e1, o) || H(n, t);
        }, s = e1.selection.getRng();
        return ((e1, t)=>((e1, t, n = L)=>n(t) ? I.none() : H(e1, Ht(t)) ? I.some(t) : eo(t, e1.join(","), (e1)=>xn(e1, "table") || n(e1)))([
                "td",
                "th"
            ], e1, t))(yn(t ? s.endContainer : s.startContainer), r).map((n)=>(gS(n, r).each((t)=>{
                e1.model.table.clearSelectedCells(t.dom);
            }), e1.selection.collapse(!t), (t ? TS : OS)(e1, r, n).each((t)=>{
                e1.selection.setRng(t);
            }), !0)).getOr(!1);
    }, PS = (e1, t)=>({
            container: e1,
            offset: t
        }), DS = za.DOM, LS = (e1)=>(t)=>e1 === t ? -1 : 0, MS = (e1, t, n)=>{
        if (er(e1) && t >= 0) return I.some(PS(e1, t));
        {
            const o = hi(DS);
            return I.from(o.backwards(e1, t, LS(e1), n)).map((e1)=>PS(e1.container, e1.container.data.length));
        }
    }, IS = (e1, t, n)=>{
        if (!er(e1)) return I.none();
        const o = e1.data;
        if (t >= 0 && t <= o.length) return I.some(PS(e1, t));
        {
            const o = hi(DS);
            return I.from(o.backwards(e1, t, LS(e1), n)).bind((e1)=>{
                const o = e1.container.data;
                return IS(e1.container, t + o.length, n);
            });
        }
    }, FS = (e1, t, n)=>{
        if (!er(e1)) return I.none();
        const o = e1.data;
        if (t <= o.length) return I.some(PS(e1, t));
        {
            const r = hi(DS);
            return I.from(r.forwards(e1, t, LS(e1), n)).bind((e1)=>FS(e1.container, t - o.length, n));
        }
    }, US = (e1, t, n, o, r)=>{
        const s = hi(e1, ((e1)=>(t)=>e1.isBlock(t) || H([
                    "BR",
                    "IMG",
                    "HR",
                    "INPUT"
                ], t.nodeName) || "false" === e1.getContentEditable(t))(e1));
        return I.from(s.backwards(t, n, o, r));
    }, zS = (e1)=>Dr(e1.toString().replace(/\u00A0/g, " ")), jS = (e1)=>"" !== e1 && -1 !== " \xa0\f\n\r\t\v".indexOf(e1), HS = (e1, t)=>e1.substring(t.length), $S = (e1, t, n, o = 0)=>{
        var r;
        return (r = yn(t.startContainer), no(r, Ug)).fold(()=>((e1, t, n, o = 0)=>{
                if (!(r = t).collapsed || !er(r.startContainer)) return I.none();
                var r;
                const s = {
                    text: "",
                    offset: 0
                }, a = e1.getParent(t.startContainer, e1.isBlock) || e1.getRoot();
                return US(e1, t.startContainer, t.startOffset, (e1, t, o)=>(s.text = o + s.text, s.offset += t, ((e1, t, n)=>{
                        let o;
                        const r = n.charAt(0);
                        for(o = t - 1; o >= 0; o--){
                            const s = e1.charAt(o);
                            if (jS(s)) return I.none();
                            if (r === s && je(e1, n, o, t)) break;
                        }
                        return I.some(o);
                    })(s.text, s.offset, n).getOr(t)), a).bind((e1)=>{
                    const r = t.cloneRange();
                    if (r.setStart(e1.container, e1.offset), r.setEnd(t.endContainer, t.endOffset), r.collapsed) return I.none();
                    const s = zS(r);
                    return 0 !== s.lastIndexOf(n) || HS(s, n).length < o ? I.none() : I.some({
                        text: HS(s, n),
                        range: r,
                        trigger: n
                    });
                });
            })(e1, t, n, o), (t)=>{
            const o = e1.createRng();
            o.selectNode(t.dom);
            const r = zS(o);
            return I.some({
                range: o,
                text: HS(r, n),
                trigger: n
            });
        });
    }, qS = (e1)=>{
        if (((e1)=>3 === e1.nodeType)(e1)) return PS(e1, e1.data.length);
        {
            const t = e1.childNodes;
            return t.length > 0 ? qS(t[t.length - 1]) : PS(e1, t.length);
        }
    }, VS = (e1, t)=>{
        const n = e1.childNodes;
        return n.length > 0 && t < n.length ? VS(n[t], 0) : n.length > 0 && ((e1)=>1 === e1.nodeType)(e1) && n.length === t ? qS(n[n.length - 1]) : PS(e1, t);
    }, WS = (e1, t, n, o = {})=>{
        var r;
        const s = t(), a = null !== (r = e1.selection.getRng().startContainer.nodeValue) && void 0 !== r ? r : "", i = Y(s.lookupByTrigger(n.trigger), (t)=>n.text.length >= t.minChars && t.matches.getOrThunk(()=>((e1)=>(t)=>{
                        const n = VS(t.startContainer, t.startOffset);
                        return !((e1, t)=>{
                            var n;
                            const o = null !== (n = e1.getParent(t.container, e1.isBlock)) && void 0 !== n ? n : e1.getRoot();
                            return US(e1, t.container, t.offset, (e1, t)=>0 === t ? -1 : t, o).filter((e1)=>{
                                const t = e1.container.data.charAt(e1.offset - 1);
                                return !jS(t);
                            }).isSome();
                        })(e1, n);
                    })(e1.dom))(n.range, a, n.text));
        if (0 === i.length) return I.none();
        const l = Promise.all(q(i, (e1)=>e1.fetch(n.text, e1.maxResults, o).then((t)=>({
                    matchText: n.text,
                    items: t,
                    columns: e1.columns,
                    onAction: e1.onAction,
                    highlightOn: e1.highlightOn
                }))));
        return I.some({
            lookupData: l,
            context: n
        });
    };
    var KS;
    !function(e1) {
        e1[e1.Error = 0] = "Error", e1[e1.Value = 1] = "Value";
    }(KS || (KS = {}));
    const YS = (e1, t, n)=>e1.stype === KS.Error ? t(e1.serror) : n(e1.svalue), GS = (e1)=>({
            stype: KS.Value,
            svalue: e1
        }), XS = (e1)=>({
            stype: KS.Error,
            serror: e1
        }), QS = YS, JS = (e1)=>f(e1) && me(e1).length > 100 ? " removed due to size" : JSON.stringify(e1, null, 2), ZS = (e1, t)=>XS([
            {
                path: e1,
                getErrorInfo: t
            }
        ]), ek = (e1, t)=>({
            extract: (n, o)=>xe(o, e1).fold(()=>((e1, t)=>ZS(e1, ()=>'Choice schema did not contain choice key: "' + t + '"'))(n, e1), (e1)=>((e1, t, n, o)=>xe(n, o).fold(()=>((e1, t, n)=>ZS(e1, ()=>'The chosen schema: "' + n + '" did not exist in branches: ' + JS(t)))(e1, n, o), (n)=>n.extract(e1.concat([
                                "branch: " + o
                            ]), t)))(n, o, t, e1)),
            toString: ()=>"chooseOn(" + e1 + "). Possible values: " + me(t)
        }), tk = (e1)=>(...t)=>{
            if (0 === t.length) throw new Error("Can't merge zero objects");
            const n = {};
            for(let o = 0; o < t.length; o++){
                const r = t[o];
                for(const t in r)Ee(r, t) && (n[t] = e1(n[t], r[t]));
            }
            return n;
        }, nk = tk((e1, t)=>g(e1) && g(t) ? nk(e1, t) : t), ok = (tk((e1, t)=>t), (e1)=>({
            tag: "defaultedThunk",
            process: N(e1)
        })), rk = (e1)=>{
        const t = ((e1)=>{
            const t = [], n = [];
            return V(e1, (e1)=>{
                YS(e1, (e1)=>n.push(e1), (e1)=>t.push(e1));
            }), {
                values: t,
                errors: n
            };
        })(e1);
        var n;
        return t.errors.length > 0 ? (n = t.errors, S(XS, ee)(n)) : GS(t.values);
    }, sk = (e1, t, n)=>{
        switch(e1.tag){
            case "field":
                return t(e1.key, e1.newKey, e1.presence, e1.prop);
            case "custom":
                return n(e1.newKey, e1.instantiator);
        }
    }, ak = (e1)=>({
            extract: (t, n)=>{
                var o, r;
                return o = e1(n), r = (e1)=>((e1, t)=>ZS(e1, N(t)))(t, e1), o.stype === KS.Error ? r(o.serror) : o;
            },
            toString: N("val")
        }), ik = ak(GS), lk = (e1, t, n, o)=>o(xe(e1, t).getOrThunk(()=>n(e1))), dk = (e1, t, n, o, r)=>{
        const s = (e1)=>r.extract(t.concat([
                o
            ]), e1), a = (e1)=>e1.fold(()=>GS(I.none()), (e1)=>{
                const n = r.extract(t.concat([
                    o
                ]), e1);
                var s, a;
                return s = n, a = I.some, s.stype === KS.Value ? {
                    stype: KS.Value,
                    svalue: a(s.svalue)
                } : s;
            });
        switch(e1.tag){
            case "required":
                return ((e1, t, n, o)=>xe(t, n).fold(()=>((e1, t, n)=>ZS(e1, ()=>'Could not find valid *required* value for "' + t + '" in ' + JS(n)))(e1, n, t), o))(t, n, o, s);
            case "defaultedThunk":
                return lk(n, o, e1.process, s);
            case "option":
                return ((e1, t, n)=>n(xe(e1, t)))(n, o, a);
            case "defaultedOptionThunk":
                return ((e1, t, n, o)=>o(xe(e1, t).map((t)=>!0 === t ? n(e1) : t)))(n, o, e1.process, a);
            case "mergeWithThunk":
                return lk(n, o, N({}), (t)=>{
                    const o = nk(e1.process(n), t);
                    return s(o);
                });
        }
    }, ck = (e1)=>({
            extract: (t, n)=>((e1, t, n)=>{
                    const o = {}, r = [];
                    for (const s of n)sk(s, (n, s, a, i)=>{
                        const l = dk(a, e1, t, n, i);
                        QS(l, (e1)=>{
                            r.push(...e1);
                        }, (e1)=>{
                            o[s] = e1;
                        });
                    }, (e1, n)=>{
                        o[e1] = n(t);
                    });
                    return r.length > 0 ? XS(r) : GS(o);
                })(t, n, e1),
            toString: ()=>{
                const t = q(e1, (e1)=>sk(e1, (e1, t, n, o)=>e1 + " -> " + o.toString(), (e1, t)=>"state(" + e1 + ")"));
                return "obj{\n" + t.join("\n") + "}";
            }
        }), uk = (e1)=>({
            extract: (t, n)=>{
                const o = q(n, (n, o)=>e1.extract(t.concat([
                        "[" + o + "]"
                    ]), n));
                return rk(o);
            },
            toString: ()=>"array(" + e1.toString() + ")"
        }), mk = (e1, t, n)=>{
        var o;
        return o = ((e1, t, n)=>((e1, t)=>e1.stype === KS.Error ? {
                    stype: KS.Error,
                    serror: t(e1.serror)
                } : e1)(t.extract([
                e1
            ], n), (e1)=>({
                    input: n,
                    errors: e1
                })))(e1, t, n), YS(o, pl.error, pl.value);
    }, fk = (e1, t)=>ek(e1, pe(t, ck)), gk = N(ik), pk = (e1, t)=>ak((n)=>{
            const o = typeof n;
            return e1(n) ? GS(n) : XS(`Expected type: ${t} but got: ${o}`);
        }), hk = pk(x, "number"), bk = pk(m, "string"), vk = pk(b, "boolean"), yk = pk(w, "function"), Ck = (e1, t, n, o)=>({
            tag: "field",
            key: e1,
            newKey: t,
            presence: n,
            prop: o
        }), wk = (e1, t)=>({
            tag: "custom",
            newKey: e1,
            instantiator: t
        }), xk = (e1, t)=>Ck(e1, e1, {
            tag: "required",
            process: {}
        }, t), Ek = (e1)=>xk(e1, bk), _k = (e1)=>xk(e1, yk), Sk = (e1, t)=>Ck(e1, e1, {
            tag: "option",
            process: {}
        }, t), kk = (e1)=>Sk(e1, bk), Nk = (e1, t, n)=>Ck(e1, e1, ok(t), n), Rk = (e1, t)=>Nk(e1, t, hk), Ak = (e1, t, n)=>Nk(e1, t, ((e1)=>{
            var t;
            return t = (t)=>H(e1, t) ? pl.value(t) : pl.error(`Unsupported value: "${t}", choose one of "${e1.join(", ")}".`), ak((e1)=>t(e1).fold(XS, GS));
        })(n)), Tk = (e1, t)=>Nk(e1, t, vk), Ok = (e1, t)=>Nk(e1, t, yk), Bk = Ek("type"), Pk = _k("fetch"), Dk = _k("onAction"), Lk = Ok("onSetup", ()=>_), Mk = kk("text"), Ik = kk("icon"), Fk = kk("tooltip"), Uk = kk("label"), zk = Tk("active", !1), jk = Tk("enabled", !0), Hk = Tk("primary", !1), $k = (e1)=>((e1, t)=>Nk("type", t, bk))(0, e1), qk = ck([
        Bk,
        Ek("trigger"),
        Rk("minChars", 1),
        ((e1, t)=>Ck(e1, e1, ok(1), gk()))("columns"),
        Rk("maxResults", 10),
        Sk("matches", yk),
        Pk,
        Dk,
        (Vk = bk, Nk("highlightOn", [], uk(Vk)))
    ]);
    var Vk;
    const Wk = [
        jk,
        Fk,
        Ik,
        Mk,
        Lk
    ], Kk = [
        zk
    ].concat(Wk), Yk = [
        Ok("predicate", L),
        Ak("scope", "node", [
            "node",
            "editor"
        ]),
        Ak("position", "selection", [
            "node",
            "selection",
            "line"
        ])
    ], Gk = Wk.concat([
        $k("contextformbutton"),
        Hk,
        Dk,
        wk("original", R)
    ]), Xk = Kk.concat([
        $k("contextformbutton"),
        Hk,
        Dk,
        wk("original", R)
    ]), Qk = Wk.concat([
        $k("contextformbutton")
    ]), Jk = Kk.concat([
        $k("contextformtogglebutton")
    ]), Zk = fk("type", {
        contextformbutton: Gk,
        contextformtogglebutton: Xk
    });
    ck([
        $k("contextform"),
        Ok("initValue", N("")),
        Uk,
        ((e1, t)=>Ck(e1, e1, {
                tag: "required",
                process: {}
            }, uk(t)))("commands", Zk),
        Sk("launch", fk("type", {
            contextformbutton: Qk,
            contextformtogglebutton: Jk
        }))
    ].concat(Yk));
    const eN = (e1)=>{
        const t = e1.ui.registry.getAll().popups, n = pe(t, (e1)=>{
            var t;
            return (t = e1, mk("Autocompleter", qk, {
                trigger: t.ch,
                ...t
            })).fold((e1)=>{
                var t;
                throw new Error("Errors: \n" + ((e1)=>{
                    const t = e1.length > 10 ? e1.slice(0, 10).concat([
                        {
                            path: [],
                            getErrorInfo: N("... (only showing first ten failures)")
                        }
                    ]) : e1;
                    return q(t, (e1)=>"Failed path: (" + e1.path.join(" > ") + ")\n" + e1.getErrorInfo());
                })((t = e1).errors).join("\n") + "\n\nInput object: " + JS(t.input));
            }, R);
        }), o = Se(Ce(n, (e1)=>e1.trigger)), r = we(n);
        return {
            dataset: n,
            triggers: o,
            lookupByTrigger: (e1)=>Y(r, (t)=>t.trigger === e1)
        };
    }, tN = (e1)=>{
        const t = Xa(), n = $a(!1), o = t.isSet, r = ()=>{
            o() && (((e1)=>{
                tw(e1).autocompleter.removeDecoration();
            })(e1), ((e1)=>{
                e1.dispatch("AutocompleterEnd");
            })(e1), n.set(!1), t.clear());
        }, s = De(()=>eN(e1)), a = (a)=>{
            ((n)=>t.get().map((t)=>$S(e1.dom, e1.selection.getRng(), t.trigger).bind((t)=>WS(e1, s, t, n))).getOrThunk(()=>((e1, t)=>{
                        const n = t(), o = e1.selection.getRng();
                        return ((e1, t, n)=>ue(n.triggers, (n)=>$S(e1, t, n)))(e1.dom, o, n).bind((n)=>WS(e1, t, n));
                    })(e1, s)))(a).fold(r, (s)=>{
                ((n)=>{
                    o() || (((e1, t)=>{
                        tw(e1).autocompleter.addDecoration(t);
                    })(e1, n.range), t.set({
                        trigger: n.trigger,
                        matchLength: n.text.length
                    }));
                })(s.context), s.lookupData.then((o)=>{
                    t.get().map((a)=>{
                        const i = s.context;
                        a.trigger === i.trigger && (i.text.length - a.matchLength >= 10 ? r() : (t.set({
                            ...a,
                            matchLength: i.text.length
                        }), n.get() ? ((e1, t)=>{
                            e1.dispatch("AutocompleterUpdate", t);
                        })(e1, {
                            lookupData: o
                        }) : (n.set(!0), ((e1, t)=>{
                            e1.dispatch("AutocompleterStart", t);
                        })(e1, {
                            lookupData: o
                        }))));
                    });
                });
            });
        };
        e1.addCommand("mceAutocompleterReload", (e1, t)=>{
            const n = f(t) ? t.fetchOptions : {};
            a(n);
        }), e1.addCommand("mceAutocompleterClose", r), ((e1, t)=>{
            const n = Ja(t.load, 50);
            e1.on("keypress compositionend", (e1)=>{
                27 !== e1.which && n.throttle();
            }), e1.on("keydown", (e1)=>{
                const o = e1.which;
                8 === o ? n.throttle() : 27 === o && t.cancelIfNecessary();
            }), e1.on("remove", n.cancel);
        })(e1, {
            cancelIfNecessary: r,
            load: a
        });
    }, nN = xt().browser.isSafari(), oN = (e1)=>Or(yn(e1)), rN = (e1, t)=>{
        var n;
        return 0 === e1.startOffset && e1.endOffset === (null === (n = t.textContent) || void 0 === n ? void 0 : n.length);
    }, sN = (e1, t)=>I.from(e1.getParent(t.container(), "details")), aN = (e1, t)=>sN(e1, t).isSome(), iN = (e1, t)=>{
        const n = t.getNode();
        v(n) || e1.selection.setCursorLocation(n, t.offset());
    }, lN = (e1, t, n)=>{
        const o = e1.dom.getParent(t.container(), "details");
        if (o && !o.open) {
            const t = e1.dom.select("summary", o)[0];
            t && (n ? Ou(t) : Bu(t)).each((t)=>iN(e1, t));
        } else iN(e1, t);
    }, dN = (e1, t, n)=>{
        const { dom: o, selection: r } = e1, s = e1.getBody();
        if ("character" === n) {
            const n = Vi.fromRangeStart(r.getRng()), a = o.getParent(n.container(), o.isBlock), i = sN(o, n), l = a && o.isEmpty(a), d = h(null == a ? void 0 : a.previousSibling), c = h(null == a ? void 0 : a.nextSibling);
            return !!(l && (t ? c : d) && ku(!t, s, n).exists((e1)=>aN(o, e1) && !Lt(i, sN(o, e1)))) || ku(t, s, n).fold(L, (n)=>{
                const r = sN(o, n);
                if (aN(o, n) && !Lt(i, r)) {
                    if (t || lN(e1, n, !1), a && l) {
                        if (t && d) return !0;
                        if (!t && c) return !0;
                        lN(e1, n, t), e1.dom.remove(a);
                    }
                    return !0;
                }
                return !1;
            });
        }
        return !1;
    }, cN = (e1, t, n, o)=>{
        const r = e1.selection.getRng(), s = Vi.fromRangeStart(r), a = e1.getBody();
        return "selection" === o ? ((e1, t)=>{
            const n = t.startSummary.exists((t)=>t.contains(e1.startContainer)), o = t.startSummary.exists((t)=>t.contains(e1.endContainer)), r = t.startDetails.forall((e1)=>t.endDetails.forall((t)=>e1 !== t));
            return (n || o) && !(n && o) || r;
        })(r, t) : n ? ((e1, t)=>t.startSummary.exists((t)=>((e1, t)=>Bu(t).exists((n)=>ar(n.getNode()) && Tu(t, n).exists((t)=>t.isEqual(e1)) || n.isEqual(e1)))(e1, t)))(s, t) || ((e1, t, n)=>n.startDetails.exists((n)=>Au(e1, t).forall((e1)=>!n.contains(e1.container()))))(a, s, t) : ((e1, t)=>t.startSummary.exists((t)=>((e1, t)=>Ou(t).exists((t)=>t.isEqual(e1)))(e1, t)))(s, t) || ((e1, t)=>t.startDetails.exists((n)=>Tu(n, e1).forall((n)=>t.startSummary.exists((t)=>!t.contains(e1.container()) && t.contains(n.container())))))(s, t);
    }, uN = (e1, t, n)=>((e1, t, n)=>((e1, t)=>{
                const n = I.from(e1.getParent(t.startContainer, "details")), o = I.from(e1.getParent(t.endContainer, "details"));
                if (n.isSome() || o.isSome()) {
                    const t = n.bind((t)=>I.from(e1.select("summary", t)[0]));
                    return I.some({
                        startSummary: t,
                        startDetails: n,
                        endDetails: o
                    });
                }
                return I.none();
            })(e1.dom, e1.selection.getRng()).fold(()=>dN(e1, t, n), (o)=>cN(e1, o, t, n) || dN(e1, t, n)))(e1, t, n) || nN && ((e1, t, n)=>{
            const o = e1.selection, r = o.getNode(), s = o.getRng(), a = Vi.fromRangeStart(s);
            return !!pr(r) && ("selection" === n && rN(s, r) || Oh(t, a, r) ? oN(r) : e1.undoManager.transact(()=>{
                const s = o.getSel();
                let { anchorNode: a, anchorOffset: i, focusNode: l, focusOffset: d } = null != s ? s : {};
                const c = ()=>{
                    C(a) && C(i) && C(l) && C(d) && (null == s || s.setBaseAndExtent(a, i, l, d));
                }, u = (e1, t)=>{
                    V(e1.childNodes, (e1)=>{
                        dm(e1) && t.appendChild(e1);
                    });
                }, m = e1.dom.create("span", {
                    "data-mce-bogus": "1"
                });
                u(r, m), r.appendChild(m), c(), "word" !== n && "line" !== n || null == s || s.modify("extend", t ? "right" : "left", n), !o.isCollapsed() && rN(o.getRng(), m) ? oN(r) : (e1.execCommand(t ? "ForwardDelete" : "Delete"), a = null == s ? void 0 : s.anchorNode, i = null == s ? void 0 : s.anchorOffset, l = null == s ? void 0 : s.focusNode, d = null == s ? void 0 : s.focusOffset, u(m, r), c()), e1.dom.remove(m);
            }), !0);
        })(e1, t, n) ? I.some(_) : I.none(), mN = (e1)=>(t, n, o = {})=>{
            const r = t.getBody(), s = {
                bubbles: !0,
                composed: !0,
                data: null,
                isComposing: !1,
                detail: 0,
                view: null,
                target: r,
                currentTarget: r,
                eventPhase: Event.AT_TARGET,
                originalTarget: r,
                explicitOriginalTarget: r,
                isTrusted: !1,
                srcElement: r,
                cancelable: !1,
                preventDefault: _,
                inputType: n
            }, a = Ea(new InputEvent(e1));
            return t.dispatch(e1, {
                ...a,
                ...s,
                ...o
            });
        }, fN = mN("input"), gN = mN("beforeinput"), pN = xt(), hN = pN.os, bN = hN.isMacOS() || hN.isiOS(), vN = pN.browser.isFirefox(), yN = (e1, t)=>{
        const n = e1.dom, o = e1.schema.getMoveCaretBeforeOnEnterElements();
        if (!t) return;
        if (/^(LI|DT|DD)$/.test(t.nodeName)) {
            const e1 = ((e1)=>{
                for(; e1;){
                    if (qo(e1) || er(e1) && e1.data && /[\r\n\s]/.test(e1.data)) return e1;
                    e1 = e1.nextSibling;
                }
                return null;
            })(t.firstChild);
            e1 && /^(UL|OL|DL)$/.test(e1.nodeName) && t.insertBefore(n.doc.createTextNode(br), t.firstChild);
        }
        const r = n.createRng();
        if (t.normalize(), t.hasChildNodes()) {
            const e1 = new jo(t, t);
            let n, s = t;
            for(; n = e1.current();){
                if (er(n)) {
                    r.setStart(n, 0), r.setEnd(n, 0);
                    break;
                }
                if (o[n.nodeName.toLowerCase()]) {
                    r.setStartBefore(n), r.setEndBefore(n);
                    break;
                }
                s = n, n = e1.next();
            }
            n || (r.setStart(s, 0), r.setEnd(s, 0));
        } else ar(t) ? t.nextSibling && n.isBlock(t.nextSibling) ? (r.setStartBefore(t), r.setEndBefore(t)) : (r.setStartAfter(t), r.setEndAfter(t)) : (r.setStart(t, 0), r.setEnd(t, 0));
        e1.selection.setRng(r), sg(e1, r);
    }, CN = (e1, t)=>{
        const n = e1.getRoot();
        let o, r = t;
        for(; r !== n && r && "false" !== e1.getContentEditable(r);){
            if ("true" === e1.getContentEditable(r)) {
                o = r;
                break;
            }
            r = r.parentNode;
        }
        return r !== n ? o : n;
    }, wN = (e1)=>I.from(e1.dom.getParent(e1.selection.getStart(!0), e1.dom.isBlock)), xN = (e1)=>{
        e1.innerHTML = '<br data-mce-bogus="1">';
    }, EN = (e1, t)=>{
        Il(e1).toLowerCase() === t.tagName.toLowerCase() && ((e1, t, n)=>{
            const o = e1.dom;
            I.from(n.style).map(o.parseStyle).each((e1)=>{
                const n = {
                    ...fo(yn(t)),
                    ...e1
                };
                o.setStyles(t, n);
            });
            const r = I.from(n.class).map((e1)=>e1.split(/\s+/)), s = I.from(t.className).map((e1)=>Y(e1.split(/\s+/), (e1)=>"" !== e1));
            Mt(r, s, (e1, n)=>{
                const r = Y(n, (t)=>!H(e1, t)), s = [
                    ...e1,
                    ...r
                ];
                o.setAttrib(t, "class", s.join(" "));
            });
            const a = [
                "style",
                "class"
            ], i = ye(n, (e1, t)=>!H(a, t));
            o.setAttribs(t, i);
        })(e1, t, Fl(e1));
    }, _N = (e1, t, n, o, r = !0, s, a)=>{
        const i = e1.dom, l = e1.schema, d = Il(e1), c = n ? n.nodeName.toUpperCase() : "";
        let u = t;
        const m = l.getTextInlineElements();
        let f;
        f = s || "TABLE" === c || "HR" === c ? i.create(s || d, a || {}) : n.cloneNode(!1);
        let g = f;
        if (r) {
            do if (m[u.nodeName]) {
                if (Du(u) || Ku(u)) continue;
                const e1 = u.cloneNode(!1);
                i.setAttrib(e1, "id", ""), f.hasChildNodes() ? (e1.appendChild(f.firstChild), f.appendChild(e1)) : (g = e1, f.appendChild(e1));
            }
            while ((u = u.parentNode) && u !== o);
        } else i.setAttrib(f, "style", null), i.setAttrib(f, "class", null);
        return EN(e1, f), xN(g), f;
    }, SN = (e1, t)=>{
        const n = null == e1 ? void 0 : e1.parentNode;
        return C(n) && n.nodeName === t;
    }, kN = (e1)=>C(e1) && /^(OL|UL|LI)$/.test(e1.nodeName), NN = (e1)=>C(e1) && /^(LI|DT|DD)$/.test(e1.nodeName), RN = (e1)=>{
        const t = e1.parentNode;
        return NN(t) ? t : e1;
    }, AN = (e1, t, n)=>{
        let o = e1[n ? "firstChild" : "lastChild"];
        for(; o && !qo(o);)o = o[n ? "nextSibling" : "previousSibling"];
        return o === t;
    }, TN = (e1)=>X(Ce(fo(yn(e1)), (e1, t)=>`${t}: ${e1};`), (e1, t)=>e1 + t, ""), ON = (e1, t)=>t && "A" === t.nodeName && e1.isEmpty(t), BN = (e1, t)=>e1.nodeName === t || e1.previousSibling && e1.previousSibling.nodeName === t, PN = (e1, t)=>C(t) && e1.isBlock(t) && !/^(TD|TH|CAPTION|FORM)$/.test(t.nodeName) && !/^(fixed|absolute)/i.test(t.style.position) && e1.isEditable(t.parentNode) && "false" !== e1.getContentEditable(t), DN = (e1, t, n)=>er(t) ? e1 ? 1 === n && t.data.charAt(n - 1) === Br ? 0 : n : n === t.data.length - 1 && t.data.charAt(n) === Br ? t.data.length : n : n, LN = {
        insert: (e1, t)=>{
            let n, o, r, s, a = !1;
            const i = e1.dom, l = e1.schema.getNonEmptyElements(), d = e1.selection.getRng(), c = Il(e1), u = yn(d.startContainer), f = In(u, d.startOffset), g = f.exists((e1)=>Vt(e1) && !oo(e1)), p = d.collapsed && g, b = (t, o)=>_N(e1, n, S, _, Hl(e1), t, o), v = (e1)=>{
                const t = DN(e1, n, o);
                if (er(n) && (e1 ? t > 0 : t < n.data.length)) return !1;
                if (n.parentNode === S && a && !e1) return !0;
                if (e1 && qo(n) && n === S.firstChild) return !0;
                if (BN(n, "TABLE") || BN(n, "HR")) return a && !e1 || !a && e1;
                const r = new jo(n, S);
                let s;
                for(er(n) && (e1 && 0 === t ? r.prev() : e1 || t !== n.data.length || r.next()); s = r.current();){
                    if (qo(s)) {
                        if (!s.getAttribute("data-mce-bogus")) {
                            const e1 = s.nodeName.toLowerCase();
                            if (l[e1] && "br" !== e1) return !1;
                        }
                    } else if (er(s) && !ss(s.data)) return !1;
                    e1 ? r.prev() : r.next();
                }
                return !0;
            }, w = ()=>{
                let t;
                return t = /^(H[1-6]|PRE|FIGURE)$/.test(r) && "HGROUP" !== k ? b(c) : b(), ((e1, t)=>{
                    const n = $l(e1);
                    return !y(t) && (m(n) ? H(Pt.explode(n), t.nodeName.toLowerCase()) : n);
                })(e1, s) && PN(i, s) && i.isEmpty(S, void 0, {
                    includeZwsp: !0
                }) ? t = i.split(s, S) : i.insertAfter(t, S), yN(e1, t), t;
            };
            Mf(i, d).each((e1)=>{
                d.setStart(e1.startContainer, e1.startOffset), d.setEnd(e1.endContainer, e1.endOffset);
            }), n = d.startContainer, o = d.startOffset;
            const x = !(!t || !t.shiftKey), E = !(!t || !t.ctrlKey);
            qo(n) && n.hasChildNodes() && !p && (a = o > n.childNodes.length - 1, n = n.childNodes[Math.min(o, n.childNodes.length - 1)] || n, o = a && er(n) ? n.data.length : 0);
            const _ = CN(i, n);
            if (!_ || ((e1, t)=>{
                const n = e1.dom.getParent(t, "ol,ul,dl");
                return null !== n && "false" === e1.dom.getContentEditableParent(n);
            })(e1, n)) return;
            x || (n = ((e1, t, n, o, r)=>{
                var s, a;
                const i = e1.dom, l = null !== (s = CN(i, o)) && void 0 !== s ? s : i.getRoot();
                let d = i.getParent(o, i.isBlock);
                if (!d || !PN(i, d)) {
                    if (d = d || l, !d.hasChildNodes()) {
                        const o = i.create(t);
                        return EN(e1, o), d.appendChild(o), n.setStart(o, 0), n.setEnd(o, 0), o;
                    }
                    let s, c = o;
                    for(; c && c.parentNode !== d;)c = c.parentNode;
                    for(; c && !i.isBlock(c);)s = c, c = c.previousSibling;
                    const u = null === (a = null == s ? void 0 : s.parentElement) || void 0 === a ? void 0 : a.nodeName;
                    if (s && u && e1.schema.isValidChild(u, t.toLowerCase())) {
                        const a = s.parentNode, l = i.create(t);
                        for(EN(e1, l), a.insertBefore(l, s), c = s; c && !i.isBlock(c);){
                            const e1 = c.nextSibling;
                            l.appendChild(c), c = e1;
                        }
                        n.setStart(o, r), n.setEnd(o, r);
                    }
                }
                return o;
            })(e1, c, d, n, o));
            let S = i.getParent(n, i.isBlock) || i.getRoot();
            s = C(null == S ? void 0 : S.parentNode) ? i.getParent(S.parentNode, i.isBlock) : null, r = S ? S.nodeName.toUpperCase() : "";
            const k = s ? s.nodeName.toUpperCase() : "";
            if ("LI" !== k || E || (S = s, s = s.parentNode, r = k), qo(s) && ((e1, t, n)=>!t && n.nodeName.toLowerCase() === Il(e1) && e1.dom.isEmpty(n) && ((t, n, o)=>{
                    let r = n;
                    for(; r && r !== t && h(r.nextSibling);){
                        const t = r.parentElement;
                        if (!t || (s = t, !Ee(e1.schema.getTextBlockElements(), s.nodeName.toLowerCase()))) return gr(t);
                        r = t;
                    }
                    var s;
                    return !1;
                })(e1.getBody(), n))(e1, x, S)) return ((e1, t, n)=>{
                var o, r, s;
                const a = t(Il(e1)), i = ((e1, t)=>e1.dom.getParent(t, gr))(e1, n);
                i && (e1.dom.insertAfter(a, i), yN(e1, a), (null !== (s = null === (r = null === (o = n.parentElement) || void 0 === o ? void 0 : o.childNodes) || void 0 === r ? void 0 : r.length) && void 0 !== s ? s : 0) > 1 && e1.dom.remove(n));
            })(e1, b, S);
            if (/^(LI|DT|DD)$/.test(r) && qo(s) && i.isEmpty(S)) return void ((e1, t, n, o, r)=>{
                const s = e1.dom, a = e1.selection.getRng(), i = n.parentNode;
                if (n === e1.getBody() || !i) return;
                var l;
                kN(l = n) && kN(l.parentNode) && (r = "LI");
                const d = NN(o) ? TN(o) : void 0;
                let c = NN(o) && d ? t(r, {
                    style: TN(o)
                }) : t(r);
                if (AN(n, o, !0) && AN(n, o, !1)) {
                    if (SN(n, "LI")) {
                        const e1 = RN(n);
                        s.insertAfter(c, e1), ((e1)=>{
                            var t;
                            return (null === (t = e1.parentNode) || void 0 === t ? void 0 : t.firstChild) === e1;
                        })(n) ? s.remove(e1) : s.remove(n);
                    } else s.replace(c, n);
                } else if (AN(n, o, !0)) SN(n, "LI") ? (s.insertAfter(c, RN(n)), c.appendChild(s.doc.createTextNode(" ")), c.appendChild(n)) : i.insertBefore(c, n), s.remove(o);
                else if (AN(n, o, !1)) s.insertAfter(c, RN(n)), s.remove(o);
                else {
                    n = RN(n);
                    const e1 = a.cloneRange();
                    e1.setStartAfter(o), e1.setEndAfter(n);
                    const t = e1.extractContents();
                    if ("LI" === r && ((e1, t)=>e1.firstChild && "LI" === e1.firstChild.nodeName)(t)) {
                        const e1 = Y(q(c.children, yn), O(Xt("br")));
                        c = t.firstChild, s.insertAfter(t, n), V(e1, (e1)=>bo(yn(c), e1)), d && c.setAttribute("style", d);
                    } else s.insertAfter(t, n), s.insertAfter(c, n);
                    s.remove(o);
                }
                yN(e1, c);
            })(e1, b, s, S, c);
            if (!(p || S !== e1.getBody() && PN(i, S))) return;
            const N = S.parentNode;
            let R;
            if (p) R = b(c), f.fold(()=>{
                vo(u, yn(R));
            }, (e1)=>{
                po(e1, yn(R));
            }), e1.selection.setCursorLocation(R, 0);
            else if (Ir(S)) R = Vr(S), i.isEmpty(S) && xN(S), EN(e1, R), yN(e1, R);
            else if (v(!1)) R = w();
            else if (v(!0) && N) {
                R = N.insertBefore(b(), S);
                const t = yn(d.startContainer).dom.hasChildNodes() && d.collapsed;
                yN(e1, BN(S, "HR") || t ? R : S);
            } else {
                const t = ((e1)=>{
                    const t = e1.cloneRange();
                    return t.setStart(e1.startContainer, DN(!0, e1.startContainer, e1.startOffset)), t.setEnd(e1.endContainer, DN(!1, e1.endContainer, e1.endOffset)), t;
                })(d).cloneRange();
                t.setEndAfter(S);
                const n = t.extractContents();
                ((e1)=>{
                    V(Fo(yn(e1), Kt), (e1)=>{
                        const t = e1.dom;
                        t.nodeValue = Dr(t.data);
                    });
                })(n), ((e1)=>{
                    let t = e1;
                    do er(t) && (t.data = t.data.replace(/^[\r\n]+/, "")), t = t.firstChild;
                    while (t);
                })(n), R = n.firstChild, i.insertAfter(n, S), ((e1, t, n)=>{
                    var o;
                    const r = [];
                    if (!n) return;
                    let s = n;
                    for(; s = s.firstChild;){
                        if (e1.isBlock(s)) return;
                        qo(s) && !t[s.nodeName.toLowerCase()] && r.push(s);
                    }
                    let a = r.length;
                    for(; a--;)s = r[a], (!s.hasChildNodes() || s.firstChild === s.lastChild && "" === (null === (o = s.firstChild) || void 0 === o ? void 0 : o.nodeValue) || ON(e1, s)) && e1.remove(s);
                })(i, l, R), ((e1, t)=>{
                    t.normalize();
                    const n = t.lastChild;
                    (!n || qo(n) && /^(left|right)$/gi.test(e1.getStyle(n, "float", !0))) && e1.add(t, "br");
                })(i, S), i.isEmpty(S) && xN(S), R.normalize(), i.isEmpty(R) ? (i.remove(R), w()) : (EN(e1, R), yN(e1, R));
            }
            i.setAttrib(R, "id", ""), e1.dispatch("NewBlock", {
                newBlock: R
            });
        },
        fakeEventName: "insertParagraph"
    }, MN = (e1, t, n)=>{
        const o = e1.dom.createRng();
        n ? (o.setStartBefore(t), o.setEndBefore(t)) : (o.setStartAfter(t), o.setEndAfter(t)), e1.selection.setRng(o), sg(e1, o);
    }, IN = (e1, t)=>{
        const n = bn("br");
        po(yn(t), n), e1.undoManager.add();
    }, FN = (e1, t)=>{
        UN(e1.getBody(), t) || ho(yn(t), bn("br"));
        const n = bn("br");
        ho(yn(t), n), MN(e1, n.dom, !1), e1.undoManager.add();
    }, UN = (e1, t)=>{
        var n;
        return n = Vi.after(t), !!ar(n.getNode()) || Au(e1, Vi.after(t)).map((e1)=>ar(e1.getNode())).getOr(!1);
    }, zN = (e1)=>e1 && "A" === e1.nodeName && "href" in e1, jN = (e1)=>e1.fold(L, zN, zN, L), HN = (e1, t)=>{
        t.fold(_, T(IN, e1), T(FN, e1), _);
    }, $N = {
        insert: (e1, t)=>{
            const n = ((e1)=>{
                const t = T(Ch, e1), n = Vi.fromRangeStart(e1.selection.getRng());
                return cE(t, e1.getBody(), n).filter(jN);
            })(e1);
            n.isSome() ? n.each(T(HN, e1)) : ((e1, t)=>{
                const n = e1.selection, o = e1.dom, r = n.getRng();
                let s, a = !1;
                Mf(o, r).each((e1)=>{
                    r.setStart(e1.startContainer, e1.startOffset), r.setEnd(e1.endContainer, e1.endOffset);
                });
                let i = r.startOffset, l = r.startContainer;
                if (qo(l) && l.hasChildNodes()) {
                    const e1 = i > l.childNodes.length - 1;
                    l = l.childNodes[Math.min(i, l.childNodes.length - 1)] || l, i = e1 && er(l) ? l.data.length : 0;
                }
                let d = o.getParent(l, o.isBlock);
                const c = d && d.parentNode ? o.getParent(d.parentNode, o.isBlock) : null, u = c ? c.nodeName.toUpperCase() : "", m = !(!t || !t.ctrlKey);
                "LI" !== u || m || (d = c), er(l) && i >= l.data.length && (((e1, t, n)=>{
                    const o = new jo(t, n);
                    let r;
                    const s = e1.getNonEmptyElements();
                    for(; r = o.next();)if (s[r.nodeName.toLowerCase()] || er(r) && r.length > 0) return !0;
                    return !1;
                })(e1.schema, l, d || o.getRoot()) || (s = o.create("br"), r.insertNode(s), r.setStartAfter(s), r.setEndAfter(s), a = !0)), s = o.create("br"), Ki(o, r, s), MN(e1, s, a), e1.undoManager.add();
            })(e1, t);
        },
        fakeEventName: "insertLineBreak"
    }, qN = (e1, t)=>wN(e1).filter((e1)=>t.length > 0 && xn(yn(e1), t)).isSome(), VN = hl([
        {
            br: []
        },
        {
            block: []
        },
        {
            none: []
        }
    ]), WN = (e1, t)=>((e1)=>qN(e1, jl(e1)))(e1), KN = (e1)=>(t, n)=>((e1)=>wN(e1).filter((e1)=>kr(yn(e1))).isSome())(t) === e1, YN = (e1, t)=>(n, o)=>{
            const r = ((e1)=>wN(e1).fold(N(""), (e1)=>e1.nodeName.toUpperCase()))(n) === e1.toUpperCase();
            return r === t;
        }, GN = (e1)=>{
        const t = CN(e1.dom, e1.selection.getStart());
        return y(t);
    }, XN = (e1)=>YN("pre", e1), QN = (e1)=>(t, n)=>Ml(t) === e1, JN = (e1, t)=>((e1)=>qN(e1, zl(e1)))(e1), ZN = (e1, t)=>t, eR = (e1)=>{
        const t = Il(e1), n = CN(e1.dom, e1.selection.getStart());
        return C(n) && e1.schema.isValidChild(n.nodeName, t);
    }, tR = (e1)=>{
        const t = e1.selection.getRng(), n = yn(t.startContainer), o = In(n, t.startOffset).map((e1)=>Vt(e1) && !oo(e1));
        return t.collapsed && o.getOr(!0);
    }, nR = (e1, t)=>(n, o)=>X(e1, (e1, t)=>e1 && t(n, o), !0) ? I.some(t) : I.none(), oR = (e1, t, n)=>{
        t.selection.isCollapsed() || ((e1)=>{
            e1.execCommand("delete");
        })(t), C(n) && gN(t, e1.fakeEventName).isDefaultPrevented() || (e1.insert(t, n), C(n) && fN(t, e1.fakeEventName));
    }, rR = (e1, t)=>{
        const n = ()=>oR($N, e1, t), o = ()=>oR(LN, e1, t), r = ((e1, t)=>eE([
                nR([
                    WN
                ], VN.none()),
                nR([
                    XN(!0),
                    GN
                ], VN.none()),
                nR([
                    YN("summary", !0)
                ], VN.br()),
                nR([
                    XN(!0),
                    QN(!1),
                    ZN
                ], VN.br()),
                nR([
                    XN(!0),
                    QN(!1)
                ], VN.block()),
                nR([
                    XN(!0),
                    QN(!0),
                    ZN
                ], VN.block()),
                nR([
                    XN(!0),
                    QN(!0)
                ], VN.br()),
                nR([
                    KN(!0),
                    ZN
                ], VN.br()),
                nR([
                    KN(!0)
                ], VN.block()),
                nR([
                    JN
                ], VN.br()),
                nR([
                    ZN
                ], VN.br()),
                nR([
                    eR
                ], VN.block()),
                nR([
                    tR
                ], VN.block())
            ], [
                e1,
                !(!t || !t.shiftKey)
            ]).getOr(VN.none()))(e1, t);
        switch(Ul(e1)){
            case "linebreak":
                r.fold(n, n, _);
                break;
            case "block":
                r.fold(o, o, _);
                break;
            case "invert":
                r.fold(o, n, _);
                break;
            default:
                r.fold(n, o, _);
        }
    }, sR = xt(), aR = sR.os.isiOS() && sR.browser.isSafari(), iR = (e1, t)=>{
        var n;
        t.isDefaultPrevented() || (t.preventDefault(), (n = e1.undoManager).typing && (n.typing = !1, n.add()), e1.undoManager.transact(()=>{
            rR(e1, t);
        }));
    }, lR = xt(), dR = (e1)=>e1.stopImmediatePropagation(), cR = (e1)=>e1.keyCode === af.PAGE_UP || e1.keyCode === af.PAGE_DOWN, uR = (e1, t, n)=>{
        n && !e1.get() ? t.on("NodeChange", dR, !0) : !n && e1.get() && t.off("NodeChange", dR), e1.set(n);
    }, mR = (e1, t)=>{
        const n = t.container(), o = t.offset();
        return er(n) ? (n.insertData(o, e1), I.some(Vi(n, o + e1.length))) : iu(t).map((n)=>{
            const o = vn(e1);
            return t.isAtEnd() ? ho(n, o) : po(n, o), Vi(o.dom, e1.length);
        });
    }, fR = T(mR, br), gR = T(mR, " "), pR = (e1)=>(t)=>{
            e1.selection.setRng(t.toRange()), e1.nodeChanged();
        }, hR = (e1)=>{
        const t = Vi.fromRangeStart(e1.selection.getRng()), n = yn(e1.getBody());
        if (e1.selection.isCollapsed()) {
            const o = T(Ch, e1), r = Vi.fromRangeStart(e1.selection.getRng());
            return cE(o, e1.getBody(), r).bind(((e1)=>(t)=>t.fold((t)=>Tu(e1.dom, Vi.before(t)), (e1)=>Ou(e1), (e1)=>Bu(e1), (t)=>Au(e1.dom, Vi.after(t))))(n)).map((o)=>()=>((e1, t, n)=>(o)=>Zp(e1, o, n) ? fR(t) : gR(t))(n, t, e1.schema)(o).each(pR(e1)));
        }
        return I.none();
    }, bR = (e1)=>{
        var t, n;
        return It(At.browser.isFirefox() && e1.selection.isEditable() && (t = e1.dom, n = e1.selection.getRng().startContainer, t.isEditable(t.getParent(n, "summary"))), ()=>{
            const t = yn(e1.getBody());
            e1.selection.isCollapsed() || e1.getDoc().execCommand("Delete"), ((e1, t, n)=>Zp(e1, t, n) ? fR(t) : gR(t))(t, Vi.fromRangeStart(e1.selection.getRng()), e1.schema).each(pR(e1));
        });
    }, vR = (e1)=>hc(e1) ? [
            {
                keyCode: af.TAB,
                action: sS(BS, e1, !0)
            },
            {
                keyCode: af.TAB,
                shiftKey: !0,
                action: sS(BS, e1, !1)
            }
        ] : [], yR = (e1)=>{
        if (e1.addShortcut("Meta+P", "", "mcePrint"), tN(e1), ZC(e1)) return $a(null);
        {
            const t = a_(e1);
            return ((e1)=>{
                e1.on("beforeinput", (t)=>{
                    e1.selection.isEditable() && !$(t.getTargetRanges(), (t)=>!Og(e1.dom, t)) || t.preventDefault();
                });
            })(e1), ((e1)=>{
                e1.on("keyup compositionstart", T(K_, e1));
            })(e1), ((e1, t)=>{
                e1.on("keydown", (n)=>{
                    n.isDefaultPrevented() || ((e1, t, n)=>{
                        const o = At.os.isMacOS() || At.os.isiOS();
                        aS([
                            {
                                keyCode: af.RIGHT,
                                action: sS(X_, e1, !0)
                            },
                            {
                                keyCode: af.LEFT,
                                action: sS(X_, e1, !1)
                            },
                            {
                                keyCode: af.UP,
                                action: sS(Q_, e1, !1)
                            },
                            {
                                keyCode: af.DOWN,
                                action: sS(Q_, e1, !0)
                            },
                            ...o ? [
                                {
                                    keyCode: af.UP,
                                    action: sS(Z_, e1, !1),
                                    metaKey: !0,
                                    shiftKey: !0
                                },
                                {
                                    keyCode: af.DOWN,
                                    action: sS(Z_, e1, !0),
                                    metaKey: !0,
                                    shiftKey: !0
                                }
                            ] : [],
                            {
                                keyCode: af.RIGHT,
                                action: sS(NS, e1, !0)
                            },
                            {
                                keyCode: af.LEFT,
                                action: sS(NS, e1, !1)
                            },
                            {
                                keyCode: af.UP,
                                action: sS(RS, e1, !1)
                            },
                            {
                                keyCode: af.DOWN,
                                action: sS(RS, e1, !0)
                            },
                            {
                                keyCode: af.UP,
                                action: sS(RS, e1, !1)
                            },
                            {
                                keyCode: af.UP,
                                action: sS(nS, e1, !1)
                            },
                            {
                                keyCode: af.DOWN,
                                action: sS(nS, e1, !0)
                            },
                            {
                                keyCode: af.RIGHT,
                                action: sS(lS, e1, !0)
                            },
                            {
                                keyCode: af.LEFT,
                                action: sS(lS, e1, !1)
                            },
                            {
                                keyCode: af.UP,
                                action: sS(dS, e1, !1)
                            },
                            {
                                keyCode: af.DOWN,
                                action: sS(dS, e1, !0)
                            },
                            {
                                keyCode: af.RIGHT,
                                action: sS(r_, e1, t, !0)
                            },
                            {
                                keyCode: af.LEFT,
                                action: sS(r_, e1, t, !1)
                            },
                            {
                                keyCode: af.RIGHT,
                                ctrlKey: !o,
                                altKey: o,
                                action: sS(i_, e1, t)
                            },
                            {
                                keyCode: af.LEFT,
                                ctrlKey: !o,
                                altKey: o,
                                action: sS(l_, e1, t)
                            },
                            {
                                keyCode: af.UP,
                                action: sS(tS, e1, !1)
                            },
                            {
                                keyCode: af.DOWN,
                                action: sS(tS, e1, !0)
                            }
                        ], n).each((e1)=>{
                            n.preventDefault();
                        });
                    })(e1, t, n);
                });
            })(e1, t), ((e1, t)=>{
                let n = !1;
                e1.on("keydown", (o)=>{
                    n = o.keyCode === af.BACKSPACE, o.isDefaultPrevented() || ((e1, t, n)=>{
                        const o = n.keyCode === af.BACKSPACE ? "deleteContentBackward" : "deleteContentForward", r = e1.selection.isCollapsed(), s = r ? "character" : "selection", a = (e1)=>r ? e1 ? "word" : "line" : "selection";
                        iS([
                            {
                                keyCode: af.BACKSPACE,
                                action: sS(P_, e1)
                            },
                            {
                                keyCode: af.BACKSPACE,
                                action: sS(Hx, e1, !1)
                            },
                            {
                                keyCode: af.DELETE,
                                action: sS(Hx, e1, !0)
                            },
                            {
                                keyCode: af.BACKSPACE,
                                action: sS(Dx, e1, !1)
                            },
                            {
                                keyCode: af.DELETE,
                                action: sS(Dx, e1, !0)
                            },
                            {
                                keyCode: af.BACKSPACE,
                                action: sS(m_, e1, t, !1)
                            },
                            {
                                keyCode: af.DELETE,
                                action: sS(m_, e1, t, !0)
                            },
                            {
                                keyCode: af.BACKSPACE,
                                action: sS(ib, e1, !1)
                            },
                            {
                                keyCode: af.DELETE,
                                action: sS(ib, e1, !0)
                            },
                            {
                                keyCode: af.BACKSPACE,
                                action: sS(uN, e1, !1, s)
                            },
                            {
                                keyCode: af.DELETE,
                                action: sS(uN, e1, !0, s)
                            },
                            ...bN ? [
                                {
                                    keyCode: af.BACKSPACE,
                                    altKey: !0,
                                    action: sS(uN, e1, !1, a(!0))
                                },
                                {
                                    keyCode: af.DELETE,
                                    altKey: !0,
                                    action: sS(uN, e1, !0, a(!0))
                                },
                                {
                                    keyCode: af.BACKSPACE,
                                    metaKey: !0,
                                    action: sS(uN, e1, !1, a(!1))
                                }
                            ] : [
                                {
                                    keyCode: af.BACKSPACE,
                                    ctrlKey: !0,
                                    action: sS(uN, e1, !1, a(!0))
                                },
                                {
                                    keyCode: af.DELETE,
                                    ctrlKey: !0,
                                    action: sS(uN, e1, !0, a(!0))
                                }
                            ],
                            {
                                keyCode: af.BACKSPACE,
                                action: sS($x, e1, !1)
                            },
                            {
                                keyCode: af.DELETE,
                                action: sS($x, e1, !0)
                            },
                            {
                                keyCode: af.BACKSPACE,
                                action: sS(S_, e1, !1)
                            },
                            {
                                keyCode: af.DELETE,
                                action: sS(S_, e1, !0)
                            },
                            {
                                keyCode: af.BACKSPACE,
                                action: sS(Nx, e1, !1)
                            },
                            {
                                keyCode: af.DELETE,
                                action: sS(Nx, e1, !0)
                            },
                            {
                                keyCode: af.BACKSPACE,
                                action: sS(_x, e1, !1)
                            },
                            {
                                keyCode: af.DELETE,
                                action: sS(_x, e1, !0)
                            },
                            {
                                keyCode: af.BACKSPACE,
                                action: sS(w_, e1, !1)
                            },
                            {
                                keyCode: af.DELETE,
                                action: sS(w_, e1, !0)
                            }
                        ], n).filter((t)=>e1.selection.isEditable()).each((t)=>{
                            n.preventDefault(), gN(e1, o).isDefaultPrevented() || (t(), fN(e1, o));
                        });
                    })(e1, t, o);
                }), e1.on("keyup", (t)=>{
                    t.isDefaultPrevented() || ((e1, t, n)=>{
                        aS([
                            {
                                keyCode: af.BACKSPACE,
                                action: sS(jx, e1)
                            },
                            {
                                keyCode: af.DELETE,
                                action: sS(jx, e1)
                            },
                            ...bN ? [
                                {
                                    keyCode: af.BACKSPACE,
                                    altKey: !0,
                                    action: sS(E_, e1)
                                },
                                {
                                    keyCode: af.DELETE,
                                    altKey: !0,
                                    action: sS(E_, e1)
                                },
                                ...n ? [
                                    {
                                        keyCode: vN ? 224 : 91,
                                        action: sS(E_, e1)
                                    }
                                ] : []
                            ] : [
                                {
                                    keyCode: af.BACKSPACE,
                                    ctrlKey: !0,
                                    action: sS(E_, e1)
                                },
                                {
                                    keyCode: af.DELETE,
                                    ctrlKey: !0,
                                    action: sS(E_, e1)
                                }
                            ]
                        ], t);
                    })(e1, t, n), n = !1;
                });
            })(e1, t), ((e1)=>{
                let t = I.none();
                e1.on("keydown", (n)=>{
                    n.keyCode === af.ENTER && (aR && ((e1)=>{
                        if (!e1.collapsed) return !1;
                        const t = e1.startContainer;
                        if (er(t)) {
                            const n = /^[\uAC00-\uD7AF\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uD7B0-\uD7FF]$/, o = t.data.charAt(e1.startOffset - 1);
                            return n.test(o);
                        }
                        return !1;
                    })(e1.selection.getRng()) ? ((e1)=>{
                        t = I.some(e1.selection.getBookmark()), e1.undoManager.add();
                    })(e1) : iR(e1, n));
                }), e1.on("keyup", (n)=>{
                    n.keyCode === af.ENTER && t.each(()=>((e1, n)=>{
                            e1.undoManager.undo(), t.fold(_, (t)=>e1.selection.moveToBookmark(t)), iR(e1, n), t = I.none();
                        })(e1, n));
                });
            })(e1), ((e1)=>{
                e1.on("keydown", (t)=>{
                    t.isDefaultPrevented() || ((e1, t)=>{
                        iS([
                            {
                                keyCode: af.SPACEBAR,
                                action: sS(hR, e1)
                            },
                            {
                                keyCode: af.SPACEBAR,
                                action: sS(bR, e1)
                            }
                        ], t).each((n)=>{
                            t.preventDefault(), gN(e1, "insertText", {
                                data: " "
                            }).isDefaultPrevented() || (n(), fN(e1, "insertText", {
                                data: " "
                            }));
                        });
                    })(e1, t);
                });
            })(e1), ((e1)=>{
                e1.on("input", (t)=>{
                    t.isComposing || ((e1)=>{
                        const t = yn(e1.getBody());
                        e1.selection.isCollapsed() && ih(t, Vi.fromRangeStart(e1.selection.getRng()), e1.schema).each((t)=>{
                            e1.selection.setRng(t.toRange());
                        });
                    })(e1);
                });
            })(e1), ((e1)=>{
                e1.on("keydown", (t)=>{
                    t.isDefaultPrevented() || ((e1, t)=>{
                        aS([
                            ...vR(e1)
                        ], t).each((e1)=>{
                            t.preventDefault();
                        });
                    })(e1, t);
                });
            })(e1), ((e1, t)=>{
                e1.on("keydown", (n)=>{
                    n.isDefaultPrevented() || ((e1, t, n)=>{
                        const o = At.os.isMacOS() || At.os.isiOS();
                        aS([
                            {
                                keyCode: af.END,
                                action: sS(J_, e1, !0)
                            },
                            {
                                keyCode: af.HOME,
                                action: sS(J_, e1, !1)
                            },
                            ...o ? [] : [
                                {
                                    keyCode: af.HOME,
                                    action: sS(Z_, e1, !1),
                                    ctrlKey: !0,
                                    shiftKey: !0
                                },
                                {
                                    keyCode: af.END,
                                    action: sS(Z_, e1, !0),
                                    ctrlKey: !0,
                                    shiftKey: !0
                                }
                            ],
                            {
                                keyCode: af.END,
                                action: sS(cS, e1, !0)
                            },
                            {
                                keyCode: af.HOME,
                                action: sS(cS, e1, !1)
                            },
                            {
                                keyCode: af.END,
                                action: sS(d_, e1, !0, t)
                            },
                            {
                                keyCode: af.HOME,
                                action: sS(d_, e1, !1, t)
                            }
                        ], n).each((e1)=>{
                            n.preventDefault();
                        });
                    })(e1, t, n);
                });
            })(e1, t), ((e1, t)=>{
                if (lR.os.isMacOS()) return;
                const n = $a(!1);
                e1.on("keydown", (t)=>{
                    cR(t) && uR(n, e1, !0);
                }), e1.on("keyup", (o)=>{
                    o.isDefaultPrevented() || ((e1, t, n)=>{
                        aS([
                            {
                                keyCode: af.PAGE_UP,
                                action: sS(d_, e1, !1, t)
                            },
                            {
                                keyCode: af.PAGE_DOWN,
                                action: sS(d_, e1, !0, t)
                            }
                        ], n);
                    })(e1, t, o), cR(o) && n.get() && (uR(n, e1, !1), e1.nodeChanged());
                });
            })(e1, t), t;
        }
    };
    class CR {
        constructor(e1){
            let t;
            this.lastPath = [], this.editor = e1;
            const n = this;
            "onselectionchange" in e1.getDoc() || e1.on("NodeChange click mouseup keyup focus", (n)=>{
                const o = e1.selection.getRng(), r = {
                    startContainer: o.startContainer,
                    startOffset: o.startOffset,
                    endContainer: o.endContainer,
                    endOffset: o.endOffset
                };
                "nodechange" !== n.type && Af(r, t) || e1.dispatch("SelectionChange"), t = r;
            }), e1.on("contextmenu", ()=>{
                e1.dispatch("SelectionChange");
            }), e1.on("SelectionChange", ()=>{
                const t = e1.selection.getStart(!0);
                t && am(e1) && !n.isSameElementPath(t) && e1.dom.isChildOf(t, e1.getBody()) && e1.nodeChanged({
                    selectionChange: !0
                });
            }), e1.on("mouseup", (t)=>{
                !t.isDefaultPrevented() && am(e1) && ("IMG" === e1.selection.getNode().nodeName ? vg.setEditorTimeout(e1, ()=>{
                    e1.nodeChanged();
                }) : e1.nodeChanged());
            });
        }
        nodeChanged(e1 = {}) {
            const t = this.editor.selection;
            let n;
            if (this.editor.initialized && t && !Od(this.editor) && !this.editor.mode.isReadOnly()) {
                const o = this.editor.getBody();
                n = t.getStart(!0) || o, n.ownerDocument === this.editor.getDoc() && this.editor.dom.isChildOf(n, o) || (n = o);
                const r = [];
                this.editor.dom.getParent(n, (e1)=>e1 === o || (r.push(e1), !1)), this.editor.dispatch("NodeChange", {
                    ...e1,
                    element: n,
                    parents: r
                });
            }
        }
        isSameElementPath(e1) {
            let t;
            const n = this.editor, o = oe(n.dom.getParents(e1, M, n.getBody()));
            if (o.length === this.lastPath.length) {
                for(t = o.length; t >= 0 && o[t] === this.lastPath[t]; t--);
                if (-1 === t) return this.lastPath = o, !0;
            }
            return this.lastPath = o, !1;
        }
    }
    const wR = ui("image"), xR = ui("event"), ER = (e1)=>(t)=>{
            t[xR] = e1;
        }, _R = ER(0), SR = ER(2), kR = ER(1), NR = (e1)=>{
        const t = e1;
        return I.from(t[xR]).exists((e1)=>0 === e1);
    };
    const RR = ui("mode"), AR = (e1)=>(t)=>{
            t[RR] = e1;
        }, TR = (e1, t)=>AR(t)(e1), OR = AR(0), BR = AR(2), PR = AR(1), DR = (e1)=>(t)=>{
            const n = t;
            return I.from(n[RR]).exists((t)=>t === e1);
        }, LR = DR(0), MR = DR(1), IR = [
        "none",
        "copy",
        "link",
        "move"
    ], FR = [
        "none",
        "copy",
        "copyLink",
        "copyMove",
        "link",
        "linkMove",
        "move",
        "all",
        "uninitialized"
    ], UR = ()=>{
        const e1 = new window.DataTransfer;
        let t = "move", n = "all";
        const o = {
            get dropEffect () {
                return t;
            },
            set dropEffect (e){
                H(IR, e) && (t = e);
            },
            get effectAllowed () {
                return n;
            },
            set effectAllowed (e){
                NR(o) && H(FR, e) && (n = e);
            },
            get items () {
                return ((e1, t)=>({
                        ...t,
                        get length () {
                            return t.length;
                        },
                        add: (n, o)=>{
                            if (LR(e1)) {
                                if (!m(n)) return t.add(n);
                                if (!v(o)) return t.add(n, o);
                            }
                            return null;
                        },
                        remove: (n)=>{
                            LR(e1) && t.remove(n);
                        },
                        clear: ()=>{
                            LR(e1) && t.clear();
                        }
                    }))(o, e1.items);
            },
            get files () {
                return MR(o) ? Object.freeze({
                    length: 0,
                    item: (e1)=>null
                }) : e1.files;
            },
            get types () {
                return e1.types;
            },
            setDragImage: (t, n, r)=>{
                var s;
                LR(o) && (s = {
                    image: t,
                    x: n,
                    y: r
                }, o[wR] = s, e1.setDragImage(t, n, r));
            },
            getData: (t)=>MR(o) ? "" : e1.getData(t),
            setData: (t, n)=>{
                LR(o) && e1.setData(t, n);
            },
            clearData: (t)=>{
                LR(o) && e1.clearData(t);
            }
        };
        return OR(o), o;
    }, zR = (e1, t)=>e1.setData("text/html", t), jR = "x-tinymce/html", HR = N(jR), $R = "\x3c!-- " + jR + " --\x3e", qR = (e1)=>$R + e1, VR = (e1)=>-1 !== e1.indexOf($R), WR = "%MCEPASTEBIN%", KR = (e1)=>e1.dom.get("mcepastebin"), YR = (e1)=>C(e1) && "mcepastebin" === e1.id, GR = (e1)=>e1 === WR, XR = (e1, t)=>(Pt.each(t, (t)=>{
            e1 = u(t, RegExp) ? e1.replace(t, "") : e1.replace(t[0], t[1]);
        }), e1), QR = (e1)=>XR(e1, [
            /^[\s\S]*<body[^>]*>\s*|\s*<\/body[^>]*>[\s\S]*$/gi,
            /<!--StartFragment-->|<!--EndFragment-->/g,
            [
                /( ?)<span class="Apple-converted-space">\u00a0<\/span>( ?)/g,
                (e1, t, n)=>t || n ? br : " "
            ],
            /<br class="Apple-interchange-newline">/g,
            /<br>$/i
        ]), JR = (e1, t)=>({
            content: e1,
            cancelled: t
        }), ZR = (e1, t)=>(e1.insertContent(t, {
            merge: tc(e1),
            paste: !0
        }), !0), eA = (e1)=>/^https?:\/\/[\w\-\/+=.,!;:&%@^~(){}?#]+$/i.test(e1), tA = (e1, t, n)=>!(e1.selection.isCollapsed() || !eA(t)) && ((e1, t, n)=>(e1.undoManager.extra(()=>{
                n(e1, t);
            }, ()=>{
                e1.execCommand("mceInsertLink", !1, t);
            }), !0))(e1, t, n), nA = (e1, t, n)=>!!((e1, t)=>eA(t) && $(pc(e1), (e1)=>$e(t.toLowerCase(), `.${e1.toLowerCase()}`)))(e1, t) && ((e1, t, n)=>(e1.undoManager.extra(()=>{
                n(e1, t);
            }, ()=>{
                e1.insertContent('<img src="' + t + '">');
            }), !0))(e1, t, n), oA = ((e1)=>{
        let t = 0;
        return ()=>"mceclip" + t++;
    })(), rA = (e1)=>{
        const t = UR();
        return zR(t, e1), BR(t), t;
    }, sA = (e1, t, n, o, r)=>{
        const s = ((e1, t, n)=>((e1, t, n)=>{
                const o = ((e1, t, n)=>e1.dispatch("PastePreProcess", {
                        content: t,
                        internal: n
                    }))(e1, t, n), r = ((e1, t)=>{
                    const n = CC({
                        sanitize: fc(e1),
                        sandbox_iframes: Cc(e1)
                    }, e1.schema);
                    n.addNodeFilter("meta", (e1)=>{
                        Pt.each(e1, (e1)=>{
                            e1.remove();
                        });
                    });
                    const o = n.parse(t, {
                        forced_root_block: !1,
                        isRootContent: !0
                    });
                    return up({
                        validate: !0
                    }, e1.schema).serialize(o);
                })(e1, o.content);
                return e1.hasEventListeners("PastePostProcess") && !o.isDefaultPrevented() ? ((e1, t, n)=>{
                    const o = e1.dom.create("div", {
                        style: "display:none"
                    }, t), r = ((e1, t, n)=>e1.dispatch("PastePostProcess", {
                            node: t,
                            internal: n
                        }))(e1, o, n);
                    return JR(r.node.innerHTML, r.isDefaultPrevented());
                })(e1, r, n) : JR(r, o.isDefaultPrevented());
            })(e1, t, n))(e1, t, n);
        if (!s.cancelled) {
            const t = s.content, n = ()=>((e1, t, n)=>{
                    n || !nc(e1) ? ZR(e1, t) : ((e1, t)=>{
                        Pt.each([
                            tA,
                            nA,
                            ZR
                        ], (n)=>!n(e1, t, ZR));
                    })(e1, t);
                })(e1, t, o);
            r ? gN(e1, "insertFromPaste", {
                dataTransfer: rA(t)
            }).isDefaultPrevented() || (n(), fN(e1, "insertFromPaste")) : n();
        }
    }, aA = (e1, t, n, o)=>{
        const r = n || VR(t);
        sA(e1, ((e1)=>e1.replace($R, ""))(t), r, !1, o);
    }, iA = (e1, t, n)=>{
        const o = e1.dom.encode(t).replace(/\r\n/g, "\n"), r = ((e1, t, n)=>{
            const o = e1.split(/\n\n/), r = ((e1, t)=>{
                let n = "<" + e1;
                const o = Ce(t, (e1, t)=>t + '="' + ea.encodeAllRaw(e1) + '"');
                return o.length && (n += " " + o.join(" ")), n + ">";
            })(t, n), s = "</" + t + ">", a = q(o, (e1)=>e1.split(/\n/).join("<br />"));
            return 1 === a.length ? a[0] : q(a, (e1)=>r + e1 + s).join("");
        })(ls(o, rc(e1)), Il(e1), Fl(e1));
        sA(e1, r, !1, !0, n);
    }, lA = (e1)=>{
        const t = {};
        if (e1 && e1.types) for(let n = 0; n < e1.types.length; n++){
            const o = e1.types[n];
            try {
                t[o] = e1.getData(o);
            } catch (e1) {
                t[o] = "";
            }
        }
        return t;
    }, dA = (e1, t)=>t in e1 && e1[t].length > 0, cA = (e1)=>dA(e1, "text/html") || dA(e1, "text/plain"), uA = (e1, t, n)=>{
        const o = "paste" === t.type ? t.clipboardData : t.dataTransfer;
        var r;
        if (Gd(e1) && o) {
            const s = ((e1, t)=>{
                const n = t.items ? te(ce(t.items), (e1)=>"file" === e1.kind ? [
                        e1.getAsFile()
                    ] : []) : [], o = t.files ? ce(t.files) : [];
                return Y(n.length > 0 ? n : o, ((e1)=>{
                    const t = pc(e1);
                    return (e1)=>He(e1.type, "image/") && $(t, (t)=>((e1)=>{
                                const t = e1.toLowerCase(), n = {
                                    jpg: "jpeg",
                                    jpe: "jpeg",
                                    jfi: "jpeg",
                                    jif: "jpeg",
                                    jfif: "jpeg",
                                    pjpeg: "jpeg",
                                    pjp: "jpeg",
                                    svg: "svg+xml"
                                };
                                return Pt.hasOwn(n, t) ? "image/" + n[t] : "image/" + t;
                            })(t) === e1.type);
                })(e1));
            })(e1, o);
            if (s.length > 0) return t.preventDefault(), (r = s, Promise.all(q(r, (e1)=>Gv(e1).then((t)=>({
                        file: e1,
                        uri: t
                    }))))).then((t)=>{
                n && e1.selection.setRng(n), V(t, (t)=>{
                    ((e1, t)=>{
                        Kv(t.uri).each(({ data: n, type: o, base64Encoded: r })=>{
                            const s = r ? n : btoa(n), a = t.file, i = e1.editorUpload.blobCache, l = i.getByData(s, o), d = null != l ? l : ((e1, t, n, o)=>{
                                const r = oA(), s = Vl(e1) && C(n.name), a = s ? ((e1, t)=>{
                                    const n = t.match(/([\s\S]+?)(?:\.[a-z0-9.]+)$/i);
                                    return C(n) ? e1.dom.encode(n[1]) : void 0;
                                })(e1, n.name) : r, i = s ? n.name : void 0, l = t.create(r, n, o, a, i);
                                return t.add(l), l;
                            })(e1, i, a, s);
                            aA(e1, `<img src="${d.blobUri()}">`, !1, !0);
                        });
                    })(e1, t);
                });
            }), !0;
        }
        return !1;
    }, mA = (e1, t, n, o, r)=>{
        let s = QR(n);
        const a = dA(t, HR()) || VR(n), i = !a && ((e1)=>!/<(?:\/?(?!(?:div|p|br|span)>)\w+|(?:(?!(?:span style="white-space:\s?pre;?">)|br\s?\/>))\w+\s[^>]+)>/i.test(e1))(s), l = eA(s);
        (GR(s) || !s.length || i && !l) && (o = !0), (o || l) && (s = dA(t, "text/plain") && i ? t["text/plain"] : ((e1)=>{
            const t = ua(), n = CC({}, t);
            let o = "";
            const r = t.getVoidElements(), s = Pt.makeMap("script noscript style textarea video audio iframe object", " "), a = t.getBlockElements(), i = (e1)=>{
                const n = e1.name, l = e1;
                if ("br" !== n) {
                    if ("wbr" !== n) {
                        if (r[n] && (o += " "), s[n]) o += " ";
                        else {
                            if (3 === e1.type && (o += e1.value), !(e1.name in t.getVoidElements())) {
                                let t = e1.firstChild;
                                if (t) do i(t);
                                while (t = t.next);
                            }
                            a[n] && l.next && (o += "\n", "p" === n && (o += "\n"));
                        }
                    }
                } else o += "\n";
            };
            return e1 = XR(e1, [
                /<!\[[^\]]+\]>/g
            ]), i(n.parse(e1)), o;
        })(s)), GR(s) || (o ? iA(e1, s, r) : aA(e1, s, a, r));
    }, fA = (e1, t, n)=>{
        ((e1, t, n)=>{
            let o;
            e1.on("keydown", (e1)=>{
                ((e1)=>af.metaKeyPressed(e1) && 86 === e1.keyCode || e1.shiftKey && 45 === e1.keyCode)(e1) && !e1.isDefaultPrevented() && (o = e1.shiftKey && 86 === e1.keyCode);
            }), e1.on("paste", (r)=>{
                if (r.isDefaultPrevented() || ((e1)=>{
                    var t, n;
                    return At.os.isAndroid() && 0 === (null === (n = null === (t = e1.clipboardData) || void 0 === t ? void 0 : t.items) || void 0 === n ? void 0 : n.length);
                })(r)) return;
                const s = "text" === n.get() || o;
                o = !1;
                const a = lA(r.clipboardData);
                !cA(a) && uA(e1, r, t.getLastRng() || e1.selection.getRng()) || (dA(a, "text/html") ? (r.preventDefault(), mA(e1, a, a["text/html"], s, !0)) : dA(a, "text/plain") && dA(a, "text/uri-list") ? (r.preventDefault(), mA(e1, a, a["text/plain"], s, !0)) : (t.create(), vg.setEditorTimeout(e1, ()=>{
                    const n = t.getHtml();
                    t.remove(), mA(e1, a, n, s, !1);
                }, 0)));
            });
        })(e1, t, n), ((e1)=>{
            const t = (e1)=>He(e1, "webkit-fake-url"), n = (e1)=>He(e1, "data:");
            e1.parser.addNodeFilter("img", (o, r, s)=>{
                if (!Gd(e1) && ((e1)=>{
                    var t;
                    return !0 === (null === (t = e1.data) || void 0 === t ? void 0 : t.paste);
                })(s)) for (const r of o){
                    const o = r.attr("src");
                    m(o) && !r.attr("data-mce-object") && o !== At.transparentSrc && (t(o) || !sc(e1) && n(o)) && r.remove();
                }
            });
        })(e1);
    }, gA = (e1, t, n, o)=>{
        ((e1, t, n)=>{
            if (!e1) return !1;
            try {
                return e1.clearData(), e1.setData("text/html", t), e1.setData("text/plain", n), e1.setData(HR(), t), !0;
            } catch (e1) {
                return !1;
            }
        })(e1.clipboardData, t.html, t.text) ? (e1.preventDefault(), o()) : n(t.html, o);
    }, pA = (e1)=>(t, n)=>{
            const { dom: o, selection: r } = e1, s = o.create("div", {
                contenteditable: "false",
                "data-mce-bogus": "all"
            }), a = o.create("div", {
                contenteditable: "true"
            }, t);
            o.setStyles(s, {
                position: "fixed",
                top: "0",
                left: "-3000px",
                width: "1000px",
                overflow: "hidden"
            }), s.appendChild(a), o.add(e1.getBody(), s);
            const i = r.getRng();
            a.focus();
            const l = o.createRng();
            l.selectNodeContents(a), r.setRng(l), vg.setEditorTimeout(e1, ()=>{
                r.setRng(i), o.remove(s), n();
            }, 0);
        }, hA = (e1)=>({
            html: qR(e1.selection.getContent({
                contextual: !0
            })),
            text: e1.selection.getContent({
                format: "text"
            })
        }), bA = (e1)=>!e1.selection.isCollapsed() || ((e1)=>!!e1.dom.getParent(e1.selection.getStart(), "td[data-mce-selected],th[data-mce-selected]", e1.getBody()))(e1), vA = (e1, t)=>{
        var n, o;
        return Uf.getCaretRangeFromPoint(null !== (n = t.clientX) && void 0 !== n ? n : 0, null !== (o = t.clientY) && void 0 !== o ? o : 0, e1.getDoc());
    }, yA = (e1, t)=>{
        e1.focus(), t && e1.selection.setRng(t);
    }, CA = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/gi, wA = (e1)=>Pt.trim(e1).replace(CA, Ca).toLowerCase(), xA = (e1, t, n)=>{
        const o = Zd(e1);
        if (n || "all" === o || !ec(e1)) return t;
        const r = o ? o.split(/[, ]/) : [];
        if (r && "none" !== o) {
            const n = e1.dom, o = e1.selection.getNode();
            t = t.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, (e1, t, s, a)=>{
                const i = n.parseStyle(n.decode(s)), l = {};
                for(let e1 = 0; e1 < r.length; e1++){
                    const t = i[r[e1]];
                    let s = t, a = n.getStyle(o, r[e1], !0);
                    /color/.test(r[e1]) && (s = wA(s), a = wA(a)), a !== s && (l[r[e1]] = t);
                }
                const d = n.serializeStyle(l, "span");
                return d ? t + ' style="' + d + '"' + a : t + a;
            });
        } else t = t.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, "$1$3");
        return t = t.replace(/(<[^>]+) data-mce-style="([^"]+)"([^>]*>)/gi, (e1, t, n, o)=>t + ' style="' + n + '"' + o), t;
    }, EA = (e1)=>{
        const t = $a(!1), n = $a(oc(e1) ? "text" : "html"), o = ((e1)=>{
            const t = $a(null);
            return {
                create: ()=>((e1, t)=>{
                        const { dom: n, selection: o } = e1, r = e1.getBody();
                        t.set(o.getRng());
                        const s = n.add(e1.getBody(), "div", {
                            id: "mcepastebin",
                            class: "mce-pastebin",
                            contentEditable: !0,
                            "data-mce-bogus": "all",
                            style: "position: fixed; top: 50%; width: 10px; height: 10px; overflow: hidden; opacity: 0"
                        }, WR);
                        At.browser.isFirefox() && n.setStyle(s, "left", "rtl" === n.getStyle(r, "direction", !0) ? 65535 : -65535), n.bind(s, "beforedeactivate focusin focusout", (e1)=>{
                            e1.stopPropagation();
                        }), s.focus(), o.select(s, !0);
                    })(e1, t),
                remove: ()=>((e1, t)=>{
                        const n = e1.dom;
                        if (KR(e1)) {
                            let o;
                            const r = t.get();
                            for(; o = KR(e1);)n.remove(o), n.unbind(o);
                            r && e1.selection.setRng(r);
                        }
                        t.set(null);
                    })(e1, t),
                getEl: ()=>KR(e1),
                getHtml: ()=>((e1)=>{
                        const t = e1.dom, n = (e1, n)=>{
                            e1.appendChild(n), t.remove(n, !0);
                        }, [o, ...r] = Y(e1.getBody().childNodes, YR);
                        V(r, (e1)=>{
                            n(o, e1);
                        });
                        const s = t.select("div[id=mcepastebin]", o);
                        for(let e1 = s.length - 1; e1 >= 0; e1--){
                            const r = t.create("div");
                            o.insertBefore(r, s[e1]), n(r, s[e1]);
                        }
                        return o ? o.innerHTML : "";
                    })(e1),
                getLastRng: t.get
            };
        })(e1);
        ((e1)=>{
            (At.browser.isChromium() || At.browser.isSafari()) && ((e1, t)=>{
                e1.on("PastePreProcess", (n)=>{
                    n.content = t(e1, n.content, n.internal);
                });
            })(e1, xA);
        })(e1), ((e1, t)=>{
            e1.addCommand("mceTogglePlainTextPaste", ()=>{
                ((e1, t)=>{
                    "text" === t.get() ? (t.set("html"), sf(e1, !1)) : (t.set("text"), sf(e1, !0)), e1.focus();
                })(e1, t);
            }), e1.addCommand("mceInsertClipboardContent", (t, n)=>{
                n.html && aA(e1, n.html, n.internal, !1), n.text && iA(e1, n.text, !1);
            });
        })(e1, n), ((e1)=>{
            const t = (t)=>(n)=>{
                    t(e1, n);
                }, n = Xd(e1);
            w(n) && e1.on("PastePreProcess", t(n));
            const o = Qd(e1);
            w(o) && e1.on("PastePostProcess", t(o));
        })(e1), e1.on("PreInit", ()=>{
            ((e1)=>{
                e1.on("cut", ((e1)=>(t)=>{
                        !t.isDefaultPrevented() && bA(e1) && e1.selection.isEditable() && gA(t, hA(e1), pA(e1), ()=>{
                            if (At.browser.isChromium() || At.browser.isFirefox()) {
                                const t = e1.selection.getRng();
                                vg.setEditorTimeout(e1, ()=>{
                                    e1.selection.setRng(t), e1.execCommand("Delete");
                                }, 0);
                            } else e1.execCommand("Delete");
                        });
                    })(e1)), e1.on("copy", ((e1)=>(t)=>{
                        !t.isDefaultPrevented() && bA(e1) && gA(t, hA(e1), pA(e1), _);
                    })(e1));
            })(e1), ((e1, t)=>{
                Yd(e1) && e1.on("dragend dragover draggesture dragdrop drop drag", (e1)=>{
                    e1.preventDefault(), e1.stopPropagation();
                }), Gd(e1) || e1.on("drop", (e1)=>{
                    const t = e1.dataTransfer;
                    t && ((e1)=>$(e1.files, (e1)=>/^image\//.test(e1.type)))(t) && e1.preventDefault();
                }), e1.on("drop", (n)=>{
                    if (n.isDefaultPrevented()) return;
                    const o = vA(e1, n);
                    if (y(o)) return;
                    const r = lA(n.dataTransfer), s = dA(r, HR());
                    if ((!cA(r) || ((e1)=>{
                        const t = e1["text/plain"];
                        return !!t && 0 === t.indexOf("file://");
                    })(r)) && uA(e1, n, o)) return;
                    const a = r[HR()], i = a || r["text/html"] || r["text/plain"], l = ((e1, t, n, o)=>{
                        const r = e1.getParent(n, (e1)=>Ts(t, e1));
                        if (!h(e1.getParent(n, "summary"))) return !0;
                        if (r && Ee(o, "text/html")) {
                            const e1 = (new DOMParser).parseFromString(o["text/html"], "text/html").body;
                            return !h(e1.querySelector(r.nodeName.toLowerCase()));
                        }
                        return !1;
                    })(e1.dom, e1.schema, o.startContainer, r), d = t.get();
                    d && !l || i && (n.preventDefault(), vg.setEditorTimeout(e1, ()=>{
                        e1.undoManager.transact(()=>{
                            (a || d && l) && e1.execCommand("Delete"), yA(e1, o);
                            const t = QR(i);
                            r["text/html"] ? aA(e1, t, s, !0) : iA(e1, t, !0);
                        });
                    }));
                }), e1.on("dragstart", (e1)=>{
                    t.set(!0);
                }), e1.on("dragover dragend", (n)=>{
                    Gd(e1) && !t.get() && (n.preventDefault(), yA(e1, vA(e1, n))), "dragend" === n.type && t.set(!1);
                }), ((e1)=>{
                    e1.on("input", (t)=>{
                        const n = (e1)=>h(e1.querySelector("summary"));
                        if ("deleteByDrag" === t.inputType) {
                            const t = Y(e1.dom.select("details"), n);
                            V(t, (t)=>{
                                ar(t.firstChild) && t.firstChild.remove();
                                const n = e1.dom.create("summary");
                                n.appendChild(Tr().dom), t.prepend(n);
                            });
                        }
                    });
                })(e1);
            })(e1, t), fA(e1, o, n);
        });
    }, _A = ar, SA = er, kA = (e1)=>dr(e1.dom), NA = (e1)=>(t)=>_n(yn(e1), t), RA = (e1, t)=>Jn(yn(e1), kA, NA(t)), AA = (e1, t, n)=>{
        const o = new jo(e1, t), r = n ? o.next.bind(o) : o.prev.bind(o);
        let s = e1;
        for(let t = n ? e1 : r(); t && !_A(t); t = r())ts(t) && (s = t);
        return s;
    }, TA = (e1)=>{
        const t = ((e1, t, n)=>{
            const o = Vi.fromRangeStart(e1).getNode(), r = ((e1, t, n)=>Jn(yn(e1), (e1)=>((e1)=>lr(e1.dom))(e1) || n.isBlock(Ht(e1)), NA(t)).getOr(yn(t)).dom)(o, t, n), s = AA(o, r, !1), a = AA(o, r, !0), i = document.createRange();
            return RA(s, r).fold(()=>{
                SA(s) ? i.setStart(s, 0) : i.setStartBefore(s);
            }, (e1)=>i.setStartBefore(e1.dom)), RA(a, r).fold(()=>{
                SA(a) ? i.setEnd(a, a.data.length) : i.setEndAfter(a);
            }, (e1)=>i.setEndAfter(e1.dom)), i;
        })(e1.selection.getRng(), e1.getBody(), e1.schema);
        e1.selection.setRng(Eb(t));
    };
    var OA;
    !function(e1) {
        e1.Before = "before", e1.After = "after";
    }(OA || (OA = {}));
    const BA = (e1, t)=>Math.abs(e1.left - t), PA = (e1, t)=>Math.abs(e1.right - t), DA = (e1, t)=>((e1)=>X(e1, (e1, t)=>e1.fold(()=>I.some(t), (e1)=>{
                    const n = Math.min(t.left, e1.left), o = Math.min(t.top, e1.top), r = Math.max(t.right, e1.right), s = Math.max(t.bottom, e1.bottom);
                    return I.some({
                        top: o,
                        right: r,
                        bottom: s,
                        left: n,
                        width: r - n,
                        height: s - o
                    });
                }), I.none()))(Y(e1, (e1)=>{
            var n, o;
            return (n = t) >= (o = e1).top && n <= o.bottom;
        })).fold(()=>[
                [],
                e1
            ], (t)=>{
            const { pass: n, fail: o } = K(e1, (e1)=>((e1, t)=>{
                    const n = ((e1, t)=>Math.max(0, Math.min(e1.bottom, t.bottom) - Math.max(e1.top, t.top)))(e1, t) / Math.min(e1.height, t.height);
                    return ((e1, t)=>e1.top < t.bottom && e1.bottom > t.top)(e1, t) && n > .5;
                })(e1, t));
            return [
                n,
                o
            ];
        }), LA = (e1, t, n)=>t > e1.left && t < e1.right ? 0 : Math.min(Math.abs(e1.left - t), Math.abs(e1.right - t)), MA = (e1, t, n, o)=>{
        const r = (e1)=>ts(e1.node) ? I.some(e1) : qo(e1.node) ? MA(ce(e1.node.childNodes), t, n, !1) : I.none(), s = (e1, s)=>{
            const a = ae(e1, (e1, o)=>s(e1, t, n) - s(o, t, n));
            return ue(a, r).map((e1)=>o && !er(e1.node) && a.length > 1 ? ((e1, o, s)=>r(o).filter((o)=>Math.abs(s(e1, t, n) - s(o, t, n)) < 2 && er(o.node)))(e1, a[1], s).getOr(e1) : e1);
        }, [a, i] = DA(zE(e1), n), { pass: l, fail: d } = K(i, (e1)=>e1.top < n);
        return s(a, LA).orThunk(()=>s(d, Ei)).orThunk(()=>s(l, Ei));
    }, IA = (e1, t, n)=>((e1, t, n)=>{
            const o = yn(e1), r = Nn(o), s = Cn(r, t, n).filter((e1)=>Sn(o, e1)).getOr(o);
            return ((e1, t, n, o)=>{
                const r = (t, s)=>{
                    const a = Y(t.dom.childNodes, O((e1)=>qo(e1) && e1.classList.contains("mce-drag-container")));
                    return s.fold(()=>MA(a, n, o, !0), (e1)=>{
                        const t = Y(a, (t)=>t !== e1.dom);
                        return MA(t, n, o, !0);
                    }).orThunk(()=>(_n(t, e1) ? I.none() : Tn(t)).bind((e1)=>r(e1, I.some(t))));
                };
                return r(t, I.none());
            })(o, s, t, n);
        })(e1, t, n).filter((e1)=>Mc(e1.node)).map((e1)=>((e1, t)=>({
                    node: e1.node,
                    position: BA(e1, t) < PA(e1, t) ? OA.Before : OA.After
                }))(e1, t)), FA = (e1)=>{
        var t, n;
        const o = e1.getBoundingClientRect(), r = e1.ownerDocument, s = r.documentElement, a = r.defaultView;
        return {
            top: o.top + (null !== (t = null == a ? void 0 : a.scrollY) && void 0 !== t ? t : 0) - s.clientTop,
            left: o.left + (null !== (n = null == a ? void 0 : a.scrollX) && void 0 !== n ? n : 0) - s.clientLeft
        };
    }, UA = (e1)=>({
            target: e1,
            srcElement: e1
        }), zA = (e1, t, n, o)=>{
        const r = ((e1, t)=>{
            const n = ((e1)=>{
                const t = UR(), n = ((e1)=>{
                    const t = e1;
                    return I.from(t[RR]);
                })(e1);
                return BR(e1), _R(t), t.dropEffect = e1.dropEffect, t.effectAllowed = e1.effectAllowed, ((e1)=>{
                    const t = e1;
                    return I.from(t[wR]);
                })(e1).each((e1)=>t.setDragImage(e1.image, e1.x, e1.y)), V(e1.types, (n)=>{
                    "Files" !== n && t.setData(n, e1.getData(n));
                }), V(e1.files, (e1)=>t.items.add(e1)), ((e1)=>{
                    const t = e1;
                    return I.from(t[xR]);
                })(e1).each((e1)=>{
                    ((e1, t)=>{
                        ER(t)(e1);
                    })(t, e1);
                }), n.each((n)=>{
                    TR(e1, n), TR(t, n);
                }), t;
            })(e1);
            return "dragstart" === t ? (_R(n), OR(n)) : "drop" === t ? (SR(n), BR(n)) : (kR(n), PR(n)), n;
        })(n, e1);
        return v(o) ? ((e1, t, n)=>{
            const o = B("Function not supported on simulated event.");
            return {
                bubbles: !0,
                cancelBubble: !1,
                cancelable: !0,
                composed: !1,
                currentTarget: null,
                defaultPrevented: !1,
                eventPhase: 0,
                isTrusted: !0,
                returnValue: !1,
                timeStamp: 0,
                type: e1,
                composedPath: o,
                initEvent: o,
                preventDefault: _,
                stopImmediatePropagation: _,
                stopPropagation: _,
                AT_TARGET: window.Event.AT_TARGET,
                BUBBLING_PHASE: window.Event.BUBBLING_PHASE,
                CAPTURING_PHASE: window.Event.CAPTURING_PHASE,
                NONE: window.Event.NONE,
                altKey: !1,
                button: 0,
                buttons: 0,
                clientX: 0,
                clientY: 0,
                ctrlKey: !1,
                metaKey: !1,
                movementX: 0,
                movementY: 0,
                offsetX: 0,
                offsetY: 0,
                pageX: 0,
                pageY: 0,
                relatedTarget: null,
                screenX: 0,
                screenY: 0,
                shiftKey: !1,
                x: 0,
                y: 0,
                detail: 0,
                view: null,
                which: 0,
                initUIEvent: o,
                initMouseEvent: o,
                getModifierState: o,
                dataTransfer: n,
                ...UA(t)
            };
        })(e1, t, r) : ((e1, t, n, o)=>({
                ...t,
                dataTransfer: o,
                type: e1,
                ...UA(n)
            }))(e1, o, t, r);
    }, jA = dr, HA = ((...e1)=>(t)=>{
            for(let n = 0; n < e1.length; n++)if (e1[n](t)) return !0;
            return !1;
        })(jA, lr), $A = (e1, t, n, o)=>{
        const r = e1.dom, s = t.cloneNode(!0);
        r.setStyles(s, {
            width: n,
            height: o
        }), r.setAttrib(s, "data-mce-selected", null);
        const a = r.create("div", {
            class: "mce-drag-container",
            "data-mce-bogus": "all",
            unselectable: "on",
            contenteditable: "false"
        });
        return r.setStyles(a, {
            position: "absolute",
            opacity: .5,
            overflow: "hidden",
            border: 0,
            padding: 0,
            margin: 0,
            width: n,
            height: o
        }), r.setStyles(s, {
            margin: 0,
            boxSizing: "border-box"
        }), a.appendChild(s), a;
    }, qA = (e1, t)=>(n)=>()=>{
                const o = "left" === e1 ? n.scrollX : n.scrollY;
                n.scroll({
                    [e1]: o + t,
                    behavior: "smooth"
                });
            }, VA = qA("left", -32), WA = qA("left", 32), KA = qA("top", -32), YA = qA("top", 32), GA = (e1)=>{
        e1 && e1.parentNode && e1.parentNode.removeChild(e1);
    }, XA = (e1, t, n, o, r)=>{
        "dragstart" === t && zR(o, e1.dom.getOuterHTML(n));
        const s = zA(t, n, o, r);
        return e1.dispatch(t, s);
    }, QA = (e1, t)=>{
        const n = Qa((e1, n)=>((e1, t, n)=>{
                e1._selectionOverrides.hideFakeCaret(), IA(e1.getBody(), t, n).fold(()=>e1.selection.placeCaretAt(t, n), (o)=>{
                    const r = e1._selectionOverrides.showCaret(1, o.node, o.position === OA.Before, !1);
                    r ? e1.selection.setRng(r) : e1.selection.placeCaretAt(t, n);
                });
            })(t, e1, n), 0);
        t.on("remove", n.cancel);
        const o = e1;
        return (r)=>e1.on((e1)=>{
                const s = Math.max(Math.abs(r.screenX - e1.screenX), Math.abs(r.screenY - e1.screenY));
                if (!e1.dragging && s > 10) {
                    const n = XA(t, "dragstart", e1.element, e1.dataTransfer, r);
                    if (C(n.dataTransfer) && (e1.dataTransfer = n.dataTransfer), n.isDefaultPrevented()) return;
                    e1.dragging = !0, t.focus();
                }
                if (e1.dragging) {
                    const s = r.currentTarget === t.getDoc().documentElement, l = ((e1, t)=>({
                            pageX: t.pageX - e1.relX,
                            pageY: t.pageY + 5
                        }))(e1, ((e1, t)=>{
                        var n, o, r;
                        return n = ((e1)=>e1.inline ? FA(e1.getBody()) : {
                                left: 0,
                                top: 0
                            })(e1), o = ((e1)=>{
                            const t = e1.getBody();
                            return e1.inline ? {
                                left: t.scrollLeft,
                                top: t.scrollTop
                            } : {
                                left: 0,
                                top: 0
                            };
                        })(e1), r = ((e1, t)=>{
                            if (t.target.ownerDocument !== e1.getDoc()) {
                                const n = FA(e1.getContentAreaContainer()), o = ((e1)=>{
                                    const t = e1.getBody(), n = e1.getDoc().documentElement, o = {
                                        left: t.scrollLeft,
                                        top: t.scrollTop
                                    }, r = {
                                        left: t.scrollLeft || n.scrollLeft,
                                        top: t.scrollTop || n.scrollTop
                                    };
                                    return e1.inline ? o : r;
                                })(e1);
                                return {
                                    left: t.pageX - n.left + o.left,
                                    top: t.pageY - n.top + o.top
                                };
                            }
                            return {
                                left: t.pageX,
                                top: t.pageY
                            };
                        })(e1, t), {
                            pageX: r.left - n.left + o.left,
                            pageY: r.top - n.top + o.top
                        };
                    })(t, r));
                    a = e1.ghost, i = t.getBody(), a.parentNode !== i && i.appendChild(a), ((e1, t, n, o, r, s, a, i, l, d, c, u)=>{
                        let m = 0, f = 0;
                        e1.style.left = t.pageX + "px", e1.style.top = t.pageY + "px", t.pageX + n > r && (m = t.pageX + n - r), t.pageY + o > s && (f = t.pageY + o - s), e1.style.width = n - m + "px", e1.style.height = o - f + "px";
                        const g = l.clientHeight, p = l.clientWidth, h = a + l.getBoundingClientRect().top, b = i + l.getBoundingClientRect().left;
                        c.on((e1)=>{
                            e1.intervalId.clear(), e1.dragging && u && (a + 8 >= g ? e1.intervalId.set(YA(d)) : a - 8 <= 0 ? e1.intervalId.set(KA(d)) : i + 8 >= p ? e1.intervalId.set(WA(d)) : i - 8 <= 0 ? e1.intervalId.set(VA(d)) : h + 16 >= window.innerHeight ? e1.intervalId.set(YA(window)) : h - 16 <= 0 ? e1.intervalId.set(KA(window)) : b + 16 >= window.innerWidth ? e1.intervalId.set(WA(window)) : b - 16 <= 0 && e1.intervalId.set(VA(window)));
                        });
                    })(e1.ghost, l, e1.width, e1.height, e1.maxX, e1.maxY, r.clientY, r.clientX, t.getContentAreaContainer(), t.getWin(), o, s), n.throttle(r.clientX, r.clientY);
                }
                var a, i;
            });
    }, JA = (e1, t, n)=>{
        e1.on((e1)=>{
            e1.intervalId.clear(), e1.dragging && n.fold(()=>XA(t, "dragend", e1.element, e1.dataTransfer), (n)=>XA(t, "dragend", e1.element, e1.dataTransfer, n));
        }), ZA(e1);
    }, ZA = (e1)=>{
        e1.on((e1)=>{
            e1.intervalId.clear(), GA(e1.ghost);
        }), e1.clear();
    }, eT = (e1)=>{
        const t = Xa(), n = za.DOM, o = document, r = ((e1, t)=>(n)=>{
                if (((e1)=>0 === e1.button)(n)) {
                    const o = J(t.dom.getParents(n.target), HA).getOr(null);
                    if (C(o) && ((e1, t, n)=>jA(n) && n !== t && e1.isEditable(n.parentElement))(t.dom, t.getBody(), o)) {
                        const r = t.dom.getPos(o), s = t.getBody(), a = t.getDoc().documentElement;
                        e1.set({
                            element: o,
                            dataTransfer: UR(),
                            dragging: !1,
                            screenX: n.screenX,
                            screenY: n.screenY,
                            maxX: (t.inline ? s.scrollWidth : a.offsetWidth) - 2,
                            maxY: (t.inline ? s.scrollHeight : a.offsetHeight) - 2,
                            relX: n.pageX - r.x,
                            relY: n.pageY - r.y,
                            width: o.offsetWidth,
                            height: o.offsetHeight,
                            ghost: $A(t, o, o.offsetWidth, o.offsetHeight),
                            intervalId: Ga(100)
                        });
                    }
                }
            })(t, e1), s = QA(t, e1), a = ((e1, t)=>(n)=>{
                e1.on((e1)=>{
                    var o;
                    if (e1.intervalId.clear(), e1.dragging) {
                        if (((e1, t, n)=>!y(t) && t !== n && !e1.dom.isChildOf(t, n) && e1.dom.isEditable(t))(t, ((e1)=>{
                            const t = e1.getSel();
                            if (C(t)) {
                                const e1 = t.getRangeAt(0).startContainer;
                                return er(e1) ? e1.parentNode : e1;
                            }
                            return null;
                        })(t.selection), e1.element)) {
                            const r = null !== (o = t.getDoc().elementFromPoint(n.clientX, n.clientY)) && void 0 !== o ? o : t.getBody();
                            XA(t, "drop", r, e1.dataTransfer, n).isDefaultPrevented() || t.undoManager.transact(()=>{
                                ((e1, t)=>{
                                    const n = e1.getParent(t.parentNode, e1.isBlock);
                                    GA(t), n && n !== e1.getRoot() && e1.isEmpty(n) && Or(yn(n));
                                })(t.dom, e1.element), ((e1)=>{
                                    const t = e1.getData("text/html");
                                    return "" === t ? I.none() : I.some(t);
                                })(e1.dataTransfer).each((e1)=>t.insertContent(e1)), t._selectionOverrides.hideFakeCaret();
                            });
                        }
                        XA(t, "dragend", t.getBody(), e1.dataTransfer, n);
                    }
                }), ZA(e1);
            })(t, e1), i = ((e1, t)=>(n)=>JA(e1, t, I.some(n)))(t, e1);
        e1.on("mousedown", r), e1.on("mousemove", s), e1.on("mouseup", a), n.bind(o, "mousemove", s), n.bind(o, "mouseup", i), e1.on("remove", ()=>{
            n.unbind(o, "mousemove", s), n.unbind(o, "mouseup", i);
        }), e1.on("keydown", (n)=>{
            n.keyCode === af.ESC && JA(t, e1, I.none());
        });
    }, tT = dr, nT = (e1, t)=>lb(e1.getBody(), t), oT = (e1)=>{
        const t = e1.selection, n = e1.dom, o = e1.getBody(), r = Pc(e1, o, n.isBlock, ()=>Rg(e1)), s = "sel-" + n.uniqueId(), a = "data-mce-selected";
        let i;
        const l = (e1)=>e1 !== o && (tT(e1) || mr(e1)) && n.isChildOf(e1, o) && n.isEditable(e1.parentNode), d = (n, o, s, a = !0)=>e1.dispatch("ShowCaret", {
                target: o,
                direction: n,
                before: s
            }).isDefaultPrevented() ? null : (a && t.scrollIntoView(o, -1 === n), r.show(s, o)), c = (e1)=>Ur(e1) || $r(e1) || qr(e1), u = (e1)=>c(e1.startContainer) || c(e1.endContainer), m = (t)=>{
            const o = e1.schema.getVoidElements(), r = n.createRng(), s = t.startContainer, a = t.startOffset, i = t.endContainer, l = t.endOffset;
            return Ee(o, s.nodeName.toLowerCase()) ? 0 === a ? r.setStartBefore(s) : r.setStartAfter(s) : r.setStart(s, a), Ee(o, i.nodeName.toLowerCase()) ? 0 === l ? r.setEndBefore(i) : r.setEndAfter(i) : r.setEnd(i, l), r;
        }, f = (r, c)=>{
            if (!r) return null;
            if (r.collapsed) {
                if (!u(r)) {
                    const e1 = c ? 1 : -1, t = au(e1, o, r), s = t.getNode(!c);
                    if (C(s)) {
                        if (Mc(s)) return d(e1, s, !!c && !t.isAtEnd(), !1);
                        if (Fr(s) && dr(s.nextSibling)) {
                            const e1 = n.createRng();
                            return e1.setStart(s, 0), e1.setEnd(s, 0), e1;
                        }
                    }
                    const a = t.getNode(c);
                    if (C(a)) {
                        if (Mc(a)) return d(e1, a, !c && !t.isAtEnd(), !1);
                        if (Fr(a) && dr(a.previousSibling)) {
                            const e1 = n.createRng();
                            return e1.setStart(a, 1), e1.setEnd(a, 1), e1;
                        }
                    }
                }
                return null;
            }
            let m = r.startContainer, f = r.startOffset;
            const g = r.endOffset;
            if (er(m) && 0 === f && tT(m.parentNode) && (m = m.parentNode, f = n.nodeIndex(m), m = m.parentNode), !qo(m)) return null;
            if (g === f + 1 && m === r.endContainer) {
                const o = m.childNodes[f];
                if (l(o)) return ((o)=>{
                    const r = o.cloneNode(!0), l = e1.dispatch("ObjectSelected", {
                        target: o,
                        targetClone: r
                    });
                    if (l.isDefaultPrevented()) return null;
                    const d = ((o, r)=>{
                        const a = yn(e1.getBody()), i = e1.getDoc(), l = to(a, "#" + s).getOrThunk(()=>{
                            const e1 = hn('<div data-mce-bogus="all" class="mce-offscreen-selection"></div>', i);
                            return Jt(e1, "id", s), vo(a, e1), e1;
                        }), d = n.createRng();
                        wo(l), Co(l, [
                            vn(br, i),
                            yn(r),
                            vn(br, i)
                        ]), d.setStart(l.dom.firstChild, 1), d.setEnd(l.dom.lastChild, 0), lo(l, {
                            top: n.getPos(o, e1.getBody()).y + "px"
                        }), ag(l);
                        const c = t.getSel();
                        return c && (c.removeAllRanges(), c.addRange(d)), d;
                    })(o, l.targetClone), c = yn(o);
                    return V(Uo(yn(e1.getBody()), `*[${a}]`), (e1)=>{
                        _n(c, e1) || on(e1, a);
                    }), n.getAttrib(o, a) || o.setAttribute(a, "1"), i = o, p(), d;
                })(o);
            }
            return null;
        }, g = ()=>{
            i && i.removeAttribute(a), to(yn(e1.getBody()), "#" + s).each(xo), i = null;
        }, p = ()=>{
            r.hide();
        };
        return ZC(e1) || (e1.on("click", (t)=>{
            n.isEditable(t.target) || (t.preventDefault(), e1.focus());
        }), e1.on("blur NewBlock", g), e1.on("ResizeWindow FullscreenStateChanged", r.reposition), e1.on("tap", (t)=>{
            const n = t.target, o = nT(e1, n);
            tT(o) ? (t.preventDefault(), Ax(e1, o).each(f)) : l(n) && Ax(e1, n).each(f);
        }, !0), e1.on("mousedown", (r)=>{
            const s = r.target;
            if (s !== o && "HTML" !== s.nodeName && !n.isChildOf(s, o)) return;
            if (!((e1, t, n)=>{
                const o = yn(e1.getBody()), r = e1.inline ? o : yn(Nn(o).dom.documentElement), s = ((e1, t, n, o)=>{
                    const r = ((e1)=>e1.dom.getBoundingClientRect())(t);
                    return {
                        x: n - (e1 ? r.left + t.dom.clientLeft + Bw(t) : 0),
                        y: o - (e1 ? r.top + t.dom.clientTop + Ow(t) : 0)
                    };
                })(e1.inline, r, t, n);
                return ((e1, t, n)=>{
                    const o = Aw(e1), r = Tw(e1);
                    return t >= 0 && n >= 0 && t <= o && n <= r;
                })(r, s.x, s.y);
            })(e1, r.clientX, r.clientY)) return;
            g(), p();
            const a = nT(e1, s);
            tT(a) ? (r.preventDefault(), Ax(e1, a).each(f)) : IA(o, r.clientX, r.clientY).each((n)=>{
                var o;
                r.preventDefault(), (o = d(1, n.node, n.position === OA.Before, !1)) && t.setRng(o), Vo(a) ? a.focus() : e1.getBody().focus();
            });
        }), e1.on("keypress", (e1)=>{
            af.modifierPressed(e1) || tT(t.getNode()) && e1.preventDefault();
        }), e1.on("GetSelectionRange", (e1)=>{
            let t = e1.range;
            if (i) {
                if (!i.parentNode) return void (i = null);
                t = t.cloneRange(), t.selectNode(i), e1.range = t;
            }
        }), e1.on("SetSelectionRange", (e1)=>{
            e1.range = m(e1.range);
            const t = f(e1.range, e1.forward);
            t && (e1.range = t);
        }), e1.on("AfterSetSelectionRange", (e1)=>{
            const t = e1.range, o = t.startContainer.parentElement;
            var r;
            u(t) || qo(r = o) && "mcepastebin" === r.id || p(), ((e1)=>C(e1) && n.hasClass(e1, "mce-offscreen-selection"))(o) || g();
        }), ((e1)=>{
            eT(e1), Id(e1) && ((e1)=>{
                const t = (t)=>{
                    if (!t.isDefaultPrevented()) {
                        const n = t.dataTransfer;
                        n && (H(n.types, "Files") || n.files.length > 0) && (t.preventDefault(), "drop" === t.type && Fw(e1, "Dropped file type is not supported"));
                    }
                }, n = (n)=>{
                    xg(e1, n.target) && t(n);
                }, o = ()=>{
                    const o = za.DOM, r = e1.dom, s = document, a = e1.inline ? e1.getBody() : e1.getDoc(), i = [
                        "drop",
                        "dragover"
                    ];
                    V(i, (e1)=>{
                        o.bind(s, e1, n), r.bind(a, e1, t);
                    }), e1.on("remove", ()=>{
                        V(i, (e1)=>{
                            o.unbind(s, e1, n), r.unbind(a, e1, t);
                        });
                    });
                };
                e1.on("init", ()=>{
                    vg.setEditorTimeout(e1, o, 0);
                });
            })(e1);
        })(e1), ((e1)=>{
            const t = Qa(()=>{
                if (!e1.removed && e1.getBody().contains(document.activeElement)) {
                    const t = e1.selection.getRng();
                    if (t.collapsed) {
                        const n = Tx(e1, t, !1);
                        e1.selection.setRng(n);
                    }
                }
            }, 0);
            e1.on("focus", ()=>{
                t.throttle();
            }), e1.on("blur", ()=>{
                t.cancel();
            });
        })(e1), ((e1)=>{
            e1.on("init", ()=>{
                e1.on("focusin", (t)=>{
                    const n = t.target;
                    if (mr(n)) {
                        const t = lb(e1.getBody(), n), o = dr(t) ? t : n;
                        e1.selection.getNode() !== o && Ax(e1, o).each((t)=>e1.selection.setRng(t));
                    }
                });
            });
        })(e1)), {
            showCaret: d,
            showBlockCaretContainer: (e1)=>{
                e1.hasAttribute("data-mce-caret") && (Vr(e1), t.scrollIntoView(e1));
            },
            hideFakeCaret: p,
            destroy: ()=>{
                r.destroy(), i = null;
            }
        };
    }, rT = (e1, t)=>{
        let n = t;
        for(let t = e1.previousSibling; er(t); t = t.previousSibling)n += t.data.length;
        return n;
    }, sT = (e1, t, n, o, r)=>{
        if (er(n) && (o < 0 || o > n.data.length)) return [];
        const s = r && er(n) ? [
            rT(n, o)
        ] : [
            o
        ];
        let a = n;
        for(; a !== t && a.parentNode;)s.push(e1.nodeIndex(a, r)), a = a.parentNode;
        return a === t ? s.reverse() : [];
    }, aT = (e1, t, n, o, r, s, a = !1)=>({
            start: sT(e1, t, n, o, a),
            end: sT(e1, t, r, s, a)
        }), iT = (e1, t)=>{
        const n = t.slice(), o = n.pop();
        return x(o) ? X(n, (e1, t)=>e1.bind((e1)=>I.from(e1.childNodes[t])), I.some(e1)).bind((e1)=>er(e1) && (o < 0 || o > e1.data.length) ? I.none() : I.some({
                node: e1,
                offset: o
            })) : I.none();
    }, lT = (e1, t)=>iT(e1, t.start).bind(({ node: n, offset: o })=>iT(e1, t.end).map(({ node: e1, offset: t })=>{
                const r = document.createRange();
                return r.setStart(n, o), r.setEnd(e1, t), r;
            })), dT = (e1, t, n)=>{
        if (t && e1.isEmpty(t) && !n(t)) {
            const o = t.parentNode;
            e1.remove(t, er(t.firstChild) && ss(t.firstChild.data)), dT(e1, o, n);
        }
    }, cT = (e1, t, n, o = !0)=>{
        const r = t.startContainer.parentNode, s = t.endContainer.parentNode;
        t.deleteContents(), o && !n(t.startContainer) && (er(t.startContainer) && 0 === t.startContainer.data.length && e1.remove(t.startContainer), er(t.endContainer) && 0 === t.endContainer.data.length && e1.remove(t.endContainer), dT(e1, r, n), r !== s && dT(e1, s, n));
    }, uT = (e1, t)=>I.from(e1.dom.getParent(t.startContainer, e1.dom.isBlock)), mT = (e1, t, n)=>{
        const o = e1.dynamicPatternsLookup({
            text: n,
            block: t
        });
        return {
            ...e1,
            blockPatterns: Cl(o).concat(e1.blockPatterns),
            inlinePatterns: wl(o).concat(e1.inlinePatterns)
        };
    }, fT = (e1, t, n, o)=>{
        const r = e1.createRng();
        return r.setStart(t, 0), r.setEnd(n, o), r.toString();
    }, gT = (e1, t, n)=>{
        ((e1, t, n)=>{
            if (er(e1) && 0 >= e1.length) return I.some(PS(e1, 0));
            {
                const t = hi(DS);
                return I.from(t.forwards(e1, 0, LS(e1), n)).map((e1)=>PS(e1.container, 0));
            }
        })(t, 0, t).each((o)=>{
            const r = o.container;
            FS(r, n.start.length, t).each((n)=>{
                const o = e1.createRng();
                o.setStart(r, 0), o.setEnd(n.container, n.offset), cT(e1, o, (e1)=>e1 === t);
            });
            const s = yn(r), a = Cr(s);
            /^\s[^\s]/.test(a) && ((e1, t)=>{
                yr.set(e1, t);
            })(s, a.slice(1));
        });
    }, pT = (e1, t)=>e1.create("span", {
            "data-mce-type": "bookmark",
            id: t
        }), hT = (e1, t)=>{
        const n = e1.createRng();
        return n.setStartAfter(t.start), n.setEndBefore(t.end), n;
    }, bT = (e1, t, n)=>{
        const o = lT(e1.getRoot(), n).getOrDie("Unable to resolve path range"), r = o.startContainer, s = o.endContainer, a = 0 === o.endOffset ? s : s.splitText(o.endOffset), i = 0 === o.startOffset ? r : r.splitText(o.startOffset), l = i.parentNode;
        return {
            prefix: t,
            end: a.parentNode.insertBefore(pT(e1, t + "-end"), a),
            start: l.insertBefore(pT(e1, t + "-start"), i)
        };
    }, vT = (e1, t, n)=>{
        dT(e1, e1.get(t.prefix + "-end"), n), dT(e1, e1.get(t.prefix + "-start"), n);
    }, yT = (e1)=>0 === e1.start.length, CT = (e1, t, n, o)=>{
        const r = t.start;
        var s;
        return US(e1, o.container, o.offset, (s = r, (e1, t)=>{
            const n = e1.data.substring(0, t), o = n.lastIndexOf(s.charAt(s.length - 1)), r = n.lastIndexOf(s);
            return -1 !== r ? r + s.length : -1 !== o ? o + 1 : -1;
        }), n).bind((o)=>{
            var s, a;
            const i = null !== (a = null === (s = n.textContent) || void 0 === s ? void 0 : s.indexOf(r)) && void 0 !== a ? a : -1;
            if (-1 !== i && o.offset >= i + r.length) {
                const t = e1.createRng();
                return t.setStart(o.container, o.offset - r.length), t.setEnd(o.container, o.offset), I.some(t);
            }
            {
                const s = o.offset - r.length;
                return IS(o.container, s, n).map((t)=>{
                    const n = e1.createRng();
                    return n.setStart(t.container, t.offset), n.setEnd(o.container, o.offset), n;
                }).filter((e1)=>e1.toString() === r).orThunk(()=>CT(e1, t, n, PS(o.container, 0)));
            }
        });
    }, wT = (e1, t, n, o)=>{
        const r = e1.dom, s = r.getRoot(), a = n.pattern, i = n.position.container, l = n.position.offset;
        return IS(i, l - n.pattern.end.length, t).bind((d)=>{
            const c = aT(r, s, d.container, d.offset, i, l, o);
            if (yT(a)) return I.some({
                matches: [
                    {
                        pattern: a,
                        startRng: c,
                        endRng: c
                    }
                ],
                position: d
            });
            {
                const i = xT(e1, n.remainingPatterns, d.container, d.offset, t, o), l = i.getOr({
                    matches: [],
                    position: d
                }), u = l.position, m = ((e1, t, n, o, r, s = !1)=>{
                    if (0 === t.start.length && !s) {
                        const t = e1.createRng();
                        return t.setStart(n, o), t.setEnd(n, o), I.some(t);
                    }
                    return MS(n, o, r).bind((n)=>CT(e1, t, r, n).bind((e1)=>{
                            var t;
                            if (s) {
                                if (e1.endContainer === n.container && e1.endOffset === n.offset) return I.none();
                                if (0 === n.offset && (null === (t = e1.endContainer.textContent) || void 0 === t ? void 0 : t.length) === e1.endOffset) return I.none();
                            }
                            return I.some(e1);
                        }));
                })(r, a, u.container, u.offset, t, i.isNone());
                return m.map((e1)=>{
                    const t = ((e1, t, n, o = !1)=>aT(e1, t, n.startContainer, n.startOffset, n.endContainer, n.endOffset, o))(r, s, e1, o);
                    return {
                        matches: l.matches.concat([
                            {
                                pattern: a,
                                startRng: t,
                                endRng: c
                            }
                        ]),
                        position: PS(e1.startContainer, e1.startOffset)
                    };
                });
            }
        });
    }, xT = (e1, t, n, o, r, s)=>{
        const a = e1.dom;
        return MS(n, o, a.getRoot()).bind((i)=>{
            const l = fT(a, r, n, o);
            for(let a = 0; a < t.length; a++){
                const d = t[a];
                if (!$e(l, d.end)) continue;
                const c = t.slice();
                c.splice(a, 1);
                const u = wT(e1, r, {
                    pattern: d,
                    remainingPatterns: c,
                    position: i
                }, s);
                if (u.isNone() && o > 0) return xT(e1, t, n, o - 1, r, s);
                if (u.isSome()) return u;
            }
            return I.none();
        });
    }, ET = (e1, t, n)=>{
        e1.selection.setRng(n), "inline-format" === t.type ? V(t.format, (t)=>{
            e1.formatter.apply(t);
        }) : e1.execCommand(t.cmd, !1, t.value);
    }, _T = (e1, t, n, o, r, s)=>{
        var a;
        return ((e1, t)=>{
            const n = ne(e1, (e1)=>$(t, (t)=>e1.pattern.start === t.pattern.start && e1.pattern.end === t.pattern.end));
            return e1.length === t.length ? n ? e1 : t : e1.length > t.length ? e1 : t;
        })(xT(e1, r.inlinePatterns, n, o, t, s).fold(()=>[], (e1)=>e1.matches), xT(e1, (a = r.inlinePatterns, ae(a, (e1, t)=>t.end.length - e1.end.length)), n, o, t, s).fold(()=>[], (e1)=>e1.matches));
    }, ST = (e1, t)=>{
        if (0 === t.length) return;
        const n = e1.dom, o = e1.selection.getBookmark(), r = ((e1, t)=>{
            const n = ui("mce_textpattern"), o = G(t, (t, o)=>{
                const r = bT(e1, n + `_end${t.length}`, o.endRng);
                return t.concat([
                    {
                        ...o,
                        endMarker: r
                    }
                ]);
            }, []);
            return G(o, (t, r)=>{
                const s = o.length - t.length - 1, a = yT(r.pattern) ? r.endMarker : bT(e1, n + `_start${s}`, r.startRng);
                return t.concat([
                    {
                        ...r,
                        startMarker: a
                    }
                ]);
            }, []);
        })(n, t);
        V(r, (t)=>{
            const o = n.getParent(t.startMarker.start, n.isBlock), r = (e1)=>e1 === o;
            yT(t.pattern) ? ((e1, t, n, o)=>{
                const r = hT(e1.dom, n);
                cT(e1.dom, r, o), ET(e1, t, r);
            })(e1, t.pattern, t.endMarker, r) : ((e1, t, n, o, r)=>{
                const s = e1.dom, a = hT(s, o), i = hT(s, n);
                cT(s, i, r), cT(s, a, r);
                const l = {
                    prefix: n.prefix,
                    start: n.end,
                    end: o.start
                }, d = hT(s, l);
                ET(e1, t, d);
            })(e1, t.pattern, t.startMarker, t.endMarker, r), vT(n, t.endMarker, r), vT(n, t.startMarker, r);
        }), e1.selection.moveToBookmark(o);
    }, kT = (e1, t)=>{
        const n = e1.selection.getRng();
        return uT(e1, n).map((o)=>{
            var r;
            const s = Math.max(0, n.startOffset), a = mT(t, o, null !== (r = o.textContent) && void 0 !== r ? r : ""), i = _T(e1, o, n.startContainer, s, a, !0), l = ((e1, t, n, o)=>{
                var r;
                const s = e1.dom, a = Il(e1);
                if (!s.is(t, a)) return [];
                const i = null !== (r = t.textContent) && void 0 !== r ? r : "";
                return ((e1, t)=>{
                    const n = ((e1)=>ae(e1, (e1, t)=>t.start.length - e1.start.length))(e1), o = t.replace(br, " ");
                    return J(n, (e1)=>0 === t.indexOf(e1.start) || 0 === o.indexOf(e1.start));
                })(n.blockPatterns, i).map((e1)=>Pt.trim(i).length === e1.start.length ? [] : [
                        {
                            pattern: e1,
                            range: aT(s, s.getRoot(), t, 0, t, 0, true)
                        }
                    ]).getOr([]);
            })(e1, o, a);
            return (l.length > 0 || i.length > 0) && (e1.undoManager.add(), e1.undoManager.extra(()=>{
                e1.execCommand("mceInsertNewLine");
            }, ()=>{
                ((e1)=>{
                    e1.insertContent(Br, {
                        preserve_zwsp: !0
                    });
                })(e1), ST(e1, i), ((e1, t)=>{
                    if (0 === t.length) return;
                    const n = e1.selection.getBookmark();
                    V(t, (t)=>((e1, t)=>{
                            const n = e1.dom, o = t.pattern, r = lT(n.getRoot(), t.range).getOrDie("Unable to resolve path range");
                            return uT(e1, r).each((t)=>{
                                "block-format" === o.type ? ((e1, t)=>{
                                    const n = t.get(e1);
                                    return p(n) && le(n).exists((e1)=>Ee(e1, "block"));
                                })(o.format, e1.formatter) && e1.undoManager.transact(()=>{
                                    gT(e1.dom, t, o), e1.formatter.apply(o.format);
                                }) : "block-command" === o.type && e1.undoManager.transact(()=>{
                                    gT(e1.dom, t, o), e1.execCommand(o.cmd, !1, o.value);
                                });
                            }), !0;
                        })(e1, t)), e1.selection.moveToBookmark(n);
                })(e1, l);
                const t = e1.selection.getRng(), n = MS(t.startContainer, t.startOffset, e1.dom.getRoot());
                e1.execCommand("mceInsertNewLine"), n.each((t)=>{
                    const n = t.container;
                    n.data.charAt(t.offset - 1) === hr && (n.deleteData(t.offset - 1, 1), dT(e1.dom, n.parentNode, (t)=>t === e1.dom.getRoot()));
                });
            }), !0);
        }).getOr(!1);
    }, NT = (e1, t, n)=>{
        for(let o = 0; o < e1.length; o++)if (n(e1[o], t)) return !0;
        return !1;
    }, RT = (e1)=>{
        const t = Pt.each, n = af.BACKSPACE, o = af.DELETE, r = e1.dom, s = e1.selection, a = e1.parser, i = At.browser, l = i.isFirefox(), d = i.isChromium() || i.isSafari(), c = At.deviceType.isiPhone() || At.deviceType.isiPad(), u = At.os.isMacOS() || At.os.isiOS(), f = (t, n)=>{
            try {
                e1.getDoc().execCommand(t, !1, String(n));
            } catch (e1) {}
        }, g = (e1)=>e1.isDefaultPrevented(), p = ()=>{
            e1.shortcuts.add("meta+a", null, "SelectAll");
        }, h = ()=>{
            e1.inline || r.bind(e1.getDoc(), "mousedown mouseup", (t)=>{
                let n;
                if (t.target === e1.getDoc().documentElement) {
                    if (n = s.getRng(), e1.getBody().focus(), "mousedown" === t.type) {
                        if (Ur(n.startContainer)) return;
                        s.placeCaretAt(t.clientX, t.clientY);
                    } else s.setRng(n);
                }
            });
        }, b = ()=>{
            Range.prototype.getClientRects || e1.on("mousedown", (t)=>{
                if (!g(t) && "HTML" === t.target.nodeName) {
                    const t = e1.getBody();
                    t.blur(), vg.setEditorTimeout(e1, ()=>{
                        t.focus();
                    });
                }
            });
        }, v = ()=>{
            const t = zd(e1);
            e1.on("click", (n)=>{
                const o = n.target;
                /^(IMG|HR)$/.test(o.nodeName) && r.isEditable(o) && (n.preventDefault(), e1.selection.select(o), e1.nodeChanged()), "A" === o.nodeName && r.hasClass(o, t) && 0 === o.childNodes.length && r.isEditable(o.parentNode) && (n.preventDefault(), s.select(o));
            });
        }, y = ()=>{
            e1.on("keydown", (e1)=>{
                if (!g(e1) && e1.keyCode === n && s.isCollapsed() && 0 === s.getRng().startOffset) {
                    const t = s.getNode().previousSibling;
                    if (t && t.nodeName && "table" === t.nodeName.toLowerCase()) return e1.preventDefault(), !1;
                }
                return !0;
            });
        }, C = ()=>{
            Bd(e1) || e1.on("BeforeExecCommand mousedown", ()=>{
                f("StyleWithCSS", !1), f("enableInlineTableEditing", !1), cd(e1) || f("enableObjectResizing", !1);
            });
        }, w = ()=>{
            e1.contentStyles.push("img:-moz-broken {-moz-force-broken-image-icon:1;min-width:24px;min-height:24px}");
        }, x = ()=>{
            e1.inline || e1.on("keydown", ()=>{
                document.activeElement === document.body && e1.getWin().focus();
            });
        }, E = ()=>{
            e1.inline || (e1.contentStyles.push("body {min-height: 150px}"), e1.on("click", (t)=>{
                let n;
                "HTML" === t.target.nodeName && (n = e1.selection.getRng(), e1.getBody().focus(), e1.selection.setRng(n), e1.selection.normalize(), e1.nodeChanged());
            }));
        }, S = ()=>{
            u && e1.on("keydown", (t)=>{
                !af.metaKeyPressed(t) || t.shiftKey || 37 !== t.keyCode && 39 !== t.keyCode || (t.preventDefault(), e1.selection.getSel().modify("move", 37 === t.keyCode ? "backward" : "forward", "lineboundary"));
            });
        }, k = ()=>{
            e1.on("click", (e1)=>{
                let t = e1.target;
                do {
                    if ("A" === t.tagName) return void e1.preventDefault();
                }while (t = t.parentNode);
            }), e1.contentStyles.push(".mce-content-body {-webkit-touch-callout: none}");
        }, N = ()=>{
            e1.on("init", ()=>{
                e1.dom.bind(e1.getBody(), "submit", (e1)=>{
                    e1.preventDefault();
                });
            });
        }, R = _;
        return ZC(e1) ? (d && (h(), v(), N(), p(), c && (x(), E(), k())), l && (b(), C(), w(), S())) : (e1.on("keydown", (t)=>{
            if (g(t) || t.keyCode !== af.BACKSPACE) return;
            let n = s.getRng();
            const o = n.startContainer, a = n.startOffset, i = r.getRoot();
            let l = o;
            if (n.collapsed && 0 === a) {
                for(; l.parentNode && l.parentNode.firstChild === l && l.parentNode !== i;)l = l.parentNode;
                "BLOCKQUOTE" === l.nodeName && (e1.formatter.toggle("blockquote", void 0, l), n = r.createRng(), n.setStart(o, 0), n.setEnd(o, 0), s.setRng(n));
            }
        }), (()=>{
            const t = (e1)=>{
                const t = r.create("body"), n = e1.cloneContents();
                return t.appendChild(n), s.serializer.serialize(t, {
                    format: "html"
                });
            };
            e1.on("keydown", (s)=>{
                const a = s.keyCode;
                if (!g(s) && (a === o || a === n) && e1.selection.isEditable()) {
                    const n = e1.selection.isCollapsed(), o = e1.getBody();
                    if (n && !gs(yn(o))) return;
                    if (!n && !((n)=>{
                        const o = t(n), s = r.createRng();
                        return s.selectNode(e1.getBody()), o === t(s);
                    })(e1.selection.getRng())) return;
                    s.preventDefault(), e1.setContent(""), o.firstChild && r.isBlock(o.firstChild) ? e1.selection.setCursorLocation(o.firstChild, 0) : e1.selection.setCursorLocation(o, 0), e1.nodeChanged();
                }
            });
        })(), At.windowsPhone || e1.on("keyup focusin mouseup", (t)=>{
            af.modifierPressed(t) || ((e1)=>{
                const t = e1.getBody(), n = e1.selection.getRng();
                return n.startContainer === n.endContainer && n.startContainer === t && 0 === n.startOffset && n.endOffset === t.childNodes.length;
            })(e1) || s.normalize();
        }, !0), d && (h(), v(), e1.on("init", ()=>{
            f("DefaultParagraphSeparator", Il(e1));
        }), N(), y(), a.addNodeFilter("br", (e1)=>{
            let t = e1.length;
            for(; t--;)"Apple-interchange-newline" === e1[t].attr("class") && e1[t].remove();
        }), c ? (x(), E(), k()) : p()), l && (e1.on("keydown", (t)=>{
            if (!g(t) && t.keyCode === n) {
                if (!e1.getBody().getElementsByTagName("hr").length) return;
                if (s.isCollapsed() && 0 === s.getRng().startOffset) {
                    const e1 = s.getNode(), n = e1.previousSibling;
                    if ("HR" === e1.nodeName) return r.remove(e1), void t.preventDefault();
                    n && n.nodeName && "hr" === n.nodeName.toLowerCase() && (r.remove(n), t.preventDefault());
                }
            }
        }), b(), (()=>{
            const n = ()=>{
                const n = r.getAttribs(s.getStart().cloneNode(!1));
                return ()=>{
                    const o = s.getStart();
                    o !== e1.getBody() && (r.setAttrib(o, "style", null), t(n, (e1)=>{
                        o.setAttributeNode(e1.cloneNode(!0));
                    }));
                };
            }, o = ()=>!s.isCollapsed() && r.getParent(s.getStart(), r.isBlock) !== r.getParent(s.getEnd(), r.isBlock);
            e1.on("keypress", (t)=>{
                let r;
                return !(!(g(t) || 8 !== t.keyCode && 46 !== t.keyCode) && o() && (r = n(), e1.getDoc().execCommand("delete", !1), r(), t.preventDefault(), 1));
            }), r.bind(e1.getDoc(), "cut", (t)=>{
                if (!g(t) && o()) {
                    const t = n();
                    vg.setEditorTimeout(e1, ()=>{
                        t();
                    });
                }
            });
        })(), C(), e1.on("SetContent ExecCommand", (e1)=>{
            "setcontent" !== e1.type && "mceInsertLink" !== e1.command || t(r.select("a:not([data-mce-block])"), (e1)=>{
                var t;
                let n = e1.parentNode;
                const o = r.getRoot();
                if ((null == n ? void 0 : n.lastChild) === e1) {
                    for(; n && !r.isBlock(n);){
                        if ((null === (t = n.parentNode) || void 0 === t ? void 0 : t.lastChild) !== n || n === o) return;
                        n = n.parentNode;
                    }
                    r.add(n, "br", {
                        "data-mce-bogus": 1
                    });
                }
            });
        }), w(), S(), y(), e1.on("drop", (t)=>{
            var n;
            const o = null === (n = t.dataTransfer) || void 0 === n ? void 0 : n.getData("text/html");
            m(o) && /^<img[^>]*>$/.test(o) && e1.dispatch("dragend", new window.DragEvent("dragend", t));
        }))), {
            refreshContentEditable: R,
            isHidden: ()=>{
                if (!l || e1.removed) return !1;
                const t = e1.selection.getSel();
                return !t || !t.rangeCount || 0 === t.rangeCount;
            }
        };
    }, AT = za.DOM, TT = (e1)=>e1.inline ? e1.getElement().nodeName.toLowerCase() : void 0, OT = (e1)=>ye(e1, (e1)=>!1 === v(e1)), BT = (e1)=>{
        const t = e1.options.get, n = e1.editorUpload.blobCache;
        return OT({
            allow_conditional_comments: t("allow_conditional_comments"),
            allow_html_data_urls: t("allow_html_data_urls"),
            allow_svg_data_urls: t("allow_svg_data_urls"),
            allow_html_in_named_anchor: t("allow_html_in_named_anchor"),
            allow_script_urls: t("allow_script_urls"),
            allow_unsafe_link_target: t("allow_unsafe_link_target"),
            convert_unsafe_embeds: t("convert_unsafe_embeds"),
            convert_fonts_to_spans: t("convert_fonts_to_spans"),
            fix_list_elements: t("fix_list_elements"),
            font_size_legacy_values: t("font_size_legacy_values"),
            forced_root_block: t("forced_root_block"),
            forced_root_block_attrs: t("forced_root_block_attrs"),
            preserve_cdata: t("preserve_cdata"),
            inline_styles: t("inline_styles"),
            root_name: TT(e1),
            sandbox_iframes: t("sandbox_iframes"),
            sanitize: t("xss_sanitization"),
            validate: !0,
            blob_cache: n,
            document: e1.getDoc()
        });
    }, PT = (e1)=>{
        const t = e1.options.get;
        return OT({
            custom_elements: t("custom_elements"),
            extended_valid_elements: t("extended_valid_elements"),
            invalid_elements: t("invalid_elements"),
            invalid_styles: t("invalid_styles"),
            schema: t("schema"),
            valid_children: t("valid_children"),
            valid_classes: t("valid_classes"),
            valid_elements: t("valid_elements"),
            valid_styles: t("valid_styles"),
            verify_html: t("verify_html"),
            padd_empty_block_inline_children: t("format_empty_lines")
        });
    }, DT = (e1)=>e1.inline ? e1.ui.styleSheetLoader : e1.dom.styleSheetLoader, LT = (e1)=>{
        const t = DT(e1), n = id(e1), o = e1.contentCSS, r = ()=>{
            t.unloadAll(o), e1.inline || e1.ui.styleSheetLoader.unloadAll(n);
        }, s = ()=>{
            e1.removed ? r() : e1.on("remove", r);
        };
        if (e1.contentStyles.length > 0) {
            let t = "";
            Pt.each(e1.contentStyles, (e1)=>{
                t += e1 + "\r\n";
            }), e1.dom.addStyle(t);
        }
        const a = Promise.all(((e1, t, n)=>{
            const { pass: o, fail: r } = K(t, (e1)=>tinymce.Resource.has(Hw(e1))), s = o.map((t)=>{
                const n = tinymce.Resource.get(Hw(t));
                return m(n) ? Promise.resolve(DT(e1).loadRawCss(t, n)) : Promise.resolve();
            }), a = [
                ...s,
                DT(e1).loadAll(r)
            ];
            return e1.inline ? a : a.concat([
                e1.ui.styleSheetLoader.loadAll(n)
            ]);
        })(e1, o, n)).then(s).catch(s), i = ad(e1);
        return i && ((e1, t)=>{
            const n = yn(e1.getBody()), o = Vn(qn(n)), r = bn("style");
            Jt(r, "type", "text/css"), vo(r, vn(t)), vo(o, r), e1.on("remove", ()=>{
                xo(r);
            });
        })(e1, i), a;
    }, MT = (e1)=>{
        !0 !== e1.removed && (((e1)=>{
            ZC(e1) || e1.load({
                initial: !0,
                format: "html"
            }), e1.startContent = e1.getContent({
                format: "raw"
            });
        })(e1), ((e1)=>{
            e1.bindPendingEventDelegates(), e1.initialized = !0, ((e1)=>{
                e1.dispatch("Init");
            })(e1), e1.focus(!0), ((e1)=>{
                const t = e1.dom.getRoot();
                e1.inline || am(e1) && e1.selection.getStart(!0) !== t || Ou(t).each((t)=>{
                    const n = t.getNode(), o = Qo(n) ? Ou(n).getOr(t) : t;
                    e1.selection.setRng(o.toRange());
                });
            })(e1), e1.nodeChanged({
                initial: !0
            });
            const t = $d(e1);
            w(t) && t.call(e1, e1), ((e1)=>{
                const t = Vd(e1);
                t && vg.setEditorTimeout(e1, ()=>{
                    let n;
                    n = !0 === t ? e1 : e1.editorManager.get(t), n && !n.destroyed && (n.focus(), n.selection.scrollIntoView());
                }, 100);
            })(e1);
        })(e1));
    }, IT = (e1)=>{
        const t = e1.getElement();
        let n = e1.getDoc();
        e1.inline && (AT.addClass(t, "mce-content-body"), e1.contentDocument = n = document, e1.contentWindow = window, e1.bodyElement = t, e1.contentAreaContainer = t);
        const o = e1.getBody();
        o.disabled = !0, e1.readonly = Bd(e1), e1._editableRoot = Pd(e1), !e1.readonly && e1.hasEditableRoot() && (e1.inline && "static" === AT.getStyle(o, "position", !0) && (o.style.position = "relative"), o.contentEditable = "true"), o.disabled = !1, e1.editorUpload = Xw(e1), e1.schema = ua(PT(e1)), e1.dom = za(n, {
            keep_values: !0,
            url_converter: e1.convertURL,
            url_converter_scope: e1,
            update_styles: !0,
            root_element: e1.inline ? e1.getBody() : null,
            collect: e1.inline,
            schema: e1.schema,
            contentCssCors: Zl(e1),
            referrerPolicy: ed(e1),
            onSetAttrib: (t)=>{
                e1.dispatch("SetAttrib", t);
            },
            force_hex_color: yc(e1)
        }), e1.parser = ((e1)=>{
            const t = CC(BT(e1), e1.schema);
            return t.addAttributeFilter("src,href,style,tabindex", (t, n)=>{
                const o = e1.dom, r = "data-mce-" + n;
                let s = t.length;
                for(; s--;){
                    const a = t[s];
                    let i = a.attr(n);
                    if (i && !a.attr(r)) {
                        if (0 === i.indexOf("data:") || 0 === i.indexOf("blob:")) continue;
                        "style" === n ? (i = o.serializeStyle(o.parseStyle(i), a.name), i.length || (i = null), a.attr(r, i), a.attr(n, i)) : "tabindex" === n ? (a.attr(r, i), a.attr(n, null)) : a.attr(r, e1.convertURL(i, n, a.name));
                    }
                }
            }), t.addNodeFilter("script", (e1)=>{
                let t = e1.length;
                for(; t--;){
                    const n = e1[t], o = n.attr("type") || "no/type";
                    0 !== o.indexOf("mce-") && n.attr("type", "mce-" + o);
                }
            }), uc(e1) && t.addNodeFilter("#cdata", (t)=>{
                var n;
                let o = t.length;
                for(; o--;){
                    const r = t[o];
                    r.type = 8, r.name = "#comment", r.value = "[CDATA[" + e1.dom.encode(null !== (n = r.value) && void 0 !== n ? n : "") + "]]";
                }
            }), t.addNodeFilter("p,h1,h2,h3,h4,h5,h6,div", (t)=>{
                let n = t.length;
                const o = e1.schema.getNonEmptyElements();
                for(; n--;){
                    const e1 = t[n];
                    e1.isEmpty(o) && 0 === e1.getAll("br").length && e1.append(new Wg("br", 1));
                }
            }), t;
        })(e1), e1.serializer = cw(((e1)=>{
            const t = e1.options.get;
            return {
                ...BT(e1),
                ...PT(e1),
                ...OT({
                    remove_trailing_brs: t("remove_trailing_brs"),
                    pad_empty_with_br: t("pad_empty_with_br"),
                    url_converter: t("url_converter"),
                    url_converter_scope: t("url_converter_scope"),
                    element_format: t("element_format"),
                    entities: t("entities"),
                    entity_encoding: t("entity_encoding"),
                    indent: t("indent"),
                    indent_after: t("indent_after"),
                    indent_before: t("indent_before")
                })
            };
        })(e1), e1), e1.selection = iw(e1.dom, e1.getWin(), e1.serializer, e1), e1.annotator = Qm(e1), e1.formatter = ix(e1), e1.undoManager = dx(e1), e1._nodeChangeDispatcher = new CR(e1), e1._selectionOverrides = oT(e1), ((e1)=>{
            const t = Xa(), n = $a(!1), o = Ja((t)=>{
                e1.dispatch("longpress", {
                    ...t,
                    type: "longpress"
                }), n.set(!0);
            }, 400);
            e1.on("touchstart", (e1)=>{
                M_(e1).each((r)=>{
                    o.cancel();
                    const s = {
                        x: r.clientX,
                        y: r.clientY,
                        target: e1.target
                    };
                    o.throttle(e1), n.set(!1), t.set(s);
                });
            }, !0), e1.on("touchmove", (r)=>{
                o.cancel(), M_(r).each((o)=>{
                    t.on((r)=>{
                        ((e1, t)=>{
                            const n = Math.abs(e1.clientX - t.x), o = Math.abs(e1.clientY - t.y);
                            return n > 5 || o > 5;
                        })(o, r) && (t.clear(), n.set(!1), e1.dispatch("longpresscancel"));
                    });
                });
            }, !0), e1.on("touchend touchcancel", (r)=>{
                o.cancel(), "touchcancel" !== r.type && t.get().filter((e1)=>e1.target.isEqualNode(r.target)).each(()=>{
                    n.get() ? r.preventDefault() : e1.dispatch("tap", {
                        ...r,
                        type: "tap"
                    });
                });
            }, !0);
        })(e1), ((e1)=>{
            ((e1)=>{
                e1.on("click", (t)=>{
                    e1.dom.getParent(t.target, "details") && t.preventDefault();
                });
            })(e1), ((e1)=>{
                e1.parser.addNodeFilter("details", (t)=>{
                    const n = bc(e1);
                    V(t, (e1)=>{
                        "expanded" === n ? e1.attr("open", "open") : "collapsed" === n && e1.attr("open", null);
                    });
                }), e1.serializer.addNodeFilter("details", (t)=>{
                    const n = vc(e1);
                    V(t, (e1)=>{
                        "expanded" === n ? e1.attr("open", "open") : "collapsed" === n && e1.attr("open", null);
                    });
                });
            })(e1);
        })(e1), ((e1)=>{
            const t = "contenteditable", n = " " + Pt.trim(dc(e1)) + " ", o = " " + Pt.trim(lc(e1)) + " ", r = $_(n), s = $_(o), a = cc(e1);
            a.length > 0 && e1.on("BeforeSetContent", (t)=>{
                ((e1, t, n)=>{
                    let o = t.length, r = n.content;
                    if ("raw" !== n.format) {
                        for(; o--;)r = r.replace(t[o], q_(e1, r, lc(e1)));
                        n.content = r;
                    }
                })(e1, a, t);
            }), e1.parser.addAttributeFilter("class", (e1)=>{
                let n = e1.length;
                for(; n--;){
                    const o = e1[n];
                    r(o) ? o.attr(t, "true") : s(o) && o.attr(t, "false");
                }
            }), e1.serializer.addAttributeFilter(t, (e1)=>{
                let n = e1.length;
                for(; n--;){
                    const o = e1[n];
                    if (!r(o) && !s(o)) continue;
                    const i = o.attr("data-mce-content");
                    a.length > 0 && i ? V_(a, i) ? (o.name = "#text", o.type = 3, o.raw = !0, o.value = i) : o.remove() : o.attr(t, null);
                }
            });
        })(e1), ZC(e1) || (((e1)=>{
            e1.on("mousedown", (t)=>{
                t.detail >= 3 && (t.preventDefault(), TA(e1));
            });
        })(e1), ((e1)=>{
            ((e1)=>{
                const t = [
                    ",",
                    ".",
                    ";",
                    ":",
                    "!",
                    "?"
                ], n = [
                    32
                ], o = ()=>{
                    var t, n;
                    return t = ac(e1), n = ic(e1), {
                        inlinePatterns: wl(t),
                        blockPatterns: Cl(t),
                        dynamicPatternsLookup: n
                    };
                }, r = ()=>((e1)=>e1.options.isSet("text_patterns_lookup"))(e1);
                e1.on("keydown", (t)=>{
                    if (13 === t.keyCode && !af.modifierPressed(t) && e1.selection.isCollapsed()) {
                        const n = o();
                        (n.inlinePatterns.length > 0 || n.blockPatterns.length > 0 || r()) && kT(e1, n) && t.preventDefault();
                    }
                }, !0);
                const s = ()=>{
                    if (e1.selection.isCollapsed()) {
                        const t = o();
                        (t.inlinePatterns.length > 0 || r()) && ((e1, t)=>{
                            const n = e1.selection.getRng();
                            uT(e1, n).map((o)=>{
                                const r = Math.max(0, n.startOffset - 1), s = fT(e1.dom, o, n.startContainer, r), a = mT(t, o, s), i = _T(e1, o, n.startContainer, r, a, !1);
                                i.length > 0 && e1.undoManager.transact(()=>{
                                    ST(e1, i);
                                });
                            });
                        })(e1, t);
                    }
                };
                e1.on("keyup", (e1)=>{
                    NT(n, e1, (e1, t)=>e1 === t.keyCode && !af.modifierPressed(t)) && s();
                }), e1.on("keypress", (n)=>{
                    NT(t, n, (e1, t)=>e1.charCodeAt(0) === t.charCode) && vg.setEditorTimeout(e1, s);
                });
            })(e1);
        })(e1));
        const r = yR(e1);
        L_(e1, r), ((e1)=>{
            e1.on("NodeChange", T(j_, e1));
        })(e1), ((e1)=>{
            var t;
            const n = e1.dom, o = Il(e1), r = null !== (t = md(e1)) && void 0 !== t ? t : "", s = (t, a)=>{
                if (((e1)=>{
                    if (mx(e1)) {
                        const t = e1.keyCode;
                        return !fx(e1) && (af.metaKeyPressed(e1) || e1.altKey || t >= 112 && t <= 123 || H(cx, t));
                    }
                    return !1;
                })(t)) return;
                const i = e1.getBody(), l = !((e1)=>mx(e1) && !(fx(e1) || "keyup" === e1.type && 229 === e1.keyCode))(t) && ((e1, t, n)=>{
                    if (gs(yn(t), !1)) {
                        const o = t.firstElementChild;
                        return !o || !e1.getStyle(t.firstElementChild, "padding-left") && !e1.getStyle(t.firstElementChild, "padding-right") && n === o.nodeName.toLowerCase();
                    }
                    return !1;
                })(n, i, o);
                ("" !== n.getAttrib(i, ux) !== l || a) && (n.setAttrib(i, ux, l ? r : null), n.setAttrib(i, "aria-placeholder", l ? r : null), ((e1, t)=>{
                    e1.dispatch("PlaceholderToggle", {
                        state: t
                    });
                })(e1, l), e1.on(l ? "keydown" : "keyup", s), e1.off(l ? "keyup" : "keydown", s));
            };
            Ye(r) && e1.on("init", (t)=>{
                s(t, !0), e1.on("change SetContent ExecCommand", s), e1.on("paste", (t)=>vg.setEditorTimeout(e1, ()=>s(t)));
            });
        })(e1), EA(e1);
        const s = ((e1)=>{
            const t = e1;
            return ((e1)=>xe(e1.plugins, "rtc").bind((e1)=>I.from(e1.setup)))(e1).fold(()=>(t.rtcInstance = JC(e1), I.none()), (e1)=>(t.rtcInstance = (()=>{
                    const e1 = N(null), t = N("");
                    return {
                        init: {
                            bindEvents: _
                        },
                        undoManager: {
                            beforeChange: _,
                            add: e1,
                            undo: e1,
                            redo: e1,
                            clear: _,
                            reset: _,
                            hasUndo: L,
                            hasRedo: L,
                            transact: e1,
                            ignore: _,
                            extra: _
                        },
                        formatter: {
                            match: L,
                            matchAll: N([]),
                            matchNode: N(void 0),
                            canApply: L,
                            closest: t,
                            apply: _,
                            remove: _,
                            toggle: _,
                            formatChanged: N({
                                unbind: _
                            })
                        },
                        editor: {
                            getContent: t,
                            setContent: N({
                                content: "",
                                html: ""
                            }),
                            insertContent: N(""),
                            addVisual: _
                        },
                        selection: {
                            getContent: t
                        },
                        autocompleter: {
                            addDecoration: _,
                            removeDecoration: _
                        },
                        raw: {
                            getModel: N(I.none())
                        }
                    };
                })(), I.some(()=>e1().then((e1)=>(t.rtcInstance = ((e1)=>{
                            const t = (e1)=>f(e1) ? e1 : {}, { init: n, undoManager: o, formatter: r, editor: s, selection: a, autocompleter: i, raw: l } = e1;
                            return {
                                init: {
                                    bindEvents: n.bindEvents
                                },
                                undoManager: {
                                    beforeChange: o.beforeChange,
                                    add: o.add,
                                    undo: o.undo,
                                    redo: o.redo,
                                    clear: o.clear,
                                    reset: o.reset,
                                    hasUndo: o.hasUndo,
                                    hasRedo: o.hasRedo,
                                    transact: (e1, t, n)=>o.transact(n),
                                    ignore: (e1, t)=>o.ignore(t),
                                    extra: (e1, t, n, r)=>o.extra(n, r)
                                },
                                formatter: {
                                    match: (e1, n, o, s)=>r.match(e1, t(n), s),
                                    matchAll: r.matchAll,
                                    matchNode: r.matchNode,
                                    canApply: (e1)=>r.canApply(e1),
                                    closest: (e1)=>r.closest(e1),
                                    apply: (e1, n, o)=>r.apply(e1, t(n)),
                                    remove: (e1, n, o, s)=>r.remove(e1, t(n)),
                                    toggle: (e1, n, o)=>r.toggle(e1, t(n)),
                                    formatChanged: (e1, t, n, o, s)=>r.formatChanged(t, n, o, s)
                                },
                                editor: {
                                    getContent: (e1)=>s.getContent(e1),
                                    setContent: (e1, t)=>({
                                            content: s.setContent(e1, t),
                                            html: ""
                                        }),
                                    insertContent: (e1, t)=>(s.insertContent(e1), ""),
                                    addVisual: s.addVisual
                                },
                                selection: {
                                    getContent: (e1, t)=>a.getContent(t)
                                },
                                autocompleter: {
                                    addDecoration: i.addDecoration,
                                    removeDecoration: i.removeDecoration
                                },
                                raw: {
                                    getModel: ()=>I.some(l.getRawModel())
                                }
                            };
                        })(e1), e1.rtc.isRemote)))));
        })(e1);
        ((e1)=>{
            const t = e1.getDoc(), n = e1.getBody();
            ((e1)=>{
                e1.dispatch("PreInit");
            })(e1), Wd(e1) || (t.body.spellcheck = !1, AT.setAttrib(n, "spellcheck", "false")), e1.quirks = RT(e1), ((e1)=>{
                e1.dispatch("PostRender");
            })(e1);
            const o = ld(e1);
            void 0 !== o && (n.dir = o);
            const r = Kd(e1);
            r && e1.on("BeforeSetContent", (e1)=>{
                Pt.each(r, (t)=>{
                    e1.content = e1.content.replace(t, (e1)=>"\x3c!--mce:protected " + escape(e1) + "--\x3e");
                });
            }), e1.on("SetContent", ()=>{
                e1.addVisual(e1.getBody());
            }), e1.on("compositionstart compositionend", (t)=>{
                e1.composing = "compositionstart" === t.type;
            });
        })(e1), s.fold(()=>{
            const t = ((e1)=>{
                let t = !1;
                const n = setTimeout(()=>{
                    t || e1.setProgressState(!0);
                }, 500);
                return ()=>{
                    clearTimeout(n), t = !0, e1.setProgressState(!1);
                };
            })(e1);
            LT(e1).then(()=>{
                MT(e1), t();
            });
        }, (t)=>{
            e1.setProgressState(!0), LT(e1).then(()=>{
                t().then((t)=>{
                    e1.setProgressState(!1), MT(e1), nw(e1);
                }, (t)=>{
                    e1.notificationManager.open({
                        type: "error",
                        text: String(t)
                    }), MT(e1), nw(e1);
                });
            });
        });
    }, FT = M, UT = za.DOM, zT = za.DOM, jT = (e1, t)=>({
            editorContainer: e1,
            iframeContainer: t,
            api: {}
        }), HT = (e1)=>{
        const t = e1.getElement();
        return e1.inline ? jT(null) : ((e1)=>{
            const t = zT.create("div");
            return zT.insertAfter(t, e1), jT(t, t);
        })(t);
    }, $T = async (e1)=>{
        e1.dispatch("ScriptsLoaded"), ((e1)=>{
            const t = Pt.trim(Kl(e1)), n = e1.ui.registry.getAll().icons, o = {
                ...Sw.get("default").icons,
                ...Sw.get(t).icons
            };
            ge(o, (t, o)=>{
                Ee(n, o) || e1.ui.registry.addIcon(o, t);
            });
        })(e1), ((e1)=>{
            const t = pd(e1);
            if (m(t)) {
                const n = Lw.get(t);
                e1.theme = n(e1, Lw.urls[t]) || {}, w(e1.theme.init) && e1.theme.init(e1, Lw.urls[t] || e1.documentBaseUrl.replace(/\/$/, ""));
            } else e1.theme = {};
        })(e1), ((e1)=>{
            const t = bd(e1), n = kw.get(t);
            e1.model = n(e1, kw.urls[t]);
        })(e1), ((e1)=>{
            const t = [];
            V(Ld(e1), (n)=>{
                ((e1, t, n)=>{
                    const o = Dw.get(n), r = Dw.urls[n] || e1.documentBaseUrl.replace(/\/$/, "");
                    if (n = Pt.trim(n), o && -1 === Pt.inArray(t, n)) {
                        if (e1.plugins[n]) return;
                        try {
                            const s = o(e1, r) || {};
                            e1.plugins[n] = s, w(s.init) && (s.init(e1, r), t.push(n));
                        } catch (t) {
                            ((e1, t, n)=>{
                                const o = Ka.translate([
                                    "Failed to initialize plugin: {0}",
                                    t
                                ]);
                                ef(e1, "PluginLoadError", {
                                    message: o
                                }), jw(o, n), Fw(e1, o);
                            })(e1, n, t);
                        }
                    }
                })(e1, t, ((e1)=>e1.replace(/^\-/, ""))(n));
            });
        })(e1);
        const t = await ((e1)=>{
            const t = e1.getElement();
            return e1.orgDisplay = t.style.display, m(pd(e1)) ? ((e1)=>{
                const t = e1.theme.renderUI;
                return t ? t() : HT(e1);
            })(e1) : w(pd(e1)) ? ((e1)=>{
                const t = e1.getElement(), n = pd(e1)(e1, t);
                return n.editorContainer.nodeType && (n.editorContainer.id = n.editorContainer.id || e1.id + "_parent"), n.iframeContainer && n.iframeContainer.nodeType && (n.iframeContainer.id = n.iframeContainer.id || e1.id + "_iframecontainer"), n.height = n.iframeHeight ? n.iframeHeight : t.offsetHeight, n;
            })(e1) : HT(e1);
        })(e1);
        ((e1, t)=>{
            const n = {
                show: I.from(t.show).getOr(_),
                hide: I.from(t.hide).getOr(_),
                isEnabled: I.from(t.isEnabled).getOr(M),
                setEnabled: (n)=>{
                    e1.mode.isReadOnly() || I.from(t.setEnabled).each((e1)=>e1(n));
                }
            };
            e1.ui = {
                ...e1.ui,
                ...n
            };
        })(e1, I.from(t.api).getOr({})), e1.editorContainer = t.editorContainer, ((e1)=>{
            e1.contentCSS = e1.contentCSS.concat(((e1)=>$w(e1, sd(e1)))(e1), ((e1)=>$w(e1, id(e1)))(e1));
        })(e1), e1.inline ? IT(e1) : ((e1, t)=>{
            ((e1, t)=>{
                const n = e1.translate("Rich Text Area"), o = tn(yn(e1.getElement()), "tabindex").bind(Xe), r = ((e1, t, n, o)=>{
                    const r = bn("iframe");
                    return o.each((e1)=>Jt(r, "tabindex", e1)), Zt(r, n), Zt(r, {
                        id: e1 + "_ifr",
                        frameBorder: "0",
                        allowTransparency: "true",
                        title: t
                    }), un(r, "tox-edit-area__iframe"), r;
                })(e1.id, n, Tl(e1), o).dom;
                r.onload = ()=>{
                    r.onload = null, e1.dispatch("load");
                }, e1.contentAreaContainer = t.iframeContainer, e1.iframeElement = r, e1.iframeHTML = ((e1)=>{
                    let t = Ol(e1) + "<html><head>";
                    Bl(e1) !== e1.documentBaseUrl && (t += '<base href="' + e1.documentBaseURI.getURI() + '" />'), t += '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />';
                    const n = Pl(e1), o = Dl(e1), r = e1.translate(jd(e1));
                    return Ll(e1) && (t += '<meta http-equiv="Content-Security-Policy" content="' + Ll(e1) + '" />'), t += `</head><body id="${n}" class="mce-content-body ${o}" data-id="${e1.id}" aria-label="${r}"><br></body></html>`, t;
                })(e1), UT.add(t.iframeContainer, r);
            })(e1, t), t.editorContainer && (t.editorContainer.style.display = e1.orgDisplay, e1.hidden = UT.isHidden(t.editorContainer)), e1.getElement().style.display = "none", UT.setAttrib(e1.id, "aria-hidden", "true"), e1.getElement().style.visibility = e1.orgVisibility, ((e1)=>{
                const t = e1.iframeElement, n = ()=>{
                    e1.contentDocument = t.contentDocument, IT(e1);
                };
                if (gc(e1) || At.browser.isFirefox()) {
                    const t = e1.getDoc();
                    t.open(), t.write(e1.iframeHTML), t.close(), n();
                } else {
                    const r = (o = yn(t), No(o, "load", FT, ()=>{
                        r.unbind(), n();
                    }));
                    t.srcdoc = e1.iframeHTML;
                }
                var o;
            })(e1);
        })(e1, {
            editorContainer: t.editorContainer,
            iframeContainer: t.iframeContainer
        });
    }, qT = za.DOM, VT = (e1)=>"-" === e1.charAt(0), WT = (e1, t, n)=>I.from(t).filter((e1)=>Ye(e1) && !Sw.has(e1)).map((t)=>({
                url: `${e1.editorManager.baseURL}/icons/${t}/icons${n}.js`,
                name: I.some(t)
            })), KT = (e1, t)=>{
        const n = Ha.ScriptLoader, o = ()=>{
            !e1.removed && ((e1)=>{
                const t = pd(e1);
                return !m(t) || C(Lw.get(t));
            })(e1) && ((e1)=>{
                const t = bd(e1);
                return C(kw.get(t));
            })(e1) && $T(e1);
        };
        ((e1, t)=>{
            const n = pd(e1);
            if (m(n) && !VT(n) && !Ee(Lw.urls, n)) {
                const o = hd(e1), r = o ? e1.documentBaseURI.toAbsolute(o) : `themes/${n}/theme${t}.js`;
                Lw.load(n, r).catch(()=>{
                    ((e1, t, n)=>{
                        Uw(e1, "ThemeLoadError", zw("theme", t, n));
                    })(e1, r, n);
                });
            }
        })(e1, t), ((e1, t)=>{
            const n = bd(e1);
            if ("plugin" !== n && !Ee(kw.urls, n)) {
                const o = vd(e1), r = m(o) ? e1.documentBaseURI.toAbsolute(o) : `models/${n}/model${t}.js`;
                kw.load(n, r).catch(()=>{
                    ((e1, t, n)=>{
                        Uw(e1, "ModelLoadError", zw("model", t, n));
                    })(e1, r, n);
                });
            }
        })(e1, t), ((e1, t)=>{
            const n = td(t), o = nd(t);
            if (!Ka.hasCode(n) && "en" !== n) {
                const r = Ye(o) ? o : `${t.editorManager.baseURL}/langs/${n}.js`;
                e1.add(r).catch(()=>{
                    ((e1, t, n)=>{
                        Uw(e1, "LanguageLoadError", zw("language", t, n));
                    })(t, r, n);
                });
            }
        })(n, e1), ((e1, t, n)=>{
            const o = WT(t, "default", n), r = ((e1)=>I.from(Yl(e1)).filter(Ye).map((e1)=>({
                        url: e1,
                        name: I.none()
                    })))(t).orThunk(()=>WT(t, Kl(t), ""));
            V(((e1)=>{
                const t = [], n = (e1)=>{
                    t.push(e1);
                };
                for(let t = 0; t < e1.length; t++)e1[t].each(n);
                return t;
            })([
                o,
                r
            ]), (n)=>{
                e1.add(n.url).catch(()=>{
                    ((e1, t, n)=>{
                        Uw(e1, "IconsLoadError", zw("icons", t, n));
                    })(t, n.url, n.name.getOrUndefined());
                });
            });
        })(n, e1, t), ((e1, t)=>{
            const n = (t, n)=>{
                Dw.load(t, n).catch(()=>{
                    ((e1, t, n)=>{
                        Uw(e1, "PluginLoadError", zw("plugin", t, n));
                    })(e1, n, t);
                });
            };
            ge(Md(e1), (t, o)=>{
                n(o, t), e1.options.set("plugins", Ld(e1).concat(o));
            }), V(Ld(e1), (e1)=>{
                !(e1 = Pt.trim(e1)) || Dw.urls[e1] || VT(e1) || n(e1, `plugins/${e1}/plugin${t}.js`);
            });
        })(e1, t), n.loadQueue().then(o, o);
    }, YT = xt().deviceType, GT = YT.isPhone(), XT = YT.isTablet(), QT = (e1)=>{
        if (y(e1)) return [];
        {
            const t = p(e1) ? e1 : e1.split(/[ ,]/), n = q(t, Ve);
            return Y(n, Ye);
        }
    }, JT = (e1, t)=>{
        const n = ((t, n)=>{
            const o = {}, r = {};
            return ve(t, (t, n)=>H(e1, n), be(o), be(r)), {
                t: o,
                f: r
            };
        })(t);
        var o, r;
        return o = n.t, r = n.f, {
            sections: N(o),
            options: N(r)
        };
    }, ZT = (e1, t)=>Ee(e1.sections(), t), eO = (e1, t)=>({
            table_grid: !1,
            object_resizing: !1,
            resize: !1,
            toolbar_mode: xe(e1, "toolbar_mode").getOr("scrolling"),
            toolbar_sticky: !1,
            ...t ? {
                menubar: !1
            } : {}
        }), tO = (e1, t)=>{
        var n;
        const o = null !== (n = t.external_plugins) && void 0 !== n ? n : {};
        return e1 && e1.external_plugins ? Pt.extend({}, e1.external_plugins, o) : o;
    }, nO = (e1, t, n, o, r)=>{
        var s;
        const a = e1 ? {
            mobile: eO(null !== (s = r.mobile) && void 0 !== s ? s : {}, t)
        } : {}, i = JT([
            "mobile"
        ], nk(a, r)), l = Pt.extend(n, o, i.options(), ((e1, t)=>e1 && ZT(t, "mobile"))(e1, i) ? ((e1, t, n = {})=>{
            const o = e1.sections(), r = xe(o, t).getOr({});
            return Pt.extend({}, n, r);
        })(i, "mobile") : {}, {
            external_plugins: tO(o, i.options())
        });
        return ((e1, t, n, o)=>{
            const r = QT(n.forced_plugins), s = QT(o.plugins), a = ((e1, t)=>ZT(e1, t) ? e1.sections()[t] : {})(t, "mobile"), i = ((e1, t, n, o)=>e1 && ZT(t, "mobile") ? o : n)(e1, t, s, a.plugins ? QT(a.plugins) : s), l = ((e1, t)=>[
                    ...QT(e1),
                    ...QT(t)
                ])(r, i);
            return Pt.extend(o, {
                forced_plugins: r,
                plugins: l
            });
        })(e1, i, o, l);
    }, oO = (e1)=>{
        ((e1)=>{
            const t = (t)=>()=>{
                    V("left,center,right,justify".split(","), (n)=>{
                        t !== n && e1.formatter.remove("align" + n);
                    }), "none" !== t && ((t, n)=>{
                        e1.formatter.toggle(t, void 0), e1.nodeChanged();
                    })("align" + t);
                };
            e1.editorCommands.addCommands({
                JustifyLeft: t("left"),
                JustifyCenter: t("center"),
                JustifyRight: t("right"),
                JustifyFull: t("justify"),
                JustifyNone: t("none")
            });
        })(e1), ((e1)=>{
            const t = (t)=>()=>{
                    const n = e1.selection, o = n.isCollapsed() ? [
                        e1.dom.getParent(n.getNode(), e1.dom.isBlock)
                    ] : n.getSelectedBlocks();
                    return $(o, (n)=>C(e1.formatter.matchNode(n, t)));
                };
            e1.editorCommands.addCommands({
                JustifyLeft: t("alignleft"),
                JustifyCenter: t("aligncenter"),
                JustifyRight: t("alignright"),
                JustifyFull: t("alignjustify")
            }, "state");
        })(e1);
    }, rO = (e1, t)=>{
        const n = e1.selection, o = e1.dom;
        return /^ | $/.test(t) ? ((e1, t, n, o)=>{
            const r = yn(e1.getRoot());
            return n = eh(r, Vi.fromRangeStart(t), o) ? n.replace(/^ /, "&nbsp;") : n.replace(/^&nbsp;/, " "), th(r, Vi.fromRangeEnd(t), o) ? n.replace(/(&nbsp;| )(<br( \/)>)?$/, "&nbsp;") : n.replace(/&nbsp;(<br( \/)?>)?$/, " ");
        })(o, n.getRng(), t, e1.schema) : t;
    }, sO = (e1, t)=>{
        if (e1.selection.isEditable()) {
            const { content: n, details: o } = ((e1)=>{
                if ("string" != typeof e1) {
                    const t = Pt.extend({
                        paste: e1.paste,
                        data: {
                            paste: e1.paste
                        }
                    }, e1);
                    return {
                        content: e1.content,
                        details: t
                    };
                }
                return {
                    content: e1,
                    details: {}
                };
            })(t);
            _C(e1, {
                ...o,
                content: rO(e1, n),
                format: "html",
                set: !1,
                selection: !0
            }).each((t)=>{
                const n = ((e1, t, n)=>ew(e1).editor.insertContent(t, n))(e1, t.content, o);
                SC(e1, n, t), e1.addVisual();
            });
        }
    }, aO = {
        "font-size": "size",
        "font-family": "face"
    }, iO = Xt("font"), lO = (e1)=>(t, n)=>I.from(n).map(yn).filter(Wt).bind((n)=>((e1, t, n)=>Lb(yn(n), (t)=>((t)=>mo(t, e1).orThunk(()=>iO(t) ? xe(aO, e1).bind((e1)=>tn(t, e1)) : I.none()))(t), (e1)=>_n(yn(t), e1)))(e1, t, n.dom).or(((e1, t)=>I.from(za.DOM.getStyle(t, e1, !0)))(e1, n.dom))).getOr(""), dO = lO("font-size"), cO = S((e1)=>e1.replace(/[\'\"\\]/g, "").replace(/,\s+/g, ","), lO("font-family")), uO = (e1)=>Ou(e1.getBody()).bind((e1)=>{
            const t = e1.container();
            return I.from(er(t) ? t.parentNode : t);
        }), mO = (e1, t)=>((e1, t)=>((e1)=>I.from(e1.selection.getRng()).bind((t)=>{
                    const n = e1.getBody();
                    return t.startContainer === n && 0 === t.startOffset ? I.none() : I.from(e1.selection.getStart(!0));
                }))(e1).orThunk(T(uO, e1)).map(yn).filter(Wt).bind(t))(e1, k(I.some, t)), fO = (e1, t)=>{
        if (/^[0-9.]+$/.test(t)) {
            const n = parseInt(t, 10);
            if (n >= 1 && n <= 7) {
                const o = ((e1)=>Pt.explode(e1.options.get("font_size_style_values")))(e1), r = ((e1)=>Pt.explode(e1.options.get("font_size_classes")))(e1);
                return r.length > 0 ? r[n - 1] || t : o[n - 1] || t;
            }
            return t;
        }
        return t;
    }, gO = (e1)=>{
        const t = e1.split(/\s*,\s*/);
        return q(t, (e1)=>-1 === e1.indexOf(" ") || He(e1, '"') || He(e1, "'") ? e1 : `'${e1}'`).join(",");
    }, pO = (e1, t)=>{
        const n = e1.dom, o = e1.selection.getRng(), r = t ? e1.selection.getStart() : e1.selection.getEnd(), s = t ? o.startContainer : o.endContainer, a = CN(n, s);
        if (!a || !a.isContentEditable) return;
        const i = t ? po : ho, l = Il(e1);
        ((e1, t, n, o)=>{
            const r = e1.dom, s = (e1)=>r.isBlock(e1) && e1.parentElement === n, a = s(t) ? t : r.getParent(o, s, n);
            return I.from(a).map(yn);
        })(e1, r, a, s).each((t)=>{
            const n = _N(e1, s, t.dom, a, !1, l);
            i(t, yn(n)), e1.selection.setCursorLocation(n, 0), e1.dispatch("NewBlock", {
                newBlock: n
            }), fN(e1, "insertParagraph");
        });
    }, hO = (e1)=>{
        oO(e1), ((e1)=>{
            e1.editorCommands.addCommands({
                "Cut,Copy,Paste": (t)=>{
                    const n = e1.getDoc();
                    let o;
                    try {
                        n.execCommand(t);
                    } catch (e1) {
                        o = !0;
                    }
                    if ("paste" !== t || n.queryCommandEnabled(t) || (o = !0), o || !n.queryCommandSupported(t)) {
                        let t = e1.translate("Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.");
                        (At.os.isMacOS() || At.os.isiOS()) && (t = t.replace(/Ctrl\+/g, "\u2318+")), e1.notificationManager.open({
                            text: t,
                            type: "error"
                        });
                    }
                }
            });
        })(e1), ((e1)=>{
            e1.editorCommands.addCommands({
                mceAddUndoLevel: ()=>{
                    e1.undoManager.add();
                },
                mceEndUndoLevel: ()=>{
                    e1.undoManager.add();
                },
                Undo: ()=>{
                    e1.undoManager.undo();
                },
                Redo: ()=>{
                    e1.undoManager.redo();
                }
            });
        })(e1), ((e1)=>{
            e1.editorCommands.addCommands({
                mceSelectNodeDepth: (t, n, o)=>{
                    let r = 0;
                    e1.dom.getParent(e1.selection.getNode(), (t)=>!qo(t) || r++ !== o || (e1.selection.select(t), !1), e1.getBody());
                },
                mceSelectNode: (t, n, o)=>{
                    e1.selection.select(o);
                },
                selectAll: ()=>{
                    const t = e1.dom.getParent(e1.selection.getStart(), lr);
                    if (t) {
                        const n = e1.dom.createRng();
                        n.selectNodeContents(t), e1.selection.setRng(n);
                    }
                }
            });
        })(e1), ((e1)=>{
            e1.editorCommands.addCommands({
                mceCleanup: ()=>{
                    const t = e1.selection.getBookmark();
                    e1.setContent(e1.getContent()), e1.selection.moveToBookmark(t);
                },
                insertImage: (t, n, o)=>{
                    sO(e1, e1.dom.createHTML("img", {
                        src: o
                    }));
                },
                insertHorizontalRule: ()=>{
                    e1.execCommand("mceInsertContent", !1, "<hr>");
                },
                insertText: (t, n, o)=>{
                    sO(e1, e1.dom.encode(o));
                },
                insertHTML: (t, n, o)=>{
                    sO(e1, o);
                },
                mceInsertContent: (t, n, o)=>{
                    sO(e1, o);
                },
                mceSetContent: (t, n, o)=>{
                    e1.setContent(o);
                },
                mceReplaceContent: (t, n, o)=>{
                    e1.execCommand("mceInsertContent", !1, o.replace(/\{\$selection\}/g, e1.selection.getContent({
                        format: "text"
                    })));
                },
                mceNewDocument: ()=>{
                    e1.setContent(Jd(e1));
                }
            });
        })(e1), ((e1)=>{
            const t = (t, n, o)=>{
                const r = m(o) ? {
                    href: o
                } : o, s = e1.dom.getParent(e1.selection.getNode(), "a");
                f(r) && m(r.href) && (r.href = r.href.replace(/ /g, "%20"), s && r.href || e1.formatter.remove("link"), r.href && e1.formatter.apply("link", r, s));
            };
            e1.editorCommands.addCommands({
                unlink: ()=>{
                    if (e1.selection.isEditable()) {
                        if (e1.selection.isCollapsed()) {
                            const t = e1.dom.getParent(e1.selection.getStart(), "a");
                            return void (t && e1.dom.remove(t, !0));
                        }
                        e1.formatter.remove("link");
                    }
                },
                mceInsertLink: t,
                createLink: t
            });
        })(e1), ((e1)=>{
            e1.editorCommands.addCommands({
                Indent: ()=>{
                    ((e1)=>{
                        O_(e1, "indent");
                    })(e1);
                },
                Outdent: ()=>{
                    B_(e1);
                }
            }), e1.editorCommands.addCommands({
                Outdent: ()=>R_(e1)
            }, "state");
        })(e1), ((e1)=>{
            e1.editorCommands.addCommands({
                InsertNewBlockBefore: ()=>{
                    ((e1)=>{
                        pO(e1, !0);
                    })(e1);
                },
                InsertNewBlockAfter: ()=>{
                    ((e1)=>{
                        pO(e1, !1);
                    })(e1);
                }
            });
        })(e1), ((e1)=>{
            e1.editorCommands.addCommands({
                insertParagraph: ()=>{
                    oR(LN, e1);
                },
                mceInsertNewLine: (t, n, o)=>{
                    rR(e1, o);
                },
                InsertLineBreak: (t, n, o)=>{
                    oR($N, e1);
                }
            });
        })(e1), ((e1)=>{
            ((e1)=>{
                e1.editorCommands.addCommands({
                    "InsertUnorderedList,InsertOrderedList": (t)=>{
                        e1.getDoc().execCommand(t);
                        const n = e1.dom.getParent(e1.selection.getNode(), "ol,ul");
                        if (n) {
                            const t = n.parentNode;
                            if (t && /^(H[1-6]|P|ADDRESS|PRE)$/.test(t.nodeName)) {
                                const o = e1.selection.getBookmark();
                                e1.dom.split(t, n), e1.selection.moveToBookmark(o);
                            }
                        }
                    }
                });
            })(e1), ((e1)=>{
                e1.editorCommands.addCommands({
                    "InsertUnorderedList,InsertOrderedList": (t)=>{
                        const n = e1.dom.getParent(e1.selection.getNode(), "ul,ol");
                        return n && ("insertunorderedlist" === t && "UL" === n.tagName || "insertorderedlist" === t && "OL" === n.tagName);
                    }
                }, "state");
            })(e1);
        })(e1), ((e1)=>{
            ((e1)=>{
                const t = (t, n)=>{
                    e1.formatter.toggle(t, n), e1.nodeChanged();
                };
                e1.editorCommands.addCommands({
                    "Bold,Italic,Underline,Strikethrough,Superscript,Subscript": (e1)=>{
                        t(e1);
                    },
                    "ForeColor,HiliteColor": (e1, n, o)=>{
                        t(e1, {
                            value: o
                        });
                    },
                    BackColor: (e1, n, o)=>{
                        t("hilitecolor", {
                            value: o
                        });
                    },
                    FontName: (t, n, o)=>{
                        ((e1, t)=>{
                            const n = fO(e1, t);
                            e1.formatter.toggle("fontname", {
                                value: gO(n)
                            }), e1.nodeChanged();
                        })(e1, o);
                    },
                    FontSize: (t, n, o)=>{
                        ((e1, t)=>{
                            e1.formatter.toggle("fontsize", {
                                value: fO(e1, t)
                            }), e1.nodeChanged();
                        })(e1, o);
                    },
                    LineHeight: (t, n, o)=>{
                        ((e1, t)=>{
                            e1.formatter.toggle("lineheight", {
                                value: String(t)
                            }), e1.nodeChanged();
                        })(e1, o);
                    },
                    Lang: (e1, n, o)=>{
                        var r;
                        t(e1, {
                            value: o.code,
                            customValue: null !== (r = o.customCode) && void 0 !== r ? r : null
                        });
                    },
                    RemoveFormat: (t)=>{
                        e1.formatter.remove(t);
                    },
                    mceBlockQuote: ()=>{
                        t("blockquote");
                    },
                    FormatBlock: (e1, n, o)=>{
                        t(m(o) ? o : "p");
                    },
                    mceToggleFormat: (e1, n, o)=>{
                        t(o);
                    }
                });
            })(e1), ((e1)=>{
                const t = (t)=>e1.formatter.match(t);
                e1.editorCommands.addCommands({
                    "Bold,Italic,Underline,Strikethrough,Superscript,Subscript": (e1)=>t(e1),
                    mceBlockQuote: ()=>t("blockquote")
                }, "state"), e1.editorCommands.addQueryValueHandler("FontName", ()=>((e1)=>mO(e1, (t)=>cO(e1.getBody(), t.dom)).getOr(""))(e1)), e1.editorCommands.addQueryValueHandler("FontSize", ()=>((e1)=>mO(e1, (t)=>dO(e1.getBody(), t.dom)).getOr(""))(e1)), e1.editorCommands.addQueryValueHandler("LineHeight", ()=>((e1)=>mO(e1, (t)=>{
                            const n = yn(e1.getBody()), o = Lb(t, (e1)=>mo(e1, "line-height"), T(_n, n));
                            return o.getOrThunk(()=>{
                                const e1 = parseFloat(co(t, "line-height")), n = parseFloat(co(t, "font-size"));
                                return String(e1 / n);
                            });
                        }).getOr(""))(e1));
            })(e1);
        })(e1), ((e1)=>{
            e1.editorCommands.addCommands({
                mceRemoveNode: (t, n, o)=>{
                    const r = null != o ? o : e1.selection.getNode();
                    if (r !== e1.getBody()) {
                        const t = e1.selection.getBookmark();
                        e1.dom.remove(r, !0), e1.selection.moveToBookmark(t);
                    }
                },
                mcePrint: ()=>{
                    e1.getWin().print();
                },
                mceFocus: (t, n, o)=>{
                    ((e1, t)=>{
                        e1.removed || (t ? Tg(e1) : ((e1)=>{
                            const t = e1.selection, n = e1.getBody();
                            let o = t.getRng();
                            e1.quirks.refreshContentEditable(), C(e1.bookmark) && !Rg(e1) && hg(e1).each((t)=>{
                                e1.selection.setRng(t), o = t;
                            });
                            const r = ((e1, t)=>e1.dom.getParent(t, (t)=>"true" === e1.dom.getContentEditable(t)))(e1, t.getNode());
                            if (r && e1.dom.isChildOf(r, n)) return Ng(r), kg(e1, o), void Tg(e1);
                            e1.inline || (At.browser.isOpera() || Ng(n), e1.getWin().focus()), (At.browser.isFirefox() || e1.inline) && (Ng(n), kg(e1, o)), Tg(e1);
                        })(e1));
                    })(e1, !0 === o);
                },
                mceToggleVisualAid: ()=>{
                    e1.hasVisual = !e1.hasVisual, e1.addVisual();
                }
            });
        })(e1);
    }, bO = [
        "toggleview"
    ], vO = (e1)=>H(bO, e1.toLowerCase());
    class yO {
        constructor(e1){
            this.commands = {
                state: {},
                exec: {},
                value: {}
            }, this.editor = e1;
        }
        execCommand(e1, t = !1, n, o) {
            const r = this.editor, s = e1.toLowerCase(), a = null == o ? void 0 : o.skip_focus;
            if (r.removed) return !1;
            if ("mcefocus" !== s && (/^(mceAddUndoLevel|mceEndUndoLevel)$/i.test(s) || a ? ((e1)=>{
                hg(e1).each((t)=>e1.selection.setRng(t));
            })(r) : r.focus()), r.dispatch("BeforeExecCommand", {
                command: e1,
                ui: t,
                value: n
            }).isDefaultPrevented()) return !1;
            const i = this.commands.exec[s];
            return !!w(i) && (i(s, t, n), r.dispatch("ExecCommand", {
                command: e1,
                ui: t,
                value: n
            }), !0);
        }
        queryCommandState(e1) {
            if (!vO(e1) && this.editor.quirks.isHidden() || this.editor.removed) return !1;
            const t = e1.toLowerCase(), n = this.commands.state[t];
            return !!w(n) && n(t);
        }
        queryCommandValue(e1) {
            if (!vO(e1) && this.editor.quirks.isHidden() || this.editor.removed) return "";
            const t = e1.toLowerCase(), n = this.commands.value[t];
            return w(n) ? n(t) : "";
        }
        addCommands(e1, t = "exec") {
            const n = this.commands;
            ge(e1, (e1, o)=>{
                V(o.toLowerCase().split(","), (o)=>{
                    n[t][o] = e1;
                });
            });
        }
        addCommand(e1, t, n) {
            const o = e1.toLowerCase();
            this.commands.exec[o] = (e1, o, r)=>t.call(null != n ? n : this.editor, o, r);
        }
        queryCommandSupported(e1) {
            const t = e1.toLowerCase();
            return !!this.commands.exec[t];
        }
        addQueryStateHandler(e1, t, n) {
            this.commands.state[e1.toLowerCase()] = ()=>t.call(null != n ? n : this.editor);
        }
        addQueryValueHandler(e1, t, n) {
            this.commands.value[e1.toLowerCase()] = ()=>t.call(null != n ? n : this.editor);
        }
    }
    const CO = "data-mce-contenteditable", wO = (e1, t, n)=>{
        try {
            e1.getDoc().execCommand(t, !1, String(n));
        } catch (e1) {}
    }, xO = (e1, t)=>{
        e1.dom.contentEditable = t ? "true" : "false";
    }, EO = (e1)=>e1.readonly, _O = (e1)=>{
        e1.parser.addAttributeFilter("contenteditable", (t)=>{
            EO(e1) && V(t, (e1)=>{
                e1.attr(CO, e1.attr("contenteditable")), e1.attr("contenteditable", "false");
            });
        }), e1.serializer.addAttributeFilter(CO, (t)=>{
            EO(e1) && V(t, (e1)=>{
                e1.attr("contenteditable", e1.attr(CO));
            });
        }), e1.serializer.addTempAttr(CO);
    }, SO = [
        "copy"
    ], kO = Pt.makeMap("focus blur focusin focusout click dblclick mousedown mouseup mousemove mouseover beforepaste paste cut copy selectionchange mouseout mouseenter mouseleave wheel keydown keypress keyup input beforeinput contextmenu dragstart dragend dragover draggesture dragdrop drop drag submit compositionstart compositionend compositionupdate touchstart touchmove touchend touchcancel", " ");
    class NO {
        static isNative(e1) {
            return !!kO[e1.toLowerCase()];
        }
        constructor(e1){
            this.bindings = {}, this.settings = e1 || {}, this.scope = this.settings.scope || this, this.toggleEvent = this.settings.toggleEvent || L;
        }
        fire(e1, t) {
            return this.dispatch(e1, t);
        }
        dispatch(e1, t) {
            const n = e1.toLowerCase(), o = _a(n, null != t ? t : {}, this.scope);
            this.settings.beforeFire && this.settings.beforeFire(o);
            const r = this.bindings[n];
            if (r) for(let e1 = 0, t = r.length; e1 < t; e1++){
                const t = r[e1];
                if (!t.removed) {
                    if (t.once && this.off(n, t.func), o.isImmediatePropagationStopped()) return o;
                    if (!1 === t.func.call(this.scope, o)) return o.preventDefault(), o;
                }
            }
            return o;
        }
        on(e1, t, n, o) {
            if (!1 === t && (t = L), t) {
                const r = {
                    func: t,
                    removed: !1
                };
                o && Pt.extend(r, o);
                const s = e1.toLowerCase().split(" ");
                let a = s.length;
                for(; a--;){
                    const e1 = s[a];
                    let t = this.bindings[e1];
                    t || (t = [], this.toggleEvent(e1, !0)), t = n ? [
                        r,
                        ...t
                    ] : [
                        ...t,
                        r
                    ], this.bindings[e1] = t;
                }
            }
            return this;
        }
        off(e1, t) {
            if (e1) {
                const n = e1.toLowerCase().split(" ");
                let o = n.length;
                for(; o--;){
                    const r = n[o];
                    let s = this.bindings[r];
                    if (!r) return ge(this.bindings, (e1, t)=>{
                        this.toggleEvent(t, !1), delete this.bindings[t];
                    }), this;
                    if (s) {
                        if (t) {
                            const e1 = K(s, (e1)=>e1.func === t);
                            s = e1.fail, this.bindings[r] = s, V(e1.pass, (e1)=>{
                                e1.removed = !0;
                            });
                        } else s.length = 0;
                        s.length || (this.toggleEvent(e1, !1), delete this.bindings[r]);
                    }
                }
            } else ge(this.bindings, (e1, t)=>{
                this.toggleEvent(t, !1);
            }), this.bindings = {};
            return this;
        }
        once(e1, t, n) {
            return this.on(e1, t, n, {
                once: !0
            });
        }
        has(e1) {
            e1 = e1.toLowerCase();
            const t = this.bindings[e1];
            return !(!t || 0 === t.length);
        }
    }
    const RO = (e1)=>(e1._eventDispatcher || (e1._eventDispatcher = new NO({
            scope: e1,
            toggleEvent: (t, n)=>{
                NO.isNative(t) && e1.toggleNativeEvent && e1.toggleNativeEvent(t, n);
            }
        })), e1._eventDispatcher), AO = {
        fire (e1, t, n) {
            return this.dispatch(e1, t, n);
        },
        dispatch (e1, t, n) {
            const o = this;
            if (o.removed && "remove" !== e1 && "detach" !== e1) return _a(e1.toLowerCase(), null != t ? t : {}, o);
            const r = RO(o).dispatch(e1, t);
            if (!1 !== n && o.parent) {
                let t = o.parent();
                for(; t && !r.isPropagationStopped();)t.dispatch(e1, r, !1), t = t.parent ? t.parent() : void 0;
            }
            return r;
        },
        on (e1, t, n) {
            return RO(this).on(e1, t, n);
        },
        off (e1, t) {
            return RO(this).off(e1, t);
        },
        once (e1, t) {
            return RO(this).once(e1, t);
        },
        hasEventListeners (e1) {
            return RO(this).has(e1);
        }
    }, TO = za.DOM;
    let OO;
    const BO = (e1, t)=>{
        if ("selectionchange" === t) return e1.getDoc();
        if (!e1.inline && /^(?:mouse|touch|click|contextmenu|drop|dragover|dragend)/.test(t)) return e1.getDoc().documentElement;
        const n = fd(e1);
        return n ? (e1.eventRoot || (e1.eventRoot = TO.select(n)[0]), e1.eventRoot) : e1.getBody();
    }, PO = (e1, t, n)=>{
        ((e1)=>!e1.hidden && !EO(e1))(e1) ? e1.dispatch(t, n) : EO(e1) && ((e1, t)=>{
            if (((e1)=>"click" === e1.type)(t) && !af.metaKeyPressed(t)) {
                const n = yn(t.target);
                ((e1, t)=>no(t, "a", (t)=>_n(t, yn(e1.getBody()))).bind((e1)=>tn(e1, "href")))(e1, n).each((n)=>{
                    if (t.preventDefault(), /^#/.test(n)) {
                        const t = e1.dom.select(`${n},[name="${ze(n, "#")}"]`);
                        t.length && e1.selection.scrollIntoView(t[0], !0);
                    } else window.open(n, "_blank", "rel=noopener noreferrer,menubar=yes,toolbar=yes,location=yes,status=yes,resizable=yes,scrollbars=yes");
                });
            } else ((e1)=>H(SO, e1.type))(t) && e1.dispatch(t.type, t);
        })(e1, n);
    }, DO = (e1, t)=>{
        if (e1.delegates || (e1.delegates = {}), e1.delegates[t] || e1.removed) return;
        const n = BO(e1, t);
        if (fd(e1)) {
            if (OO || (OO = {}, e1.editorManager.on("removeEditor", ()=>{
                e1.editorManager.activeEditor || OO && (ge(OO, (t, n)=>{
                    e1.dom.unbind(BO(e1, n));
                }), OO = null);
            })), OO[t]) return;
            const o = (n)=>{
                const o = n.target, r = e1.editorManager.get();
                let s = r.length;
                for(; s--;){
                    const e1 = r[s].getBody();
                    (e1 === o || TO.isChildOf(o, e1)) && PO(r[s], t, n);
                }
            };
            OO[t] = o, TO.bind(n, t, o);
        } else {
            const o = (n)=>{
                PO(e1, t, n);
            };
            TO.bind(n, t, o), e1.delegates[t] = o;
        }
    }, LO = {
        ...AO,
        bindPendingEventDelegates () {
            const e1 = this;
            Pt.each(e1._pendingNativeEvents, (t)=>{
                DO(e1, t);
            });
        },
        toggleNativeEvent (e1, t) {
            const n = this;
            "focus" !== e1 && "blur" !== e1 && (n.removed || (t ? n.initialized ? DO(n, e1) : n._pendingNativeEvents ? n._pendingNativeEvents.push(e1) : n._pendingNativeEvents = [
                e1
            ] : n.initialized && n.delegates && (n.dom.unbind(BO(n, e1), e1, n.delegates[e1]), delete n.delegates[e1])));
        },
        unbindAllNativeEvents () {
            const e1 = this, t = e1.getBody(), n = e1.dom;
            e1.delegates && (ge(e1.delegates, (t, n)=>{
                e1.dom.unbind(BO(e1, n), n, t);
            }), delete e1.delegates), !e1.inline && t && n && (t.onload = null, n.unbind(e1.getWin()), n.unbind(e1.getDoc())), n && (n.unbind(t), n.unbind(e1.getContainer()));
        }
    }, MO = (e1)=>m(e1) ? {
            value: e1.split(/[ ,]/),
            valid: !0
        } : E(e1, m) ? {
            value: e1,
            valid: !0
        } : {
            valid: !1,
            message: "The value must be a string[] or a comma/space separated string."
        }, IO = (e1, t)=>e1 + (Ge(t.message) ? "" : `. ${t.message}`), FO = (e1)=>e1.valid, UO = (e1, t, n = "")=>{
        const o = t(e1);
        return b(o) ? o ? {
            value: e1,
            valid: !0
        } : {
            valid: !1,
            message: n
        } : o;
    }, zO = [
        "design",
        "readonly"
    ], jO = (e1, t, n, o)=>{
        const r = n[t.get()], s = n[o];
        try {
            s.activate();
        } catch (e1) {
            return void console.error(`problem while activating editor mode ${o}:`, e1);
        }
        r.deactivate(), r.editorReadOnly !== s.editorReadOnly && ((e1, t)=>{
            const n = yn(e1.getBody());
            ((e1, t, n)=>{
                gn(e1, t) && !n ? fn(e1, t) : n && un(e1, t);
            })(n, "mce-content-readonly", t), t ? (e1.selection.controlSelection.hideResizeRect(), e1._selectionOverrides.hideFakeCaret(), ((e1)=>{
                I.from(e1.selection.getNode()).each((e1)=>{
                    e1.removeAttribute("data-mce-selected");
                });
            })(e1), e1.readonly = !0, xO(n, !1), V(Uo(n, '*[contenteditable="true"]'), (e1)=>{
                Jt(e1, CO, "true"), xO(e1, !1);
            })) : (e1.readonly = !1, e1.hasEditableRoot() && xO(n, !0), V(Uo(n, `*[${CO}="true"]`), (e1)=>{
                on(e1, CO), xO(e1, !0);
            }), wO(e1, "StyleWithCSS", !1), wO(e1, "enableInlineTableEditing", !1), wO(e1, "enableObjectResizing", !1), Ag(e1) && e1.focus(), ((e1)=>{
                e1.selection.setRng(e1.selection.getRng());
            })(e1), e1.nodeChanged());
        })(e1, s.editorReadOnly), t.set(o), ((e1, t)=>{
            e1.dispatch("SwitchMode", {
                mode: t
            });
        })(e1, o);
    }, HO = Pt.each, $O = Pt.explode, qO = {
        f1: 112,
        f2: 113,
        f3: 114,
        f4: 115,
        f5: 116,
        f6: 117,
        f7: 118,
        f8: 119,
        f9: 120,
        f10: 121,
        f11: 122,
        f12: 123
    }, VO = Pt.makeMap("alt,ctrl,shift,meta,access"), WO = (e1)=>{
        const t = {}, n = At.os.isMacOS() || At.os.isiOS();
        HO($O(e1.toLowerCase(), "+"), (e1)=>{
            ((e1)=>e1 in VO)(e1) ? t[e1] = !0 : /^[0-9]{2,}$/.test(e1) ? t.keyCode = parseInt(e1, 10) : (t.charCode = e1.charCodeAt(0), t.keyCode = qO[e1] || e1.toUpperCase().charCodeAt(0));
        });
        const o = [
            t.keyCode
        ];
        let r;
        for(r in VO)t[r] ? o.push(r) : t[r] = !1;
        return t.id = o.join(","), t.access && (t.alt = !0, n ? t.ctrl = !0 : t.shift = !0), t.meta && (n ? t.meta = !0 : (t.ctrl = !0, t.meta = !1)), t;
    };
    class KO {
        constructor(e1){
            this.shortcuts = {}, this.pendingPatterns = [], this.editor = e1;
            const t = this;
            e1.on("keyup keypress keydown", (e1)=>{
                !t.hasModifier(e1) && !t.isFunctionKey(e1) || e1.isDefaultPrevented() || (HO(t.shortcuts, (n)=>{
                    t.matchShortcut(e1, n) && (t.pendingPatterns = n.subpatterns.slice(0), "keydown" === e1.type && t.executeShortcutAction(n));
                }), t.matchShortcut(e1, t.pendingPatterns[0]) && (1 === t.pendingPatterns.length && "keydown" === e1.type && t.executeShortcutAction(t.pendingPatterns[0]), t.pendingPatterns.shift()));
            });
        }
        add(e1, t, n, o) {
            const r = this, s = r.normalizeCommandFunc(n);
            return HO($O(Pt.trim(e1)), (e1)=>{
                const n = r.createShortcut(e1, t, s, o);
                r.shortcuts[n.id] = n;
            }), !0;
        }
        remove(e1) {
            const t = this.createShortcut(e1);
            return !!this.shortcuts[t.id] && (delete this.shortcuts[t.id], !0);
        }
        normalizeCommandFunc(e1) {
            const t = this, n = e1;
            return "string" == typeof n ? ()=>{
                t.editor.execCommand(n, !1, null);
            } : Pt.isArray(n) ? ()=>{
                t.editor.execCommand(n[0], n[1], n[2]);
            } : n;
        }
        createShortcut(e1, t, n, o) {
            const r = Pt.map($O(e1, ">"), WO);
            return r[r.length - 1] = Pt.extend(r[r.length - 1], {
                func: n,
                scope: o || this.editor
            }), Pt.extend(r[0], {
                desc: this.editor.translate(t),
                subpatterns: r.slice(1)
            });
        }
        hasModifier(e1) {
            return e1.altKey || e1.ctrlKey || e1.metaKey;
        }
        isFunctionKey(e1) {
            return "keydown" === e1.type && e1.keyCode >= 112 && e1.keyCode <= 123;
        }
        matchShortcut(e1, t) {
            return !!t && t.ctrl === e1.ctrlKey && t.meta === e1.metaKey && t.alt === e1.altKey && t.shift === e1.shiftKey && !!(e1.keyCode === t.keyCode || e1.charCode && e1.charCode === t.charCode) && (e1.preventDefault(), !0);
        }
        executeShortcutAction(e1) {
            return e1.func ? e1.func.call(e1.scope) : null;
        }
    }
    const YO = ()=>{
        const e1 = (()=>{
            const e1 = {}, t = {}, n = {}, o = {}, r = {}, s = {}, a = {}, i = {}, l = (e1, t)=>(n, o)=>{
                    e1[n.toLowerCase()] = {
                        ...o,
                        type: t
                    };
                };
            return {
                addButton: l(e1, "button"),
                addGroupToolbarButton: l(e1, "grouptoolbarbutton"),
                addToggleButton: l(e1, "togglebutton"),
                addMenuButton: l(e1, "menubutton"),
                addSplitButton: l(e1, "splitbutton"),
                addMenuItem: l(t, "menuitem"),
                addNestedMenuItem: l(t, "nestedmenuitem"),
                addToggleMenuItem: l(t, "togglemenuitem"),
                addAutocompleter: l(n, "autocompleter"),
                addContextMenu: l(r, "contextmenu"),
                addContextToolbar: l(s, "contexttoolbar"),
                addContextForm: l(s, "contextform"),
                addSidebar: l(a, "sidebar"),
                addView: l(i, "views"),
                addIcon: (e1, t)=>o[e1.toLowerCase()] = t,
                getAll: ()=>({
                        buttons: e1,
                        menuItems: t,
                        icons: o,
                        popups: n,
                        contextMenus: r,
                        contextToolbars: s,
                        sidebars: a,
                        views: i
                    })
            };
        })();
        return {
            addAutocompleter: e1.addAutocompleter,
            addButton: e1.addButton,
            addContextForm: e1.addContextForm,
            addContextMenu: e1.addContextMenu,
            addContextToolbar: e1.addContextToolbar,
            addIcon: e1.addIcon,
            addMenuButton: e1.addMenuButton,
            addMenuItem: e1.addMenuItem,
            addNestedMenuItem: e1.addNestedMenuItem,
            addSidebar: e1.addSidebar,
            addSplitButton: e1.addSplitButton,
            addToggleButton: e1.addToggleButton,
            addGroupToolbarButton: e1.addGroupToolbarButton,
            addToggleMenuItem: e1.addToggleMenuItem,
            addView: e1.addView,
            getAll: e1.getAll
        };
    }, GO = za.DOM, XO = Pt.extend, QO = Pt.each;
    class JO {
        constructor(e1, t, n){
            this.plugins = {}, this.contentCSS = [], this.contentStyles = [], this.loadedCSS = {}, this.isNotDirty = !1, this.composing = !1, this.destroyed = !1, this.hasHiddenInput = !1, this.iframeElement = null, this.initialized = !1, this.readonly = !1, this.removed = !1, this.startContent = "", this._pendingNativeEvents = [], this._skinLoaded = !1, this._editableRoot = !0, this.editorManager = n, this.documentBaseUrl = n.documentBaseURL, XO(this, LO);
            const o = this;
            this.id = e1, this.hidden = !1;
            const r = ((e1, t)=>nO(GT || XT, GT, t, e1, t))(n.defaultOptions, t);
            this.options = ((e1, t)=>{
                const n = {}, o = {}, r = (e1, t, n)=>{
                    const r = UO(t, n);
                    return FO(r) ? (o[e1] = r.value, !0) : (console.warn(IO(`Invalid value passed for the ${e1} option`, r)), !1);
                }, s = (e1)=>Ee(n, e1);
                return {
                    register: (e1, s)=>{
                        const a = ((e1)=>m(e1.processor))(s) ? ((e1)=>{
                            const t = (()=>{
                                switch(e1){
                                    case "array":
                                        return p;
                                    case "boolean":
                                        return b;
                                    case "function":
                                        return w;
                                    case "number":
                                        return x;
                                    case "object":
                                        return f;
                                    case "string":
                                        return m;
                                    case "string[]":
                                        return MO;
                                    case "object[]":
                                        return (e1)=>E(e1, f);
                                    case "regexp":
                                        return (e1)=>u(e1, RegExp);
                                    default:
                                        return M;
                                }
                            })();
                            return (n)=>UO(n, t, `The value must be a ${e1}.`);
                        })(s.processor) : s.processor, i = ((e1, t, n)=>{
                            if (!v(t)) {
                                const o = UO(t, n);
                                if (FO(o)) return o.value;
                                console.error(IO(`Invalid default value passed for the "${e1}" option`, o));
                            }
                        })(e1, s.default, a);
                        n[e1] = {
                            ...s,
                            default: i,
                            processor: a
                        }, xe(o, e1).orThunk(()=>xe(t, e1)).each((t)=>r(e1, t, a));
                    },
                    isRegistered: s,
                    get: (e1)=>xe(o, e1).orThunk(()=>xe(n, e1).map((e1)=>e1.default)).getOrUndefined(),
                    set: (e1, t)=>{
                        if (s(e1)) {
                            const o = n[e1];
                            return o.immutable ? (console.error(`"${e1}" is an immutable option and cannot be updated`), !1) : r(e1, t, o.processor);
                        }
                        return console.warn(`"${e1}" is not a registered option. Ensure the option has been registered before setting a value.`), !1;
                    },
                    unset: (e1)=>{
                        const t = s(e1);
                        return t && delete o[e1], t;
                    },
                    isSet: (e1)=>Ee(o, e1)
                };
            })(0, r), ((e1)=>{
                const t = e1.options.register;
                t("id", {
                    processor: "string",
                    default: e1.id
                }), t("selector", {
                    processor: "string"
                }), t("target", {
                    processor: "object"
                }), t("suffix", {
                    processor: "string"
                }), t("cache_suffix", {
                    processor: "string"
                }), t("base_url", {
                    processor: "string"
                }), t("referrer_policy", {
                    processor: "string",
                    default: ""
                }), t("language_load", {
                    processor: "boolean",
                    default: !0
                }), t("inline", {
                    processor: "boolean",
                    default: !1
                }), t("iframe_attrs", {
                    processor: "object",
                    default: {}
                }), t("doctype", {
                    processor: "string",
                    default: "<!DOCTYPE html>"
                }), t("document_base_url", {
                    processor: "string",
                    default: e1.documentBaseUrl
                }), t("body_id", {
                    processor: Al(e1, "tinymce"),
                    default: "tinymce"
                }), t("body_class", {
                    processor: Al(e1),
                    default: ""
                }), t("content_security_policy", {
                    processor: "string",
                    default: ""
                }), t("br_in_pre", {
                    processor: "boolean",
                    default: !0
                }), t("forced_root_block", {
                    processor: (e1)=>{
                        const t = m(e1) && Ye(e1);
                        return t ? {
                            value: e1,
                            valid: t
                        } : {
                            valid: !1,
                            message: "Must be a non-empty string."
                        };
                    },
                    default: "p"
                }), t("forced_root_block_attrs", {
                    processor: "object",
                    default: {}
                }), t("newline_behavior", {
                    processor: (e1)=>{
                        const t = H([
                            "block",
                            "linebreak",
                            "invert",
                            "default"
                        ], e1);
                        return t ? {
                            value: e1,
                            valid: t
                        } : {
                            valid: !1,
                            message: "Must be one of: block, linebreak, invert or default."
                        };
                    },
                    default: "default"
                }), t("br_newline_selector", {
                    processor: "string",
                    default: ".mce-toc h2,figcaption,caption"
                }), t("no_newline_selector", {
                    processor: "string",
                    default: ""
                }), t("keep_styles", {
                    processor: "boolean",
                    default: !0
                }), t("end_container_on_empty_block", {
                    processor: (e1)=>b(e1) || m(e1) ? {
                            valid: !0,
                            value: e1
                        } : {
                            valid: !1,
                            message: "Must be boolean or a string"
                        },
                    default: "blockquote"
                }), t("font_size_style_values", {
                    processor: "string",
                    default: "xx-small,x-small,small,medium,large,x-large,xx-large"
                }), t("font_size_legacy_values", {
                    processor: "string",
                    default: "xx-small,small,medium,large,x-large,xx-large,300%"
                }), t("font_size_classes", {
                    processor: "string",
                    default: ""
                }), t("automatic_uploads", {
                    processor: "boolean",
                    default: !0
                }), t("images_reuse_filename", {
                    processor: "boolean",
                    default: !1
                }), t("images_replace_blob_uris", {
                    processor: "boolean",
                    default: !0
                }), t("icons", {
                    processor: "string",
                    default: ""
                }), t("icons_url", {
                    processor: "string",
                    default: ""
                }), t("images_upload_url", {
                    processor: "string",
                    default: ""
                }), t("images_upload_base_path", {
                    processor: "string",
                    default: ""
                }), t("images_upload_credentials", {
                    processor: "boolean",
                    default: !1
                }), t("images_upload_handler", {
                    processor: "function"
                }), t("language", {
                    processor: "string",
                    default: "en"
                }), t("language_url", {
                    processor: "string",
                    default: ""
                }), t("entity_encoding", {
                    processor: "string",
                    default: "named"
                }), t("indent", {
                    processor: "boolean",
                    default: !0
                }), t("indent_before", {
                    processor: "string",
                    default: "p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,tfoot,tbody,tr,section,details,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist"
                }), t("indent_after", {
                    processor: "string",
                    default: "p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,tfoot,tbody,tr,section,details,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist"
                }), t("indent_use_margin", {
                    processor: "boolean",
                    default: !1
                }), t("indentation", {
                    processor: "string",
                    default: "40px"
                }), t("content_css", {
                    processor: (e1)=>{
                        const t = !1 === e1 || m(e1) || E(e1, m);
                        return t ? m(e1) ? {
                            value: q(e1.split(","), Ve),
                            valid: t
                        } : p(e1) ? {
                            value: e1,
                            valid: t
                        } : !1 === e1 ? {
                            value: [],
                            valid: t
                        } : {
                            value: e1,
                            valid: t
                        } : {
                            valid: !1,
                            message: "Must be false, a string or an array of strings."
                        };
                    },
                    default: Sd(e1) ? [] : [
                        "default"
                    ]
                }), t("content_style", {
                    processor: "string"
                }), t("content_css_cors", {
                    processor: "boolean",
                    default: !1
                }), t("font_css", {
                    processor: (e1)=>{
                        const t = m(e1) || E(e1, m);
                        return t ? {
                            value: p(e1) ? e1 : q(e1.split(","), Ve),
                            valid: t
                        } : {
                            valid: !1,
                            message: "Must be a string or an array of strings."
                        };
                    },
                    default: []
                }), t("inline_boundaries", {
                    processor: "boolean",
                    default: !0
                }), t("inline_boundaries_selector", {
                    processor: "string",
                    default: "a[href],code,span.mce-annotation"
                }), t("object_resizing", {
                    processor: (e1)=>{
                        const t = b(e1) || m(e1);
                        return t ? !1 === e1 || El.isiPhone() || El.isiPad() ? {
                            value: "",
                            valid: t
                        } : {
                            value: !0 === e1 ? "table,img,figure.image,div,video,iframe" : e1,
                            valid: t
                        } : {
                            valid: !1,
                            message: "Must be boolean or a string"
                        };
                    },
                    default: !_l
                }), t("resize_img_proportional", {
                    processor: "boolean",
                    default: !0
                }), t("event_root", {
                    processor: "object"
                }), t("service_message", {
                    processor: "string"
                }), t("theme", {
                    processor: (e1)=>!1 === e1 || m(e1) || w(e1),
                    default: "silver"
                }), t("theme_url", {
                    processor: "string"
                }), t("formats", {
                    processor: "object"
                }), t("format_empty_lines", {
                    processor: "boolean",
                    default: !1
                }), t("format_noneditable_selector", {
                    processor: "string",
                    default: ""
                }), t("preview_styles", {
                    processor: (e1)=>{
                        const t = !1 === e1 || m(e1);
                        return t ? {
                            value: !1 === e1 ? "" : e1,
                            valid: t
                        } : {
                            valid: !1,
                            message: "Must be false or a string"
                        };
                    },
                    default: "font-family font-size font-weight font-style text-decoration text-transform color background-color border border-radius outline text-shadow"
                }), t("custom_ui_selector", {
                    processor: "string",
                    default: ""
                }), t("hidden_input", {
                    processor: "boolean",
                    default: !0
                }), t("submit_patch", {
                    processor: "boolean",
                    default: !0
                }), t("encoding", {
                    processor: "string"
                }), t("add_form_submit_trigger", {
                    processor: "boolean",
                    default: !0
                }), t("add_unload_trigger", {
                    processor: "boolean",
                    default: !0
                }), t("custom_undo_redo_levels", {
                    processor: "number",
                    default: 0
                }), t("disable_nodechange", {
                    processor: "boolean",
                    default: !1
                }), t("readonly", {
                    processor: "boolean",
                    default: !1
                }), t("editable_root", {
                    processor: "boolean",
                    default: !0
                }), t("plugins", {
                    processor: "string[]",
                    default: []
                }), t("external_plugins", {
                    processor: "object"
                }), t("forced_plugins", {
                    processor: "string[]"
                }), t("model", {
                    processor: "string",
                    default: e1.hasPlugin("rtc") ? "plugin" : "dom"
                }), t("model_url", {
                    processor: "string"
                }), t("block_unsupported_drop", {
                    processor: "boolean",
                    default: !0
                }), t("visual", {
                    processor: "boolean",
                    default: !0
                }), t("visual_table_class", {
                    processor: "string",
                    default: "mce-item-table"
                }), t("visual_anchor_class", {
                    processor: "string",
                    default: "mce-item-anchor"
                }), t("iframe_aria_text", {
                    processor: "string",
                    default: "Rich Text Area. Press ALT-0 for help."
                }), t("setup", {
                    processor: "function"
                }), t("init_instance_callback", {
                    processor: "function"
                }), t("url_converter", {
                    processor: "function",
                    default: e1.convertURL
                }), t("url_converter_scope", {
                    processor: "object",
                    default: e1
                }), t("urlconverter_callback", {
                    processor: "function"
                }), t("allow_conditional_comments", {
                    processor: "boolean",
                    default: !1
                }), t("allow_html_data_urls", {
                    processor: "boolean",
                    default: !1
                }), t("allow_svg_data_urls", {
                    processor: "boolean"
                }), t("allow_html_in_named_anchor", {
                    processor: "boolean",
                    default: !1
                }), t("allow_script_urls", {
                    processor: "boolean",
                    default: !1
                }), t("allow_unsafe_link_target", {
                    processor: "boolean",
                    default: !1
                }), t("convert_fonts_to_spans", {
                    processor: "boolean",
                    default: !0,
                    deprecated: !0
                }), t("fix_list_elements", {
                    processor: "boolean",
                    default: !1
                }), t("preserve_cdata", {
                    processor: "boolean",
                    default: !1
                }), t("remove_trailing_brs", {
                    processor: "boolean",
                    default: !0
                }), t("pad_empty_with_br", {
                    processor: "boolean",
                    default: !1
                }), t("inline_styles", {
                    processor: "boolean",
                    default: !0,
                    deprecated: !0
                }), t("element_format", {
                    processor: "string",
                    default: "html"
                }), t("entities", {
                    processor: "string"
                }), t("schema", {
                    processor: "string",
                    default: "html5"
                }), t("convert_urls", {
                    processor: "boolean",
                    default: !0
                }), t("relative_urls", {
                    processor: "boolean",
                    default: !0
                }), t("remove_script_host", {
                    processor: "boolean",
                    default: !0
                }), t("custom_elements", {
                    processor: "string"
                }), t("extended_valid_elements", {
                    processor: "string"
                }), t("invalid_elements", {
                    processor: "string"
                }), t("invalid_styles", {
                    processor: Rl
                }), t("valid_children", {
                    processor: "string"
                }), t("valid_classes", {
                    processor: Rl
                }), t("valid_elements", {
                    processor: "string"
                }), t("valid_styles", {
                    processor: Rl
                }), t("verify_html", {
                    processor: "boolean",
                    default: !0
                }), t("auto_focus", {
                    processor: (e1)=>m(e1) || !0 === e1
                }), t("browser_spellcheck", {
                    processor: "boolean",
                    default: !1
                }), t("protect", {
                    processor: "array"
                }), t("images_file_types", {
                    processor: "string",
                    default: "jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp"
                }), t("deprecation_warnings", {
                    processor: "boolean",
                    default: !0
                }), t("a11y_advanced_options", {
                    processor: "boolean",
                    default: !1
                }), t("api_key", {
                    processor: "string"
                }), t("paste_block_drop", {
                    processor: "boolean",
                    default: !1
                }), t("paste_data_images", {
                    processor: "boolean",
                    default: !0
                }), t("paste_preprocess", {
                    processor: "function"
                }), t("paste_postprocess", {
                    processor: "function"
                }), t("paste_webkit_styles", {
                    processor: "string",
                    default: "none"
                }), t("paste_remove_styles_if_webkit", {
                    processor: "boolean",
                    default: !0
                }), t("paste_merge_formats", {
                    processor: "boolean",
                    default: !0
                }), t("smart_paste", {
                    processor: "boolean",
                    default: !0
                }), t("paste_as_text", {
                    processor: "boolean",
                    default: !1
                }), t("paste_tab_spaces", {
                    processor: "number",
                    default: 4
                }), t("text_patterns", {
                    processor: (e1)=>E(e1, f) || !1 === e1 ? {
                            value: xl(!1 === e1 ? [] : e1),
                            valid: !0
                        } : {
                            valid: !1,
                            message: "Must be an array of objects or false."
                        },
                    default: [
                        {
                            start: "*",
                            end: "*",
                            format: "italic"
                        },
                        {
                            start: "**",
                            end: "**",
                            format: "bold"
                        },
                        {
                            start: "#",
                            format: "h1"
                        },
                        {
                            start: "##",
                            format: "h2"
                        },
                        {
                            start: "###",
                            format: "h3"
                        },
                        {
                            start: "####",
                            format: "h4"
                        },
                        {
                            start: "#####",
                            format: "h5"
                        },
                        {
                            start: "######",
                            format: "h6"
                        },
                        {
                            start: "1. ",
                            cmd: "InsertOrderedList"
                        },
                        {
                            start: "* ",
                            cmd: "InsertUnorderedList"
                        },
                        {
                            start: "- ",
                            cmd: "InsertUnorderedList"
                        }
                    ]
                }), t("text_patterns_lookup", {
                    processor: (e1)=>{
                        var t;
                        return w(e1) ? {
                            value: (t = e1, (e1)=>{
                                const n = t(e1);
                                return xl(n);
                            }),
                            valid: !0
                        } : {
                            valid: !1,
                            message: "Must be a single function"
                        };
                    },
                    default: (e1)=>[]
                }), t("noneditable_class", {
                    processor: "string",
                    default: "mceNonEditable"
                }), t("editable_class", {
                    processor: "string",
                    default: "mceEditable"
                }), t("noneditable_regexp", {
                    processor: (e1)=>E(e1, kl) ? {
                            value: e1,
                            valid: !0
                        } : kl(e1) ? {
                            value: [
                                e1
                            ],
                            valid: !0
                        } : {
                            valid: !1,
                            message: "Must be a RegExp or an array of RegExp."
                        },
                    default: []
                }), t("table_tab_navigation", {
                    processor: "boolean",
                    default: !0
                }), t("highlight_on_focus", {
                    processor: "boolean",
                    default: !1
                }), t("xss_sanitization", {
                    processor: "boolean",
                    default: !0
                }), t("details_initial_state", {
                    processor: (e1)=>{
                        const t = H([
                            "inherited",
                            "collapsed",
                            "expanded"
                        ], e1);
                        return t ? {
                            value: e1,
                            valid: t
                        } : {
                            valid: !1,
                            message: "Must be one of: inherited, collapsed, or expanded."
                        };
                    },
                    default: "inherited"
                }), t("details_serialized_state", {
                    processor: (e1)=>{
                        const t = H([
                            "inherited",
                            "collapsed",
                            "expanded"
                        ], e1);
                        return t ? {
                            value: e1,
                            valid: t
                        } : {
                            valid: !1,
                            message: "Must be one of: inherited, collapsed, or expanded."
                        };
                    },
                    default: "inherited"
                }), t("init_content_sync", {
                    processor: "boolean",
                    default: !1
                }), t("newdocument_content", {
                    processor: "string",
                    default: ""
                }), t("force_hex_color", {
                    processor: (e1)=>{
                        const t = [
                            "always",
                            "rgb_only",
                            "off"
                        ], n = H(t, e1);
                        return n ? {
                            value: e1,
                            valid: n
                        } : {
                            valid: !1,
                            message: `Must be one of: ${t.join(", ")}.`
                        };
                    },
                    default: "off"
                }), t("sandbox_iframes", {
                    processor: "boolean",
                    default: !1
                }), t("convert_unsafe_embeds", {
                    processor: "boolean",
                    default: !1
                }), e1.on("ScriptsLoaded", ()=>{
                    t("directionality", {
                        processor: "string",
                        default: Ka.isRtl() ? "rtl" : void 0
                    }), t("placeholder", {
                        processor: "string",
                        default: Sl.getAttrib(e1.getElement(), "placeholder")
                    });
                });
            })(o);
            const s = this.options.get;
            s("deprecation_warnings") && ((e1, t)=>{
                ((e1, t)=>{
                    const n = bw(e1), o = Cw(t), r = o.length > 0, s = n.length > 0, a = "mobile" === t.theme;
                    if (r || s || a) {
                        const e1 = "\n- ", t = a ? `\n\nThemes:${e1}mobile` : "", i = r ? `\n\nPlugins:${e1}${o.join(e1)}` : "", l = s ? `\n\nOptions:${e1}${n.join(e1)}` : "";
                        console.warn("The following deprecated features are currently enabled and have been removed in TinyMCE 6.0. These features will no longer work and should be removed from the TinyMCE configuration. See https://www.tiny.cloud/docs/tinymce/6/migration-from-5x/ for more information." + t + i + l);
                    }
                })(e1, t), ((e1, t)=>{
                    const n = vw(e1), o = ww(t), r = o.length > 0, s = n.length > 0;
                    if (r || s) {
                        const e1 = "\n- ", t = r ? `\n\nPlugins:${e1}${o.map(xw).join(e1)}` : "", a = s ? `\n\nOptions:${e1}${n.join(e1)}` : "";
                        console.warn("The following deprecated features are currently enabled but will be removed soon." + t + a);
                    }
                })(e1, t);
            })(t, r);
            const a = s("suffix");
            a && (n.suffix = a), this.suffix = n.suffix;
            const i = s("base_url");
            i && n._setBaseUrl(i), this.baseUri = n.baseURI;
            const l = ed(o);
            l && (Ha.ScriptLoader._setReferrerPolicy(l), za.DOM.styleSheetLoader._setReferrerPolicy(l));
            const d = Dd(o);
            C(d) && za.DOM.styleSheetLoader._setContentCssCors(d), Ya.languageLoad = s("language_load"), Ya.baseURL = n.baseURL, this.setDirty(!1), this.documentBaseURI = new aC(Bl(o), {
                base_uri: this.baseUri
            }), this.baseURI = this.baseUri, this.inline = Sd(o), this.hasVisual = Fd(o), this.shortcuts = new KO(this), this.editorCommands = new yO(this), hO(this);
            const c = s("cache_suffix");
            c && (At.cacheSuffix = c.replace(/^[\?\&]+/, "")), this.ui = {
                registry: YO(),
                styleSheetLoader: void 0,
                show: _,
                hide: _,
                setEnabled: _,
                isEnabled: M
            }, this.mode = ((e1)=>{
                const t = $a("design"), n = $a({
                    design: {
                        activate: _,
                        deactivate: _,
                        editorReadOnly: !1
                    },
                    readonly: {
                        activate: _,
                        deactivate: _,
                        editorReadOnly: !0
                    }
                });
                return ((e1)=>{
                    e1.serializer ? _O(e1) : e1.on("PreInit", ()=>{
                        _O(e1);
                    });
                })(e1), ((e1)=>{
                    e1.on("ShowCaret", (t)=>{
                        EO(e1) && t.preventDefault();
                    }), e1.on("ObjectSelected", (t)=>{
                        EO(e1) && t.preventDefault();
                    });
                })(e1), {
                    isReadOnly: ()=>EO(e1),
                    set: (o)=>((e1, t, n, o)=>{
                            if (o !== n.get()) {
                                if (!Ee(t, o)) throw new Error(`Editor mode '${o}' is invalid`);
                                e1.initialized ? jO(e1, n, t, o) : e1.on("init", ()=>jO(e1, n, t, o));
                            }
                        })(e1, n.get(), t, o),
                    get: ()=>t.get(),
                    register: (e1, t)=>{
                        n.set(((e1, t, n)=>{
                            if (H(zO, t)) throw new Error(`Cannot override default mode ${t}`);
                            return {
                                ...e1,
                                [t]: {
                                    ...n,
                                    deactivate: ()=>{
                                        try {
                                            n.deactivate();
                                        } catch (e1) {
                                            console.error(`problem while deactivating editor mode ${t}:`, e1);
                                        }
                                    }
                                }
                            };
                        })(n.get(), e1, t));
                    }
                };
            })(o), n.dispatch("SetupEditor", {
                editor: this
            });
            const g = Hd(o);
            w(g) && g.call(o, o);
        }
        render() {
            ((e1)=>{
                const t = e1.id;
                Ka.setCode(td(e1));
                const n = ()=>{
                    qT.unbind(window, "ready", n), e1.render();
                };
                if (!Ta.Event.domLoaded) return void qT.bind(window, "ready", n);
                if (!e1.getElement()) return;
                const o = yn(e1.getElement()), r = rn(o);
                e1.on("remove", ()=>{
                    W(o.dom.attributes, (e1)=>on(o, e1.name)), Zt(o, r);
                }), e1.ui.styleSheetLoader = ((e1, t)=>Is.forElement(e1, {
                        contentCssCors: Dd(t),
                        referrerPolicy: ed(t)
                    }))(o, e1), Sd(e1) ? e1.inline = !0 : (e1.orgVisibility = e1.getElement().style.visibility, e1.getElement().style.visibility = "hidden");
                const s = e1.getElement().form || qT.getParent(t, "form");
                s && (e1.formElement = s, kd(e1) && !Zo(e1.getElement()) && (qT.insertAfter(qT.create("input", {
                    type: "hidden",
                    name: t
                }), t), e1.hasHiddenInput = !0), e1.formEventDelegate = (t)=>{
                    e1.dispatch(t.type, t);
                }, qT.bind(s, "submit reset", e1.formEventDelegate), e1.on("reset", ()=>{
                    e1.resetContent();
                }), !Nd(e1) || s.submit.nodeType || s.submit.length || s._mceOldSubmit || (s._mceOldSubmit = s.submit, s.submit = ()=>(e1.editorManager.triggerSave(), e1.setDirty(!1), s._mceOldSubmit(s)))), e1.windowManager = Mw(e1), e1.notificationManager = Pw(e1), ((e1)=>"xml" === e1.options.get("encoding"))(e1) && e1.on("GetContent", (e1)=>{
                    e1.save && (e1.content = qT.encode(e1.content));
                }), Rd(e1) && e1.on("submit", ()=>{
                    e1.initialized && e1.save();
                }), Ad(e1) && (e1._beforeUnload = ()=>{
                    !e1.initialized || e1.destroyed || e1.isHidden() || e1.save({
                        format: "raw",
                        no_events: !0,
                        set_dirty: !1
                    });
                }, e1.editorManager.on("BeforeUnload", e1._beforeUnload)), e1.editorManager.add(e1), KT(e1, e1.suffix);
            })(this);
        }
        focus(e1) {
            this.execCommand("mceFocus", !1, e1);
        }
        hasFocus() {
            return Rg(this);
        }
        translate(e1) {
            return Ka.translate(e1);
        }
        getParam(e1, t, n) {
            const o = this.options;
            return o.isRegistered(e1) || (C(n) ? o.register(e1, {
                processor: n,
                default: t
            }) : o.register(e1, {
                processor: M,
                default: t
            })), o.isSet(e1) || v(t) ? o.get(e1) : t;
        }
        hasPlugin(e1, t) {
            return !(!H(Ld(this), e1) || t && void 0 === Dw.get(e1));
        }
        nodeChanged(e1) {
            this._nodeChangeDispatcher.nodeChanged(e1);
        }
        addCommand(e1, t, n) {
            this.editorCommands.addCommand(e1, t, n);
        }
        addQueryStateHandler(e1, t, n) {
            this.editorCommands.addQueryStateHandler(e1, t, n);
        }
        addQueryValueHandler(e1, t, n) {
            this.editorCommands.addQueryValueHandler(e1, t, n);
        }
        addShortcut(e1, t, n, o) {
            this.shortcuts.add(e1, t, n, o);
        }
        execCommand(e1, t, n, o) {
            return this.editorCommands.execCommand(e1, t, n, o);
        }
        queryCommandState(e1) {
            return this.editorCommands.queryCommandState(e1);
        }
        queryCommandValue(e1) {
            return this.editorCommands.queryCommandValue(e1);
        }
        queryCommandSupported(e1) {
            return this.editorCommands.queryCommandSupported(e1);
        }
        show() {
            const e1 = this;
            e1.hidden && (e1.hidden = !1, e1.inline ? e1.getBody().contentEditable = "true" : (GO.show(e1.getContainer()), GO.hide(e1.id)), e1.load(), e1.dispatch("show"));
        }
        hide() {
            const e1 = this;
            e1.hidden || (e1.save(), e1.inline ? (e1.getBody().contentEditable = "false", e1 === e1.editorManager.focusedEditor && (e1.editorManager.focusedEditor = null)) : (GO.hide(e1.getContainer()), GO.setStyle(e1.id, "display", e1.orgDisplay)), e1.hidden = !0, e1.dispatch("hide"));
        }
        isHidden() {
            return this.hidden;
        }
        setProgressState(e1, t) {
            this.dispatch("ProgressState", {
                state: e1,
                time: t
            });
        }
        load(e1 = {}) {
            const t = this, n = t.getElement();
            if (t.removed) return "";
            if (n) {
                const o = {
                    ...e1,
                    load: !0
                }, r = Zo(n) ? n.value : n.innerHTML, s = t.setContent(r, o);
                return o.no_events || t.dispatch("LoadContent", {
                    ...o,
                    element: n
                }), s;
            }
            return "";
        }
        save(e1 = {}) {
            const t = this;
            let n = t.getElement();
            if (!n || !t.initialized || t.removed) return "";
            const o = {
                ...e1,
                save: !0,
                element: n
            };
            let r = t.getContent(o);
            const s = {
                ...o,
                content: r
            };
            if (s.no_events || t.dispatch("SaveContent", s), "raw" === s.format && t.dispatch("RawSaveContent", s), r = s.content, Zo(n)) n.value = r;
            else {
                !e1.is_removing && t.inline || (n.innerHTML = r);
                const o = GO.getParent(t.id, "form");
                o && QO(o.elements, (e1)=>e1.name !== t.id || (e1.value = r, !1));
            }
            return s.element = o.element = n = null, !1 !== s.set_dirty && t.setDirty(!1), r;
        }
        setContent(e1, t) {
            return uw(this, e1, t);
        }
        getContent(e1) {
            return ((e1, t = {})=>{
                const n = ((e1, t)=>({
                        ...e1,
                        format: t,
                        get: !0,
                        getInner: !0
                    }))(t, t.format ? t.format : "html");
                return xC(e1, n).fold(R, (t)=>{
                    const n = ((e1, t)=>ew(e1).editor.getContent(t))(e1, t);
                    return EC(e1, n, t);
                });
            })(this, e1);
        }
        insertContent(e1, t) {
            t && (e1 = XO({
                content: e1
            }, t)), this.execCommand("mceInsertContent", !1, e1);
        }
        resetContent(e1) {
            void 0 === e1 ? uw(this, this.startContent, {
                format: "raw"
            }) : uw(this, e1), this.undoManager.reset(), this.setDirty(!1), this.nodeChanged();
        }
        isDirty() {
            return !this.isNotDirty;
        }
        setDirty(e1) {
            const t = !this.isNotDirty;
            this.isNotDirty = !e1, e1 && e1 !== t && this.dispatch("dirty");
        }
        getContainer() {
            const e1 = this;
            return e1.container || (e1.container = e1.editorContainer || GO.get(e1.id + "_parent")), e1.container;
        }
        getContentAreaContainer() {
            return this.contentAreaContainer;
        }
        getElement() {
            return this.targetElm || (this.targetElm = GO.get(this.id)), this.targetElm;
        }
        getWin() {
            const e1 = this;
            if (!e1.contentWindow) {
                const t = e1.iframeElement;
                t && (e1.contentWindow = t.contentWindow);
            }
            return e1.contentWindow;
        }
        getDoc() {
            const e1 = this;
            if (!e1.contentDocument) {
                const t = e1.getWin();
                t && (e1.contentDocument = t.document);
            }
            return e1.contentDocument;
        }
        getBody() {
            var e1, t;
            const n = this.getDoc();
            return null !== (t = null !== (e1 = this.bodyElement) && void 0 !== e1 ? e1 : null == n ? void 0 : n.body) && void 0 !== t ? t : null;
        }
        convertURL(e1, t, n) {
            const o = this, r = o.options.get, s = qd(o);
            if (w(s)) return s.call(o, e1, n, !0, t);
            if (!r("convert_urls") || "link" === n || f(n) && "LINK" === n.nodeName || 0 === e1.indexOf("file:") || 0 === e1.length) return e1;
            const a = new aC(e1);
            return "http" !== a.protocol && "https" !== a.protocol && "" !== a.protocol ? e1 : r("relative_urls") ? o.documentBaseURI.toRelative(e1) : e1 = o.documentBaseURI.toAbsolute(e1, r("remove_script_host"));
        }
        addVisual(e1) {
            ((e1, t)=>{
                ((e1, t)=>{
                    tw(e1).editor.addVisual(t);
                })(e1, t);
            })(this, e1);
        }
        setEditableRoot(e1) {
            ((e1, t)=>{
                e1._editableRoot !== t && (e1._editableRoot = t, e1.readonly || (e1.getBody().contentEditable = String(e1.hasEditableRoot()), e1.nodeChanged()), ((e1, t)=>{
                    e1.dispatch("EditableRootStateChange", {
                        state: t
                    });
                })(e1, t));
            })(this, e1);
        }
        hasEditableRoot() {
            return this._editableRoot;
        }
        remove() {
            ((e1)=>{
                if (!e1.removed) {
                    const { _selectionOverrides: t, editorUpload: n } = e1, o = e1.getBody(), r = e1.getElement();
                    o && e1.save({
                        is_removing: !0
                    }), e1.removed = !0, e1.unbindAllNativeEvents(), e1.hasHiddenInput && C(null == r ? void 0 : r.nextSibling) && Ew.remove(r.nextSibling), ((e1)=>{
                        e1.dispatch("remove");
                    })(e1), e1.editorManager.remove(e1), !e1.inline && o && ((e1)=>{
                        Ew.setStyle(e1.id, "display", e1.orgDisplay);
                    })(e1), ((e1)=>{
                        e1.dispatch("detach");
                    })(e1), Ew.remove(e1.getContainer()), _w(t), _w(n), e1.destroy();
                }
            })(this);
        }
        destroy(e1) {
            ((e1, t)=>{
                const { selection: n, dom: o } = e1;
                e1.destroyed || (t || e1.removed ? (t || (e1.editorManager.off("beforeunload", e1._beforeUnload), e1.theme && e1.theme.destroy && e1.theme.destroy(), _w(n), _w(o)), ((e1)=>{
                    const t = e1.formElement;
                    t && (t._mceOldSubmit && (t.submit = t._mceOldSubmit, delete t._mceOldSubmit), Ew.unbind(t, "submit reset", e1.formEventDelegate));
                })(e1), ((e1)=>{
                    const t = e1;
                    t.contentAreaContainer = t.formElement = t.container = t.editorContainer = null, t.bodyElement = t.contentDocument = t.contentWindow = null, t.iframeElement = t.targetElm = null;
                    const n = e1.selection;
                    if (n) {
                        const e1 = n.dom;
                        t.selection = n.win = n.dom = e1.doc = null;
                    }
                })(e1), e1.destroyed = !0) : e1.remove());
            })(this, e1);
        }
        uploadImages() {
            return this.editorUpload.uploadImages();
        }
        _scanForImages() {
            return this.editorUpload.scanForImages();
        }
    }
    const ZO = za.DOM, eB = Pt.each;
    let tB, nB = !1, oB = [];
    const rB = (e1)=>{
        const t = e1.type;
        eB(lB.get(), (n)=>{
            switch(t){
                case "scroll":
                    n.dispatch("ScrollWindow", e1);
                    break;
                case "resize":
                    n.dispatch("ResizeWindow", e1);
            }
        });
    }, sB = (e1)=>{
        if (e1 !== nB) {
            const t = za.DOM;
            e1 ? (t.bind(window, "resize", rB), t.bind(window, "scroll", rB)) : (t.unbind(window, "resize", rB), t.unbind(window, "scroll", rB)), nB = e1;
        }
    }, aB = (e1)=>{
        const t = oB;
        return oB = Y(oB, (t)=>e1 !== t), lB.activeEditor === e1 && (lB.activeEditor = oB.length > 0 ? oB[0] : null), lB.focusedEditor === e1 && (lB.focusedEditor = null), t.length !== oB.length;
    }, iB = "CSS1Compat" !== document.compatMode, lB = {
        ...AO,
        baseURI: null,
        baseURL: null,
        defaultOptions: {},
        documentBaseURL: null,
        suffix: null,
        majorVersion: "6",
        minorVersion: "8.6",
        releaseDate: "TBD",
        i18n: Ka,
        activeEditor: null,
        focusedEditor: null,
        setup () {
            const e1 = this;
            let t = "", n = "", o = aC.getDocumentBaseUrl(document.location);
            /^[^:]+:\/\/\/?[^\/]+\//.test(o) && (o = o.replace(/[\?#].*$/, "").replace(/[\/\\][^\/]+$/, ""), /[\/\\]$/.test(o) || (o += "/"));
            const r = window.tinymce || window.tinyMCEPreInit;
            if (r) t = r.base || r.baseURL, n = r.suffix;
            else {
                const e1 = document.getElementsByTagName("script");
                for(let o = 0; o < e1.length; o++){
                    const r = e1[o].src || "";
                    if ("" === r) continue;
                    const s = r.substring(r.lastIndexOf("/"));
                    if (/tinymce(\.full|\.jquery|)(\.min|\.dev|)\.js/.test(r)) {
                        -1 !== s.indexOf(".min") && (n = ".min"), t = r.substring(0, r.lastIndexOf("/"));
                        break;
                    }
                }
                if (!t && document.currentScript) {
                    const e1 = document.currentScript.src;
                    -1 !== e1.indexOf(".min") && (n = ".min"), t = e1.substring(0, e1.lastIndexOf("/"));
                }
            }
            var s;
            e1.baseURL = new aC(o).toAbsolute(t), e1.documentBaseURL = o, e1.baseURI = new aC(e1.baseURL), e1.suffix = n, (s = e1).on("AddEditor", T(_g, s)), s.on("RemoveEditor", T(Sg, s));
        },
        overrideDefaults (e1) {
            const t = e1.base_url;
            t && this._setBaseUrl(t);
            const n = e1.suffix;
            n && (this.suffix = n), this.defaultOptions = e1;
            const o = e1.plugin_base_urls;
            void 0 !== o && ge(o, (e1, t)=>{
                Ya.PluginManager.urls[t] = e1;
            });
        },
        init (e1) {
            const t = this;
            let n;
            const o = Pt.makeMap("area base basefont br col frame hr img input isindex link meta param embed source wbr track colgroup option table tbody tfoot thead tr th td script noscript style textarea video audio iframe object menu", " ");
            let r = (e1)=>{
                n = e1;
            };
            const s = ()=>{
                let n = 0;
                const a = [];
                let i;
                ZO.unbind(window, "ready", s), ((n)=>{
                    const o = e1.onpageload;
                    o && o.apply(t, []);
                })(), i = ((e1, t)=>{
                    const n = [], o = w(t) ? (e1)=>$(n, (n)=>t(n, e1)) : (e1)=>H(n, e1);
                    for(let t = 0, r = e1.length; t < r; t++){
                        const r = e1[t];
                        o(r) || n.push(r);
                    }
                    return n;
                })(((e1)=>At.browser.isIE() || At.browser.isEdge() ? (jw("TinyMCE does not support the browser you are using. For a list of supported browsers please see: https://www.tiny.cloud/docs/tinymce/6/support/#supportedwebbrowsers"), []) : iB ? (jw("Failed to initialize the editor as the document is not in standards mode. TinyMCE requires standards mode."), []) : m(e1.selector) ? ZO.select(e1.selector) : C(e1.target) ? [
                        e1.target
                    ] : [])(e1)), Pt.each(i, (e1)=>{
                    var n;
                    (n = t.get(e1.id)) && n.initialized && !(n.getContainer() || n.getBody()).parentNode && (aB(n), n.unbindAllNativeEvents(), n.destroy(!0), n.removed = !0);
                }), i = Pt.grep(i, (e1)=>!t.get(e1.id)), 0 === i.length ? r([]) : eB(i, (s)=>{
                    ((e1, t)=>e1.inline && t.tagName.toLowerCase() in o)(e1, s) ? jw("Could not initialize inline editor on invalid inline target element", s) : ((e1, o, s)=>{
                        const l = new JO(e1, o, t);
                        a.push(l), l.on("init", ()=>{
                            ++n === i.length && r(a);
                        }), l.targetElm = l.targetElm || s, l.render();
                    })(((e1)=>{
                        let t = e1.id;
                        return t || (t = xe(e1, "name").filter((e1)=>!ZO.get(e1)).getOrThunk(ZO.uniqueId), e1.setAttribute("id", t)), t;
                    })(s), e1, s);
                });
            };
            return ZO.bind(window, "ready", s), new Promise((e1)=>{
                n ? e1(n) : r = (t)=>{
                    e1(t);
                };
            });
        },
        get (e1) {
            return 0 === arguments.length ? oB.slice(0) : m(e1) ? J(oB, (t)=>t.id === e1).getOr(null) : x(e1) && oB[e1] ? oB[e1] : null;
        },
        add (e1) {
            const t = this, n = t.get(e1.id);
            return n === e1 || (null === n && oB.push(e1), sB(!0), t.activeEditor = e1, t.dispatch("AddEditor", {
                editor: e1
            }), tB || (tB = (e1)=>{
                const n = t.dispatch("BeforeUnload");
                if (n.returnValue) return e1.preventDefault(), e1.returnValue = n.returnValue, n.returnValue;
            }, window.addEventListener("beforeunload", tB))), e1;
        },
        createEditor (e1, t) {
            return this.add(new JO(e1, t, this));
        },
        remove (e1) {
            const t = this;
            let n;
            if (e1) {
                if (!m(e1)) return n = e1, h(t.get(n.id)) ? null : (aB(n) && t.dispatch("RemoveEditor", {
                    editor: n
                }), 0 === oB.length && window.removeEventListener("beforeunload", tB), n.remove(), sB(oB.length > 0), n);
                eB(ZO.select(e1), (e1)=>{
                    n = t.get(e1.id), n && t.remove(n);
                });
            } else for(let e1 = oB.length - 1; e1 >= 0; e1--)t.remove(oB[e1]);
        },
        execCommand (e1, t, n) {
            var o;
            const r = this, s = f(n) ? null !== (o = n.id) && void 0 !== o ? o : n.index : n;
            switch(e1){
                case "mceAddEditor":
                    if (!r.get(s)) {
                        const e1 = n.options;
                        new JO(s, e1, r).render();
                    }
                    return !0;
                case "mceRemoveEditor":
                    {
                        const e1 = r.get(s);
                        return e1 && e1.remove(), !0;
                    }
                case "mceToggleEditor":
                    {
                        const e1 = r.get(s);
                        return e1 ? (e1.isHidden() ? e1.show() : e1.hide(), !0) : (r.execCommand("mceAddEditor", !1, n), !0);
                    }
            }
            return !!r.activeEditor && r.activeEditor.execCommand(e1, t, n);
        },
        triggerSave: ()=>{
            eB(oB, (e1)=>{
                e1.save();
            });
        },
        addI18n: (e1, t)=>{
            Ka.add(e1, t);
        },
        translate: (e1)=>Ka.translate(e1),
        setActive (e1) {
            const t = this.activeEditor;
            this.activeEditor !== e1 && (t && t.dispatch("deactivate", {
                relatedTarget: e1
            }), e1.dispatch("activate", {
                relatedTarget: t
            })), this.activeEditor = e1;
        },
        _setBaseUrl (e1) {
            this.baseURL = new aC(this.documentBaseURL).toAbsolute(e1.replace(/\/+$/, "")), this.baseURI = new aC(this.baseURL);
        }
    };
    lB.setup();
    const dB = (()=>{
        const e1 = Xa();
        return {
            FakeClipboardItem: (e1)=>({
                    items: e1,
                    types: me(e1),
                    getType: (t)=>xe(e1, t).getOrUndefined()
                }),
            write: (t)=>{
                e1.set(t);
            },
            read: ()=>e1.get().getOrUndefined(),
            clear: e1.clear
        };
    })(), cB = Math.min, uB = Math.max, mB = Math.round, fB = (e1, t, n)=>{
        let o = t.x, r = t.y;
        const s = e1.w, a = e1.h, i = t.w, l = t.h, d = (n || "").split("");
        return "b" === d[0] && (r += l), "r" === d[1] && (o += i), "c" === d[0] && (r += mB(l / 2)), "c" === d[1] && (o += mB(i / 2)), "b" === d[3] && (r -= a), "r" === d[4] && (o -= s), "c" === d[3] && (r -= mB(a / 2)), "c" === d[4] && (o -= mB(s / 2)), gB(o, r, s, a);
    }, gB = (e1, t, n, o)=>({
            x: e1,
            y: t,
            w: n,
            h: o
        }), pB = {
        inflate: (e1, t, n)=>gB(e1.x - t, e1.y - n, e1.w + 2 * t, e1.h + 2 * n),
        relativePosition: fB,
        findBestRelativePosition: (e1, t, n, o)=>{
            for(let r = 0; r < o.length; r++){
                const s = fB(e1, t, o[r]);
                if (s.x >= n.x && s.x + s.w <= n.w + n.x && s.y >= n.y && s.y + s.h <= n.h + n.y) return o[r];
            }
            return null;
        },
        intersect: (e1, t)=>{
            const n = uB(e1.x, t.x), o = uB(e1.y, t.y), r = cB(e1.x + e1.w, t.x + t.w), s = cB(e1.y + e1.h, t.y + t.h);
            return r - n < 0 || s - o < 0 ? null : gB(n, o, r - n, s - o);
        },
        clamp: (e1, t, n)=>{
            let o = e1.x, r = e1.y, s = e1.x + e1.w, a = e1.y + e1.h;
            const i = t.x + t.w, l = t.y + t.h, d = uB(0, t.x - o), c = uB(0, t.y - r), u = uB(0, s - i), m = uB(0, a - l);
            return o += d, r += c, n && (s += d, a += c, o -= u, r -= m), s -= u, a -= m, gB(o, r, s - o, a - r);
        },
        create: gB,
        fromClientRect: (e1)=>gB(e1.left, e1.top, e1.width, e1.height)
    }, hB = (()=>{
        const e1 = {}, t = {}, n = {};
        return {
            load: (n, o)=>{
                const r = `Script at URL "${o}" failed to load`, s = `Script at URL "${o}" did not call \`tinymce.Resource.add('${n}', data)\` within 1 second`;
                if (void 0 !== e1[n]) return e1[n];
                {
                    const a = new Promise((e1, a)=>{
                        const i = ((e1, t, n = 1e3)=>{
                            let o = !1, r = null;
                            const s = (e1)=>(...t)=>{
                                    o || (o = !0, null !== r && (clearTimeout(r), r = null), e1.apply(null, t));
                                }, a = s(e1), i = s(t);
                            return {
                                start: (...e1)=>{
                                    o || null !== r || (r = setTimeout(()=>i.apply(null, e1), n));
                                },
                                resolve: a,
                                reject: i
                            };
                        })(e1, a);
                        t[n] = i.resolve, Ha.ScriptLoader.loadScript(o).then(()=>i.start(s), ()=>i.reject(r));
                    });
                    return e1[n] = a, a;
                }
            },
            add: (o, r)=>{
                void 0 !== t[o] && (t[o](r), delete t[o]), e1[o] = Promise.resolve(r), n[o] = r;
            },
            has: (e1)=>e1 in n,
            get: (e1)=>n[e1],
            unload: (t)=>{
                delete e1[t];
            }
        };
    })();
    let bB;
    try {
        const e1 = "__storage_test__";
        bB = window.localStorage, bB.setItem(e1, e1), bB.removeItem(e1);
    } catch (e1) {
        bB = (()=>{
            let e1 = {}, t = [];
            const n = {
                getItem: (t)=>e1[t] || null,
                setItem: (n, o)=>{
                    t.push(n), e1[n] = String(o);
                },
                key: (e1)=>t[e1],
                removeItem: (n)=>{
                    t = t.filter((e1)=>e1 === n), delete e1[n];
                },
                clear: ()=>{
                    t = [], e1 = {};
                },
                length: 0
            };
            return Object.defineProperty(n, "length", {
                get: ()=>t.length,
                configurable: !1,
                enumerable: !1
            }), n;
        })();
    }
    const vB = {
        geom: {
            Rect: pB
        },
        util: {
            Delay: vg,
            Tools: Pt,
            VK: af,
            URI: aC,
            EventDispatcher: NO,
            Observable: AO,
            I18n: Ka,
            LocalStorage: bB,
            ImageUploader: (e1)=>{
                const t = Vw(), n = Gw(e1, t);
                return {
                    upload: (t, o = !0)=>n.upload(t, o ? Yw(e1) : void 0)
                };
            }
        },
        dom: {
            EventUtils: Ta,
            TreeWalker: jo,
            TextSeeker: hi,
            DOMUtils: za,
            ScriptLoader: Ha,
            RangeUtils: Uf,
            Serializer: cw,
            StyleSheetLoader: Ms,
            ControlSelection: mf,
            BookmarkManager: Jm,
            Selection: iw,
            Event: Ta.Event
        },
        html: {
            Styles: wa,
            Entities: ea,
            Node: Wg,
            Schema: ua,
            DomParser: CC,
            Writer: cp,
            Serializer: up
        },
        Env: At,
        AddOnManager: Ya,
        Annotator: Qm,
        Formatter: ix,
        UndoManager: dx,
        EditorCommands: yO,
        WindowManager: Mw,
        NotificationManager: Pw,
        EditorObservable: LO,
        Shortcuts: KO,
        Editor: JO,
        FocusManager: bg,
        EditorManager: lB,
        DOM: za.DOM,
        ScriptLoader: Ha.ScriptLoader,
        PluginManager: Dw,
        ThemeManager: Lw,
        ModelManager: kw,
        IconManager: Sw,
        Resource: hB,
        FakeClipboard: dB,
        trim: Pt.trim,
        isArray: Pt.isArray,
        is: Pt.is,
        toArray: Pt.toArray,
        makeMap: Pt.makeMap,
        each: Pt.each,
        map: Pt.map,
        grep: Pt.grep,
        inArray: Pt.inArray,
        extend: Pt.extend,
        walk: Pt.walk,
        resolve: Pt.resolve,
        explode: Pt.explode,
        _addCacheSuffix: Pt._addCacheSuffix
    }, yB = Pt.extend(lB, vB);
    ((e1)=>{
        window.tinymce = e1, window.tinyMCE = e1;
    })(yB), ((e1)=>{
        try {
            module.exports = e1;
        } catch (e1) {}
    })(yB);
}();

});

})();
//# sourceMappingURL=tinymce.min.560c202f.js.map
